// @ts-nocheck
import { supabase } from './supabase';
import React from 'react';
import { useState, useEffect, useCallback, useRef } from "react";
import { NativePurchases } from '@capgo/native-purchases';
import InstallPrompt from './InstallPrompt';
import { HEXAGRAMS, HEXAGRAM_BY_NUMBER, WU_XING_STRENGTH, HEX_TABLE, TRIGRAMS } from './data/hexagrams';
import IntuitionTab from './features/intuition/IntuitionTab';
import ReflectTab from './features/intuition/ReflectTab';
import CosmosCard from './features/cosmos/CosmosCard';
import CosmosPage from './features/cosmos/CosmosPage';
import { useUserLocation, resolveUserLocation } from './lib/userLocation';
import RegionPrompt from './components/RegionPrompt';
const IAP_PRODUCT_ID = 'com.koji.kigaku.premium';
const CHIBI_IMG = "data:image/png;base64,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";

const STAR_CHARS = {
  1: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
    <circle cx="40" cy="28" r="20" fill="#dbeafe" stroke="#1d4ed8" stroke-width="2"/>
    <circle cx="33" cy="24" r="3" fill="#1d4ed8"/><circle cx="47" cy="24" r="3" fill="#1d4ed8"/>
    <path d="M33 34 Q40 40 47 34" stroke="#1d4ed8" stroke-width="2" fill="none" stroke-linecap="round"/>
    <ellipse cx="40" cy="55" rx="18" ry="14" fill="#93c5fd" stroke="#1d4ed8" stroke-width="2"/>
    <path d="M22 50 Q15 55 18 65" stroke="#1d4ed8" stroke-width="2" fill="none"/>
    <path d="M58 50 Q65 55 62 65" stroke="#1d4ed8" stroke-width="2" fill="none"/>
    <path d="M28 69 Q40 75 52 69" stroke="#1d4ed8" stroke-width="2" fill="none"/>
    <text x="40" y="14" text-anchor="middle" font-size="10" fill="#1d4ed8">一白</text>
    <path d="M30 8 Q40 2 50 8" stroke="#60a5fa" stroke-width="1.5" fill="none"/>
  </svg>`,
  2: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
    <circle cx="40" cy="28" r="20" fill="#fef3c7" stroke="#92400e" stroke-width="2"/>
    <circle cx="33" cy="24" r="3" fill="#78350f"/><circle cx="47" cy="24" r="3" fill="#78350f"/>
    <path d="M33 35 Q40 40 47 35" stroke="#78350f" stroke-width="2" fill="none" stroke-linecap="round"/>
    <ellipse cx="40" cy="55" rx="18" ry="14" fill="#d97706" stroke="#92400e" stroke-width="2"/>
    <path d="M22 50 Q15 55 18 65" stroke="#92400e" stroke-width="2" fill="none"/>
    <path d="M58 50 Q65 55 62 65" stroke="#92400e" stroke-width="2" fill="none"/>
    <path d="M28 69 Q40 75 52 69" stroke="#92400e" stroke-width="2" fill="none"/>
    <text x="40" y="14" text-anchor="middle" font-size="10" fill="#92400e">二黒</text>
    <ellipse cx="40" cy="6" rx="8" ry="4" fill="#fbbf24" stroke="#d97706" stroke-width="1"/>
  </svg>`,
  3: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
    <circle cx="40" cy="28" r="20" fill="#dcfce7" stroke="#15803d" stroke-width="2"/>
    <circle cx="33" cy="24" r="3" fill="#15803d"/><circle cx="47" cy="24" r="3" fill="#15803d"/>
    <path d="M33 34 Q40 42 47 34" stroke="#15803d" stroke-width="2" fill="none" stroke-linecap="round"/>
    <ellipse cx="40" cy="55" rx="18" ry="14" fill="#4ade80" stroke="#15803d" stroke-width="2"/>
    <path d="M22 50 Q15 55 18 65" stroke="#15803d" stroke-width="2" fill="none"/>
    <path d="M58 50 Q65 55 62 65" stroke="#15803d" stroke-width="2" fill="none"/>
    <path d="M28 69 Q40 75 52 69" stroke="#15803d" stroke-width="2" fill="none"/>
    <text x="40" y="14" text-anchor="middle" font-size="10" fill="#15803d">三碧</text>
    <line x1="36" y1="5" x2="34" y2="10" stroke="#fbbf24" stroke-width="2"/>
    <line x1="40" y1="3" x2="40" y2="9" stroke="#fbbf24" stroke-width="2"/>
    <line x1="44" y1="5" x2="46" y2="10" stroke="#fbbf24" stroke-width="2"/>
  </svg>`,
  4: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
    <circle cx="40" cy="28" r="20" fill="#ecfdf5" stroke="#16a34a" stroke-width="2"/>
    <circle cx="33" cy="24" r="3" fill="#166534"/><circle cx="47" cy="24" r="3" fill="#166534"/>
    <path d="M34 35 Q40 39 46 35" stroke="#166534" stroke-width="2" fill="none" stroke-linecap="round"/>
    <ellipse cx="40" cy="55" rx="18" ry="14" fill="#86efac" stroke="#16a34a" stroke-width="2"/>
    <path d="M22 50 Q15 55 18 65" stroke="#16a34a" stroke-width="2" fill="none"/>
    <path d="M58 50 Q65 55 62 65" stroke="#16a34a" stroke-width="2" fill="none"/>
    <path d="M28 69 Q40 75 52 69" stroke="#16a34a" stroke-width="2" fill="none"/>
    <text x="40" y="14" text-anchor="middle" font-size="10" fill="#166534">四緑</text>
    <path d="M32 6 Q40 1 48 6 Q44 10 40 8 Q36 10 32 6Z" fill="#86efac" stroke="#16a34a" stroke-width="1"/>
  </svg>`,
  5: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
    <circle cx="40" cy="28" r="20" fill="#fffbeb" stroke="#d97706" stroke-width="2"/>
    <circle cx="33" cy="23" r="3.5" fill="#92400e"/><circle cx="47" cy="23" r="3.5" fill="#92400e"/>
    <path d="M32 34 Q40 38 48 34" stroke="#92400e" stroke-width="2.5" fill="none" stroke-linecap="round"/>
    <ellipse cx="40" cy="55" rx="18" ry="14" fill="#fbbf24" stroke="#d97706" stroke-width="2"/>
    <path d="M22 50 Q14 54 17 64" stroke="#d97706" stroke-width="2.5" fill="none"/>
    <path d="M58 50 Q66 54 63 64" stroke="#d97706" stroke-width="2.5" fill="none"/>
    <path d="M28 69 Q40 76 52 69" stroke="#d97706" stroke-width="2" fill="none"/>
    <text x="40" y="14" text-anchor="middle" font-size="10" fill="#92400e">五黄</text>
    <circle cx="40" cy="6" r="4" fill="#fbbf24" stroke="#d97706" stroke-width="1.5"/>
    <line x1="40" y1="2" x2="40" y2="0" stroke="#d97706" stroke-width="1.5"/>
  </svg>`,
  6: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
    <circle cx="40" cy="28" r="20" fill="#f1f5f9" stroke="#374151" stroke-width="2"/>
    <circle cx="33" cy="24" r="3" fill="#1f2937"/><circle cx="47" cy="24" r="3" fill="#1f2937"/>
    <path d="M34 34 Q40 39 46 34" stroke="#1f2937" stroke-width="2" fill="none" stroke-linecap="round"/>
    <ellipse cx="40" cy="55" rx="18" ry="14" fill="#9ca3af" stroke="#374151" stroke-width="2"/>
    <path d="M22 50 Q15 55 18 65" stroke="#374151" stroke-width="2" fill="none"/>
    <path d="M58 50 Q65 55 62 65" stroke="#374151" stroke-width="2" fill="none"/>
    <path d="M28 69 Q40 75 52 69" stroke="#374151" stroke-width="2" fill="none"/>
    <text x="40" y="14" text-anchor="middle" font-size="10" fill="#374151">六白</text>
    <polygon points="40,1 43,8 50,8 44,13 46,20 40,16 34,20 36,13 30,8 37,8" fill="#fbbf24" stroke="#d97706" stroke-width="1"/>
  </svg>`,
  7: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
    <circle cx="40" cy="28" r="20" fill="#fff1f2" stroke="#be123c" stroke-width="2"/>
    <circle cx="33" cy="24" r="3" fill="#9f1239"/><circle cx="47" cy="24" r="3" fill="#9f1239"/>
    <path d="M33 35 Q40 41 47 35" stroke="#9f1239" stroke-width="2" fill="none" stroke-linecap="round"/>
    <ellipse cx="40" cy="55" rx="18" ry="14" fill="#fb7185" stroke="#be123c" stroke-width="2"/>
    <path d="M22 50 Q15 55 18 65" stroke="#be123c" stroke-width="2" fill="none"/>
    <path d="M58 50 Q65 55 62 65" stroke="#be123c" stroke-width="2" fill="none"/>
    <path d="M28 69 Q40 75 52 69" stroke="#be123c" stroke-width="2" fill="none"/>
    <text x="40" y="14" text-anchor="middle" font-size="10" fill="#9f1239">七赤</text>
    <circle cx="33" cy="7" r="3" fill="#fda4af"/><circle cx="47" cy="7" r="3" fill="#fda4af"/>
    <path d="M33 4 Q33 1 30 2" stroke="#be123c" stroke-width="1.5" fill="none"/>
    <path d="M47 4 Q47 1 50 2" stroke="#be123c" stroke-width="1.5" fill="none"/>
  </svg>`,
  8: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
    <circle cx="40" cy="28" r="20" fill="#fafaf9" stroke="#44403c" stroke-width="2"/>
    <circle cx="33" cy="24" r="3" fill="#292524"/><circle cx="47" cy="24" r="3" fill="#292524"/>
    <path d="M34 34 Q40 38 46 34" stroke="#292524" stroke-width="2" fill="none" stroke-linecap="round"/>
    <ellipse cx="40" cy="55" rx="18" ry="14" fill="#a8a29e" stroke="#44403c" stroke-width="2"/>
    <path d="M22 50 Q15 55 18 65" stroke="#44403c" stroke-width="2" fill="none"/>
    <path d="M58 50 Q65 55 62 65" stroke="#44403c" stroke-width="2" fill="none"/>
    <path d="M28 69 Q40 75 52 69" stroke="#44403c" stroke-width="2" fill="none"/>
    <text x="40" y="14" text-anchor="middle" font-size="10" fill="#44403c">八白</text>
    <path d="M28 8 L40 2 L52 8 L52 12 L40 7 L28 12Z" fill="#d6d3d1" stroke="#44403c" stroke-width="1"/>
  </svg>`,
  9: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
    <circle cx="40" cy="28" r="20" fill="#fff7ed" stroke="#c2410c" stroke-width="2"/>
    <circle cx="33" cy="23" r="3" fill="#9a3412"/><circle cx="47" cy="23" r="3" fill="#9a3412"/>
    <path d="M33 34 Q40 41 47 34" stroke="#9a3412" stroke-width="2" fill="none" stroke-linecap="round"/>
    <ellipse cx="40" cy="55" rx="18" ry="14" fill="#fb923c" stroke="#c2410c" stroke-width="2"/>
    <path d="M22 50 Q15 55 18 65" stroke="#c2410c" stroke-width="2" fill="none"/>
    <path d="M58 50 Q65 55 62 65" stroke="#c2410c" stroke-width="2" fill="none"/>
    <path d="M28 69 Q40 75 52 69" stroke="#c2410c" stroke-width="2" fill="none"/>
    <text x="40" y="14" text-anchor="middle" font-size="10" fill="#9a3412">九紫</text>
    <path d="M40 2 L44 8 L50 6 L46 12 L50 17 L44 15 L40 20 L36 15 L30 17 L34 12 L30 6 L36 8Z" fill="#fb923c" stroke="#c2410c" stroke-width="1"/>
  </svg>`,
};

// ═══ STORAGE ═══
const mem={};
async function sGet(k,d){try{if((window as any).storage){const r=await (window as any).storage.get(k);return r?.value!=null?JSON.parse(r.value):d;}}catch{}try{const v=localStorage.getItem(k);return v!=null?JSON.parse(v):d;}catch{}return k in mem?mem[k]:d;}
async function sSet(k,v){const s=JSON.stringify(v);mem[k]=v;try{if((window as any).storage){await (window as any).storage.set(k,s);return;}}catch{}try{localStorage.setItem(k,s);}catch{}}

// ═══ KI-GAKU DATA ═══

const GOGYOU_REL={
  "木木":"比和","木火":"相生（木→火）","木土":"相剋（木→土）","木金":"相剋（金→木）","木水":"相生（水→木）",
  "火木":"相生（木→火）","火火":"比和","火土":"相生（火→土）","火金":"相剋（火→金）","火水":"相剋（水→火）",
  "土木":"相剋（木→土）","土火":"相生（火→土）","土土":"比和","土金":"相生（土→金）","土水":"相剋（土→水）",
  "金木":"相剋（金→木）","金火":"相剋（火→金）","金土":"相生（土→金）","金金":"比和","金水":"相生（金→水）",
  "水木":"相生（水→木）","水火":"相剋（水→火）","水土":"相剋（土→水）","水金":"相生（金→水）","水水":"比和",
};
const GOGYOU_REL_DESC={
  "比和":"同じ気質を持つ。共鳴しやすく、長所も短所も増幅される。",
  "相生（木→火）":"本命星が月命星を育てる。表に出る自分が内面を活性化する。",
  "相生（火→土）":"本命星が月命星を育てる。行動が内面を安定させる。",
  "相生（土→金）":"本命星が月命星を育てる。地道さが内面の鋭さを磨く。",
  "相生（金→水）":"本命星が月命星を育てる。決断力が内面の知恵を深める。",
  "相生（水→木）":"本命星が月命星を育てる。感受性が内面の成長を促す。",
  "相剋（木→土）":"本命星と月命星が葛藤する。調和を求める外面と安定を求める内面が衝突しやすい。",
  "相剋（金→木）":"本命星と月命星が葛藤する。決断力と柔軟性の間で揺れやすい。",
  "相剋（水→火）":"本命星と月命星が葛藤する。感受性と情熱が相反することがある。",
  "相剋（火→金）":"本命星と月命星が葛藤する。情熱と合理性の間で迷いやすい。",
  "相剋（土→水）":"本命星と月命星が葛藤する。安定志向と変化への欲求が葛藤する。",
};
const GOGYOU_BODY={
  "木木":"肝臓・神経・筋肉に負荷がかかりやすい",
  "木火":"熱と活力が増すが、消耗も激しくなる",
  "木土":"消化器と神経系のバランスに注意",
  "木金":"皮膚・呼吸器・神経系に影響が出やすい",
  "木水":"腎臓・膀胱・神経系のケアが大切",
  "火木":"エネルギー過多になりやすく、心臓・頭部に注意",
  "火火":"心臓・血管・目への負荷が蓄積しやすい",
  "火土":"胃腸と心臓のバランスが乱れやすい",
  "火金":"肺・皮膚・循環器に影響が出やすい",
  "火水":"冷えと熱のバランスが崩れやすい",
  "土木":"消化器・筋肉・神経系に影響が出やすい",
  "土火":"胃腸と心臓への負担に注意",
  "土土":"胃腸・脾臓・筋肉が疲れやすい",
  "土金":"肺・皮膚・消化器のケアが大切",
  "土水":"腎臓・消化器のバランスに注意",
  "金木":"皮膚・呼吸器・神経系に影響が出やすい",
  "金火":"肺と心臓のバランスに注意",
  "金土":"肺・大腸・消化器のケアが大切",
  "金金":"肺・大腸・皮膚・鼻への負荷が蓄積しやすい",
  "金水":"腎臓・肺・皮膚のケアが大切",
  "水木":"腎臓・膀胱・神経系のケアが大切",
  "水火":"冷えと熱の葛藤が体に出やすい",
  "水土":"腎臓・消化器のバランスに注意",
  "水金":"腎臓・肺・皮膚に影響が出やすい",
  "水水":"腎臓・膀胱・耳・骨への負荷が蓄積しやすい",
};
const STAR_ELEM_NAME=["","水","土","木","木","土","金","金","土","火"];
const STAR_NATURE={
  1:["縁・知恵・流動が人生のテーマ","水のように形を変え、あらゆる場に適応する力がある","内省と感受性が豊かで、深い洞察をもたらす"],
  2:["忍耐・育成・協調が人生のテーマ","大地のように支え育てる包容力がある","地道な努力が最終的に大きな実を結ぶ"],
  3:["行動・突破・革新が人生のテーマ","雷のように素早く行動し、新しい道を切り開く","先駆者の精神が運気を開く"],
  4:["縁・信頼・調和・流通が人生のテーマ","風のように広がる人脈が力の源","コミュニケーションと信頼関係が人生を豊かにする"],
  5:["変革・統率・大局が人生のテーマ","中心として全体を動かす力を持つ","大きな力が集まる分、責任も大きい"],
  6:["権威・決断・天運が人生のテーマ","天のような大局観と指導力がある","誠実さと品格が天運を引き寄せる"],
  7:["喜び・表現・財が人生のテーマ","楽しさを感じないとエネルギーが出ない","口才と発信力が運気の鍵"],
  8:["転換・蓄積・不動が人生のテーマ","山のように動じない芯の強さがある","変化の時に最も輝く"],
  9:["直感・名誉・美が人生のテーマ","鋭い直感と美的感覚が武器","輝きと注目が運気を高める"],
};
const TSUKI_NATURE={
  1:["内面は深い感受性と知恵を求めている","孤独な思索の中に真実を見出す"],
  2:["内面は安定と安心を強く求めている","誰かの役に立つことで満たされる"],
  3:["内面は刺激と変化を強く求めている","動いていないと不安になりやすい"],
  4:["内面は縁と調和を求めている","人とのつながりの中でエネルギーが湧く"],
  5:["内面は力と主導権を求めている","自分がコントロールできないと焦りやすい"],
  6:["内面は誠実さと秩序を求めている","曖昧さや不誠実さに強いストレスを感じる"],
  7:["内面は喜び・表現・鋭さを求めている","楽しさを感じないとエネルギーが出ない"],
  8:["内面は安定した基盤と実績を求めている","着実な積み上げが内面の安心につながる"],
  9:["内面は美・認知・輝きを求めている","注目されることで内面が活性化する"],
};

const STAR_INFO={
  1:{name:"一白水星",elem:"水",k:"一白",c:"#1d4ed8",bg:"#eff6ff",br:"#93c5fd",g:"☵",
    traits:["知性","流動性","適応力","洞察力","コミュニケーション"],
    colors:["黒","紺","深青"],foods:["蕎麦","海産物","塩辛い物","昆布","豆腐"],
    desc:"水のように柔軟で深い洞察を持つ。変化を恐れず流れに乗ることで才能が開花。",
    work:"情報・コミュニケーション・流通業に縁がある。柔軟な思考と深い洞察で問題を解決する。",
    love:"感情を内に秘めがちだが、深く相手を理解する。じっくり関係を育てるタイプ。",
    health:"腎臓・泌尿器系・耳に注意。水分補給を心がけ、冷えを避けること。",
    money:"知識投資が高いリターンをもたらす。流動性の高い資産と相性が良い。"},
  2:{name:"二黒土星",elem:"土",k:"二黒",c:"#374151",bg:"#f9fafb",br:"#6b7280",g:"☷",
    traits:["勤勉","母性","包容力","忍耐","堅実"],
    colors:["黒","黄土色","茶"],foods:["根菜","里芋","米","豆腐","玄米"],
    desc:"大地のように揺るぎない安定感と包容力。地道な努力を積み重ねる力を持つ。",
    work:"農業・食品・不動産・介護・サービス業に縁がある。縁の下の力持ち。",
    love:"深い愛情と包容力で相手を支える。母性的な愛で家庭を温める。",
    health:"胃腸・消化器系に注意。規則正しい食事と睡眠が大切。",
    money:"地道な積み重ねで資産を形成。不動産投資に縁がある。"},
  3:{name:"三碧木星",elem:"木",k:"三碧",c:"#065f46",bg:"#ecfdf5",br:"#6ee7b7",g:"☳",
    traits:["行動力","成長","スタート力","創造性","情熱"],
    colors:["緑","青","水色"],foods:["葉物野菜","山菜","春菊","柑橘類","麺類"],
    desc:"雷のような爆発的なエネルギーと行動力。新しいことへの挑戦と成長を愛す。",
    work:"マスコミ・芸能・新興産業・スポーツ・音楽に縁がある。先駆者精神で道を切り開く。",
    love:"情熱的で積極的に愛情表現。新鮮さを大切にし、相手に活気をもたらす。",
    health:"肝臓・神経系・声帯に注意。過労を避け、適度な運動で気を巡らせること。",
    money:"大胆な投資判断が吉。スタートアップや新事業への投資に縁がある。"},
  4:{name:"四緑木星",elem:"木",k:"四緑",c:"#14532d",bg:"#f0fdf4",br:"#86efac",g:"☴",
    traits:["信頼","縁","調和","社交性","誠実"],
    colors:["緑","青緑","白"],foods:["葉野菜","豆類","ハーブ","穀物","青魚"],
    desc:"風のように縁と信頼を広げる。人と人を結びつける調和の才能を持つ。",
    work:"貿易・外交・観光・旅行業・コンサルタントに縁がある。人と人を繋ぐ才能を発揮。",
    love:"誠実で信頼関係を大切にする。長い縁を育む、穏やかで安定した愛情表現。",
    health:"呼吸器・腸に注意。深呼吸と腸活が健康の鍵。",
    money:"人脈を通じた収入が高まる。長期的な投資や信頼関係からの収益に縁がある。"},
  5:{name:"五黄土星",elem:"土",k:"五黄",c:"#78350f",bg:"#fffbeb",br:"#fde047",g:"⊕",
    traits:["支配力","変革","カリスマ","強運","帝王"],
    colors:["黄","茶","黒"],foods:["根菜全般","穀物","山の食材","味噌","漬物"],
    desc:"最強のカリスマと帝王の気質。極めて強烈なエネルギーを持つ帝王の星。",
    work:"政治・経営・リーダーシップ・大企業に縁がある。変革者として業界を動かす。",
    love:"圧倒的な存在感で相手を引きつける。強い絆を築くが、独占欲に注意。",
    health:"全身の中心。ストレス管理が最重要。土台となる体力維持が鍵。",
    money:"大きな流れに乗ると莫大な収益。リスク管理を徹底することが大切。"},
  6:{name:"六白金星",elem:"金",k:"六白",c:"#374151",bg:"#f8fafc",br:"#cbd5e1",g:"☰",
    traits:["指導力","権威","完璧主義","統率","誇り"],
    colors:["白","銀","グレー"],foods:["辛い物","大根","山芋","白い食材","鶏肉"],
    desc:"天のエネルギーを体現するリーダー。完璧主義と高い理想を持ち組織を統率する。",
    work:"法律・金融・政治・精密機器に縁がある。組織のリーダーとして力を発揮。",
    love:"完璧主義で理想が高い。真剣な交際を求め、一度決めたら誠実に尽くす。",
    health:"頭部・肺・大腸に注意。完璧主義からくるストレスに要注意。",
    money:"計画的な財務管理が得意。株式・金融商品との相性が良い。"},
  7:{name:"七赤金星",elem:"金",k:"七赤",c:"#7f1d1d",bg:"#fff1f2",br:"#fca5a5",g:"☱",
    traits:["喜び","表現力","金運","社交性","楽観"],
    colors:["白","赤","ピンク"],foods:["甘い物","果物","デザート","鶏肉","卵料理"],
    desc:"喜びと輝きをもたらす金運の星。表現力と社交性に長け、人を楽しませる才能。",
    work:"芸能・飲食・接客・美容・金融に縁がある。場を明るくする天性の才能。",
    love:"明るく楽しい恋愛を好む。社交的で多くの縁に恵まれる。",
    health:"口腔・肺・呼吸器に注意。楽しみながら健康を維持することが大切。",
    money:"金運が強く、予期しない収入に恵まれやすい。飲食・エンタメへの投資が吉。"},
  8:{name:"八白土星",elem:"土",k:"八白",c:"#44403c",bg:"#fafaf9",br:"#d6d3d1",g:"☶",
    traits:["転換","蓄積","安定","変化力","不動"],
    colors:["白","黄","ベージュ"],foods:["根菜","山の食材","豆類","穀物","芋類"],
    desc:"山の如く動じない安定感と、その内に秘めた転換力。着実に力を蓄える。",
    work:"建設・不動産・金融・教育・投資に縁がある。変化の時期に真価を発揮。",
    love:"ゆっくりと深い関係を築く。一度決めたら変わらぬ愛情を注ぐ不動の心。",
    health:"関節・脊椎・皮膚に注意。基礎体力の蓄積と規則正しい生活が鍵。",
    money:"長期的な資産形成が得意。不動産・債券・堅実な積立投資に縁がある。"},
  9:{name:"九紫火星",elem:"火",k:"九紫",c:"#4c1d95",bg:"#faf5ff",br:"#c4b5fd",g:"☲",
    traits:["才能","名誉","情熱","直感","美意識"],
    colors:["赤","紫","オレンジ"],foods:["苦い物","ナッツ","赤い野菜","卵","スパイス料理"],
    desc:"眩い輝きを放つ火の星。卓越した才能と鋭い直感、強烈な情熱と名誉への欲求。",
    work:"芸術・学術・美容・マスコミ・宗教に縁がある。輝く才能で名声を得る。",
    love:"情熱的で理想が高い。美しい愛を求め、相手を熱烈に愛するロマンチスト。",
    health:"心臓・目・血液循環に注意。精神的な興奮を鎮める時間が必要。",
    money:"才能や名声を通じた収入が大きい。芸術・エンタメへの投資に縁がある。"},
};

const PALACES=[
  {n:"巽",d:"東南",abbr:"SE"},{n:"離",d:"南",abbr:"S"},{n:"坤",d:"西南",abbr:"SW"},
  {n:"震",d:"東",abbr:"E"},{n:"中",d:"中央",abbr:"C"},{n:"兌",d:"西",abbr:"W"},
  {n:"艮",d:"東北",abbr:"NE"},{n:"坎",d:"北",abbr:"N"},{n:"乾",d:"西北",abbr:"NW"},
];
const OPP={0:8,1:7,2:6,3:5,5:3,6:2,7:1,8:0};
const BASE=[4,9,2,3,5,7,8,1,6];
const KI_NAMES=["寅","卯","辰","巳","午","未","申","酉","戌","亥","子","丑"];
const KI_NODE_NAMES=["立春","啓蟄","清明","立夏","芒種","小暑","立秋","白露","寒露","立冬","大雪","小寒"];
const KI_NODES=[[2,4],[3,6],[4,5],[5,6],[6,6],[7,7],[8,8],[9,8],[10,8],[11,7],[12,7],[1,6]];
const TENDO=[3,6,7,8,5,2,1,0,3,6,1,0];
const SETSU_TABLE={
  2024:[[2,4,17],[3,5,11],[4,4,16],[5,5,11],[6,5,17],[7,6,23],[8,7,9],[9,7,18],[10,8,3],[11,7,9],[12,7,6],[1,6,11]],
  2025:[[2,3,22],[3,5,18],[4,4,22],[5,5,17],[6,5,23],[7,7,5],[8,7,15],[9,7,23],[10,8,9],[11,7,15],[12,7,11],[1,5,17]],
  2026:[[2,4,4],[3,5,23],[4,5,4],[5,5,22],[6,6,4],[7,7,10],[8,7,20],[9,8,5],[10,8,15],[11,7,21],[12,7,17],[1,6,23]],
};
const S_ELEM={1:"水",2:"土",3:"木",4:"木",5:"土",6:"金",7:"金",8:"土",9:"火"};
const GEN={水:"木",木:"火",火:"土",土:"金",金:"水"};
const OVC={水:"火",木:"土",火:"金",土:"水",金:"木"};
const ELEM_STAR={水:1,木:4,火:9,土:8,金:6};
const COMPAT_REL={
  相生受:{lv:"最高",c:"#d97706",bg:"#fffbeb",i:"✨",msg:"相手があなたを最高に引き出してくれる理想的な関係。"},
  相生生:{lv:"吉",c:"#16a34a",bg:"#f0fdf4",i:"🌿",msg:"あなたが相手を育てる関係。与えることで自分も成長できる。"},
  比和:  {lv:"共鳴",c:"#2563eb",bg:"#eff6ff",i:"⚡",msg:"同じ気質の共鳴。理解し合いやすいが結果が拡大する。"},
  相剋受:{lv:"注意",c:"#d97706",bg:"#fffbeb",i:"⚠️",msg:"相手の気があなたに干渉。適切な距離感が大切。"},
  相剋攻:{lv:"注意",c:"#dc2626",bg:"#fef2f2",i:"🔥",msg:"あなたの気が相手に強く当たる。思いやりある接し方を。"},
};
const KEISHA_DESC={
  0:"巽宮傾斜 — 縁と流通の才能。人脈から道が開ける。遠方や異国との縁も人生を彩る。",
  1:"離宮傾斜 — 才能と輝きへの傾斜。芸術・文化・美的センスが際立ち、人前で輝く運命。",
  2:"坤宮傾斜 — 堅実と母性への傾斜。地道な努力と包容力で周囲の信頼を集め続ける。",
  3:"震宮傾斜 — 行動と挑戦への傾斜。動くことで運が開く。先陣を切る開拓者の気質。",
  4:"中宮傾斜 — 帝王・変化への傾斜。波乱万丈だが大きな力を秘める。変化が成長をもたらす。",
  5:"兌宮傾斜 — 喜びと表現への傾斜。楽しむことで才能が開花。金運と縁に恵まれやすい。",
  6:"艮宮傾斜 — 転換と蓄積への傾斜。立ち止まり考える力が真価をもたらす。変化の先読みが得意。",
  7:"坎宮傾斜 — 内省と深慮への傾斜。静かな中に宿る深い知恵と洞察力で人生を切り開く。",
  8:"乾宮傾斜 — 指導と統率への傾斜。天性のリーダーシップ。組織を動かす本能的な力を持つ。",
};
const PAL_FORTUNE={
  0:{r:"中吉",i:"🌿",title:"縁と信頼の方位",t:"東南の巽宮。縁と信頼が広がる。人脈から吉報。遠方との縁も吉。"},
  1:{r:"吉",i:"☀️",title:"才能と輝きの方位",t:"南の離宮。才能が輝く。評価される場面が増える。積極的行動が吉。"},
  2:{r:"中吉",i:"🌱",title:"堅実と家庭の方位",t:"西南の坤宮。努力が評価される。家族・身近な縁を大切に。"},
  3:{r:"小吉",i:"⚡",title:"行動と挑戦の方位",t:"東の震宮。新しい挑戦への意欲が高まる。一歩踏み出すと道が開ける。"},
  4:{r:"変化",i:"⊕",title:"中宮・変化と転換",t:"大きな転換点に立つ時。慎重さと決断力の両方が問われる。"},
  5:{r:"吉",i:"💎",title:"喜びと表現の方位",t:"西の兌宮。喜びと縁の日。金運も連れてくる。人との対話を大切に。"},
  6:{r:"小吉",i:"🏔️",title:"転換と変化の方位",t:"東北の艮宮。物事の転換点。立ち止まることで新しい道が見える。"},
  7:{r:"養生",i:"🌊",title:"内省と蓄積の方位",t:"北の坎宮。力を蓄える時。無理をせず静かに過ごし次の運気を呼び込む。"},
  8:{r:"中吉",i:"🌌",title:"統率と指導の方位",t:"西北の乾宮。指導力が高まる。リーダーシップを発揮する場面が訪れる。"},
};

// 天気コード → 五行
const WX_ELEM={0:"火",1:"火",2:"土",3:"土",45:"水",48:"水",51:"水",53:"水",55:"水",61:"水",63:"水",65:"水",71:"水",73:"水",75:"水",80:"水",81:"水",82:"水",95:"木",96:"木",99:"木"};
const WX_DESC={0:"快晴 ☀️",1:"晴れ 🌤️",2:"曇り時々晴れ ⛅",3:"曇り ☁️",45:"霧 🌫️",48:"霧 🌫️",51:"小雨 🌦️",53:"雨 🌧️",55:"強雨 🌧️",61:"小雨 🌦️",63:"雨 🌧️",65:"大雨 ⛈️",71:"雪 🌨️",73:"雪 ❄️",75:"大雪 ❄️",80:"にわか雨 🌦️",81:"雨 🌧️",82:"激しい雨 ⛈️",95:"雷雨 ⛈️",96:"雷雨 ⛈️",99:"激しい雷雨 ⛈️"};
const WX_KI_MSG={
  火:"晴れの日は九紫火星の気が強まります。才能・アイデア・発信に最適な日。積極的な行動で輝きましょう。",
  木:"風・嵐の日は三碧・四緑の気が活発です。新しい挑戦や変化の波に乗るチャンスです。",
  水:"雨の日は一白水星の気が深まります。内省・学習・計画立案に最適な日。じっくり考えることで洞察が深まる。",
  土:"曇りの日は土星の気が安定します。地道な作業・整理整頓・家庭を大切にする日。着実に進めて。",
  金:"穏やかな日は金星の気が整います。整理・決断・美的なことに向く日。品質にこだわった行動が吉。",
};

// 物・キーワード五行マッピング（拡張）
const THING_MAPS=[
  // エンタメ・趣味
  {w:["映画","ドラマ","映像","シネマ","鑑賞","ストーリー","脚本","監督"],e:"火",i:"🎬",r:"映画や映像作品は九紫火星の輝きと直感のエネルギーに属します。あなたの直感が研ぎ澄まされている今、物語の奥深い意味を感じ取る力が高まっています。この作品との出会いがあなたの感性を豊かにし、新しい視点や発想をもたらすでしょう。感動した場面や気になったシーンには、今のあなたへのメッセージが隠されています。"},
  {w:["音楽","歌","ライブ","コンサート","演奏","バンド","楽器","ピアノ","ギター","歌手"],e:"火",i:"🎵",r:"音楽は九紫火星の表現と感性のエネルギーに深く共鳴します。音の振動はあなたの気のエネルギーを整え、感情の流れを調和させる力があります。今あなたに響く音楽は、魂が必要としているメッセージそのものです。積極的に音楽と関わることで運気が高まります。"},
  {w:["スポーツ","運動","筋トレ","ランニング","ジム","トレーニング","体を動かす","ウォーキング"],e:"木",i:"⚡",r:"スポーツや運動は三碧木星の行動力と突破力のエネルギーに属します。体を動かすことで木の気が活性化し、停滞していたエネルギーが一気に流れ出します。今取り組んでいる運動は運気の流れを大きく変える可能性を持っています。継続することで心身ともに強化されます。"},
  {w:["ゴルフ","テニス","野球","サッカー","水泳","スキー","ボルダリング","マラソン"],e:"木",i:"⛳",r:"このスポーツは木の気と相性が良く、競争と成長のエネルギーを高めます。今のあなたに必要な集中力と持久力を鍛える最適な活動です。仲間と切磋琢磨することで縁も広がります。"},
  {w:["釣り","魚釣り","フィッシング","海釣り"],e:"水",i:"🎣",r:"釣りは一白水星の水の気と深く繋がる活動です。水辺に身を置くことで心が浄化され、直感力が研ぎ澄まされます。静かに待つ釣りの時間は内省と気の充電に最適です。今日の釣りには思わぬ幸運が潜んでいます。"},
  {w:["ゲーム","テレビゲーム","オンラインゲーム","RPG","eスポーツ","アプリゲーム"],e:"水",i:"🎮",r:"ゲームは水の気の知的探求と戦略のエネルギーに属します。仮想空間での体験があなたの問題解決能力と直感力を鍛えています。ただし水の気は過剰になると現実逃避につながるため、適度なバランスが大切です。"},
  {w:["アウトドア","キャンプ","登山","ハイキング","自然","森","山"],e:"木",i:"🏕️",r:"アウトドア活動は木の気の成長と生命力のエネルギーに満ちています。大自然に触れることで都市生活で乱れた気のバランスが整います。山や森は木の気が最も濃く集まる場所。今のあなたの運気を大きく充電してくれます。"},
  {w:["料理","クッキング","食事","グルメ","レシピ","食べ物","食べる","外食"],e:"土",i:"🍳",r:"料理や食は二黒土星の育む力と大地の恵みのエネルギーに属します。手をかけて作る食事はあなたの土の気を強化し、心身の安定をもたらします。食を通じた縁や交流が運気を高める今、大切な人と食事を共にすることが最高の開運行動です。"},
  {w:["カメラ","写真","撮影","フォト","インスタ","SNS撮影"],e:"火",i:"📷",r:"カメラと写真は九紫火星の美と表現のエネルギーに属します。あなたの目を通して切り取られた世界は、感性と直感の産物です。今撮影したいと感じるものには、あなたの魂が惹きつけられているメッセージがあります。発信することでさらに縁が広がります。"},
  {w:["旅行","旅","出張","移動","引越","海外","異国","遠出","ドライブ","バックパック","世界"],e:"水",i:"✈️",r:"旅は一白水星の流動と縁のエネルギーを最大限に活用できます。新しい土地への移動は気の流れを一新し、停滞した運気を大きく動かします。特に吉方位への旅は運命を変えるほどの影響力を持ちます。今感じている旅への衝動を大切にしてください。"},
  // 仕事・ビジネス
  {w:["仕事","ビジネス","職場","会社","転職","就職","副業","起業"],e:"金",i:"💼",r:"仕事運は六白・七赤金星の決断と実行力のエネルギーと密接に関わります。今のあなたの本命星の位置が仕事運の流れを決定します。積極的な行動と誠実な姿勢が周囲からの信頼を集め、大きなチャンスを引き寄せます。重要な判断は吉日を選んで行いましょう。"},
  {w:["お金","金運","収入","投資","資産","貯蓄","節約","財布"],e:"金",i:"💰",r:"金運は七赤金星の喜びと豊かさのエネルギーに属します。金の気が高まる今、お金の流れに意識を向けることが大切です。衝動的な出費を避け、本当に価値あるものへの投資が吉です。西の方位や兌宮に縁のある行動が金運を高めます。"},
  {w:["勉強","学習","資格","試験","スキル","学校","受験","語学","英語"],e:"水",i:"📚",r:"学びは一白水星の知恵と探求のエネルギーに属します。今のあなたの知識への渇望は正しい方向性を示しています。坎宮（北）の静かな気の中での学習が最も効果的です。習得した知識は必ず将来の大きな資産となります。着実に積み重ねてください。"},
  {w:["恋愛","恋","出会い","婚活","結婚","デート","告白","好きな人"],e:"木",i:"💕",r:"恋愛運は木の気の縁と成長のエネルギーに深く関わります。今のあなたの本命星が位置する宮が恋愛の方向性を示しています。積極的なコミュニケーションと誠実な気持ちの表現が縁を引き寄せます。東南（巽宮）の方位が恋愛縁を高める吉方位です。"},
  {w:["健康","体調","病気","医療","ダイエット","美容","睡眠","疲れ"],e:"土",i:"🌿",r:"健康は五行すべてのバランスに関わります。あなたの本命星の五行元素が示す臓器に特に意識を向けてください。土の気を整える食事と規則正しい生活リズムが基盤です。今感じている体のサインを大切に、無理のないペースで整えていきましょう。"},
  {w:["人間関係","友人","家族","親","子供","職場の人","コミュニティ"],e:"土",i:"🤝",r:"人間関係は土の気の包容力と水の気の縁が複合的に働きます。今のあなたの周囲の人々との関係には重要な気の交流があります。与えることを意識した関わりが関係を深め、予想外の形で恩恵が返ってきます。"},
  // アート・創作
  {w:["アート","芸術","絵","絵画","デザイン","創作","クリエイティブ","彫刻"],e:"火",i:"🎨",r:"芸術と創作は九紫火星の輝きと美のエネルギーの真髄です。あなたの創造力が今最高潮に高まっています。内なるビジョンを形にする勇気が運気を大きく開きます。美しいものを作ることへの情熱を大切にしてください。"},
  {w:["PC","パソコン","コンピュータ","スマホ","IT","AI","テクノロジー","SNS","ネット","アプリ"],e:"水",i:"💻",r:"テクノロジーと情報は一白水星の流動と知の探求に属します。デジタルの流れを上手く活用することで、あなたの可能性が無限に広がります。情報の流れに乗ることが今の開運の鍵です。"},
  {w:["本","書籍","読書","図書","ノート","教科書","知識","情報","研究","論文"],e:"水",i:"📖",r:"読書と知識探求は水の気の深い洞察力を高めます。今のあなたが惹きつけられる本には、人生の転換点となるメッセージが宿っています。"},
  {w:["お酒","アルコール","ビール","ワイン","日本酒","飲み会","バー","乾杯"],e:"水",i:"🍶",r:"お酒と社交の場は水の気と金の気が交差します。人との縁が深まる宴席は吉ですが、度を超えると水の気が乱れます。楽しいコミュニケーションを大切にしながら適度に楽しんでください。"},
];
const EVENT_TYPES=["結婚式","新居・引越","旅行・遠出","開業・起業","転職・就活","資格試験","病院・手術","投資・金融","子育て・出産","会議・交渉","縁起物・購入","家族イベント","告白・プロポーズ","謝罪・和解","SNS発信","契約・サイン","運動・習慣始め","ダイエット開始","大きな買い物","新しいこと始め","仕事","お金","勉強","恋愛","健康","人間関係","音楽","映画","スポーツ","料理","旅行","ゴルフ","釣り","ゲーム","アート","読書"];
const EVENT_TYPES_PREMIUM=["🔮 今、何をすべきか？","🔮 この状況でどう動くべきか？","🔮 転機に何をすべきか？","🔮 停滞を打破するには？"];
const EVENT_ADVICE={"結婚式":["縁と喜びの宮にある日を選ぶと良縁に恵まれます","凶方位を避け、天道方位への移動を伴う日が吉"],"新居・引越":["年盤で本命星が吉方位にある時期を最優先","凶方位への引越しは大凶。年月盤で必ず確認"],"旅行・遠出":["天道方位への移動は幸運を呼び込む","五黄殺・暗剣殺方位への移動は避ける"],"開業・起業":["年盤で本命星が震・巽・離宮に位置する年が最吉","月盤で五黄殺・暗剣殺がない月を選ぶ"],"転職・就活":["年盤で本命星が乾（西北）または震（東）宮に位置する年が吉","行動日は日盤で本命星の位置を確認"],"資格試験":["北宮（坎）や東宮（震）に本命星が位置する日が吉","静かな環境で集中できる日を選ぶ"],"病院・手術":["本命星が中宮（変化）に入る日は避ける","坤宮（西南）・乾宮（西北）に位置する日が療養に向く"],"投資・金融":["兌宮（西）に本命星が入る月・年は金運が高まる","五黄殺・暗剣殺の年月は大きな金融行動を避ける"],"会議・交渉":["天道方位の日は交渉力が高まる","離宮（南）か乾宮（西北）に位置する日が説得力が増す"],"子育て・出産":["坤宮（西南）・坎宮（北）に本命星がある時期は子育ての縁が深まる","家族の絆を大切にする日を選ぶ"],"縁起物・購入":["兌宮（西）・離宮（南）に本命星がある日が金運・縁起が上がる","天道方位の日に購入すると吉"],"家族イベント":["坤宮（西南）に本命星がある時期は家族の絆が深まる","凶方位のない日を選んで家族で過ごすと吉"],"告白・プロポーズ":["木の気が高まる震宮（東）・巽宮（東南）に本命星がある日が縁の始まりに最吉","月盤で五黄殺・暗剣殺のない日を選び、真摯な気持ちを伝えて"],"謝罪・和解":["坤宮（西南）に本命星がある日は誠実さが相手に伝わりやすい","水の気が流れる坎宮（北）の日は感情が素直に通じ合う"],"SNS発信":["離宮（南）に本命星がある日は発信力・注目度が高まる","天道方位と一致する時期の発信は広い縁を引き寄せる"],"契約・サイン":["乾宮（西北）に本命星がある日は決断力と信頼感が増す","凶方位・五黄殺の日を避け、月盤で吉日を確認してから署名を"],"運動・習慣始め":["震宮（東）・坎宮（北）に本命星がある時期は行動力が高まり継続しやすい","春（木の季節）に始める習慣は根付きやすく長続きする"],"ダイエット開始":["坎宮（北）の水の気は身体のデトックスと浄化を助ける","五黄殺・暗剣殺のない日に始め、月の節入り直後が気の切り替えに最適"],"大きな買い物":["兌宮（西）に本命星がある日は金運と選択眼が高まる","天道方位の日に購入すると長く愛用できるご縁が結ばれる"],"新しいこと始め":["震宮（東）に本命星がある日は新規スタートのエネルギーが最大になる","春の節入り・月の節入り直後は気の流れが一新され新しい縁を呼び込む"]};

// 都市→方角インデックス（ユーザーの登録場所からの相対方角で上書き推奨）
const CITY_DIR={
  "北海道":7,"旭川":7,"札幌":7,"函館":7,"青森":7,"秋田":7,"岩手":7,"仙台":7,"山形":7,"福島":7,
  "東京":3,"横浜":3,"千葉":3,"埼玉":3,"神奈川":3,"茨城":3,"栃木":3,"群馬":3,
  "新潟":6,"富山":6,"金沢":6,"福井":6,"石川":6,
  "長野":3,"山梨":3,"静岡":1,"浜松":1,"名古屋":5,"愛知":5,"三重":2,"岐阜":6,
  "大阪":2,"神戸":2,"兵庫":2,"奈良":1,"和歌山":1,
  "鳥取":8,"島根":8,"岡山":5,"広島":5,"山口":5,
  "徳島":1,"香川":5,"愛媛":5,"高知":1,
  "福岡":2,"佐賀":2,"長崎":2,"熊本":2,"大分":2,"宮崎":1,"鹿児島":2,
  "那覇":1,"沖縄":1,"ハワイ":3,"アメリカ":3,"欧州":8,"ヨーロッパ":8,
  "中国":3,"韓国":3,"台湾":1,"タイ":1,"インド":0,"海外":3
};
const DIR_ELEM={SE:"木",S:"火",SW:"土",E:"木",W:"金",NE:"土",N:"水",NW:"金"};
const PLACE_CHARS={
  SE:"縁と流通の方位。人との繋がりが広がる場所。",
  S:"才能と名誉の方位。自己表現できる場所。",
  SW:"堅実と基盤の方位。安定感ある場所。",
  E:"行動と挑戦の方位。新鮮なエネルギーが満ちる場所。",
  W:"喜びと金運の方位。楽しみと収益が生まれる場所。",
  NE:"転換と変化の方位。新旧が入れ替わる場所。",
  N:"内省と蓄積の方位。静かな思索の場所。",
  NW:"指導と権威の方位。格式と組織力が漂う場所。",
};
const ABBR_IDX=["SE","S","SW","E","C","W","NE","N","NW"];

// ═══ CALC FUNCTIONS ═══
function getYearStar(y){const r=(9-((y-1901)%9))%9;return r||9;}

const J1_TEAMS=[
  {id:"kashima",    name:"鹿島アントラーズ",   shortName:"鹿島",    kiYear:1947, lat:36.0833, lng:140.6519, city:"茨城県鹿嶋市",    founded:"1947（住友金属工業蹴球団）",       manager:"鬼木達",                   managerBirth:"1974-04-20"},
  {id:"urawa",      name:"浦和レッズ",          shortName:"浦和",    kiYear:1950, lat:35.8942, lng:139.6237, city:"埼玉県さいたま市", founded:"1950（三菱重工業サッカー部）",    manager:"曺貴裁",                   managerBirth:"1969-01-16"},
  {id:"kashiwa",    name:"柏レイソル",          shortName:"柏",      kiYear:1940, lat:35.8668, lng:139.9717, city:"千葉県柏市",       founded:"1940（日立製作所本社サッカー部）", manager:"リカルド・ロドリゲス",     managerBirth:"1974-04-03"},
  {id:"fctokyo",    name:"FC東京",              shortName:"FC東京",  kiYear:1999, lat:35.6641, lng:139.5278, city:"東京都調布市",     founded:"1999（法人化・独立）",            manager:"松橋力蔵",                 managerBirth:"1968-08-22"},
  {id:"verdy",      name:"東京ヴェルディ",      shortName:"東京V",   kiYear:1969, lat:35.6641, lng:139.5278, city:"東京都調布市",     founded:"1969（読売クラブ）",              manager:"城福浩",                   managerBirth:"1961-03-21"},
  {id:"machida",    name:"FC町田ゼルビア",      shortName:"町田",    kiYear:2004, lat:35.5456, lng:139.4442, city:"東京都町田市",     founded:"2004（現クラブ体制）",            manager:"黒田剛",                   managerBirth:"1970-05-26"},
  {id:"kawasaki",   name:"川崎フロンターレ",    shortName:"川崎F",   kiYear:1996, lat:35.5741, lng:139.6513, city:"神奈川県川崎市",   founded:"1996（市民クラブ独立）",          manager:"長谷部茂利",               managerBirth:"1971-04-23"},
  {id:"yokohamafm", name:"横浜F・マリノス",     shortName:"横浜FM",  kiYear:1972, lat:35.5100, lng:139.6061, city:"神奈川県横浜市",   founded:"1972（日産自動車サッカー部）",    manager:"スティーブ・コリカ",       managerBirth:"1973-03-24"},
  {id:"shimizu",    name:"清水エスパルス",      shortName:"清水",    kiYear:1991, lat:34.9806, lng:138.4200, city:"静岡県静岡市",     founded:"1991（Jリーグ創設参加）",         manager:"吉田孝行",                 managerBirth:"1977-03-14"},
  {id:"nagoya",     name:"名古屋グランパス",    shortName:"名古屋",  kiYear:1939, lat:35.0875, lng:137.1564, city:"愛知県豊田市",     founded:"1939（トヨタ自動車工業サッカー部）",manager:"ミハイロ・ペトロヴィッチ", managerBirth:"1957-10-18"},
  {id:"kyoto",      name:"京都サンガF.C.",      shortName:"京都",    kiYear:1993, lat:35.0114, lng:135.5800, city:"京都府亀岡市",     founded:"1993（京都パープルサンガ法人化）", manager:"ランコ・ポポヴィッチ",     managerBirth:"1967-06-26"},
  {id:"gamba",      name:"ガンバ大阪",          shortName:"G大阪",   kiYear:1980, lat:34.7978, lng:135.5372, city:"大阪府吹田市",     founded:"1980（松下電器産業サッカー部）",  manager:"明神智和",                 managerBirth:"1978-01-24"},
  {id:"cerezo",     name:"セレッソ大阪",        shortName:"C大阪",   kiYear:1957, lat:34.6136, lng:135.5200, city:"大阪府大阪市",     founded:"1957（ヤンマーディーゼルサッカー部）",manager:"パブロ・マチン",          managerBirth:"1975-04-07"},
  {id:"kobe",       name:"ヴィッセル神戸",      shortName:"神戸",    kiYear:1995, lat:34.6474, lng:135.1950, city:"兵庫県神戸市",     founded:"1995（ヴィッセル神戸法人化）",    manager:"ミヒャエル・スキッベ",     managerBirth:"1965-08-04"},
  {id:"okayama",    name:"ファジアーノ岡山",    shortName:"岡山",    kiYear:2004, lat:34.6600, lng:133.9400, city:"岡山県岡山市",     founded:"2004（現クラブ体制）",            manager:"木山隆之",                 managerBirth:"1972-02-18"},
  {id:"hiroshima",  name:"サンフレッチェ広島",  shortName:"広島",    kiYear:1938, lat:34.3938, lng:132.4870, city:"広島県広島市",     founded:"1938（東洋工業サッカー部）",      manager:"バルトシュ・ガウル",       managerBirth:"1987-10-05"},
  {id:"fukuoka",    name:"アビスパ福岡",        shortName:"福岡",    kiYear:1994, lat:33.6061, lng:130.4197, city:"福岡県福岡市",     founded:"1994（アビスパ福岡法人化）",      manager:"塚原真也",                 managerBirth:"1985-04-02"},
  {id:"mito",       name:"水戸ホーリーホック",  shortName:"水戸",    kiYear:1994, lat:36.4500, lng:140.4900, city:"茨城県那珂市",     founded:"1994（水戸ホーリーホック創設）",  manager:"樹森大介",                 managerBirth:"1977-07-28"},
  {id:"nagasaki",   name:"V・ファーレン長崎",   shortName:"長崎",    kiYear:2006, lat:32.7500, lng:129.8769, city:"長崎県長崎市",     founded:"2006（V・ファーレン長崎創設）",   manager:"高木琢也",                 managerBirth:"1967-11-12"},
  {id:"chiba",      name:"ジェフU市原・千葉",   shortName:"千葉",    kiYear:1946, lat:35.5947, lng:140.1133, city:"千葉県千葉市",     founded:"1946（古河電工サッカー部）",      manager:"小林慶行",                 managerBirth:"1978-01-27"},
];

const J2_TEAMS=[
  {id:"yokohamafc",  name:"横浜FC",               shortName:"横浜FC",  kiYear:1998, lat:35.4485, lng:139.5936, city:"神奈川県横浜市",        founded:"1998（横浜FC創設）",                 manager:"須藤大輔",                   managerBirth:"1977-04-25"},
  {id:"niigata",     name:"アルビレックス新潟",     shortName:"新潟",    kiYear:1965, lat:37.6220, lng:139.1183, city:"新潟県新潟市",          founded:"1965（新潟十一フットボールクラブ）",  manager:"船越優蔵",                   managerBirth:"1977-06-12"},
  {id:"iwaki",       name:"いわきFC",               shortName:"いわき",  kiYear:2016, lat:37.0500, lng:140.8880, city:"福島県いわき市",        founded:"2016（いわきFC創設）",               manager:"田村雄三",                   managerBirth:"1982-12-07"},
  {id:"imabari",     name:"FC今治",                shortName:"今治",    kiYear:2014, lat:34.0660, lng:132.9980, city:"愛媛県今治市",          founded:"2014（岡田武史代表就任・現体制）",   manager:"アベル・モウレロ・ロペス",   managerBirth:"1974-10-19"},
  {id:"toyama",      name:"カターレ富山",           shortName:"富山",    kiYear:2006, lat:36.7020, lng:137.2130, city:"富山県富山市",          founded:"2006（カターレ富山法人化）",          manager:"安達亮",                     managerBirth:"1969-07-02"},
  {id:"hachinohe",   name:"ヴァンラーレ八戸",       shortName:"八戸",    kiYear:2002, lat:40.5120, lng:141.4880, city:"青森県八戸市",          founded:"2002（八戸フットボールクラブ創設）", manager:"倉石圭二",                   managerBirth:"1982-06-26"},
  {id:"oita",        name:"大分トリニータ",          shortName:"大分",    kiYear:1994, lat:33.2380, lng:131.6060, city:"大分県大分市",          founded:"1994（大分FC創設）",                 manager:"四方田修平",                 managerBirth:"1973-03-14"},
  {id:"tochigicity", name:"栃木シティ",             shortName:"栃木C",   kiYear:2004, lat:36.5557, lng:139.8833, city:"栃木県宇都宮市",        founded:"2004（栃木ウーヴァFC前身創設）",     manager:"今矢直城",                   managerBirth:"1980-06-18"},
  {id:"kofu",        name:"ヴァンフォーレ甲府",     shortName:"甲府",    kiYear:1965, lat:35.6580, lng:138.5720, city:"山梨県甲府市",          founded:"1965（甲府クラブ創設）",             manager:"渋谷洋樹",                   managerBirth:"1966-11-30"},
  {id:"rbomiya",     name:"RB大宮アルディージャ",   shortName:"大宮",    kiYear:1969, lat:35.9068, lng:139.6261, city:"埼玉県さいたま市大宮区", founded:"1969（NTT大宮サッカー部創設）",      manager:"ナルシス・ペラッチ・ナダル", managerBirth:"1988-09-05"},
  {id:"tokushima",   name:"徳島ヴォルティス",       shortName:"徳島",    kiYear:1955, lat:34.0660, lng:134.5590, city:"徳島県徳島市",          founded:"1955（徳島市蹴球団）",               manager:"吉本岳史",                   managerBirth:"1978-05-13"},
  {id:"akita",       name:"ブラウブリッツ秋田",     shortName:"秋田",    kiYear:1965, lat:39.7200, lng:140.1020, city:"秋田県秋田市",          founded:"1965（TDK SC秋田前身）",            manager:"吉田謙",                     managerBirth:"1970-03-01"},
  {id:"fujieda",     name:"藤枝MYFC",              shortName:"藤枝",    kiYear:2009, lat:34.8680, lng:138.2580, city:"静岡県藤枝市",          founded:"2009（藤枝MYFC法人化）",            manager:"槙野智章",                   managerBirth:"1987-05-11"},
  {id:"shonan",      name:"湘南ベルマーレ",         shortName:"湘南",    kiYear:1994, lat:35.3290, lng:139.3440, city:"神奈川県平塚市",        founded:"1994（ベルマーレ平塚として独立）",   manager:"長澤徹",                     managerBirth:"1968-05-28"},
  {id:"sapporo",     name:"北海道コンサドーレ札幌",  shortName:"札幌",    kiYear:1935, lat:43.0142, lng:141.3558, city:"北海道札幌市",          founded:"1935（東芝堀川町サッカー部）",       manager:"川井健太",                   managerBirth:"1981-06-07"},
  {id:"sendai",      name:"ベガルタ仙台",           shortName:"仙台",    kiYear:1988, lat:38.2682, lng:140.8694, city:"宮城県仙台市",          founded:"1988（ブランメル仙台）",             manager:"森山佳郎",                   managerBirth:"1967-11-09"},
  {id:"yamagata",    name:"モンテディオ山形",       shortName:"山形",    kiYear:1984, lat:38.2420, lng:140.3630, city:"山形県山形市",          founded:"1984（NEC山形SC）",                 manager:"横内昭展",                   managerBirth:"1967-11-30"},
  {id:"jubilo",      name:"ジュビロ磐田",           shortName:"磐田",    kiYear:1972, lat:34.7160, lng:137.8510, city:"静岡県磐田市",          founded:"1972（ヤマハ発動機サッカー部）",     manager:"秋葉忠宏",                   managerBirth:"1975-10-13"},
  {id:"tosu",        name:"サガン鳥栖",             shortName:"鳥栖",    kiYear:1997, lat:33.3640, lng:130.5060, city:"佐賀県鳥栖市",          founded:"1997（サガン鳥栖創設）",             manager:"小菊昭雄",                   managerBirth:"1975-07-07"},
  {id:"miyazaki",    name:"テゲバジャーロ宮崎",     shortName:"宮崎",    kiYear:2010, lat:31.9110, lng:131.4230, city:"宮崎県宮崎市",          founded:"2010（テゲバジャーロ宮崎創設）",     manager:"大熊裕司",                   managerBirth:"1969-01-19"},
];

function getTeamKiStar(teamId){
  const t=[...J1_TEAMS,...J2_TEAMS].find(x=>x.id===teamId);
  return t?getYearStar(t.kiYear):null;
}

function getTeamStarName(teamId){
  const s=getTeamKiStar(teamId);
  return s?STAR_INFO[s]?.k||"不明":"不明";
}

function getJ2TeamKiStar(teamId){
  const t=J2_TEAMS.find(x=>x.id===teamId);
  return t?getYearStar(t.kiYear):null;
}

function getJ2TeamStarName(teamId){
  const s=getJ2TeamKiStar(teamId);
  return s?STAR_INFO[s]?.k||"不明":"不明";
}
function getFirstMonthStar(ys){return[1,4,7].includes(ys)?8:[2,5,8].includes(ys)?2:5;}
function getMonthStar(ys,km){return((getFirstMonthStar(ys)-km-1+900)%9)+1;}
function getStarsFor(c){return BASE.map(b=>((b+c-5-1+900)%9)+1);}
function getKiMonthIdx(m,d){if(m===1&&d<6)return 10;if(m===1)return 11;if(m===2&&d<4)return 11;for(let i=KI_NODES.length-2;i>=0;i--){const[mm,dd]=KI_NODES[i];if(m>mm||(m===mm&&d>=dd))return i;}return 0;}
function getHonmei(by,bm,bd=15){let y=by;if(bm===1||(bm===2&&bd<4))y--;return getYearStar(y);}
function getDayStar(dt){const ref=new Date(2000,0,1);const d=Math.floor((dt-ref)/86400000);const m=dt.getMonth()+1,dy=dt.getDate();const isYin=(m===6&&dy>=19)||(m>=7&&m<=11)||(m===12&&dy<=15);if(isYin)return((9-d%9)%9)+1;return((d-1)%9+9)%9+1;}
const BASE_POS=[6,1,8,7,5,3,2,9,4]; // 定位盤(NW,N,NE,W,C,E,SW,S,SE順 = 六白,一白,八白,七赤,五黄,三碧,二黒,九紫,四緑)
function getElemRel(a,b){if(!a||!b)return"比和";if(a===b)return"比和";if(GEN[b]===a)return"相生受";if(GEN[a]===b)return"相生生";if(OVC[b]===a)return"相剋受";return"相剋攻";}
function getStarRel(s1,s2){return getElemRel(S_ELEM[s1],S_ELEM[s2]);}
function adaptText(text,period){
  if(!text)return text;
  if(period==='month'){return text.replace(/日盤/g,'月盤').replace(/今日は/g,'今月は').replace(/今日の/g,'今月の').replace(/今日/g,'今月').replace(/特別な日/g,'特別な月').replace(/この日/g,'この月').replace(/吉の日/g,'吉の月').replace(/最高の日/g,'最高の月').replace(/朝一番/g,'月の初め').replace(/午前中/g,'月の前半').replace(/午後から/g,'月の後半から').replace(/午後/g,'月の後半').replace(/最高の好機/g,'大きなチャンス').replace(/特に吉で/g,'特に吉です');}
  if(period==='year'){return text.replace(/日盤/g,'年盤').replace(/今日は/g,'今年は').replace(/今日の/g,'今年の').replace(/今日/g,'今年').replace(/特別な日/g,'特別な年').replace(/この日/g,'この年').replace(/吉の日/g,'吉の年').replace(/最高の日/g,'最高の年').replace(/朝一番/g,'年の初め').replace(/午前中/g,'年の前半').replace(/午後から/g,'年の後半から').replace(/午後/g,'年の後半').replace(/最高の好機/g,'飛躍のチャンス').replace(/特に吉で/g,'特に吉です');}
  return text;
}
function getSanbanInfo(hs,ts,today){
  const d=today||new Date();
  const yr=d.getFullYear(),mo=d.getMonth()+1,dy=d.getDate();
  const km=getKiMonthIdx(mo,dy);
  const kiY=(km===11||(mo===1&&dy<6))?yr-1:yr;
  const yrC=getYearStar(kiY),moC=getMonthStar(yrC,km),dayC=getDayStar(d);
  const yrS=getStarsFor(yrC),moS=getStarsFor(moC),dayS=getStarsFor(dayC);
  const DN=["東南","南","西南","東","中","西","東北","北","西北"];
  const SN=["","一白水星","二黒土星","三碧木星","四緑木星","五黄土星","六白金星","七赤金星","八白土星","九紫火星"];
  const RL={"相生受":"生気・最吉","比和":"比和・吉","相生生":"退気・吉","相剋攻":"殺気・注意","相剋受":"殺気・凶"};
  const pi=(s,stars)=>{const p=stars.indexOf(s);if(p<0)return"不明";const r=getStarRel(s,BASE_POS[p]);return DN[p]+"宮（"+(RL[r]||r)+"）";};
  let txt=`【三盤鑑定根拠】\n■年盤（${kiY}年・中宮:${SN[yrC]}）\n　本命星${SN[hs]}→${pi(hs,yrS)}`;
  if(ts)txt+=`\n　月命星${SN[ts]}→${pi(ts,yrS)}`;
  txt+=`\n■月盤（${yr}年${mo}月・中宮:${SN[moC]}）\n　本命星${SN[hs]}→${pi(hs,moS)}`;
  if(ts)txt+=`\n　月命星${SN[ts]}→${pi(ts,moS)}`;
  txt+=`\n■日盤（${yr}年${mo}月${dy}日・中宮:${SN[dayC]}）\n　本命星${SN[hs]}→${pi(hs,dayS)}`;
  if(ts)txt+=`\n　月命星${SN[ts]}→${pi(ts,dayS)}`;
  return txt;
}function safeOpp(i){return OPP[i]!==undefined?OPP[i]:null;}
function buildKyohoi(yrS,moS,hs,ts){
  const res=[];
  const add=(t,pi,lv)=>{if(pi!=null&&pi!==4)res.push({type:t,pi,lv});};
  const gy=yrS.indexOf(5);if(gy!==-1){add("五黄殺（年）",gy,"大凶");add("暗剣殺（年）",safeOpp(gy),"大凶");}
  const hy=yrS.indexOf(hs);if(hy!==-1&&hy!==4){add("本命殺（年）",hy,"凶");add("本命的殺（年）",safeOpp(hy),"凶");}
  const gm=moS.indexOf(5);if(gm!==-1){add("五黄殺（月）",gm,"大凶");add("暗剣殺（月）",safeOpp(gm),"大凶");}
  const tm=moS.indexOf(ts);if(tm!==-1&&tm!==4){add("月命殺（月）",tm,"凶");add("月命的殺（月）",safeOpp(tm),"凶");}
  return res;
}

// ===== 六爻占術トップレベルエンジン =====
// 卦象テーブル定数（hexagrams.ts順: 0=坤,1=艮,2=坎,3=巽,4=震,5=離,6=兌,7=乾）
const LIUYAO_TRIG_NAMES=['坤','艮','坎','巽','震','離','兌','乾'];
const LIUYAO_TRIG_DISP=['地','山','水','風','雷','火','沢','天'];
const LIUYAO_TRIG_5E=['土','土','水','木','木','火','金','金'];

/** 日辰地支インデックス (子=0,丑=1,...,亥=11); 基準2000-01-07=子(0) */
function getDayBranchIndex(date){
  const ref=new Date(2000,0,7);
  const days=Math.floor((date.getTime()-ref.getTime())/86400000);
  return((days%12)+12)%12;
}

/** 月建インデックス (子=0,丑=1,寅=2,...,亥=11) */
function getMonthBranchIndex(date){
  const ki=getKiMonthIdx(date.getMonth()+1,date.getDate()); // 0=寅...11=丑
  return(ki+2)%12;
}

/** 五行旺相休囚死 (monthKiIndex: 0=寅...11=丑 = KI_NAMES順) */
function getElementStrength(element,monthKiIndex){
  return((WU_XING_STRENGTH[monthKiIndex]||WU_XING_STRENGTH[0])[element])||'休';
}

function _lyIsYang(v){return v===7||v===9;}
function _lyTriIdx(a,b,c){return(a?4:0)+(b?2:0)+(c?1:0);}

/** lines配列(6爻)から卦データを構築 */
function buildHexFromLines(ls){
  if(!ls||ls.length<6)return null;
  const lo=_lyTriIdx(_lyIsYang(ls[0]),_lyIsYang(ls[1]),_lyIsYang(ls[2]));
  const up=_lyTriIdx(_lyIsYang(ls[3]),_lyIsYang(ls[4]),_lyIsYang(ls[5]));
  const hexNum=(HEX_TABLE[lo]&&HEX_TABLE[lo][up])||1;
  const movingLines=ls.map((l,i)=>(l===6||l===9)?i:-1).filter(i=>i>=0);
  const hasChg=movingLines.length>0;
  let clo=lo,cup=up,chgHexNum=null;
  if(hasChg){
    const cl=ls.map(l=>l===9?8:l===6?7:l);
    clo=_lyTriIdx(_lyIsYang(cl[0]),_lyIsYang(cl[1]),_lyIsYang(cl[2]));
    cup=_lyTriIdx(_lyIsYang(cl[3]),_lyIsYang(cl[4]),_lyIsYang(cl[5]));
    chgHexNum=(HEX_TABLE[clo]&&HEX_TABLE[clo][cup])||null;
  }
  const hexDef=HEXAGRAM_BY_NUMBER[hexNum]||null;
  const chgHexDef=chgHexNum?HEXAGRAM_BY_NUMBER[chgHexNum]||null:null;
  return{
    lines:ls,movingLines,
    primaryHex:hexNum,changedHex:chgHexNum,
    primaryHexagram:hexNum,changedHexagram:chgHexNum,
    hexData:hexDef,
    main:{up,lo,name:hexDef?.name||LIUYAO_TRIG_NAMES[up]+'×'+LIUYAO_TRIG_NAMES[lo],elem:LIUYAO_TRIG_DISP[up]+'/'+LIUYAO_TRIG_DISP[lo]},
    change:hasChg?{up:cup,lo:clo,name:chgHexDef?.name||LIUYAO_TRIG_NAMES[cup]+'×'+LIUYAO_TRIG_NAMES[clo],elem:LIUYAO_TRIG_DISP[cup]+'/'+LIUYAO_TRIG_DISP[clo]}:null,
  };
}

/** タイムスタンプシード疑似乱数でコイン法6爻を生成 */
function generateHexagram(timestamp){
  let seed=(timestamp||new Date()).getTime();
  function lcg(){seed=((seed*1664525+1013904223)>>>0);return seed/0x100000000;}
  const lines=[];
  for(let i=0;i<6;i++){
    const n=[lcg()>.5,lcg()>.5,lcg()>.5].filter(Boolean).length;
    lines.push(n===3?9:n===2?7:n===1?8:6);
  }
  return buildHexFromLines(lines);
}

// ② 正しい日辰地支五行（子=水,丑=土,寅=木,卯=木,辰=土,巳=火,午=火,未=土,申=金,酉=金,戌=土,亥=水）
const DAY_BRANCH_ELEM=['水','土','木','木','土','火','火','土','金','金','土','水'] as const;
const BRANCH_NAMES=['子','丑','寅','卯','辰','巳','午','未','申','酉','戌','亥'];
const LINE_NAMES=['初爻','二爻','三爻','四爻','五爻','上爻'];

/** 宮五行から六親ごとの五行を求める */
function getRokushinElems(palaceE:string){
  const keys=Object.keys(GEN);
  return{
    兄弟:palaceE,
    子孫:GEN[palaceE],
    妻財:OVC[palaceE],
    官鬼:keys.find(k=>OVC[k]===palaceE)||'土',
    父母:keys.find(k=>GEN[k]===palaceE)||'土',
  };
}

/** 開運鑑定用：六爻の卦象を「現状分析」に使える形で構造化 */
function buildFortuneRokkoInfo(lines:number[],fieldId:string,at:Date){
  const hex=buildHexFromLines(lines);
  if(!hex)return'';
  const def=hex.hexData;
  const chgDef=hex.changedHex?HEXAGRAM_BY_NUMBER[hex.changedHex]:null;
  const palaceE=(def?.palaceElement as string)||'土';
  const wl=def?.worldLine||3;
  const rl=def?.responseLine||(wl<=3?wl+3:wl-3);
  const worldE=wl<=3?LIUYAO_TRIG_5E[hex.main.lo]:LIUYAO_TRIG_5E[hex.main.up];
  const respE=rl<=3?LIUYAO_TRIG_5E[hex.main.lo]:LIUYAO_TRIG_5E[hex.main.up];
  const kmi=getKiMonthIdx(at.getMonth()+1,at.getDate());
  const monthBr=getMonthBranchIndex(at);
  const dayBr=getDayBranchIndex(at);
  const monthE=DAY_BRANCH_ELEM[monthBr];
  const dayE=DAY_BRANCH_ELEM[dayBr];
  const rs=getRokushinElems(palaceE);
  const YONGSHIN:{[k:string]:{name:string,elem:string,why:string}}={
    work:{name:'官鬼',elem:rs.官鬼,why:'仕事・地位・役職を司る'},
    money:{name:'妻財',elem:rs.妻財,why:'財・収入・手にするものを司る'},
    study:{name:'父母',elem:rs.父母,why:'学問・文書・資格を司る'},
    health:{name:'子孫',elem:rs.子孫,why:'病を退け心身を癒やす（併せて世爻の強弱を見る）'},
    human:{name:'応爻',elem:respE,why:'相手・周囲の人を表す'},
    love:{name:'応爻',elem:respE,why:'相手を表す（世爻＝本人との関係で縁を見る）'},
    parent:{name:'父母',elem:rs.父母,why:'親・目上の人を表す'},
    child:{name:'子孫',elem:rs.子孫,why:'子・目下の人を表す'},
    sibling:{name:'兄弟',elem:rs.兄弟,why:'兄弟姉妹・友人を表す'},
  };
  const ys=YONGSHIN[fieldId]||{name:'世爻',elem:worldE,why:'相談者自身の状態を表す'};
  const relTxt=(r:string)=>r==='相生受'?'生じられる（強まる）':r==='比和'?'比和（支えられる）':r==='相生生'?'洩らす（力を使う）':r==='相剋受'?'剋される（抑えられる）':'剋す（消耗する）';
  const moving=hex.movingLines as number[];
  const movingTxt=moving.length===0?'なし（静卦：状況は当面固定、自ら動くことで変わる）':moving.map(i=>LINE_NAMES[i]+(i+1===wl?'（世爻＝本人が発動）':i+1===rl?'（応爻＝相手・環境が発動）':'')).join('・');
  const wrRel=getElemRel(worldE,respE);
  return`【六爻占術の卦象データ】
本卦：${def?.name||hex.main.name}（${def?.reading||''}）${def?.palace||''}・宮五行${palaceE}・${def?.palaceType||''}
本卦の象：${def?.image||'—'}
変卦：${chgDef?`${chgDef.name}（${chgDef.reading}）／象：${chgDef.image}／宮五行${chgDef.palaceElement}`:'なし'}
動爻：${movingTxt}
世爻：${LINE_NAMES[wl-1]}（五行${worldE}）／応爻：${LINE_NAMES[rl-1]}（五行${respE}）／世から見た応：${relTxt(wrRel)}
月建：${BRANCH_NAMES[monthBr]}月（${monthE}）／日辰：${BRANCH_NAMES[dayBr]}日（${dayE}）
六親の五行：兄弟${rs.兄弟}・子孫${rs.子孫}・妻財${rs.妻財}・官鬼${rs.官鬼}・父母${rs.父母}
用神：${ys.name}（五行${ys.elem}）…${ys.why}
用神の旺衰：月令で「${getElementStrength(ys.elem,kmi)}」／日辰から${relTxt(getElemRel(ys.elem,dayE))}
世爻の旺衰：月令で「${getElementStrength(worldE,kmi)}」／日辰から${relTxt(getElemRel(worldE,dayE))}
${chgDef?`変卦の宮五行${chgDef.palaceElement}から用神は${relTxt(getElemRel(ys.elem,chgDef.palaceElement as string))}（事の行き着く先）`:''}`;
}

/** 時盤：相談時刻の中宮星・本命星の宮位と、当日の吉時（本命星を生じる/比和の刻） */
function buildHourBoardInfo(hs:number,at:Date){
  const SN=["","一白水星","二黒土星","三碧木星","四緑木星","五黄土星","六白金星","七赤金星","八白土星","九紫火星"];
  const DN=["東南","南","西南","東","中","西","東北","北","西北"];
  const dayStar=getDayStar(at);
  const br=Math.floor(((at.getHours()+1)%24)/2);
  const hStar=getHourStar(at.getHours(),dayStar);
  const hStars=getStarsFor(hStar);
  const p=hStars.indexOf(hs);
  const pos=p<0?'不明':p===4?'中宮':DN[p]+'宮';
  const range=(b:number)=>`${String((b*2+23)%24).padStart(2,'0')}〜${String((b*2+1)%24).padStart(2,'0')}時`;
  const good:string[]=[];
  for(let b=0;b<12;b++){
    const h=(b*2)%24; // 各刻の中心時刻
    const s=getHourStar(h,dayStar);
    const r=getStarRel(hs,s);
    if(r==='相生受'||r==='比和')good.push(`${BRANCH_NAMES[b]}の刻（${range(b)}・中宮${SN[s]}・${r==='相生受'?'生気':'比和'}）`);
  }
  return`【時盤（相談時刻）】
${at.getHours()}時${String(at.getMinutes()).padStart(2,'0')}分＝${BRANCH_NAMES[br]}の刻／時盤中宮：${SN[hStar]}／本命星${SN[hs]}は${pos}（中宮星との気：${getStarRel(hs,hStar)}）
本日の吉時（本命星を生じる・比和の刻）：${good.join('、')||'なし（行動は日中の落ち着いた時間帯に）'}`;
}

/** 月盤の流れ：相談日から期限までの各月の本命星の宮位と凶殺 */
function buildMonthFlowInfo(hs:number,ts:number,from:Date,to:Date){
  const SN=["","一白","二黒","三碧","四緑","五黄","六白","七赤","八白","九紫"];
  const DN=["東南","南","西南","東","中宮","西","東北","北","西北"];
  const RL:{[k:string]:string}={"相生受":"生気","比和":"比和","相生生":"退気","相剋攻":"殺気","相剋受":"死気"};
  const rows:string[]=[];
  const months=Math.min(12,Math.max(1,(to.getFullYear()-from.getFullYear())*12+(to.getMonth()-from.getMonth())+1));
  for(let i=0;i<months;i++){
    const dt=i===0?from:new Date(from.getFullYear(),from.getMonth()+i,15);
    const mo=dt.getMonth()+1,dy=dt.getDate();
    const kmi=getKiMonthIdx(mo,dy);
    const kiY=(kmi===11||(mo===1&&dy<6))?dt.getFullYear()-1:dt.getFullYear();
    const yrC2=getYearStar(kiY),moC2=getMonthStar(yrC2,kmi);
    const yrS=getStarsFor(yrC2),moS=getStarsFor(moC2);
    const p=moS.indexOf(hs);
    const rel=p<0||p===4?'—':(RL[getStarRel(hs,BASE_POS[p])]||'');
    const ky=buildKyohoi(yrS,moS,hs,ts).filter(k=>k.type==='暗剣殺（月）'||k.type==='五黄殺（月）');
    const hit=ky.filter(k=>k.pi===p).map(k=>k.type.replace('（月）',''));
    rows.push(`${dt.getFullYear()}年${mo}月：月盤中宮${SN[moC2]}／本命星は${p<0?'不明':DN[p]}（${rel}）${p===4?'※八方塞がり・内省の月':''}${hit.length?'／'+hit.join('・')+'を帯びる':''}`);
  }
  return`【月盤の流れ（相談日〜期限）】\n${rows.join('\n')}`;
}

/** 六爻×九星気学統合スコア算出 */
function calcBattleScore({hexagram,sideAElement,sideBElement,mgrAElement,mgrBElement,battleDate,occupationDate,kigakuRel,skillGapPt=0,teamAIsHome=true,hourRelA,hourRelB,bearingRelA,bearingRelB,yearRelA,yearRelB,monthRelA,monthRelB,dayRelA,dayRelB,kyoHoiA,kyoHoiB,kyoLabelA,kyoLabelB,tendoA,tendoB,venueRelA,venueRelB,teamStrA=50,teamStrB=50}:{hexagram:any,sideAElement:string,sideBElement:string,mgrAElement?:string,mgrBElement?:string,battleDate:any,occupationDate:any,kigakuRel:any,skillGapPt?:number,teamAIsHome?:boolean,hourRelA?:string,hourRelB?:string,bearingRelA?:string,bearingRelB?:string,yearRelA?:string,yearRelB?:string,monthRelA?:string,monthRelB?:string,dayRelA?:string,dayRelB?:string,kyoHoiA?:boolean,kyoHoiB?:boolean,kyoLabelA?:string,kyoLabelB?:string,tendoA?:boolean,tendoB?:boolean,venueRelA?:string,venueRelB?:string,teamStrA?:number,teamStrB?:number}){
  if(!hexagram)return{sideAScore:50,sideBScore:50,confidence:50,verdict:'均衡',worldLine:3,responseLine:6,worldElem:'土',responseElem:'土',wStrength:'休',rStrength:'休',worldLineStrength:'休',responseLineStrength:'休',reasoning:[],skillGapLabel:'',scoreBand:'',scoreBandDetail:''};
  const hexNum=hexagram.primaryHex||hexagram.primaryHexagram||1;
  const hexDef=HEXAGRAM_BY_NUMBER[hexNum];
  const wl=(hexDef&&hexDef.worldLine)||3;
  const rl=wl<=3?wl+3:wl-3;
  const lo=hexagram.main.lo,up=hexagram.main.up;
  const worldElem=wl<=3?LIUYAO_TRIG_5E[lo]:LIUYAO_TRIG_5E[up];
  const responseElem=rl<=3?LIUYAO_TRIG_5E[lo]:LIUYAO_TRIG_5E[up];
  const execDt=occupationDate||new Date();
  const kmi=getKiMonthIdx(execDt.getMonth()+1,execDt.getDate());
  const dayBranchE=DAY_BRANCH_ELEM[getDayBranchIndex(execDt)];
  const wStr=getElementStrength(worldElem,kmi);
  const rStr=getElementStrength(responseElem,kmi);
  const sMap={'旺':20,'相':10,'休':0,'囚':-10,'死':-15};

  // ── 六爻伝統則：ホームチーム＝世爻、アウェイチーム＝応爻 ──
  // teamAIsHome=true → A=世爻(ホーム) / teamAIsHome=false → B=世爻(ホーム)
  const aIsWorld=teamAIsHome;
  // 六爻効果をホーム(世爻)・アウェイ(応爻)それぞれの正しいチームに加算するヘルパー
  let sA=0, sB=0;
  const addHome=(v:number)=>{ if(aIsWorld)sA+=v; else sB+=v; };
  const addAway=(v:number)=>{ if(aIsWorld)sB+=v; else sA+=v; };
  // チームA/Bが対応する爻要素（Aがホームなら世爻、アウェイなら応爻）
  const aCompElem=aIsWorld?worldElem:responseElem;  // Aのクラブ元素と比較する爻五行
  const bCompElem=aIsWorld?responseElem:worldElem;  // Bのクラブ元素と比較する爻五行
  const homeLabel=aIsWorld?'A(ホーム)':'B(ホーム)';
  const awayLabel=aIsWorld?'B(アウェイ)':'A(アウェイ)';

  // ── v3.0 ベーススコア：実力差45%+六爻官鬼論30%+ホームアドバンテージ10% ──
  // 官鬼爻(用神)の月建旺相 → 勝負の決まりやすさ(decisiveness)
  const palaceE=(hexDef?.palaceElement as string)||'土';
  const kankiE=(Object.keys(OVC) as string[]).find(k=>OVC[k as keyof typeof OVC]===palaceE)||'土';
  const kankiStr=getElementStrength(kankiE,kmi);
  const kankiDecide=sMap[kankiStr]||0;
  const kankiDayBonus=GEN[dayBranchE]===kankiE?8:OVC[dayBranchE]===kankiE?-8:0;
  const decScore=kankiDecide+kankiDayBonus*0.5;
  // 官鬼強(decScore>0)→勝負が実力通りに出やすい / 官鬼弱→均衡に寄る
  const effScale=Math.max(15,30-decScore*0.35);
  const expLogistic=(x:number,s:number)=>1/(1+Math.exp(-x/s));
  const strDiff=teamStrA-teamStrB;
  const P_str=expLogistic(strDiff,effScale);
  const P_home=teamAIsHome?0.55:0.45;
  // 合成基礎確率(実力+六爻75% + ホーム10% + 九星残15%は後続補正)
  const P_base=0.85*P_str+0.10*P_home+0.05*0.5;
  addHome(P_base*80+10);
  addAway((1-P_base)*80+10);
  const reasoning:string[]=[];
  const decLabel=decScore>=10?'高（勝負が実力に出やすい）':decScore>=-10?'中（やや均衡に寄る）':'低（引き分け傾向）';
  reasoning.push(`官鬼爻（${kankiE}・${kankiStr}）勝負決定度：${decLabel}（scale=${effScale.toFixed(0)}）`);
  reasoning.push(`実力スコア A=${teamStrA} vs B=${teamStrB}（差${strDiff>=0?'+':''}${strDiff}）→ ベースP(A)=${Math.round(P_str*100)}%`);
  reasoning.push(`ホームアドバンテージ：${teamAIsHome?'A(ホーム)':'B(ホーム)'}+5%`);
  reasoning.push(`世爻（${homeLabel}）第${wl}爻 ${worldElem}：月建${wStr} / 応爻（${awayLabel}）第${rl}爻 ${responseElem}：月建${rStr}`);
  // 【修正②】世爻≒応爻の均衡相：ホームアドバンテージを六爻でも反映
  // 世爻(ホーム)と応爻(アウェイ)の月建旺相スコア差が10pt未満のとき、
  // ホームチームにの本拠地優位として+5ptを加算する（統計的ホーム勝率55%の六爻反映）
  const wScore=sMap[wStr]||0;
  const rScore=sMap[rStr]||0;
  if(Math.abs(wScore-rScore)<10){
    addHome(5);
    reasoning.push(`六爻均衡補正（世爻${wScore}pt≈応爻${rScore}pt）：${homeLabel}ホーム地の利+5pt`);
  }

  // 日辰（地支五行）× 世爻/応爻：方向を明確に区別
  // 日辰→世爻 生（日辰が世爻を生じる）= 吉+8
  // 世爻→日辰 生（世爻が日辰を生じる）= 泄気-4
  // 日辰→世爻 剋（日辰が世爻を剋す）= 凶-8
  // 世爻→日辰 剋（世爻が日辰を剋す）= 補正なし（active加点廃止）
  if(GEN[dayBranchE]===worldElem){addHome(8);reasoning.push(`日辰（${dayBranchE}）→世爻（${worldElem}）生：${homeLabel}+8`);}
  else if(GEN[worldElem]===dayBranchE){addHome(-4);reasoning.push(`世爻（${worldElem}）→日辰（${dayBranchE}）泄気：${homeLabel}-4`);}
  else if(OVC[dayBranchE]===worldElem){addHome(-8);reasoning.push(`日辰（${dayBranchE}）→世爻（${worldElem}）剋：${homeLabel}-8`);}
  else if(OVC[worldElem]===dayBranchE){reasoning.push(`世爻（${worldElem}）→日辰（${dayBranchE}）剋（補正なし）`);}
  if(GEN[dayBranchE]===responseElem){addAway(8);reasoning.push(`日辰（${dayBranchE}）→応爻（${responseElem}）生：${awayLabel}+8`);}
  else if(GEN[responseElem]===dayBranchE){addAway(-4);reasoning.push(`応爻（${responseElem}）→日辰（${dayBranchE}）泄気：${awayLabel}-4`);}
  else if(OVC[dayBranchE]===responseElem){addAway(-8);reasoning.push(`日辰（${dayBranchE}）→応爻（${responseElem}）剋：${awayLabel}-8`);}
  else if(OVC[responseElem]===dayBranchE){reasoning.push(`応爻（${responseElem}）→日辰（${dayBranchE}）剋（補正なし）`);}

  // 変爻処理：動爻は「活性化した爻が他爻に与える生剋」のみ評価
  // 【修正①】世爻・応爻が「動く」こと自体への固定加点を廃止。
  //   動爻の五行が世爻/応爻を生じる・剋する場合のみ加減点する（方向性は生剋で決まる）。
  //   世爻自体が動爻の場合：世爻が変化の主体となり変卦で評価される（重複加点しない）。
  for(const mi of(hexagram.movingLines||[])){
    const lineNum=mi+1;
    const lE=lineNum<=3?LIUYAO_TRIG_5E[lo]:LIUYAO_TRIG_5E[up];
    // 世爻・応爻が動く場合は変卦側で評価するため、ここでは生剋のみ判定
    if(lineNum!==wl){
      if(OVC[lE]===worldElem){addHome(-10);reasoning.push(`動爻第${lineNum}爻(${lE})→世爻(${worldElem})剋：${homeLabel}-10`);}
      else if(GEN[lE]===worldElem){addHome(8);reasoning.push(`動爻第${lineNum}爻(${lE})→世爻(${worldElem})生：${homeLabel}+8`);}
      else{reasoning.push(`動爻第${lineNum}爻(${lE})：世爻(${worldElem})への生剋なし`);}
    } else {
      reasoning.push(`動爻第${lineNum}爻（世爻 ${worldElem}）：世爻自身が動く→変卦で評価`);
    }
    if(lineNum!==rl){
      if(OVC[lE]===responseElem){addAway(-10);reasoning.push(`動爻第${lineNum}爻(${lE})→応爻(${responseElem})剋：${awayLabel}-10`);}
      else if(GEN[lE]===responseElem){addAway(8);reasoning.push(`動爻第${lineNum}爻(${lE})→応爻(${responseElem})生：${awayLabel}+8`);}
    } else {
      reasoning.push(`動爻第${lineNum}爻（応爻 ${responseElem}）：応爻自身が動く→変卦で評価`);
    }
  }

  // 変卦の世爻・応爻を旺相評価に追加（動爻数に応じた重み）
  // 【修正③】月建偏り緩和：絶対値(旺+20)ではなく「本卦との相対差」を加点する。
  //   本卦世爻の旺相より変卦世爻が強ければ+、弱ければ−として方向性だけを反映。
  //   最大加点を±10ptに抑えることで、月が偏っても大きく傾かないようにする。
  const mCount=(hexagram.movingLines||[]).length;
  if(mCount>0&&hexagram.changedHex){
    const chgDef=HEXAGRAM_BY_NUMBER[hexagram.changedHex];
    if(chgDef){
      const chgWl=(chgDef.worldLine)||3;
      const clo=hexagram.change?.lo??lo,cup=hexagram.change?.up??up;
      const chgWE=chgWl<=3?LIUYAO_TRIG_5E[clo]:LIUYAO_TRIG_5E[cup];
      const chgRE=(chgWl<=3?LIUYAO_TRIG_5E[cup]:LIUYAO_TRIG_5E[clo]);
      const chgWStr=getElementStrength(chgWE,kmi);
      const chgRStr=getElementStrength(chgRE,kmi);
      // 動爻数が多いほど変卦の重みが大きい（1-2爻:30% 3爻:50% 4-5爻:70% 6爻:100%）
      const chgW=mCount>=6?1.0:mCount>=4?0.7:mCount===3?0.5:0.3;
      // 相対差：変卦の旺相スコアと本卦の旺相スコアの差（最大±35→±10にスケール）
      const baseWScore=sMap[wStr]||0;
      const baseRScore=sMap[rStr]||0;
      const chgWRaw=(sMap[chgWStr]||0);
      const chgRRaw=(sMap[chgRStr]||0);
      const relDiffW=Math.max(-10,Math.min(10,(chgWRaw-baseWScore)*0.4));
      const relDiffR=Math.max(-10,Math.min(10,(chgRRaw-baseRScore)*0.4));
      const chgSHome=relDiffW*chgW;
      const chgSAway=relDiffR*chgW;
      if(Math.abs(chgSHome)>0.5||Math.abs(chgSAway)>0.5){
        addHome(chgSHome);addAway(chgSAway);
        reasoning.push(`変卦（重み${Math.round(chgW*100)}%）世爻${chgWE}:${chgWStr}→本卦比(${relDiffW>=0?'+':''}${relDiffW.toFixed(1)}pt→${chgSHome>=0?'+':''}${chgSHome.toFixed(1)}pt) 応爻${chgRE}:${chgRStr}→本卦比(${relDiffR>=0?'+':''}${relDiffR.toFixed(1)}pt→${chgSAway>=0?'+':''}${chgSAway.toFixed(1)}pt)`);
      } else {
        reasoning.push(`変卦（重み${Math.round(chgW*100)}%）世爻${chgWE}:${chgWStr} / 応爻${chgRE}:${chgRStr}（本卦との差小・補正なし）`);
      }
    }
  }

  // クラブ本命星（五行）× 担当爻（Aが世爻かどうかに基づく）
  if(sideAElement){
    if(sideAElement===aCompElem){sA+=8;reasoning.push(`Aクラブ${sideAElement}＝${aIsWorld?'世':'応'}爻：A親和+8`);}
    else if(GEN[aCompElem]===sideAElement){sA+=5;reasoning.push(`Aクラブ${sideAElement}→${aIsWorld?'世':'応'}爻相生+5`);}
    else if(OVC[aCompElem]===sideAElement){sA-=5;reasoning.push(`Aクラブ${sideAElement}→${aIsWorld?'世':'応'}爻相剋-5`);}
  }
  if(sideBElement){
    if(sideBElement===bCompElem){sB+=8;reasoning.push(`Bクラブ${sideBElement}＝${aIsWorld?'応':'世'}爻：B親和+8`);}
    else if(GEN[bCompElem]===sideBElement){sB+=5;reasoning.push(`Bクラブ${sideBElement}→${aIsWorld?'応':'世'}爻相生+5`);}
    else if(OVC[bCompElem]===sideBElement){sB-=5;reasoning.push(`Bクラブ${sideBElement}→${aIsWorld?'応':'世'}爻相剋-5`);}
  }

  // 監督本命星（五行）× 担当爻（クラブの半重み）
  if(mgrAElement){
    if(mgrAElement===aCompElem){sA+=4;reasoning.push(`A監督${mgrAElement}＝${aIsWorld?'世':'応'}爻：A親和+4`);}
    else if(GEN[aCompElem]===mgrAElement){sA+=3;reasoning.push(`A監督${mgrAElement}→${aIsWorld?'世':'応'}爻相生+3`);}
    else if(OVC[aCompElem]===mgrAElement){sA-=3;reasoning.push(`A監督${mgrAElement}→${aIsWorld?'世':'応'}爻相剋-3`);}
  }
  if(mgrBElement){
    if(mgrBElement===bCompElem){sB+=4;reasoning.push(`B監督${mgrBElement}＝${aIsWorld?'応':'世'}爻：B親和+4`);}
    else if(GEN[bCompElem]===mgrBElement){sB+=3;reasoning.push(`B監督${mgrBElement}→${aIsWorld?'応':'世'}爻相生+3`);}
    else if(OVC[bCompElem]===mgrBElement){sB-=3;reasoning.push(`B監督${mgrBElement}→${aIsWorld?'応':'世'}爻相剋-3`);}
  }
  // チーム間の九星相生剋補正（A本命 vs B本命の勝負五行関係）
  // 相生受(B→A生)=A栄養受 / 相生生(A→B生)=A泄気 / 相剋受(B→A剋)=A被剋 / 相剋攻(A→B剋)=A優勢
  // ── 覚醒/消耗分岐テーブル ──
  // 相剋受（被剋）時の五行タイプ別反応
  //   土・水 = 覚醒型：圧力に対して粘り強く、形を変えて適応（ペナルティ軽減）
  //   木     = 中立：どちらにも分岐しない
  //   火・金 = 消耗型：剋されると崩れやすい（ペナルティ増加）
  const KAKUSEI_ADJ:Record<string,number>={'木':0,'火':-3,'土':+4,'金':-2,'水':+5};
  const KAKUSEI_L:Record<string,string>={'木':'中立','火':'消耗型','土':'覚醒型','金':'消耗型','水':'覚醒型'};
  if(kigakuRel==='相生受'){sA+=10;reasoning.push('九星（B→A生）：A相生受+10');}
  else if(kigakuRel==='相生生'){sA-=3;reasoning.push('九星（A→B生）：A泄気-3');}
  else if(kigakuRel==='相剋受'){
    // Aが剋される → A五行の覚醒/消耗タイプで調整
    const k=KAKUSEI_ADJ[sideAElement]||0;
    const pt=-10+k;
    sA+=pt;
    reasoning.push(`九星（B→A剋）A相剋受[${KAKUSEI_L[sideAElement]||'中立'}]：${pt>=0?'+':''}${pt}pt`);
  }
  else if(kigakuRel==='相剋攻'){
    // Aが剋す → B五行の覚醒/消耗タイプで調整（Bが覚醒型なら優勢が減る）
    const bK=KAKUSEI_ADJ[sideBElement]||0;
    const pt=5-Math.round(bK*0.5);
    sA+=pt;
    reasoning.push(`九星（A→B剋）A相剋攻[B:${KAKUSEI_L[sideBElement]||'中立'}]：+${pt}pt`);
  }
  else if(kigakuRel==='比和'){reasoning.push('九星（比和）：同五行・補正なし');}
  // ④ 時盤補正（キックオフ時刻の九星とクラブ本命星の関係）
  const relAdj=(rel:string|undefined,plus:number,minus:number)=>rel==='相生受'?plus:rel==='相生生'?Math.round(plus*0.6):rel==='相剋受'?-minus:rel==='相剋攻'?-Math.round(minus*0.6):0;
  if(hourRelA&&hourRelA!=='不明'){const v=relAdj(hourRelA,4,4);if(v!==0){sA+=v;reasoning.push(`時盤 A${hourRelA}：${v>0?'+':''}${v}pt`);}}
  if(hourRelB&&hourRelB!=='不明'){const v=relAdj(hourRelB,4,4);if(v!==0){sB+=v;reasoning.push(`時盤 B${hourRelB}：${v>0?'+':''}${v}pt`);}}
  // ⑤ 移動方位補正（本拠地→会場の方位とクラブ本命星の関係）
  if(bearingRelA&&bearingRelA!=='不明'){const v=relAdj(bearingRelA,5,5);if(v!==0){sA+=v;reasoning.push(`方位 A${bearingRelA}：${v>0?'+':''}${v}pt`);}}
  if(bearingRelB&&bearingRelB!=='不明'){const v=relAdj(bearingRelB,5,5);if(v!==0){sB+=v;reasoning.push(`方位 B${bearingRelB}：${v>0?'+':''}${v}pt`);}}
  // ⑥ 年盤補正（試合年のエネルギーとクラブ本命星の関係）
  if(yearRelA&&yearRelA!=='不明'){const v=relAdj(yearRelA,3,3);if(v!==0){sA+=v;reasoning.push(`年盤 A${yearRelA}：${v>0?'+':''}${v}pt`);}}
  if(yearRelB&&yearRelB!=='不明'){const v=relAdj(yearRelB,3,3);if(v!==0){sB+=v;reasoning.push(`年盤 B${yearRelB}：${v>0?'+':''}${v}pt`);}}
  // ⑦ 月盤補正（試合月のエネルギーとクラブ本命星の関係）
  if(monthRelA&&monthRelA!=='不明'){const v=relAdj(monthRelA,2,2);if(v!==0){sA+=v;reasoning.push(`月盤 A${monthRelA}：${v>0?'+':''}${v}pt`);}}
  if(monthRelB&&monthRelB!=='不明'){const v=relAdj(monthRelB,2,2);if(v!==0){sB+=v;reasoning.push(`月盤 B${monthRelB}：${v>0?'+':''}${v}pt`);}}
  // ⑧ 日盤補正（試合日のエネルギーとクラブ本命星の関係）
  if(dayRelA&&dayRelA!=='不明'){const v=relAdj(dayRelA,2,2);if(v!==0){sA+=v;reasoning.push(`日盤 A${dayRelA}：${v>0?'+':''}${v}pt`);}}
  if(dayRelB&&dayRelB!=='不明'){const v=relAdj(dayRelB,2,2);if(v!==0){sB+=v;reasoning.push(`日盤 B${dayRelB}：${v>0?'+':''}${v}pt`);}}
  // ⑨ 三盤の重ね合わせ（年×月×日の一致強度）
  const isGoodR=(r?:string)=>r==='相生受'||r==='比和';
  const isBadR=(r?:string)=>r==='相剋受'||r==='相剋攻';
  // 年×月×日 全一致：最強の吉凶サイン
  if(yearRelA&&monthRelA&&dayRelA&&yearRelA!=='不明'&&monthRelA!=='不明'&&dayRelA!=='不明'){
    if(isGoodR(yearRelA)&&isGoodR(monthRelA)&&isGoodR(dayRelA)){sA+=6;reasoning.push('三盤全一致(年×月×日) A大吉：+6');}
    else if(isBadR(yearRelA)&&isBadR(monthRelA)&&isBadR(dayRelA)){sA-=6;reasoning.push('三盤全一致(年×月×日) A大凶：-6');}
  } else if(yearRelA&&monthRelA&&yearRelA!=='不明'&&monthRelA!=='不明'){
    if(isGoodR(yearRelA)&&isGoodR(monthRelA)){sA+=4;reasoning.push('三盤一致(年×月) A吉：+4');}
    else if(isBadR(yearRelA)&&isBadR(monthRelA)){sA-=4;reasoning.push('三盤一致(年×月) A凶：-4');}
  }
  if(yearRelB&&monthRelB&&dayRelB&&yearRelB!=='不明'&&monthRelB!=='不明'&&dayRelB!=='不明'){
    if(isGoodR(yearRelB)&&isGoodR(monthRelB)&&isGoodR(dayRelB)){sB+=6;reasoning.push('三盤全一致(年×月×日) B大吉：+6');}
    else if(isBadR(yearRelB)&&isBadR(monthRelB)&&isBadR(dayRelB)){sB-=6;reasoning.push('三盤全一致(年×月×日) B大凶：-6');}
  } else if(yearRelB&&monthRelB&&yearRelB!=='不明'&&monthRelB!=='不明'){
    if(isGoodR(yearRelB)&&isGoodR(monthRelB)){sB+=4;reasoning.push('三盤一致(年×月) B吉：+4');}
    else if(isBadR(yearRelB)&&isBadR(monthRelB)){sB-=4;reasoning.push('三盤一致(年×月) B凶：-4');}
  }
  // ⑥ 五黄殺・暗剣殺・歳破（移動方位が凶方位に当たる場合）
  // 凶方位ペナルティは統計的に精度を下げるため廃止（両チームともスコア変更なし・ログのみ記録）
  if(kyoHoiA){reasoning.push(`凶方位(${kyoLabelA||'五黄殺/暗剣殺/歳破'}) A：補正なし`);}
  if(kyoHoiB){reasoning.push(`凶方位(${kyoLabelB||'五黄殺/暗剣殺/歳破'}) B：補正なし`);}
  // ⑦ 天道方位（移動方位が天道方位と一致）
  if(tendoA){sA+=6;reasoning.push('天道方位 A：+6');}
  if(tendoB){sB+=6;reasoning.push('天道方位 B：+6');}
  // ⑧ 開催地の地の気（東京→開催地方位の五行 × クラブ本命星）
  // ホームチームは本拠地の気に慣れているため補正対象外。アウェイチームのみ適用。
  const aIsHome=teamAIsHome;
  if(venueRelA&&venueRelA!=='不明'&&!aIsHome){const v=relAdj(venueRelA,4,4);if(v!==0){sA+=v;reasoning.push(`開催地地気 A${venueRelA}（アウェイ）：${v>0?'+':''}${v}pt`);}}
  if(venueRelA&&venueRelA!=='不明'&&aIsHome){reasoning.push(`開催地地気 A（ホーム）：本拠地慣れにつき補正なし`);}
  if(venueRelB&&venueRelB!=='不明'&&aIsHome){const v=relAdj(venueRelB,4,4);if(v!==0){sB+=v;reasoning.push(`開催地地気 B${venueRelB}（アウェイ）：${v>0?'+':''}${v}pt`);}}
  if(venueRelB&&venueRelB!=='不明'&&!aIsHome){reasoning.push(`開催地地気 B（ホーム）：本拠地慣れにつき補正なし`);}
  // ⑩ 五行固有特性補正（試合機能分析 v2.0）
  // 各五行は攻撃性と防御性の固有バランスを持つ
  // 爻の旺相が「旺・相」= 攻撃期（積極的エネルギーを発揮）→ 攻撃特性値を採用
  // 爻の旺相が「休・囚・死」= 防御期（耐えるエネルギー）→ 防御特性値を採用
  // 五行攻守特性（最大±3pt）
  //   木：攻撃2・防御-1（突破・成長型。攻撃期に強いが守りは弱い）
  //   火：攻撃3・防御-2（最大爆発力。ただし守りに転じると弱い）
  //   土：攻撃-1・防御3（安定・持続型。守り最強。攻撃は不得意）
  //   金：攻撃2・防御1（決断・精密。攻守ともに堅実）
  //   水：攻撃-2・防御3（流動・適応。守りに徹すると粘れる）
  const GOGYOU_ATK:Record<string,number>={'木':2,'火':3,'土':-1,'金':2,'水':-2};
  const GOGYOU_DEF:Record<string,number>={'木':-1,'火':-2,'土':3,'金':1,'水':3};
  const aStr=aIsWorld?wStr:rStr;  // Aが担当する爻の月建旺相
  const bStr=aIsWorld?rStr:wStr;  // Bが担当する爻の月建旺相
  const aAtk=aStr==='旺'||aStr==='相';  // Aが攻撃期か防御期か
  const bAtk=bStr==='旺'||bStr==='相';
  if(sideAElement){
    const pt=aAtk?(GOGYOU_ATK[sideAElement]||0):(GOGYOU_DEF[sideAElement]||0);
    if(pt!==0){sA+=pt;reasoning.push(`五行特性 A${sideAElement}[${aAtk?'攻撃期':'防御期'}]：${pt>=0?'+':''}${pt}pt`);}
  }
  if(sideBElement){
    const pt=bAtk?(GOGYOU_ATK[sideBElement]||0):(GOGYOU_DEF[sideBElement]||0);
    if(pt!==0){sB+=pt;reasoning.push(`五行特性 B${sideBElement}[${bAtk?'攻撃期':'防御期'}]：${pt>=0?'+':''}${pt}pt`);}
  }
  // ③ 実力差補正：1pt単位の手動設定（正=A有利、負=B有利）
  if(skillGapPt!==0){
    // teamAIsHome=true → 正値はA(ホーム)有利、負値はB(アウェイ)有利
    const ptA=teamAIsHome?skillGapPt:-skillGapPt;
    sA+=ptA;sB-=ptA;
    const side=skillGapPt>0?(teamAIsHome?'ホーム':'アウェイ'):(teamAIsHome?'アウェイ':'ホーム');
    reasoning.push(`実力補正：${side}${Math.abs(skillGapPt)}pt（A${ptA>=0?'+':''}${ptA}pt / B${-ptA>=0?'+':''}${-ptA}pt）`);
  }
  const skillGapLabel=skillGapPt===0?'互角・拮抗（実力補正なし）':`実力差補正：${skillGapPt>0?'A(ホーム)':'B(アウェイ)'}有利 ${Math.abs(skillGapPt)}pt`;
  const confFactor=Math.max(0.75,1-Math.abs(skillGapPt)/40);

  // 【修正3】九星補正の過剰積み上げ防止：ベース以降の九星補正合計を±15ptにキャップ
  // ベーススコア(addHome/addAway)はP_baseから計算済み。その後の九星系補正分だけキャップする。
  // ベーススコア部分を先に取り出し、九星補正分(sA_base, sB_base以降)を±15clamp
  // 実装: sA/sBをclampする前にベースを分離するのは複雑なため、
  //       最終スコアのベース(P_base*80+10相当)からの乖離を±15ptに制限する
  const baseScoreA=P_base*80+10;
  const baseScoreB=(1-P_base)*80+10;
  const kigakuDeltaA=sA-baseScoreA;
  const kigakuDeltaB=sB-baseScoreB;
  const CAP=15;
  const clampedDeltaA=Math.max(-CAP,Math.min(CAP,kigakuDeltaA));
  const clampedDeltaB=Math.max(-CAP,Math.min(CAP,kigakuDeltaB));
  if(Math.abs(kigakuDeltaA)>CAP||Math.abs(kigakuDeltaB)>CAP){
    reasoning.push(`九星補正キャップ適用：A補正 ${kigakuDeltaA.toFixed(1)}→${clampedDeltaA}pt / B補正 ${kigakuDeltaB.toFixed(1)}→${clampedDeltaB}pt（上限±${CAP}pt）`);
  }
  sA=baseScoreA+clampedDeltaA;
  sB=baseScoreB+clampedDeltaB;

  sA=Math.max(10,Math.min(90,sA));sB=Math.max(10,Math.min(90,sB));
  const total=sA+sB;
  const pA=Math.round((sA/total)*100),pB=100-pA;
  let conf=Math.min(95,Math.max(40,Math.abs(pA-50)*2+50));
  conf=Math.min(95,Math.round(conf*confFactor));

  // 【修正4】引き分けゾーン検出：pA=47〜53%は「引き分け候補」として判定
  const drawZone=pA>=45&&pA<=55;
  const verdict=drawZone?'引き分け候補（接戦・均衡）':pA>=65?'A側が有利':pA>=55?'A側がやや有利':pB>=65?'B側が有利':pB>=55?'B側がやや有利':'ほぼ均衡';
  if(drawZone){reasoning.push(`引き分け候補：A=${pA}% / B=${pB}% → 均衡ゾーン（47〜53%）。スコアレスドロー・延長戦の可能性あり`);}

  // 【予想スコア帯 v2】改善①〜⑤を反映
  const mCount2=(hexagram.movingLines||[]).length;

  // 改善①：変卦の有無 → 試合が動く象 → +1.0
  const hasChangedHex=!!(hexagram.changedHex);
  const chgBonus=hasChangedHex?1.0:0;

  // 改善②：官鬼爻の五行別得点係数（細分化）
  const kankiGoalWeight:Record<string,number>={'火':1.5,'木':1.0,'金':0.7,'水':0.2,'土':0.0};
  const kankiGoalEff=kankiGoalWeight[kankiE]??0;

  // 改善⑤：応爻自身が動く爻がある場合 → 相手チームが主体的に動く → +0.8
  const responseMoving=(hexagram.movingLines||[]).some(mi=>mi+1===rl);
  const responseMovingBonus=responseMoving?0.8:0;

  // 総得点傾向（動爻数・変卦・官鬼五行・応爻動・官鬼強弱）
  const totalGoalFactor=mCount2*0.5+chgBonus+kankiGoalEff+responseMovingBonus+(decScore>5?0.5:decScore<-5?-0.5:0);

  // 改善③：九星キャップ飽和度 → 実際の気力差がキャップを超えるほど得点差大
  const capSaturationA=Math.max(0,Math.abs(kigakuDeltaA)-CAP)/CAP;
  const capSaturationB=Math.max(0,Math.abs(kigakuDeltaB)-CAP)/CAP;
  const saturationBonus=(capSaturationA+capSaturationB)*0.5;

  // 得点差傾向：pの差・実力差・旺相差・キャップ飽和度
  const pDiff=Math.abs(pA-50);
  const strAbsDiff=Math.abs(teamStrA-teamStrB);
  const roiStrength=Math.abs((sMap[wStr]||0)-(sMap[rStr]||0));
  // 改善④：pDiff係数を0.05→0.07に引き上げ（大差勝利の過小評価を補正）
  const scoreDiffFactor=pDiff*0.07+strAbsDiff*0.03+roiStrength*0.02+saturationBonus;

  // 改善①⑤の根拠をログ出力
  if(hasChangedHex)reasoning.push(`変卦あり：試合が動く象（得点傾向+1.0）`);
  if(responseMoving)reasoning.push(`応爻自身が動く：相手チーム主体的活動（得点傾向+0.8）`);
  if(saturationBonus>0)reasoning.push(`九星キャップ飽和：気力差がキャップ超（得点差傾向+${saturationBonus.toFixed(2)}）`);

  let scoreBand='';
  let scoreBandDetail='';
  if(drawZone){
    // 引き分け圏
    if(totalGoalFactor<=0.3){scoreBand='0-0';scoreBandDetail='スコアレスドロー濃厚（動爻なし・官鬼弱・守備的）';}
    else if(totalGoalFactor<=1.2){scoreBand='0-0 〜 1-1';scoreBandDetail='ロースコアの引き分け（膠着・均衡）';}
    else if(totalGoalFactor<=2.5){scoreBand='1-1 〜 2-2';scoreBandDetail='両チーム得点の引き分け（打ち合い均衡）';}
    else{scoreBand='2-2 〜 3-3';scoreBandDetail='ハイスコアの引き分け（多得点・一進一退）';}
  } else {
    // 勝敗あり：勝利チームと得点差を推定
    const winnerIsA=pA>pB;
    const winner=winnerIsA?(teamAIsHome?'ホーム':'アウェイ'):(teamAIsHome?'アウェイ':'ホーム');
    // 改善④：閾値を下げて大差・中差をより検出しやすくする
    if(scoreDiffFactor>=2.0){
      // 大差
      if(totalGoalFactor>=2.5){scoreBand=`4-0 〜 5-1`;scoreBandDetail=`${winner}の圧勝（大差・多得点）`;}
      else if(totalGoalFactor>=1.5){scoreBand=`3-0 〜 4-1`;scoreBandDetail=`${winner}の快勝（大差・双方得点あり）`;}
      else{scoreBand=`2-0 〜 3-0`;scoreBandDetail=`${winner}の完封勝ち（大差・少失点）`;}
    } else if(scoreDiffFactor>=1.0){
      // 中差
      if(totalGoalFactor>=2.5){scoreBand=`3-1 〜 4-2`;scoreBandDetail=`${winner}の順当勝ち（中差・多得点）`;}
      else if(totalGoalFactor>=1.5){scoreBand=`2-1 〜 3-1`;scoreBandDetail=`${winner}の順当勝ち（中差・双方得点）`;}
      else{scoreBand=`1-0 〜 2-0`;scoreBandDetail=`${winner}の堅実勝ち（中差・少得点）`;}
    } else {
      // 接戦
      if(totalGoalFactor>=1.5){scoreBand=`2-1`;scoreBandDetail=`${winner}のギリギリ勝ち（接戦・双方得点）`;}
      else{scoreBand=`1-0`;scoreBandDetail=`${winner}の最少差勝ち（接戦・ロースコア）`;}
    }
  }
  reasoning.push(`予想スコア帯：${scoreBand}（${scoreBandDetail}）`);

  return{sideAScore:pA,sideBScore:pB,worldLine:wl,responseLine:rl,worldElem,responseElem,wStrength:wStr,rStrength:rStr,worldLineStrength:wStr,responseLineStrength:rStr,confidence:Math.round(conf),verdict,reasoning,skillGapLabel,scoreBand,scoreBandDetail};
}

/** 本命星から数霊回数を返す */
function getKotodamaCount(honmeiStar){
  const counts={1:[1,6],2:[2,5,8],3:[3,8],4:[4,3,9],5:[5,2,8],6:[6,1,7],7:[7,6],8:[8,2,5],9:[9,3,4]};
  return counts[honmeiStar]||[1];
}

// ─── 六爻占術ユーティリティ（FortuneTab・BattleTab共用） ───

// ── 世界・日本主要都市座標テーブル ──
const CITY_COORDS:{[key:string]:[number,number]}={
  // 日本: Jリーグ・なでしこ全本拠地＋主要都市
  '札幌':[43.0642,141.3469],'北海道':[43.0642,141.3469],'函館':[41.7686,140.7290],
  '青森':[40.8246,140.7401],'盛岡':[39.7036,141.1527],'仙台':[38.2682,140.8694],
  '秋田':[39.7186,140.1024],'山形':[38.2404,140.3633],'福島':[37.7500,140.4678],
  '水戸':[36.3418,140.4469],'宇都宮':[36.5551,139.8828],'前橋':[36.3908,139.0601],
  '大宮':[35.9065,139.6239],'さいたま':[35.8617,139.6455],'千葉':[35.6073,140.1063],
  '東京':[35.6762,139.6503],'新宿':[35.6896,139.7006],'渋谷':[35.6580,139.7016],
  '横浜':[35.4437,139.6380],'川崎':[35.5308,139.7029],'相模原':[35.5533,139.3964],
  '新潟':[37.9161,139.0364],'富山':[36.6953,137.2113],'金沢':[36.5613,136.6562],
  '福井':[36.0652,136.2216],'甲府':[35.6640,138.5686],'長野':[36.6485,138.1955],
  '松本':[36.2380,137.9720],'岐阜':[35.3912,136.7223],'静岡':[34.9769,138.3831],
  '浜松':[34.7108,137.7261],'名古屋':[35.1815,136.9066],'豊田':[35.0838,137.1563],
  '津':[34.7302,136.5086],'大津':[35.0045,135.8686],'京都':[35.0211,135.7556],
  '大阪':[34.6937,135.5023],'神戸':[34.6913,135.1830],'奈良':[34.6851,135.8048],
  '和歌山':[34.2306,135.1708],'鳥取':[35.5011,134.2351],'松江':[35.4681,133.0486],
  '岡山':[34.6618,133.9350],'広島':[34.3853,132.4553],'山口':[34.1860,131.4706],
  '徳島':[34.0657,134.5593],'高松':[34.3401,134.0434],'松山':[33.8395,132.7657],
  '高知':[33.5597,133.5311],'福岡':[33.5904,130.4017],'北九州':[33.8834,130.8751],
  '佐賀':[33.2494,130.2990],'長崎':[32.7448,129.8736],'熊本':[32.8031,130.7079],
  '大分':[33.2382,131.6126],'宮崎':[31.9077,131.4202],'鹿児島':[31.5966,130.5571],
  '那覇':[26.2124,127.6809],'沖縄':[26.2124,127.6809],
  // Jリーグクラブ本拠地・よく使われる都市（都道府県+市名フォーマットも含む）
  '市原':[35.4976,140.1165],'市原市':[35.4976,140.1165],'千葉県市原市':[35.4976,140.1165],
  '吹田':[34.7735,135.5168],'吹田市':[34.7735,135.5168],'大阪府吹田市':[34.7735,135.5168],'ガンバ大阪':[34.7735,135.5168],
  '鹿島':[35.9650,140.6430],'鹿嶋':[35.9650,140.6430],'鹿嶋市':[35.9650,140.6430],'茨城県鹿嶋市':[35.9650,140.6430],'カシマ':[35.9650,140.6430],
  '埼玉':[35.8914,139.6563],'浦和':[35.8617,139.6455],
  '茨城県水戸市':[36.3418,140.4469],
  '埼玉県さいたま市':[35.8617,139.6455],'さいたま市':[35.8617,139.6455],
  '千葉県柏市':[35.8558,139.9488],
  '神奈川県川崎市':[35.5308,139.7029],
  '東京都町田市':[35.5487,139.4412],
  '愛知県豊田市':[35.0838,137.1563],
  '長崎県長崎市':[32.7448,129.8736],
  '京都府京都市':[35.0211,135.7556],
  '等々力':[35.5700,139.6500],'川崎フロンターレ':[35.5700,139.6500],
  'ニッパツ':[35.3989,139.6296],'横浜FC':[35.3989,139.6296],
  '日産スタジアム':[35.5100,139.6060],'横浜マリノス':[35.5100,139.6060],
  'パナスタ':[34.7735,135.5168],
  '豊田スタジアム':[35.0838,137.1563],'名古屋グランパス':[35.0838,137.1563],
  'セレッソ':[34.6101,135.5100],'長居':[34.6101,135.5100],
  'ヴィッセル':[34.6913,135.1830],'神戸メリケンパーク':[34.6800,135.1900],
  'サンフレッチェ':[34.3853,132.4553],'エディオン':[34.3853,132.4553],
  'アビスパ':[33.5904,130.4017],'ベスト電器':[33.6050,130.4200],
  'サガン鳥栖':[33.3803,130.5080],'鳥栖':[33.3803,130.5080],
  'ロアッソ熊本':[32.8031,130.7079],'えがお健康':[32.8031,130.7079],
  'ヴァンラーレ八戸':[40.5122,141.4882],'八戸':[40.5122,141.4882],
  'ブラウブリッツ秋田':[39.7186,140.1024],
  'モンテディオ山形':[38.2404,140.3633],
  'ベガルタ仙台':[38.2682,140.8694],
  'いわきFC':[37.0500,140.8900],'いわき':[37.0500,140.8900],
  '水戸ホーリーホック':[36.3418,140.4469],
  'ザスパクサツ群馬':[36.3908,139.0601],'群馬':[36.3908,139.0601],
  'アルビレックス新潟':[37.9161,139.0364],
  'ツエーゲン金沢':[36.5613,136.6562],
  'AC長野パルセイロ':[36.6485,138.1955],
  '松本山雅':[36.2380,137.9720],
  'ジュビロ磐田':[34.7312,137.8463],'磐田':[34.7312,137.8463],
  '清水エスパルス':[34.9769,138.3831],
  'アスルクラロ沼津':[35.0975,138.8631],'沼津':[35.0975,138.8631],
  'FC岐阜':[35.3912,136.7223],
  'ヴァンフォーレ甲府':[35.6640,138.5686],
  '大宮アルディージャ':[35.9065,139.6239],
  'FC東京':[35.6646,139.5277],'味スタ':[35.6646,139.5277],'調布':[35.6573,139.5458],'調布市':[35.6573,139.5458],
  '東京ヴェルディ':[35.6646,139.5277],
  '府中':[35.6674,139.4773],'府中市':[35.6674,139.4773],
  '三鷹':[35.6836,139.5591],'三鷹市':[35.6836,139.5591],
  '武蔵野':[35.7139,139.5661],'武蔵野市':[35.7139,139.5661],
  '世田谷':[35.6464,139.6532],'世田谷区':[35.6464,139.6532],
  '江東':[35.6720,139.8172],'江東区':[35.6720,139.8172],
  '豊島':[35.7295,139.7109],'豊島区':[35.7295,139.7109],
  '練馬':[35.7356,139.6517],'練馬区':[35.7356,139.6517],
  '板橋':[35.7510,139.7099],'板橋区':[35.7510,139.7099],
  '江戸川':[35.7067,139.8689],'江戸川区':[35.7067,139.8689],
  '葛飾':[35.7440,139.8471],'葛飾区':[35.7440,139.8471],
  '荒川':[35.7359,139.7836],'荒川区':[35.7359,139.7836],
  '足立':[35.7752,139.8043],'足立区':[35.7752,139.8043],
  '八王子':[35.6663,139.3159],'八王子市':[35.6663,139.3159],
  '立川':[35.6979,139.4131],'立川市':[35.6979,139.4131],
  '多摩':[35.6368,139.4468],'多摩市':[35.6368,139.4468],
  '稲城':[35.6386,139.5016],'稲城市':[35.6386,139.5016],
  '小平':[35.7291,139.4759],'小平市':[35.7291,139.4759],
  '西東京':[35.7258,139.5381],'西東京市':[35.7258,139.5381],
  '柏レイソル':[35.8558,139.9488],'柏':[35.8558,139.9488],'柏市':[35.8558,139.9488],
  'ジェフ千葉':[35.6073,140.1063],
  '横浜F・マリノス':[35.5100,139.6060],
  '湘南ベルマーレ':[35.3375,139.4846],'平塚':[35.3375,139.4846],
  'FC町田ゼルビア':[35.5487,139.4412],'町田':[35.5487,139.4412],
  'ギラヴァンツ北九州':[33.8834,130.8751],
  'V・ファーレン長崎':[32.7448,129.8736],
  'テゲバジャーロ宮崎':[31.9077,131.4202],
  '鹿児島ユナイテッド':[31.5966,130.5571],
  'FC琉球':[26.2124,127.6809],'琉球':[26.2124,127.6809],
  // 海外主要都市
  'ロンドン':[51.5074,-0.1278],'London':[51.5074,-0.1278],
  'マンチェスター':[53.4808,-2.2426],'Manchester':[53.4808,-2.2426],
  'リバプール':[53.4084,-2.9916],'Liverpool':[53.4084,-2.9916],
  'ニューカッスル':[54.9783,-1.6178],'Newcastle':[54.9783,-1.6178],
  'バーミンガム':[52.4862,-1.8904],'Birmingham':[52.4862,-1.8904],
  'リーズ':[53.8008,-1.5491],'Leeds':[53.8008,-1.5491],
  'チェルシー':[51.4816,-0.1910],'Fulham':[51.4814,-0.2149],
  'アーセナル':[51.5549,-0.1084],'Arsenal':[51.5549,-0.1084],
  'トッテナム':[51.6042,-0.0665],'Tottenham':[51.6042,-0.0665],
  'バルセロナ':[41.3809,2.1228],'Barcelona':[41.3809,2.1228],
  'マドリード':[40.4168,-3.7038],'Madrid':[40.4168,-3.7038],
  'レアル・マドリード':[40.4531,-3.6883],
  'セビージャ':[37.3841,-5.9730],'Seville':[37.3841,-5.9730],
  'バレンシア':[39.4699,-0.3763],'Valencia':[39.4699,-0.3763],
  'パリ':[48.8566,2.3522],'Paris':[48.8566,2.3522],
  'リヨン':[45.7640,4.8357],'Lyon':[45.7640,4.8357],
  'マルセイユ':[43.2965,5.3698],'Marseille':[43.2965,5.3698],
  'ミラノ':[45.4654,9.1859],'Milan':[45.4654,9.1859],'Milano':[45.4654,9.1859],
  'ローマ':[41.9028,12.4964],'Roma':[41.9028,12.4964],'Rome':[41.9028,12.4964],
  'ナポリ':[40.8518,14.2681],'Naples':[40.8518,14.2681],
  'トリノ':[45.0703,7.6869],'Turin':[45.0703,7.6869],
  'フィレンツェ':[43.7696,11.2558],'Florence':[43.7696,11.2558],
  'ベルリン':[52.5200,13.4050],'Berlin':[52.5200,13.4050],
  'ミュンヘン':[48.1351,11.5820],'Munich':[48.1351,11.5820],'München':[48.1351,11.5820],
  'ドルトムント':[51.5136,7.4653],'Dortmund':[51.5136,7.4653],
  'ハンブルク':[53.5753,10.0153],'Hamburg':[53.5753,10.0153],
  'フランクフルト':[50.1109,8.6821],'Frankfurt':[50.1109,8.6821],
  'ライプツィヒ':[51.3397,12.3731],'Leipzig':[51.3397,12.3731],
  'アムステルダム':[52.3676,4.9041],'Amsterdam':[52.3676,4.9041],
  'リスボン':[38.7169,-9.1399],'Lisbon':[38.7169,-9.1399],'Lisboa':[38.7169,-9.1399],
  'ポルト':[41.1579,-8.6291],'Porto':[41.1579,-8.6291],
  'ブリュッセル':[50.8503,4.3517],'Brussels':[50.8503,4.3517],
  'ウィーン':[48.2082,16.3738],'Vienna':[48.2082,16.3738],'Wien':[48.2082,16.3738],
  'チューリッヒ':[47.3769,8.5417],'Zurich':[47.3769,8.5417],
  'コペンハーゲン':[55.6761,12.5683],'Copenhagen':[55.6761,12.5683],
  'オスロ':[59.9139,10.7522],'Oslo':[59.9139,10.7522],
  'ストックホルム':[59.3293,18.0686],'Stockholm':[59.3293,18.0686],
  'ヘルシンキ':[60.1699,24.9384],'Helsinki':[60.1699,24.9384],
  'ワルシャワ':[52.2297,21.0122],'Warsaw':[52.2297,21.0122],
  'プラハ':[50.0755,14.4378],'Prague':[50.0755,14.4378],
  'ブダペスト':[47.4979,19.0402],'Budapest':[47.4979,19.0402],
  'モスクワ':[55.7558,37.6173],'Moscow':[55.7558,37.6173],
  'サンクトペテルブルク':[59.9311,30.3609],'Saint Petersburg':[59.9311,30.3609],
  'イスタンブール':[41.0082,28.9784],'Istanbul':[41.0082,28.9784],
  'アテネ':[37.9838,23.7275],'Athens':[37.9838,23.7275],
  'ブカレスト':[44.4268,26.1025],'Bucharest':[44.4268,26.1025],
  'ニューヨーク':[40.7128,-74.0060],'New York':[40.7128,-74.0060],'NYC':[40.7128,-74.0060],
  'ロサンゼルス':[34.0522,-118.2437],'Los Angeles':[34.0522,-118.2437],'LA':[34.0522,-118.2437],
  'シカゴ':[41.8781,-87.6298],'Chicago':[41.8781,-87.6298],
  'ヒューストン':[29.7604,-95.3698],'Houston':[29.7604,-95.3698],
  'ダラス':[32.7767,-96.7970],'Dallas':[32.7767,-96.7970],
  'マイアミ':[25.7617,-80.1918],'Miami':[25.7617,-80.1918],
  'アトランタ':[33.7490,-84.3880],'Atlanta':[33.7490,-84.3880],
  'フィラデルフィア':[39.9526,-75.1652],'Philadelphia':[39.9526,-75.1652],
  'シアトル':[47.6062,-122.3321],'Seattle':[47.6062,-122.3321],
  'ポートランド':[45.5231,-122.6765],'Portland':[45.5231,-122.6765],
  'デンバー':[39.7392,-104.9903],'Denver':[39.7392,-104.9903],
  'フェニックス':[33.4484,-112.0740],'Phoenix':[33.4484,-112.0740],
  'サンフランシスコ':[37.7749,-122.4194],'San Francisco':[37.7749,-122.4194],
  'ボストン':[42.3601,-71.0589],'Boston':[42.3601,-71.0589],
  'ワシントン':[38.9072,-77.0369],'Washington':[38.9072,-77.0369],
  'トロント':[43.6532,-79.3832],'Toronto':[43.6532,-79.3832],
  'バンクーバー':[49.2827,-123.1207],'Vancouver':[49.2827,-123.1207],
  'モントリオール':[45.5017,-73.5673],'Montreal':[45.5017,-73.5673],
  'メキシコシティ':[19.4326,-99.1332],'Mexico City':[19.4326,-99.1332],
  'サンパウロ':[- 23.5505,-46.6333],'São Paulo':[- 23.5505,-46.6333],'サンパウロ':[-23.5505,-46.6333],
  'リオデジャネイロ':[-22.9068,-43.1729],'Rio de Janeiro':[-22.9068,-43.1729],
  'ブエノスアイレス':[-34.6037,-58.3816],'Buenos Aires':[-34.6037,-58.3816],
  'ボゴタ':[4.7110,-74.0721],'Bogota':[4.7110,-74.0721],
  'サンティアゴ':[-33.4489,-70.6693],'Santiago':[-33.4489,-70.6693],
  'リマ':[-12.0464,-77.0428],'Lima':[-12.0464,-77.0428],
  'カイロ':[30.0444,31.2357],'Cairo':[30.0444,31.2357],
  'ヨハネスブルグ':[-26.2041,28.0473],'Johannesburg':[-26.2041,28.0473],
  'ラゴス':[6.5244,3.3792],'Lagos':[6.5244,3.3792],
  'ナイロビ':[-1.2921,36.8219],'Nairobi':[-1.2921,36.8219],
  'カサブランカ':[33.5731,-7.5898],'Casablanca':[33.5731,-7.5898],
  'ドバイ':[25.2048,55.2708],'Dubai':[25.2048,55.2708],
  'リヤド':[24.6877,46.7219],'Riyadh':[24.6877,46.7219],
  'テヘラン':[35.6892,51.3890],'Tehran':[35.6892,51.3890],
  'カラチ':[24.8607,67.0011],'Karachi':[24.8607,67.0011],
  'ムンバイ':[19.0760,72.8777],'Mumbai':[19.0760,72.8777],'Bombay':[19.0760,72.8777],
  'デリー':[28.6139,77.2090],'Delhi':[28.6139,77.2090],
  'コルカタ':[22.5726,88.3639],'Kolkata':[22.5726,88.3639],
  'チェンナイ':[13.0827,80.2707],'Chennai':[13.0827,80.2707],
  'バンガロール':[12.9716,77.5946],'Bangalore':[12.9716,77.5946],
  'ダッカ':[23.8103,90.4125],'Dhaka':[23.8103,90.4125],
  'ラホール':[31.5204,74.3587],'Lahore':[31.5204,74.3587],
  'コロンボ':[6.9271,79.8612],'Colombo':[6.9271,79.8612],
  'カトマンズ':[27.7172,85.3240],'Kathmandu':[27.7172,85.3240],
  'カブール':[34.5553,69.2075],'Kabul':[34.5553,69.2075],
  'バグダッド':[33.3152,44.3661],'Baghdad':[33.3152,44.3661],
  'テルアビブ':[32.0853,34.7818],'Tel Aviv':[32.0853,34.7818],
  'アンカラ':[39.9334,32.8597],'Ankara':[39.9334,32.8597],
  'ソウル':[37.5665,126.9780],'Seoul':[37.5665,126.9780],
  '釜山':[35.1796,129.0756],'Busan':[35.1796,129.0756],
  '仁川':[37.4563,126.7052],'Incheon':[37.4563,126.7052],
  '北京':[39.9042,116.4074],'Beijing':[39.9042,116.4074],'ペキン':[39.9042,116.4074],
  '上海':[31.2304,121.4737],'Shanghai':[31.2304,121.4737],'シャンハイ':[31.2304,121.4737],
  '広州':[23.1291,113.2644],'Guangzhou':[23.1291,113.2644],
  '深圳':[22.5431,114.0579],'Shenzhen':[22.5431,114.0579],
  '成都':[30.5728,104.0668],'Chengdu':[30.5728,104.0668],
  '武漢':[30.5928,114.3055],'Wuhan':[30.5928,114.3055],
  '香港':[22.3193,114.1694],'Hong Kong':[22.3193,114.1694],'ホンコン':[22.3193,114.1694],
  '台北':[25.0330,121.5654],'Taipei':[25.0330,121.5654],'タイペイ':[25.0330,121.5654],
  'バンコク':[13.7563,100.5018],'Bangkok':[13.7563,100.5018],
  'ジャカルタ':[-6.2088,106.8456],'Jakarta':[-6.2088,106.8456],
  'クアラルンプール':[3.1390,101.6869],'Kuala Lumpur':[3.1390,101.6869],
  'シンガポール':[1.3521,103.8198],'Singapore':[1.3521,103.8198],
  'マニラ':[14.5995,120.9842],'Manila':[14.5995,120.9842],
  'ハノイ':[21.0285,105.8542],'Hanoi':[21.0285,105.8542],
  'ホーチミン':[10.8231,106.6297],'Ho Chi Minh':[10.8231,106.6297],
  'ヤンゴン':[16.8661,96.1951],'Yangon':[16.8661,96.1951],
  'カルカッタ':[22.5726,88.3639],
  'シドニー':[-33.8688,151.2093],'Sydney':[-33.8688,151.2093],
  'メルボルン':[-37.8136,144.9631],'Melbourne':[-37.8136,144.9631],
  'ブリスベン':[-27.4698,153.0251],'Brisbane':[-27.4698,153.0251],
  'パース':[-31.9505,115.8605],'Perth':[-31.9505,115.8605],
  'オークランド':[-36.8485,174.7633],'Auckland':[-36.8485,174.7633],
  // 追加: J1/J2全スタジアム・本拠地（2024年）
  '那珂':[36.4500,140.4833],'茨城県那珂市':[36.4500,140.4833],
  '西が丘':[35.7614,139.6889],'西が丘サッカー場':[35.7614,139.6889],
  '国立':[35.6782,139.7142],'国立競技場':[35.6782,139.7142],
  '熊谷':[36.1383,139.3886],'熊谷市':[36.1383,139.3886],'埼玉県熊谷市':[36.1383,139.3886],
  '久留米':[33.3167,130.5167],'久留米市':[33.3167,130.5167],'福岡県久留米市':[33.3167,130.5167],
  '鈴鹿':[34.8833,136.5833],'鈴鹿市':[34.8833,136.5833],'三重県鈴鹿市':[34.8833,136.5833],
  '西京極':[35.0167,135.7000],'西京極競技場':[35.0167,135.7000],
  '草津':[35.0167,135.9667],'草津市':[35.0167,135.9667],'滋賀県草津市':[35.0167,135.9667],
  '尼崎':[34.7333,135.4167],'尼崎市':[34.7333,135.4167],'兵庫県尼崎市':[34.7333,135.4167],
  '西宮':[34.7167,135.3333],'西宮市':[34.7167,135.3333],'兵庫県西宮市':[34.7167,135.3333],
  '姫路':[34.8394,134.6939],'姫路市':[34.8394,134.6939],'兵庫県姫路市':[34.8394,134.6939],
  '倉敷':[34.5850,133.7722],'倉敷市':[34.5850,133.7722],'岡山県倉敷市':[34.5850,133.7722],
  '福山':[34.4833,133.3500],'福山市':[34.4833,133.3500],'広島県福山市':[34.4833,133.3500],
  '下関':[33.9500,130.9167],'下関市':[33.9500,130.9167],'山口県下関市':[33.9500,130.9167],
  '宇部':[33.9500,131.2500],'宇部市':[33.9500,131.2500],'山口県宇部市':[33.9500,131.2500],
  '丸亀':[34.2833,133.8000],'丸亀市':[34.2833,133.8000],'香川県丸亀市':[34.2833,133.8000],
  // J1/J2 スタジアム名別名
  'サンガスタジアム':[35.0167,135.7000],'京都スタジアム':[35.0167,135.7000],
  '鴨池':[31.5966,130.5571],'白波スタ':[31.5966,130.5571],
  'えがお':[32.8031,130.7079],'KKウイング':[32.8031,130.7079],
  'Uvanceとどろきスタジアム':[35.5700,139.6500],
  'IAIスタジアム':[34.9769,138.3831],'アイスタ':[34.9769,138.3831],
  'ソユースタジアム':[31.9077,131.4202],
  '鳴門大塚スポーツパーク':[34.0657,134.5593],'鳴門':[34.0657,134.5593],
  'レモンガスくまがやスタジアム':[36.1383,139.3886],
  'デンカビッグスワン':[37.9161,139.0364],'ビッグスワン':[37.9161,139.0364],
  'いしかわ総合スポーツセンター':[36.5613,136.6562],
  'サンプロアルウィン':[36.2380,137.9720],'アルウィン':[36.2380,137.9720],
  'ヤマハスタジアム':[34.7312,137.8463],
  'オリックス・バファローズ本拠地':[34.7735,135.5168],
};

// ── クラブ名→本拠地都市 エイリアステーブル ──
const CITY_ALIASES:{[key:string]:string}={
  // J1
  '鹿島アントラーズ':'鹿嶋','アントラーズ':'鹿嶋',
  '浦和レッズ':'浦和','レッズ':'浦和',
  '大宮アルディージャ':'大宮','アルディージャ':'大宮',
  'FC町田ゼルビア':'町田','町田ゼルビア':'町田',
  '柏レイソル':'柏','レイソル':'柏',
  'FC東京':'調布','東京FC':'調布',
  '東京ヴェルディ':'調布','ヴェルディ':'調布',
  '川崎フロンターレ':'等々力','フロンターレ':'等々力',
  '横浜F・マリノス':'横浜','マリノス':'横浜',
  '横浜FC':'横浜','横浜エフシー':'横浜',
  '湘南ベルマーレ':'平塚','ベルマーレ':'平塚',
  'ジュビロ磐田':'磐田','磐田':'磐田',
  '清水エスパルス':'静岡','エスパルス':'静岡',
  '名古屋グランパス':'豊田','グランパス':'豊田',
  'ガンバ大阪':'吹田','ガンバ':'吹田',
  'セレッソ大阪':'長居','セレッソ':'長居',
  'ヴィッセル神戸':'神戸','ヴィッセル':'神戸',
  'サンフレッチェ広島':'広島','サンフレッチェ':'広島',
  'アビスパ福岡':'福岡','アビスパ':'福岡',
  'サガン鳥栖':'鳥栖',
  'ロアッソ熊本':'熊本','ロアッソ':'熊本',
  // J2
  '水戸ホーリーホック':'那珂','ホーリーホック':'那珂',
  'ザスパ群馬':'前橋','ザスパクサツ群馬':'前橋',
  'ヴァンフォーレ甲府':'甲府','ヴァンフォーレ':'甲府',
  'アルビレックス新潟':'新潟','アルビレックス':'新潟',
  'ツエーゲン金沢':'金沢','ツエーゲン':'金沢',
  'ジェフユナイテッド千葉':'千葉','ジェフ千葉':'千葉','ジェフ':'千葉',
  'モンテディオ山形':'山形','モンテディオ':'山形',
  'ブラウブリッツ秋田':'秋田','ブラウブリッツ':'秋田',
  'いわきFC':'いわき',
  'AC長野パルセイロ':'長野','長野パルセイロ':'長野',
  '松本山雅FC':'松本','松本山雅':'松本',
  'アスルクラロ沼津':'沼津','アスルクラロ':'沼津',
  'FC岐阜':'岐阜',
  '京都サンガ':'西京極','サンガ':'西京極',
  'ファジアーノ岡山':'岡山','ファジアーノ':'岡山',
  'レノファ山口':'山口','レノファ':'山口',
  'カマタマーレ讃岐':'丸亀','讃岐':'丸亀',
  'ロアッソ熊本':'熊本',
  'テゲバジャーロ宮崎':'宮崎','テゲバジャーロ':'宮崎',
  'ギラヴァンツ北九州':'北九州','ギラヴァンツ':'北九州',
  'V・ファーレン長崎':'長崎','ファーレン長崎':'長崎',
  '鹿児島ユナイテッド':'鹿児島','鹿児島ユナイテッドFC':'鹿児島',
  'FC琉球':'那覇','琉球':'那覇',
  'ヴァンラーレ八戸':'八戸','ヴァンラーレ':'八戸',
};
function resolveCityName(name:string):string{
  if(!name)return name;
  const t=name.trim();
  if(CITY_ALIASES[t])return CITY_ALIASES[t];
  // 部分一致: エイリアスキーが含まれている場合
  const ak=Object.keys(CITY_ALIASES).find(k=>t.includes(k)||k.includes(t));
  if(ak)return CITY_ALIASES[ak];
  return t;
}

// ── 都市名正規化（市/町/村/区/県/都/道/府/市区町村を除去） ──
function normCity(name:string):string{
  return name.trim()
    .replace(/[都道府県]$/,'')
    .replace(/[市区町村郡]$/,'')
    .replace(/\s/g,'');
}

// ── 都市名検索（正規化＋部分一致・先頭優先） ──
function findCity(name:string):[number,number]|null{
  if(!name)return null;
  const raw=name.trim();
  // 完全一致
  if(CITY_COORDS[raw])return CITY_COORDS[raw];
  // 正規化した名前で完全一致
  const n=normCity(raw);
  if(CITY_COORDS[n])return CITY_COORDS[n];
  // 嶋↔島 の異体字変換
  const n2=n.replace(/嶋/g,'島').replace(/島/g,'嶋');
  if(CITY_COORDS[n2.replace(/嶋/g,'島')])return CITY_COORDS[n2.replace(/嶋/g,'島')];
  // 先頭一致（正規化後）
  const keys=Object.keys(CITY_COORDS);
  const k=keys.find(k=>k.startsWith(n)||n.startsWith(k)||normCity(k)===n);
  if(k)return CITY_COORDS[k];
  // 部分一致（正規化後）
  const k2=keys.find(k=>normCity(k).includes(n)||n.includes(normCity(k)));
  if(k2)return CITY_COORDS[k2];
  // 都道府県名を含む入力（例:「茨城県鹿嶋市」→「鹿嶋」→「鹿島」）
  const stripped=raw.replace(/^.+[都道府県]/,'').replace(/[市区町村郡]$/,'');
  if(stripped&&stripped!==raw){
    const r=findCity(stripped);
    if(r)return r;
  }
  return null;
}

// ── Nominatim APIで座標取得してキャッシュ ──
const _geocacheCity:{[k:string]:[number,number]}={};
async function geocodeCity(name:string):Promise<[number,number]|null>{
  if(!name)return null;
  const cached=findCity(name);
  if(cached)return cached;
  if(_geocacheCity[name])return _geocacheCity[name];
  const fetchWithTimeout=(url:string,ms:number)=>{
    const ctrl=new AbortController();
    const tid=setTimeout(()=>ctrl.abort(),ms);
    return fetch(url,{signal:ctrl.signal}).finally(()=>clearTimeout(tid));
  };
  try{
    const q=encodeURIComponent(name+' Japan');
    const r=await fetchWithTimeout(`https://nominatim.openstreetmap.org/search?q=${q}&format=json&limit=1&accept-language=ja`,5000);
    const d=await r.json();
    if(d&&d[0]){const coord:[number,number]=[parseFloat(d[0].lat),parseFloat(d[0].lon)];_geocacheCity[name]=coord;CITY_COORDS[name]=coord;return coord;}
    const r2=await fetchWithTimeout(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(name)}&format=json&limit=1&accept-language=ja`,5000);
    const d2=await r2.json();
    if(d2&&d2[0]){const coord:[number,number]=[parseFloat(d2[0].lat),parseFloat(d2[0].lon)];_geocacheCity[name]=coord;CITY_COORDS[name]=coord;return coord;}
  }catch(e){console.warn('geocode failed',name,e);}
  return null;
}

// ── 方位計算（球面三角法→八方位→宮位） ──
// ── 五黄殺・暗剣殺・天道方位ヘルパー ──
const PALACE_TO_DIR8:{[k:number]:string|null}={1:'北',2:'南西',3:'東',4:'南東',5:null,6:'北西',7:'西',8:'北東',9:'南'};
const OPP_DIR8:{[k:string]:string}={'北':'南','南':'北','東':'西','西':'東','北東':'南西','南西':'北東','北西':'南東','南東':'北西'};
function getStarPalace(star:number,centerStar:number):number{return((star+5-centerStar-1+18)%9)+1;}
// 五黄殺方位（年盤or月盤の中宮星を渡す）
function getGoouDir8(cStar:number):string|null{return PALACE_TO_DIR8[getStarPalace(5,cStar)]??null;}
// 天道方位：六白金星（天の気）が入る宮の方位
function getTendoDir8(cStar:number):string|null{return PALACE_TO_DIR8[getStarPalace(6,cStar)]??null;}
// 歳破方位（試合年から算出）―年の十二支の反対方位
function getSaihaDir8(year:number):string{
  const ji=(year-4+120)%12; // 0=子,1=丑,2=寅,3=卯,4=辰,5=巳,6=午,7=未,8=申,9=酉,10=戌,11=亥
  const opp8=['南','南西','南西','西','北西','北西','北','北東','北東','東','南東','南東'];
  return opp8[ji];
}

function calcBearingCoords(from:[number,number],to:[number,number]):{deg:number,dir8:string,palace:number,star:number,elem:string}{
  const [lat1,lon1]=from.map(d=>d*Math.PI/180);
  const [lat2,lon2]=to.map(d=>d*Math.PI/180);
  const dLon=lon2-lon1;
  const y=Math.sin(dLon)*Math.cos(lat2);
  const x=Math.cos(lat1)*Math.sin(lat2)-Math.sin(lat1)*Math.cos(lat2)*Math.cos(dLon);
  let deg=(Math.atan2(y,x)*180/Math.PI+360)%360;
  // 八方位
  const DIR8=['北','北東','東','南東','南','南西','西','北西'];
  const dir8=DIR8[Math.round(deg/45)%8];
  // 九星: 北=1, 南西=2, 東=3, 南東=4, 中=5(使わず), 北西=6, 西=7, 北東=8, 南=9
  const DIR_PALACE:{[k:string]:number}={'北':1,'南西':2,'東':3,'南東':4,'北西':6,'西':7,'北東':8,'南':9};
  const palace=DIR_PALACE[dir8]||5;
  const star=palace;
  const S_ELEM_MAP:{[k:number]:string}={1:'水',2:'土',3:'木',4:'木',5:'土',6:'金',7:'金',8:'土',9:'火'};
  return{deg:Math.round(deg),dir8,palace,star,elem:S_ELEM_MAP[palace]||'土'};
}
// 同期版（テーブルヒット時のみ）
function calcBearing(fromCity:string,toCity:string):{deg:number,dir8:string,palace:number,star:number,elem:string}|null{
  const from=findCity(fromCity);const to=findCity(toCity);
  if(!from||!to)return null;
  return calcBearingCoords(from,to);
}
// 非同期版（Nominatim fallback付き）
async function calcBearingAsync(fromCity:string,toCity:string):Promise<{deg:number,dir8:string,palace:number,star:number,elem:string}|null>{
  const from=await geocodeCity(fromCity);const to=await geocodeCity(toCity);
  if(!from||!to)return null;
  return calcBearingCoords(from,to);
}

// ── 時盤中宮星計算 ──
// 時盤の計算: 日盤中宮星 × 時刻の十二支で定局
function getHourStar(jstHour:number,dayStar:number):number{
  // 十二支の時刻区分（子=23-1, 丑=1-3, 寅=3-5, ...）
  const branch=Math.floor(((jstHour+1)%24)/2); // 0=子,1=丑,...,11=亥
  // 陽遁/陰遁は日盤中宮が1-5=陽遁, 6-9=陰遁
  const isYodon=dayStar<=5;
  // 時盤: 子の刻の宮 = 日盤中宮が奇数宮の場合は子=8宮起点など
  // 簡易実装: 日盤中宮から分岐する定局表（三奇六儀的）
  const HOUR_BASE:{[k:number]:number}={1:1,2:4,3:7,4:1,5:4,6:7,7:1,8:4,9:7};
  const base=HOUR_BASE[dayStar]||1;
  let hour_star:number;
  if(isYodon){
    hour_star=((base-1+branch)%9)+1;
  } else {
    hour_star=((base-1-branch+9*10)%9)+1;
  }
  return hour_star;
}

const ROKKO_TRIG=['乾','兌','離','震','巽','坎','艮','坤'];
const ROKKO_ELEM=['天','沢','火','雷','風','水','山','地'];
const ROKKO_MAP:Record<string,number>={'111':0,'011':1,'101':2,'001':3,'110':4,'010':5,'100':6,'000':7};
function rokkoIsYang(v:number){return v===7||v===9;}
function rokkoTriIdx(a:boolean,b:boolean,c:boolean){return ROKKO_MAP[(a?'1':'0')+(b?'1':'0')+(c?'1':'0')]??0;}
function flipCoins(){const c=[Math.random()>.5,Math.random()>.5,Math.random()>.5];const n=c.filter(Boolean).length;return n===3?9:n===2?7:n===1?8:6;}
function calcHex(ls:number[]){
  if(ls.length<6)return null;
  const lo=rokkoTriIdx(rokkoIsYang(ls[0]),rokkoIsYang(ls[1]),rokkoIsYang(ls[2]));
  const up=rokkoTriIdx(rokkoIsYang(ls[3]),rokkoIsYang(ls[4]),rokkoIsYang(ls[5]));
  const hasChg=ls.some(l=>l===6||l===9);
  let clo=lo,cup=up;
  if(hasChg){const cl=ls.map(l=>l===9?8:l===6?7:l);clo=rokkoTriIdx(rokkoIsYang(cl[0]),rokkoIsYang(cl[1]),rokkoIsYang(cl[2]));cup=rokkoTriIdx(rokkoIsYang(cl[3]),rokkoIsYang(cl[4]),rokkoIsYang(cl[5]));}
  return{main:{up,lo,name:ROKKO_TRIG[up]+'×'+ROKKO_TRIG[lo],elem:ROKKO_ELEM[up]+'/'+ROKKO_ELEM[lo]},change:hasChg?{up:cup,lo:clo,name:ROKKO_TRIG[cup]+'×'+ROKKO_TRIG[clo],elem:ROKKO_ELEM[cup]+'/'+ROKKO_ELEM[clo]}:null,lines:ls};
}

/** 今後N日間の三重・二重吉方位日をリストアップ */
function getTripleAuspiciousDays(honmeiStar,startDate,days){
  const DN=["東南","南","西南","東","中","西","東北","北","西北"];
  const results=[];
  const n=days||30;
  for(let d=0;d<n;d++){
    const dt=new Date(startDate);
    dt.setDate(startDate.getDate()+d);
    const yr=dt.getFullYear(),mo=dt.getMonth()+1,dy=dt.getDate();
    const kmi=getKiMonthIdx(mo,dy);
    const kiY=(kmi===11||(mo===1&&dy<6))?yr-1:yr;
    const yrC=getYearStar(kiY);
    const moC=getMonthStar(yrC,kmi);
    const dayC=getDayStar(dt);
    const yrS=getStarsFor(yrC),moS=getStarsFor(moC),dayS=getStarsFor(dayC);
    const bestDirs=[];
    for(let i=0;i<9;i++){
      if(i===4)continue;
      const allThree=yrS[i]===honmeiStar&&moS[i]===honmeiStar&&dayS[i]===honmeiStar;
      const twoBoards=(yrS[i]===honmeiStar&&moS[i]===honmeiStar)||(yrS[i]===honmeiStar&&dayS[i]===honmeiStar)||(moS[i]===honmeiStar&&dayS[i]===honmeiStar);
      if(allThree||twoBoards){
        bestDirs.push({direction:DN[i],strength:allThree?'三重':twoBoards?'二重':'一重'});
      }
    }
    if(bestDirs.length>0){
      const dateStr=`${mo}/${dy}`;
      results.push({date:dateStr,dateObj:new Date(dt),directions:bestDirs,best:bestDirs[0]?.direction||'',strength:bestDirs[0]?.strength||''});
    }
  }
  return results;
}

function findThingElem(kw){
  for(const{w,e,i,r}of THING_MAPS){if(w.some(x=>kw.includes(x)))return{elem:e,icon:i,rich:r};}
  // 自由入力：五行キーワードで判定
  const waterKW=["水","海","川","池","雨","流","冷","夜","暗","黒","青","紺","知","情","感","心","深","静","冬","北"];
  const woodKW=["木","森","草","緑","春","風","成","長","動","新","始","朝","東","南東","行","早","若","縁","人","友"];
  const fireKW=["火","光","輝","赤","夏","南","美","華","発","信","才","名","目立","表","熱","情熱","直感","創","芸"];
  const earthKW=["土","地","安","定","家","食","育","母","父","支","助","農","建","不動","基","根","茶","黄","秋"];
  const metalKW=["金","白","西","秋","決","断","鋭","整","清","勝","競","権","力","リーダ","指導","契約","法","医"];
  const counts={水:0,木:0,火:0,土:0,金:0};
  for(const k of waterKW)if(kw.includes(k))counts["水"]++;
  for(const k of woodKW)if(kw.includes(k))counts["木"]++;
  for(const k of fireKW)if(kw.includes(k))counts["火"]++;
  for(const k of earthKW)if(kw.includes(k))counts["土"]++;
  for(const k of metalKW)if(kw.includes(k))counts["金"]++;
  const maxElem=Object.entries(counts).sort((a,b)=>b[1]-a[1])[0];
  const elemMap={
    "水":{icon:"💧",rich:"「"+kw+"」は水の気と共鳴します。水の気は流動・知恵・縁・適応力のエネルギー。坎宮（北）の方位に吉の気があり、静かな環境での内省と学びが力になります。柔軟に状況に合わせながら、深い洞察を活かしてください。"},
    "木":{icon:"🌿",rich:"「"+kw+"」は木の気と共鳴します。木の気は成長・行動・縁・突破力のエネルギー。震宮（東）・巽宮（東南）の方位が吉で、積極的な行動と新しいチャレンジが運気を開きます。今こそ動くべき時です。"},
    "火":{icon:"🔥",rich:"「"+kw+"」は火の気と共鳴します。火の気は輝き・直感・名誉・表現のエネルギー。離宮（南）の方位が吉で、才能と個性を積極的に発揮することが開運につながります。自信を持って表現してください。"},
    "土":{icon:"⛰️",rich:"「"+kw+"」は土の気と共鳴します。土の気は安定・育成・包容力・基盤のエネルギー。坤宮（西南）・艮宮（東北）の方位が吉で、地道な積み重ねと誠実な関わりが運気を高めます。焦らず着実に進んでください。"},
    "金":{icon:"✨",rich:"「"+kw+"」は金の気と共鳴します。金の気は決断・権威・洗練・実行力のエネルギー。乾宮（西北）・兌宮（西）の方位が吉で、明確な判断と品格ある行動が運気を高めます。今こそ決断の時です。"},
  };
  const h=maxElem[1]>0?maxElem[0]:"水";
  const chars=["水","木","火","土","金"];
  let idx=0;for(let i=0;i<kw.length;i++)idx=(idx*31+kw.charCodeAt(i))%5;
  const finalElem=maxElem[1]>0?h:chars[idx];
  return{elem:finalElem,icon:elemMap[finalElem]?.icon||"🔮",rich:elemMap[finalElem]?.rich||"あなたの直感が示す道を信じて進んでください。"};
}

function buildPersonCompat(myHs,myTs,oHs,oTs){
  const myE=S_ELEM[myHs],oE=S_ELEM[oHs];
  const rel=getStarRel(myHs,oHs),tsRel=getStarRel(myHs,oTs);
  const si=STAR_INFO[myHs],oi=STAR_INFO[oHs];
  const ri=COMPAT_REL[rel];
  const overall={
    相生受:`${oi.name}のエネルギーが、あなた（${si.name}）を最高に引き出してくれる理想的な関係です。相手はあなたに欠けているものを自然に補い、長所を際立たせてくれます。二人が一緒にいることで1+1が3にも4にもなる可能性を秘めています。`,
    相生生:`あなた（${si.name}）が相手（${oi.name}）を育て支える関係です。あなたの存在が相手の成長を促し、その成長があなた自身にも喜びをもたらします。与える側のあなたには、見返りを求めすぎないことが長続きの鍵です。`,
    比和:`同じ気質（${myE}の気）を持つ共鳴関係。互いをよく理解し、心地よい安心感があります。一方で、似ている分だけ良い面も悪い面も増幅されやすく、互いを高め合う意識が大切です。`,
    相剋受:`相手（${oi.name}）の気があなた（${si.name}）に干渉しやすい関係です。相手の言動があなたのエネルギーを削ぐことがあるかもしれません。ただしこの緊張感が成長の刺激になることもあり、適切な距離感を保つことで良い関係が築けます。`,
    相剋攻:`あなた（${si.name}）の気が相手（${oi.name}）に強く作用する関係です。無意識に相手にプレッシャーをかけてしまうことがあります。相手の気質を尊重し、配慮ある接し方を意識することで逆に深い信頼関係につながります。`,
  }[rel];
  const work={
    相生受:`仕事面でも最強のコンビになれます。相手はあなたの能力を最大限に引き出し、得意でない部分を自然に補います。共同プロジェクトや事業パートナーとして非常に有望です。`,
    相生生:`あなたが相手を指導・サポートする関係。あなたのリードで相手が成長しチームとしての成果が上がります。メンター・メンティー的な関係で力を発揮します。`,
    比和:`同じ方向を向いて動ける仕事仲間。連携は取りやすいですが二人の弱点も共有されやすいので役割分担が鍵です。`,
    相剋受:`役割分担を明確にし、お互いの専門性を活かす仕組みを作ることが成功の鍵です。相手から学べることも多くあります。`,
    相剋攻:`あなたのパワーが相手に強く作用します。リーダーシップを発揮できる一方、相手の意見をしっかり聞く姿勢が協力関係を深めます。`,
  }[rel];
  const emot={
    相生受:`感情面で最高の相性。相手はあなたの気持ちを自然に理解し、安心感と満足感を与えてくれます。共にいることで幸福感が高まる理想的な情緒的関係です。`,
    相生生:`あなたが相手の感情を支え包む関係。相手はあなたの存在に安心し感情的な依存が深まることも。バランスを保ちながら関係を育てることが大切です。`,
    比和:`感情的に共鳴しやすく、共感力が高い関係。喜怒哀楽を共有しやすい一方、感情が増幅されすぎることも。冷静なバランス感覚を持つことが鍵です。`,
    相剋受:`相手の感情表現がときに重荷に感じることがあるかもしれません。相手の感情リズムを理解し、受け止める余裕を持つことで深い絆が生まれます。`,
    相剋攻:`あなたの感情的なエネルギーが相手を圧倒しやすい面があります。相手の繊細な感情への気配りが、深い信頼関係の構築につながります。`,
  }[rel];
  const comm={
    相生受:`あなた（${si.elem}の気）と相手（${oi.elem}の気）の会話スタイルは自然に調和します。互いの話を理解しやすく、誤解が生まれにくい関係です。`,
    相生生:`あなたが会話のリードを取ることで二人の対話が豊かになります。相手の言葉に耳を傾け引き出す姿勢が、深い理解につながります。`,
    比和:`同じ気質を持つため共感しやすい一方、同じ盲点も持ちやすいです。異なる視点を意識的に取り入れることで会話が豊かになります。`,
    相剋受:`コミュニケーションに工夫が必要です。相手の話し方の意図をよく理解してから反応することで良い対話が生まれます。`,
    相剋攻:`あなたの言葉が相手に強く響くことがあります。言葉を選び、相手が受け取りやすい表現を心がけることが大切です。`,
  }[rel];
  const longterm={
    相生受:`長期的に見て最も安定した相性。年月を重ねるほど二人の絆は深まり、互いの存在が人生の大きな支えになります。`,
    相生生:`年を重ねるにつれ、育てる側と育てられる側の関係がより明確になります。相手の成長があなたの生きがいになる深い縁の関係です。`,
    比和:`長期的には安定した関係。似ている分だけ刺激が少なくなることもありますが、共通の価値観が長い縁を育みます。`,
    相剋受:`理解を深めることで関係は徐々に改善します。長い時間をかけて育てた関係は、互いの強さを磨く貴重な縁になります。`,
    相剋攻:`成熟するにつれ相手への配慮を深めることで、深い信頼関係へと発展する可能性を秘めています。`,
  }[rel];
  const advice={
    相生受:`この相性を活かすには、相手のサポートを素直に受け入れることが大切。遠慮せず頼り合える関係を育ててください。二人で取り組む共通の目標を持つと相乗効果が最大化されます。`,
    相生生:`相手のために何かをする喜びを大切にしてください。ただし一方通行にならないよう、相手からの感謝や反応を受け取ることも忘れずに。`,
    比和:`良いところも悪いところも増幅されやすい関係です。互いの長所を称え合い、弱点は補い合う意識で接することで最高のパートナーシップが生まれます。`,
    相剋受:`相手のペースや価値観を尊重することが鍵。「違い」を否定せず、相手の強みから学ぶ姿勢を持つことでこの相性は大きな成長の源になります。`,
    相剋攻:`相手の繊細な感情や意見に耳を傾けることが最重要。あなたのエネルギーを相手への「贈り物」として丁寧に届ける意識で接してください。`,
  }[rel];

  // 今日の二人のエネルギー
  const today=new Date();
  const km=getKiMonthIdx(today.getMonth()+1,today.getDate());
  const dayC=getDayStar(today);
  const dayS=getStarsFor(dayC);
  const myDayP=dayS.indexOf(myHs),oDayP=dayS.indexOf(oHs);
  const todayMsg=`今日のあなた（${si.name}）は${PALACES[myDayP]?.d}宮に位置し${PAL_FORTUNE[myDayP]?.r}の運気。相手（${oi.name}）は${PALACES[oDayP]?.d}宮で${PAL_FORTUNE[oDayP]?.r}の気配です。${([1,2,5].includes(myDayP)&&[1,2,5].includes(oDayP))?"今日は二人ともエネルギーが高く、共に行動したり話し合うことに最適です。":"今日は互いのペースを尊重しながら穏やかに過ごすことが吉です。"}`;

  return{rel,ri,overall,work,emot,comm,longterm,advice,todayMsg,tsRel,tsRelInfo:COMPAT_REL[tsRel]||COMPAT_REL["比和"],myE,oE};
}

// ═══ SHARED UI ═══
const CS={
  card:{borderRadius:"12px",background:"#1C1C1C",border:"0.5px solid #C9A84C55",boxShadow:"0 4px 20px rgba(0,0,0,0.5)",overflow:"hidden",marginBottom:"12px"},
  inp:{padding:"9px 12px",background:"#f9fafb",border:"1px solid #e5e7eb",borderRadius:"8px",color:"#1f2937",fontSize:"16px",fontFamily:"inherit",width:"100%"},
  btn:(col="#d97706")=>({padding:"10px 20px",background:`linear-gradient(135deg,${col},${col}bb)`,border:"none",borderRadius:"9px",color:"white",fontWeight:"bold",fontSize:"15px",cursor:"pointer",fontFamily:"serif",letterSpacing:"1px"}),
  ghost:{padding:"7px 14px",background:"white",border:"1px solid #e5e7eb",borderRadius:"8px",color:"#6b7280",fontSize:"14px",cursor:"pointer",fontFamily:"inherit"},
};

function RatingBadge({r}){
  const m={"最高":{c:"#92400e",bg:"#fffbeb",br:"#fde68a"},"吉":{c:"#065f46",bg:"#ecfdf5",br:"#6ee7b7"},"中吉":{c:"#065f46",bg:"#f0fdf4",br:"#86efac"},"中":{c:"#1e40af",bg:"#eff6ff",br:"#bfdbfe"},"注意":{c:"#92400e",bg:"#fffbeb",br:"#fde68a"},"凶":{c:"#991b1b",bg:"#fef2f2",br:"#fca5a5"},"大凶":{c:"#7f1d1d",bg:"#fff1f2",br:"#f87171"},"小吉":{c:"#374151",bg:"#f9fafb",br:"#d1d5db"},"養生":{c:"#1e40af",bg:"#eff6ff",br:"#bfdbfe"},"変化":{c:"#4c1d95",bg:"#faf5ff",br:"#ddd6fe"},"共鳴":{c:"#1e40af",bg:"#eff6ff",br:"#93c5fd"}};
  const cfg=m[r]||{c:"#374151",bg:"#f9fafb",br:"#e5e7eb"};
  return(<span style={{padding:"2px 10px",borderRadius:"12px",background:cfg.bg,border:`1px solid ${cfg.br}`,fontSize:"15px",color:cfg.c,fontWeight:"bold"}}>{r}</span>);
}

function StarBadge({star,size=40}){
  const s=STAR_INFO[star];if(!s)return null;
  return(
    <div style={{display:"flex",alignItems:"center",gap:size>30?10:6}}>
      <div style={{width:size,height:size,borderRadius:"50%",background:s.bg,border:`2px solid ${s.br}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:size*0.44,flexShrink:0,boxShadow:`0 2px 8px ${s.br}55`}}>{s.g}</div>
      <div><div style={{fontSize:size>30?14:11,fontWeight:"bold",color:s.c,fontFamily:"serif"}}>{s.name}</div><div style={{fontSize:size>30?10:9,color:"#6b7280"}}>{s.elem}の気</div></div>
    </div>
  );
}

function MiniGrid({stars,hl,title,center}){
  return(
    <div style={{flex:"1 1 110px"}}>
      <div style={{fontSize:"14px",textAlign:"center",color:"#6b7280",marginBottom:"4px"}}>{title}</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"2px"}}>
        {stars.map((star,i)=>{const inf=STAR_INFO[star];const isH=star===hl,isC=i===4;return(
          <div key={i} style={{padding:isC?"8px 2px":"5px 2px",textAlign:"center",background:isH?inf.bg:isC?"#fffbeb":"#fafafa",border:`1px solid ${isH?inf.br:isC?"#fde68a":"#f3f4f6"}`,borderRadius:isC?"50%":"4px",boxShadow:isH?`0 0 5px ${inf.br}55`:"none"}}>
            <div style={{fontSize:"9px",color:"#d1d5db"}}>{PALACES[i].n}</div>
            <div style={{fontSize:isH?"11px":"9px",color:isH?inf.c:"#6b7280",fontFamily:"serif",fontWeight:isH?"bold":"normal"}}>{inf.k}</div>
          </div>);
        })}
      </div>
      <div style={{textAlign:"center",fontSize:"14px",color:"#6b7280",marginTop:"3px"}}>中宮:{STAR_INFO[center]?.k}</div>
    </div>
  );
}

function CompassGrid({kyohoi,dayStars,honmei,tendo}){
  const km={};kyohoi.forEach(k=>{if(!km[k.pi])km[k.pi]=[];km[k.pi].push(k);});
  const hmDay=dayStars.indexOf(honmei);
  return(
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"5px",maxWidth:"290px",margin:"0 auto"}}>
      {[0,1,2,3,4,5,6,7,8].map(i=>{
        const isC=i===4;const ks=km[i]||[];
        const bigK=ks.some(k=>k.lv==="大凶"),k=ks.some(k=>k.lv==="凶");
        const isHM=hmDay===i&&!isC,isTen=tendo===i&&!isC;
        let bg="#f0fdf4",br="#86efac",lb="吉",lc="#16a34a";
        if(isC){bg="#fffbeb";br="#fde68a";lb="中央";lc="#92400e";}
        else if(bigK){bg="#fef2f2";br="#fca5a5";lb="大凶";lc="#dc2626";}
        else if(k){bg="#fffbeb";br="#fde68a";lb="凶";lc="#d97706";}
        return(
          <div key={i} style={{padding:isC?"14px 4px":"9px 4px",background:bg,border:`${isHM?"2px":"1.5px"} solid ${isHM?"#a78bfa":br}`,borderRadius:isC?"50%":"8px",textAlign:"center",position:"relative"}}>
            {isTen&&<div style={{position:"absolute",top:"2px",right:"3px",fontSize:"9px",color:"#d97706",fontWeight:"bold"}}>天</div>}
            <div style={{fontSize:"14px",color:"#6b7280"}}>{PALACES[i].d}</div>
            <div style={{fontSize:"14px",fontWeight:"bold",color:lc,lineHeight:1.3}}>{lb}</div>
            {ks.length>0&&!isC&&<div style={{fontSize:"8px",color:lc,opacity:0.8}}>{ks.map(k=>k.type.replace(/（年）|（月）/,"")).slice(0,2).join("/")}</div>}
            {isHM&&<div style={{fontSize:"9px",color:"#7c3aed"}}>★本命</div>}
          </div>
        );
      })}
    </div>
  );
}

function StepCard({num,title,color="#d97706",defaultOpen=true,children}){
  const[open,setOpen]=useState(defaultOpen);
  return(
    <div style={{...CS.card,borderLeft:`3px solid ${color}`}}>
      <div onClick={()=>setOpen(o=>!o)} style={{padding:"10px 16px",display:"flex",alignItems:"center",gap:"10px",cursor:"pointer",background:`linear-gradient(90deg,${color}08,transparent)`,borderBottom:open?"1px solid #f3f4f6":"none"}}>
        <div style={{width:"22px",height:"22px",borderRadius:"50%",flexShrink:0,background:`linear-gradient(135deg,${color},${color}cc)`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"14px",fontWeight:"bold",color:"white"}}>{num}</div>
        <div style={{flex:1,fontSize:"15px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>{title}</div>
        <div style={{fontSize:"14px",color:color}}>{open?"▲":"▼"}</div>
      </div>
      {open&&<div style={{padding:"14px 16px"}}>{children}</div>}
    </div>
  );
}

function ScoreBar({score}){
  const cfg=score<=2?{c:"#dc2626",l:"凶"}:score<=3?{c:"#d97706",l:"注意"}:score<=5?{c:"#6b7280",l:"小吉"}:score<=7?{c:"#16a34a",l:"吉"}:{c:"#d97706",l:"大吉"};
  return(<div><div style={{display:"flex",alignItems:"center",gap:"8px",marginBottom:"6px"}}><span style={{fontSize:"14px",color:"#6b7280"}}>吉凶スコア</span><span style={{fontSize:"20px",fontWeight:"bold",color:cfg.c,fontFamily:"serif"}}>{cfg.l}</span><span style={{fontSize:"15px",color:"#6b7280"}}>({score}/10)</span></div><div style={{height:"6px",background:"#f3f4f6",borderRadius:"3px",overflow:"hidden"}}><div style={{height:"100%",width:`${score*10}%`,background:cfg.c,borderRadius:"3px",transition:"width 0.8s ease"}}/></div></div>);
}

function SectionTitle({children}){
  return(<div style={{fontSize:"14px",letterSpacing:"2px",color:"#6b7280",marginBottom:"7px",borderBottom:"1px solid #f3f4f6",paddingBottom:"4px"}}>{children}</div>);
}

function InfoBlock({label,value,color="#1f2937"}){
  return(
    <div style={{padding:"8px 12px",background:"#f9fafb",borderRadius:"8px",border:"1px solid #f3f4f6",marginBottom:"6px"}}>
      <div style={{fontSize:"14px",color:"#6b7280",marginBottom:"2px"}}>{label}</div>
      <div style={{fontSize:"14px",color:color,lineHeight:1.65}}>{value}</div>
    </div>
  );
}

// ═══ ERROR BOUNDARY ═══
class TabErrorBoundary extends React.Component{
  constructor(props){super(props);this.state={hasError:false,err:""};}
  static getDerivedStateFromError(e){return{hasError:true,err:e?.message||"不明なエラー"};}
  componentDidCatch(e,info){console.warn("TabError:",e,info);}
  render(){
    if(this.state.hasError){
      return(
        <div style={{textAlign:"center",padding:"40px 20px"}}>
          <div style={{fontSize:"38px",marginBottom:"12px"}}>⚠️</div>
          <div style={{fontSize:"17px",fontWeight:"bold",color:"#374151",marginBottom:"6px"}}>表示エラーが発生しました</div>
          <div style={{fontSize:"15px",color:"#6b7280",marginBottom:"16px"}}>{this.state.err}</div>
          <button onClick={()=>this.setState({hasError:false,err:""})} style={{padding:"8px 20px",background:"#d97706",color:"white",border:"none",borderRadius:"8px",cursor:"pointer",fontFamily:"inherit"}}>再試行</button>
        </div>
      );
    }
    return this.props.children;
  }
}

function NeedProfile(){
  return(
    <div style={{textAlign:"center",padding:"40px 20px"}}>
      <img src={CHIBI_IMG} alt="気学くん" style={{width:"80px",opacity:0.5,marginBottom:"12px"}}/>
      <div style={{fontSize:"18px",fontWeight:"bold",fontFamily:"serif",color:"#374151",marginBottom:"6px"}}>プロフィールが必要です</div>
      <div style={{fontSize:"14px",color:"#6b7280"}}>「プロフィール」タブから生年月日を登録してください</div>
    </div>
  );
}

// ═══ TODAY TAB ═══
// ── キャラクター今日のひとことメッセージ（改良版） ──
// 本命星(9種) × 今日の宮(9種) × 運勢ランク × 天気五行 × シード で数千通り生成
function getDailyCharMsg(name,hs,elem,fortuneRating,palaceName,weatherElem,today){
  const d=today.getDate(),m=today.getMonth()+1,y=today.getFullYear();
  const seed=((y*10000+m*100+d)*97+hs*31)>>>0;
  const pick=(arr)=>arr[seed%arr.length];
  const pick2=(arr)=>arr[(seed+13)%arr.length];

  // ① 本命星キャラ別・口調パターン（各星6種）
  const STAR_VOICE={
    1:[ // 一白水星：クール・知的
      `${name}さん、水の気を持つあなたは`,
      `${name}さん、一白水星の流れを読んで—`,
      `${name}さん、今日の水のエネルギーで言うと`,
      `${name}さん、一白の深い知恵を活かして今日は`,
      `${name}さん、水星らしく静かに流れに乗って`,
      `${name}さん、一白の直観力が冴える今日は`,
    ],
    2:[ // 二黒土星：温かく包む
      `${name}さん、大地の気を持つあなたへ。`,
      `${name}さん、二黒の安定感を活かして、`,
      `${name}さん、今日はね、大地みたいにどっしりと`,
      `${name}さん、二黒土星の包容力で今日は`,
      `${name}さん、大地のように根を張って今日は`,
      `${name}さん、二黒の育む力が光る今日は`,
    ],
    3:[ // 三碧木星：元気・行動的
      `${name}さん！三碧木星の雷エネルギーで今日は`,
      `${name}さん！行動の星らしく今日は`,
      `${name}さん、今日の三碧の気は`,
      `${name}さん！雷のように突破力ある三碧、今日は`,
      `${name}！三碧木星の春の芽吹きみたいに今日は`,
      `${name}さん、三碧の若々しいエネルギーで今日は`,
    ],
    4:[ // 四緑木星：柔らかく穏やか
      `${name}さん、風のような四緑の気で今日は`,
      `${name}さん、縁の星らしく今日は`,
      `${name}さん〜、四緑の風に乗って今日は`,
      `${name}さん、四緑木星の縁結びパワーで今日は`,
      `${name}さん、風のように遠くまで届く四緑、今日は`,
      `${name}さん〜、四緑の信頼と縁の力を活かして`,
    ],
    5:[ // 五黄土星：帝王・力強く
      `${name}さん、五黄帝王の気が今日は`,
      `${name}！最強の五黄土星、今日の気の流れは`,
      `${name}さん、五黄の大きなエネルギー的に今日は`,
      `${name}さん、宇宙の中心・五黄土星として今日は`,
      `${name}！帝王の気を持つ五黄土星、今日の流れは`,
      `${name}さん、五黄の圧倒的な生命力で今日は`,
    ],
    6:[ // 六白金星：格調・リーダー
      `${name}さん、六白金星のリーダー気質で今日は`,
      `${name}さん、天の気を持つあなたに言うと今日は`,
      `${name}さん、六白らしく高い視点から見ると今日は`,
      `${name}さん、天運を味方にする六白金星、今日は`,
      `${name}さん、六白の品格と決断力で今日は`,
      `${name}さん、天のエネルギーを受ける六白として`,
    ],
    7:[ // 七赤金星：明るく楽しく
      `${name}さん〜！七赤の金運と喜びで今日は`,
      `${name}！輝く七赤金星の今日はね、`,
      `${name}さん、楽しい七赤エネルギー的に今日は`,
      `${name}さん〜、七赤の笑顔と金運パワーで今日は`,
      `${name}！七赤金星の喜びオーラが今日は`,
      `${name}さん、七赤の口才と社交力で今日は`,
    ],
    8:[ // 八白土星：堅実・転換
      `${name}さん、山のような八白の気、今日は`,
      `${name}さん、八白土星の蓄積エネルギーで言うと`,
      `${name}さん、転換の星らしく今日の気の流れは`,
      `${name}さん、八白の山のように動じない力で今日は`,
      `${name}さん、八白土星の変化と蓄積パワーで今日は`,
      `${name}さん、山の頂を目指す八白として今日は`,
    ],
    9:[ // 九紫火星：情熱・直感
      `${name}さん！九紫の炎が今日は`,
      `${name}、直感の星・九紫火星、今日は`,
      `${name}さん、九紫の情熱的なエネルギーで今日は`,
      `${name}さん！九紫火星の輝きが今日は`,
      `${name}、炎のような直感を持つ九紫、今日の気は`,
      `${name}さん、九紫の美意識と感性で今日は`,
    ],
  };

  // ② 宮位置ごとの具体的アドバイス（各6種）
  const PALACE_ADVICE={
    "東南":["縁と出会いに最高の方位。人に連絡して！","信頼関係から嬉しいことが来る日。誠実に動こう。","人脈が広がる気配。SNSや集まりを活用して。","今日の縁は本物。大切にしてね。","遠くの縁も近づく日。返信やメッセージが吉。","旅や移動が良い縁を呼ぶ日。どこかに出かけてみて。"],
    "南":  ["才能と名誉が輝く宮！目立っていい日。","自分を表現することで運が開ける日。発信しよう。","評価される日。得意なことを前に出してみて！","アイデアが輝く日。創造的な活動を大切に。","南の気でセンスが爆上がり。表現・デザイン・発信が吉。","直感でアウトプットする日。考えすぎず感性で動いて。"],
    "西南":["地道な努力が報われる宮。コツコツがキモ。","家族や身近な人との縁が深まる日。","丁寧に、誠実に。それが今日一番の正解。","安定と育みの気。身近な人を大切にする日。","焦らず積み重ねてきたことが報われる日。","今日は実家や家族のことを思う日にしてみて。"],
    "東":  ["行動と新しいスタートの宮！一歩踏み出して。","新鮮なチャレンジが運気を上げる日。","思い立ったら即行動。今日はスタートの気。","東の気で朝の行動が特に吉。早起きがカギ。","新しいこと、初挑戦を恐れない日。","スピードが勝負の日。迷ったら動いてみて。"],
    "中央":["変化と中心の宮。何かが動き始めるかも。","焦らず中心を保って。流れが読める日。","じっくり観察する日。焦らなくていい。","五感を研ぎ澄ませる日。周りの変化に気づいて。","今日は目立たなくていい。内側を磨く日。","大きな転換の予兆がある日。深呼吸して臨んで。"],
    "西":  ["金運と喜びの宮！嬉しいことが来そう。","人との対話が運を引き寄せる日。","楽しむことが一番の運気アップ。今日は笑顔で！","西の気で金運上昇中。嬉しい知らせが来そう。","喜びを分かち合うことで運気がさらに上がる日。","好きなことに没頭するだけで運が味方してくれる日。"],
    "東北":["転換点の宮。立ち止まって見直す日。","変化の兆しあり。受け入れる準備をして。","焦らずに。今日は次のステージへの準備日。","東北の気で蓄積と変化が同時に起きる日。","今日の一歩が未来の大きな変化につながる。","過去の積み重ねが光り始める日。焦らなくて大丈夫。"],
    "北":  ["静かな力が蓄えられる宮。インプット最高。","知恵と洞察が冴える日。考えることが吉。","今日は休養と充電が最優先。しっかり休んで。","一人の時間が宝になる日。内省が運気を高める。","北の静けさの中に、大きな知恵が宿る日。","本を読んだり、学びの時間を作るとgood。"],
    "西北":["指導力と決断の宮。大事な判断はこの日に。","リーダーシップを発揮できる日。前に出よう。","統率力が高まる日。まとめ役になるといい。","天の気が降りてくる日。誠実な行動が吉。","西北の権威の気で、目上の人との縁が深まる日。","大事な決断・契約・申請はこの日に。"],
    "中":  ["今日は中庸な気。穏やかに過ごすのが正解。","焦らずに、いつも通りで大丈夫。","普通が一番の日。無理せずナチュラルに。","いつも通りが最強な日。ありのままで過ごして。","中央の気。流れを観察する日にしてみて。","特別なことしなくていい日。日常を大切に。"],
  };

  // ③ 運勢ランク × 天気五行の掛け合わせで語尾・結び変化（各6種）
  const WEATHER_BONUS={
    match:[ // 天気の五行と相性良い
      "今日の天気もあなたの味方！外に出るといいことありそう✨",
      "天気もいい感じに後押ししてくれてる日。流れに乗って！",
      "空の気もあなたと同調してる。自然の力も借りてみて。",
      "お天気もGood！積極的に外の空気を吸いに行こう。",
      "自然のエネルギーとシンクロしてる日。外へGO！",
      "天気と五行が共鳴してる日。自然の中で過ごすと最高。",
    ],
    clash:[ // 天気が逆の五行
      "天気は少し違う気だけど、室内で集中するといいかも。",
      "外より内側を磨く日。自分の時間を大切に。",
      "今日は天気に逆らわず、自分のペースを守って。",
      "天候が逆の気だけど、そういう日は内省が深まるよ。",
      "室内でのインプットや整理整頓が吉な日。",
      "外の天気と少しズレてるけど、それがかえって集中力を生む日。",
    ],
    neutral:[
      "今日も一日、自分らしく過ごしてね！",
      "気の流れを意識しながら、丁寧に一日を。",
      "焦らず、自分のリズムで動いていこう。",
      "今日も宇宙の流れを感じながら、一歩一歩ね。",
      "どんな日も気の学びがある。今日も楽しんでいこう！",
      "シンプルに、正直に、一日を大切にしてね。",
    ],
  };

  // 天気との相性判定
  const GEN_MAP={水:"木",木:"火",火:"土",土:"金",金:"水"};
  const OVC_MAP={水:"火",木:"土",火:"金",土:"水",金:"木"};
  let wxKey="neutral";
  if(weatherElem){
    if(GEN_MAP[weatherElem]===elem||GEN_MAP[elem]===weatherElem)wxKey="match";
    else if(OVC_MAP[weatherElem]===elem||OVC_MAP[elem]===weatherElem)wxKey="clash";
    else if(weatherElem===elem)wxKey="match";
  }

  // ④ ランク別メインメッセージ（各5種）
  const PA=PALACE_ADVICE[palaceName]||PALACE_ADVICE["中"];
  const p0=PA[seed%PA.length];
  const p1=PA[(seed+7)%PA.length];
  const p2=PA[(seed+13)%PA.length];
  const RANK_MAIN={
    "最高":[
      `最高潮に達してる！${p0} 今日は全力で動いて、後悔ゼロの一日にしちゃって！`,
      `マジで今日は来てるよ！${p1} 勝負かけるなら絶対今日。全力でいこ！`,
      `${palaceName}宮に入って全力全開の日！${p0} 思い切った行動が最高の結果を呼ぶ。`,
      `今日の気、最強クラス！${p2} チャンスは逃さないで。自信を持って進んで。`,
      `宇宙が今日のあなたを後押ししてる！${p1} 大きな夢に向かって動いていい日。`,
    ],
    "大吉":[
      `大吉！今日は天運が味方してる。${p0} 全力でいこう！`,
      `${palaceName}宮で大吉。こんな日はとにかく動くに限る！${p1}`,
      `大吉の日はやっぱり行動あるのみ！${p2} 躊躇なく進んで。`,
      `今日は大吉。何を始めても吉の気が後押しする。${p0}`,
      `運気が最高潮！${p1} 思い描いてたことを今日やってみて。`,
    ],
    "吉":[
      `いい感じに運気が来てる！${p0} 積極的に動くといいよ〜`,
      `${palaceName}宮に位置して、ちゃんと運気来てるよ。${p1}`,
      `今日は吉！${p0} 大事な連絡とか、前向きな行動するといいタイミング。`,
      `吉の日。小さな一歩が大きな変化につながる日。${p2}`,
      `今日の気は上昇中！${p1} 気持ちよく行動して。`,
    ],
    "中吉":[
      `穏やかないい日。${p0} 焦らずマイペースでいこ。`,
      `${palaceName}宮で中吉。悪くないよ！${p1}`,
      `地道にやってる事が報われる感じの日。${p0}`,
      `中吉の穏やかな気。コツコツが一番輝く日。${p2}`,
      `ゆっくりでも確実に前進できる日。${p1} 丁寧に動いてね。`,
    ],
    "小吉":[
      `今日は小吉。可もなく不可もなくだけど、${p0} 誠実に動けば大丈夫。`,
      `${palaceName}宮で小吉。派手じゃなくていい、${p1}`,
      `地味にいい日。目立たなくていい。${p0}`,
      `小吉の日は無理せず、でも確実に。${p2}`,
      `今日は小さな幸せを大切にする日。${p1} それが一番の開運。`,
    ],
    "注意":[
      `今日ちょっと注意な日。${p0} 無理しないで、決断は明日以降でOK！`,
      `${palaceName}宮で少し不安定。体調と気分優先で、無理せずいこ〜。`,
      `守りの日。新しいこと始めるより、今あるものを大切にする感じで。${p1}`,
      `今日はスローダウンのサイン。焦らず、慎重に。${p2}`,
      `注意の気。言葉や行動は丁寧に。あとで振り返ると大切な日になるよ。`,
    ],
    "凶":[
      `今日はちょっとしんどい日かも。でも大丈夫、嵐は必ず過ぎる！今日は休んで充電しよ。${p0}`,
      `${palaceName}宮、凶日だけど落ち込まないで。じっとしてるのが正解な日もあるから！`,
      `今日は無理しないで！大きな決断・行動はお休み。自分を労わる日にして。`,
      `凶の日は、次の大吉への充電期間。今日は流れに身を任せて。`,
      `しんどい日こそ、優しく自分に接してね。嵐の後は必ず晴れるから。`,
    ],
    "大凶":[
      `今日は超守りの日！何もしないのが一番の正解かも。ゆっくり休んで、また明日ね。`,
      `${palaceName}宮で大凶…こういう日は流れに逆らわないで。静かにいこ！嵐の後は必ず晴れるから。`,
      `今日だけは全部後回しにしていい日。安全第一で過ごして！明日また全力でいこう。`,
      `大凶の日は動かないが正解。体を休め、心を落ち着けることが最大の開運。`,
      `今日は「何もしない」を選んで。そのことがのちの大きな飛躍につながるよ。`,
    ],
    "変化":[
      `変化のエネルギーが強い日！何か予想外のことが起きるかも。${p0} 焦らず受け入れて。`,
      `${palaceName}宮で変化の日。いつもと違う選択してみると面白い展開になるかも！`,
      `転換点の気配。${p1} 変化を恐れずにね。`,
      `今日は何かが大きく動く日。流れに乗ることが大吉。${p2}`,
      `変化の日は、新しい自分への扉が開く日。ドキドキしていい！${p0}`,
    ],
    "共鳴":[
      `宇宙と共鳴してる日！直感を信じて行動してみて。${p0}`,
      `${palaceName}宮で共鳴モード。感性がさえてる日だから、アートや音楽も取り入れてみて！`,
      `直感が冴えてる日。${p1} 感じたことをそのまま行動にして。`,
      `今日は感性が宇宙とつながってる。創造的なことを思いっきりやって。${p2}`,
      `共鳴の日は、魂の声を聞く日。静かに自分の内側と対話してみて。`,
    ],
    "養生":[
      `養生の日。頑張りすぎず、体と心をいたわって。${p0}`,
      `${palaceName}宮で養生日。睡眠・食事・休息を大事に。明日への充電日だよ！`,
      `今日はゆったりするのが一番の運気アップ。${p1}`,
      `養生の気。焦らず自分のペースで過ごすのが正解な日。`,
      `今日はセルフケアに専念して。自分を大切にすることが最大の開運行動。`,
    ],
  };

  const rankKey=fortuneRating in RANK_MAIN?fortuneRating:"吉";
  const voice=pick(STAR_VOICE[hs]||STAR_VOICE[1]);
  const mainArr=RANK_MAIN[rankKey];
  const main=mainArr[(seed+17)%mainArr.length];
  const bonusArr=WEATHER_BONUS[wxKey];
  const bonus=bonusArr[(seed+23)%bonusArr.length];

  return`${voice}${main} ${bonus}`;
}



// ═══ 相談履歴タブ ═══
function ConsultHistoryTab({authUser}:{authUser:any}){
  const[history,setHistory]=React.useState([]);
  const[selected,setSelected]=React.useState(null);
  const[loading,setLoading]=React.useState(false);
  const[page,setPage]=React.useState(0);
  const[migrated,setMigrated]=React.useState(false);
  const STAR_NAMES=["","一白水星","二黒土星","三碧木星","四緑木星","五黄土星","六白金星","七赤金星","八白土星","九紫火星"];
  const PAGE_SIZE=10;

  // ── ローカル履歴をSupabaseに移行（初回ログイン時） ──
  const migrateLocalToCloud=React.useCallback(async(uid:string)=>{
    try{
      const local=JSON.parse(localStorage.getItem('ki_consult_history')||'[]');
      if(local.length===0)return;
      const rows=local.map((h:any)=>({
        user_id:uid,
        created_at:h.date||new Date().toISOString(),
        title:h.title||'鑑定',
        type:h.type||'開運',
        star:h.star||null,
        answer:h.answer||'',
      }));
      await supabase.from('consult_history').upsert(rows,{onConflict:'user_id,created_at',ignoreDuplicates:true});
    }catch(e){console.error('migrate error',e);}
  },[]);

  // ── 履歴読み込み ──
  React.useEffect(()=>{
    let cancelled=false;
    async function load(){
      setLoading(true);
      if(authUser?.id){
        // Supabaseから取得
        const{data}=await supabase.from('consult_history')
          .select('*').eq('user_id',authUser.id)
          .order('created_at',{ascending:false}).limit(200);
        if(!cancelled)setHistory(data||[]);
        // 初回のみローカル移行
        const key='ki_history_migrated_'+authUser.id;
        if(!localStorage.getItem(key)&&!migrated){
          await migrateLocalToCloud(authUser.id);
          localStorage.setItem(key,'1');
          setMigrated(true);
          // 移行後に再取得
          const{data:d2}=await supabase.from('consult_history')
            .select('*').eq('user_id',authUser.id)
            .order('created_at',{ascending:false}).limit(200);
          if(!cancelled)setHistory(d2||[]);
        }
      }else{
        // localStorageから取得
        try{const h=JSON.parse(localStorage.getItem('ki_consult_history')||'[]');if(!cancelled)setHistory(h);}catch(e){}
      }
      if(!cancelled)setLoading(false);
    }
    load();
    return()=>{cancelled=true;};
  },[authUser?.id]);

  // ── 削除 ──
  const deleteItem=async(id:any)=>{
    if(authUser?.id){
      await supabase.from('consult_history').delete().eq('id',id).eq('user_id',authUser.id);
    }else{
      const next=(history as any[]).filter((h:any)=>h.id!==id);
      localStorage.setItem('ki_consult_history',JSON.stringify(next));
    }
    setHistory(prev=>(prev as any[]).filter((h:any)=>h.id!==id));
    if((selected as any)?.id===id)setSelected(null);
  };

  const getDate=(h:any)=>h.created_at||h.date||'';
  const getId=(h:any)=>h.id;

  const totalPages=Math.ceil((history as any[]).length/PAGE_SIZE);
  const pageItems=(history as any[]).slice(page*PAGE_SIZE,(page+1)*PAGE_SIZE);

  if(selected){
    const sel=selected as any;
    const d=new Date(getDate(sel));
    const dateStr=d.getFullYear()+"年"+(d.getMonth()+1)+"月"+d.getDate()+"日 "+d.getHours()+":"+String(d.getMinutes()).padStart(2,"0");
    return(
      <div style={{maxWidth:"900px",margin:"0 auto",padding:"14px",animation:"fadeIn 0.3s"}}>
        <button onClick={()=>setSelected(null)} style={{background:"none",border:"none",cursor:"pointer",fontSize:"14px",color:"#6b7280",marginBottom:"12px",display:"flex",alignItems:"center",gap:"6px"}}>← 履歴一覧に戻る</button>
        <div style={{background:"white",borderRadius:"14px",border:"1px solid #f3f4f6",padding:"16px",boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"12px"}}>
            <div>
              <div style={{fontSize:"12px",color:"#9ca3af",marginBottom:"4px"}}>{dateStr}</div>
              <div style={{fontSize:"17px",fontWeight:"bold",color:"#1f2937",fontFamily:"serif"}}>{sel.title}</div>
              <div style={{fontSize:"12px",color:sel.type==="開運"?"#d97706":"#2563eb",marginTop:"4px",fontWeight:"bold"}}>{sel.type==="開運"?"✨ 開運相談":"⚡ 勝負相談"}</div>
            </div>
            <button onClick={()=>deleteItem(getId(sel))} style={{padding:"6px 10px",background:"#fef2f2",border:"1px solid #fca5a5",borderRadius:"8px",fontSize:"12px",color:"#dc2626",cursor:"pointer"}}>削除</button>
          </div>
          <div style={{borderTop:"1px solid #f3f4f6",paddingTop:"14px"}}>
            {(()=>{
              const ans=sel.answer||'';
              const secs2:{[k:string]:string}={};
              const parts2=ans.split(/【(.+?)】/);
              for(let i=1;i<parts2.length;i+=2)secs2[parts2[i]]=(parts2[i+1]||'').trim();
              const isBattle=sel.type==='勝負';
              if(Object.keys(secs2).length===0){
                return <div style={{fontSize:"13px",color:"#374151",lineHeight:2.0,whiteSpace:"pre-wrap"}}>{ans}</div>;
              }
              const battleSections=[
                {key:'古語',icon:'✦',label:'式神の言葉',bg:'linear-gradient(135deg,#1a0a0e,#0a1a0a)',color:'#fef3c7',titleColor:'#d4a017'},
                {key:'六爻占術の判定',icon:'🎯',label:'六爻占術の判定',bg:'linear-gradient(135deg,#0d0a1a,#1a1040)',color:'#e2e8f0',titleColor:'#c4b5fd'},
                {key:'六爻占術の解釈',icon:'☯',label:'六爻占術の解釈',bg:'white',color:'#374151',titleColor:'#4c1d95'},
                {key:'九星気学の補強',icon:'🌟',label:'九星気学の補強',bg:'white',color:'#374151',titleColor:'#1d4ed8'},
                {key:'九星気学の判断',icon:'🌟',label:'九星気学の判断',bg:'white',color:'#374151',titleColor:'#1d4ed8'},
                {key:'時盤・方位の吉凶',icon:'🧭',label:'時盤・方位の吉凶',bg:'linear-gradient(135deg,#f0fdf4,#dcfce7)',color:'#14532d',titleColor:'#15803d'},
                {key:'総合判定',icon:'⚔️',label:'総合判定',bg:'linear-gradient(135deg,#fffbeb,#fef3c7)',color:'#1f2937',titleColor:'#92400e'},
                {key:'試合展開予測',icon:'⚽',label:'試合展開予測',bg:'linear-gradient(135deg,#fffbeb,#fef3c7)',color:'#78350f',titleColor:'#92400e'},
                {key:'警告・注意点',icon:'⚠️',label:'警告・注意点',bg:'#fef2f2',color:'#991b1b',titleColor:'#dc2626'},
                {key:'警告',icon:'⚠️',label:'警告',bg:'#fef2f2',color:'#991b1b',titleColor:'#dc2626'},
                {key:'最良のタイミング',icon:'⏰',label:'最良のタイミング',bg:'linear-gradient(135deg,#f0fdf4,#dcfce7)',color:'#374151',titleColor:'#16a34a'},
                {key:'行動指針',icon:'📋',label:'行動指針',bg:'white',color:'#374151',titleColor:'#374151'},
              ];
              const fortuneSections=[
                {key:'古語',icon:'✦',label:'式神の言葉',bg:'linear-gradient(135deg,#1a0a0e,#2a1a0a)',color:'#fef3c7',titleColor:'#b8860b'},
                {key:'鑑定の前提',icon:'📋',label:'鑑定の前提',bg:'#f9fafb',color:'#374151',titleColor:'#374151'},
                {key:'年盤の解釈',icon:'①',label:'年盤の解釈',bg:'white',color:'#374151',titleColor:'#78350f'},
                {key:'月盤の流れ',icon:'②',label:'月盤の流れ',bg:'white',color:'#374151',titleColor:'#78350f'},
                {key:'吉時・吉方位',icon:'③',label:'吉時・吉方位',bg:'#fffbeb',color:'#374151',titleColor:'#d97706'},
                {key:'卦象による現状分析',icon:'④',label:'卦象による現状分析',bg:'#f5f3ff',color:'#374151',titleColor:'#6d28d9'},
                {key:'卦が示す取るべき行動',icon:'⑤',label:'卦が示す取るべき行動',bg:'#f5f3ff',color:'#374151',titleColor:'#6d28d9'},
                {key:'行動計画',icon:'⑥',label:'期限までの行動計画',bg:'linear-gradient(135deg,#f0fdf4,#dcfce7)',color:'#374151',titleColor:'#16a34a'},
                {key:'現代語解説',icon:'📖',label:'現代語での解説',bg:'white',color:'#374151',titleColor:'#78350f'},
                {key:'行動指針',icon:'⭐',label:'具体的な行動指針',bg:'#fffbeb',color:'#374151',titleColor:'#78350f'},
                {key:'最良のタイミング',icon:'⏰',label:'最良のタイミング',bg:'linear-gradient(135deg,#f0fdf4,#dcfce7)',color:'#374151',titleColor:'#16a34a'},
                {key:'吉方位活用法',icon:'🧭',label:'吉方位の活用法',bg:'#fffbeb',color:'#374151',titleColor:'#d97706'},
                {key:'祈祷法',icon:'🙏',label:'祈祷法',bg:'white',color:'#374151',titleColor:'#4c1d95'},
                {key:'今日の開運アクション',icon:'🌟',label:'今日の開運アクション',bg:'white',color:'#374151',titleColor:'#b8860b'},
              ];
              const scoreBlock=ans.includes('【試合情報】')?ans.split('━━━━━━━━━━━━━━━━━━━━━━━━').filter(b=>b.includes('試合情報'))[0]:'';
              return(
                <div>
                  {scoreBlock&&(
                    <div style={{background:"#f0f9ff",borderRadius:"10px",padding:"12px",marginBottom:"12px",border:"1px solid #bae6fd",fontSize:"12px",color:"#374151",lineHeight:1.8,whiteSpace:"pre-wrap"}}>{scoreBlock.trim()}</div>
                  )}
                  {(isBattle?battleSections:fortuneSections).map(s=>{
                    const txt=secs2[s.key];
                    if(!txt||txt==='なし')return null;
                    const dominated=s.key==='警告・注意点'||s.key==='警告';
                    return(
                      <div key={s.key} style={{background:s.bg,borderRadius:"12px",padding:"14px",marginBottom:"10px",border:dominated?"2px solid #fca5a5":"1px solid rgba(0,0,0,0.06)"}}>
                        <div style={{fontSize:"12px",fontWeight:"bold",color:s.titleColor,marginBottom:"6px"}}>{s.icon} {s.label}</div>
                        <div style={{fontSize:"13px",color:s.color,lineHeight:1.9,whiteSpace:"pre-wrap"}}>{txt}</div>
                      </div>
                    );
                  })}
                </div>
              );
            })()}
          </div>
        </div>
      </div>
    );
  }

  return(
    <div style={{maxWidth:"900px",margin:"0 auto",padding:"14px",animation:"fadeIn 0.3s"}}>
      <div style={{marginBottom:"16px",borderBottom:"0.5px solid #C9A84C55",paddingBottom:"8px"}}>
        <div style={{fontSize:"11px",color:"#9ca3af",letterSpacing:"2px"}}>HISTORY</div>
        <div style={{fontSize:"18px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>相談履歴</div>
        {authUser?.id?(
          <div style={{fontSize:"12px",color:"#059669",marginTop:"4px"}}>☁️ クラウド同期中（複数デバイス対応）</div>
        ):(
          <div style={{fontSize:"12px",color:"#9ca3af",marginTop:"4px",background:"#f9fafb",borderRadius:"8px",padding:"8px 10px"}}>
            💡 ログインすると複数デバイスで履歴が同期されます
          </div>
        )}
      </div>
      {loading?(
        <div style={{textAlign:"center",padding:"40px",color:"#9ca3af"}}>読み込み中...</div>
      ):history.length===0?(
        <div style={{textAlign:"center",padding:"40px 20px",color:"#9ca3af"}}>
          <div style={{fontSize:"32px",marginBottom:"12px"}}>📋</div>
          <div style={{fontSize:"15px"}}>相談履歴がありません</div>
          <div style={{fontSize:"13px",marginTop:"8px"}}>開運・勝負タブで相談すると<br/>ここに記録されます</div>
        </div>
      ):(
        <>
          {pageItems.map((h:any)=>{
            const d=new Date(getDate(h));
            const dateStr=(d.getMonth()+1)+"月"+d.getDate()+"日 "+d.getHours()+":"+String(d.getMinutes()).padStart(2,"0");
            const ans=h.answer||'';
            const secs2:{[k:string]:string}={};
            const parts2=ans.split(/【(.+?)】/);
            for(let i=1;i<parts2.length;i+=2)secs2[parts2[i]]=(parts2[i+1]||'').trim();
            const preview=secs2['総合判定']||secs2['古語']||secs2['現代語解説']||'';
            return(
              <div key={getId(h)} onClick={()=>setSelected(h)} style={{background:"white",borderRadius:"12px",border:"1px solid #f3f4f6",padding:"14px",marginBottom:"10px",cursor:"pointer",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
                <div style={{display:"flex",alignItems:"center",gap:"12px",marginBottom:preview?"8px":"0"}}>
                  <div style={{fontSize:"24px"}}>{h.type==="開運"?"✨":"⚡"}</div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:"12px",color:"#9ca3af",marginBottom:"3px"}}>{dateStr}</div>
                    <div style={{fontSize:"15px",fontWeight:"bold",color:"#1f2937"}}>{h.title}</div>
                    <div style={{fontSize:"12px",color:h.type==="開運"?"#d97706":"#2563eb"}}>{h.type==="開運"?"開運相談":"勝負相談"}{h.star?` · ${STAR_NAMES[h.star]||""}`:""}</div>
                  </div>
                  <div style={{fontSize:"12px",color:"#9ca3af"}}>→</div>
                </div>
                {preview&&(
                  <div style={{fontSize:"12px",color:"#6b7280",lineHeight:1.6,background:"#f9fafb",borderRadius:"8px",padding:"8px 10px",borderLeft:"3px solid "+(h.type==="開運"?"#d97706":"#2563eb")}}>
                    {preview.slice(0,100)}{preview.length>100?'…':''}
                  </div>
                )}
              </div>
            );
          })}
          {totalPages>1&&(
            <div style={{display:"flex",justifyContent:"center",gap:"8px",marginTop:"16px"}}>
              <button onClick={()=>setPage(p=>Math.max(0,p-1))} disabled={page===0} style={{padding:"8px 16px",border:"1px solid #e5e7eb",borderRadius:"8px",background:page===0?"#f9fafb":"white",cursor:page===0?"not-allowed":"pointer",fontSize:"14px"}}>← 前へ</button>
              <span style={{padding:"8px 12px",fontSize:"14px",color:"#6b7280"}}>{page+1} / {totalPages}</span>
              <button onClick={()=>setPage(p=>Math.min(totalPages-1,p+1))} disabled={page===totalPages-1} style={{padding:"8px 16px",border:"1px solid #e5e7eb",borderRadius:"8px",background:page===totalPages-1?"#f9fafb":"white",cursor:page===totalPages-1?"not-allowed":"pointer",fontSize:"14px"}}>次へ →</button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

// ═══ 方位取りの記録タブ ═══
function HouiRecordTab({profile}){
  const[records,setRecords]=React.useState([]);
  const[showForm,setShowForm]=React.useState(false);
  const[form,setForm]=React.useState({date:"",direction:"",destination:"",purpose:"",result:""});
  const DIRS=["北","北東","東","南東","南","南西","西","北西"];

  React.useEffect(()=>{
    try{const r=JSON.parse(localStorage.getItem("ki_houi_records")||"[]");setRecords(r);}catch(e){}
  },[]);

  const saveRecord=()=>{
    if(!form.date||!form.direction)return;
    const next=[{id:Date.now(),...form},...records];
    setRecords(next);
    localStorage.setItem("ki_houi_records",JSON.stringify(next.slice(0,100)));
    setForm({date:"",direction:"",destination:"",purpose:"",result:""});
    setShowForm(false);
  };
  const deleteRecord=(id)=>{
    const next=records.filter(r=>r.id!==id);
    setRecords(next);
    localStorage.setItem("ki_houi_records",JSON.stringify(next));
  };

  return(
    <div style={{maxWidth:"900px",margin:"0 auto",padding:"14px",animation:"fadeIn 0.3s"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"16px",borderBottom:"0.5px solid #C9A84C55",paddingBottom:"8px"}}>
        <div>
          <div style={{fontSize:"11px",color:"#9ca3af",letterSpacing:"2px"}}>DIRECTION LOG</div>
          <div style={{fontSize:"18px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>方位取りの記録</div>
        </div>
        <button onClick={()=>setShowForm(!showForm)} style={{padding:"8px 14px",background:"linear-gradient(135deg,#16a34a,#15803d)",color:"white",border:"none",borderRadius:"10px",fontSize:"13px",cursor:"pointer",fontWeight:"bold"}}>＋ 記録する</button>
      </div>

      {showForm&&(
        <div style={{background:"white",borderRadius:"14px",border:"2px solid #86efac",padding:"16px",marginBottom:"16px",boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
          <div style={{fontSize:"15px",fontWeight:"bold",color:"#166534",marginBottom:"14px"}}>🧭 方位取りを記録</div>
          <div style={{display:"flex",flexDirection:"column",gap:"12px"}}>
            <div><label style={{fontSize:"13px",color:"#6b7280",display:"block",marginBottom:"4px"}}>日付</label>
              <input type="date" value={form.date} onChange={e=>setForm({...form,date:e.target.value})} style={{width:"100%",padding:"10px",borderRadius:"8px",border:"1px solid #e5e7eb",fontSize:"14px",boxSizing:"border-box"}}/></div>
            <div><label style={{fontSize:"13px",color:"#6b7280",display:"block",marginBottom:"4px"}}>方位</label>
              <select value={form.direction} onChange={e=>setForm({...form,direction:e.target.value})} style={{width:"100%",padding:"10px",borderRadius:"8px",border:"1px solid #e5e7eb",fontSize:"14px",appearance:"auto"}}>
                <option value="">選択</option>
                {DIRS.map(d=><option key={d} value={d}>{d}</option>)}
              </select></div>
            <div><label style={{fontSize:"13px",color:"#6b7280",display:"block",marginBottom:"4px"}}>行き先</label>
              <input value={form.destination} onChange={e=>setForm({...form,destination:e.target.value})} placeholder="例：大阪、熱海温泉..." style={{width:"100%",padding:"10px",borderRadius:"8px",border:"1px solid #e5e7eb",fontSize:"14px",boxSizing:"border-box"}}/></div>
            <div><label style={{fontSize:"13px",color:"#6b7280",display:"block",marginBottom:"4px"}}>目的</label>
              <input value={form.purpose} onChange={e=>setForm({...form,purpose:e.target.value})} placeholder="例：仕事運UP、縁結び..." style={{width:"100%",padding:"10px",borderRadius:"8px",border:"1px solid #e5e7eb",fontSize:"14px",boxSizing:"border-box"}}/></div>
            <div><label style={{fontSize:"13px",color:"#6b7280",display:"block",marginBottom:"4px"}}>結果メモ</label>
              <textarea value={form.result} onChange={e=>setForm({...form,result:e.target.value})} placeholder="方位取りの効果・変化・出来事を記録..." rows={3} style={{width:"100%",padding:"10px",borderRadius:"8px",border:"1px solid #e5e7eb",fontSize:"14px",resize:"none",boxSizing:"border-box",fontFamily:"inherit"}}/></div>
            <div style={{display:"flex",gap:"10px"}}>
              <button onClick={saveRecord} style={{flex:1,padding:"12px",background:"linear-gradient(135deg,#16a34a,#15803d)",color:"white",border:"none",borderRadius:"10px",fontSize:"14px",cursor:"pointer",fontWeight:"bold"}}>💾 保存する</button>
              <button onClick={()=>setShowForm(false)} style={{padding:"12px 16px",background:"white",border:"1px solid #e5e7eb",borderRadius:"10px",fontSize:"14px",cursor:"pointer",color:"#6b7280"}}>キャンセル</button>
            </div>
          </div>
        </div>
      )}

      {records.length===0&&!showForm?(
        <div style={{textAlign:"center",padding:"40px 20px",color:"#9ca3af"}}>
          <div style={{fontSize:"32px",marginBottom:"12px"}}>🧭</div>
          <div style={{fontSize:"15px"}}>方位取りの記録がありません</div>
          <div style={{fontSize:"13px",marginTop:"8px"}}>「＋ 記録する」から方位取りの<br/>記録を残しましょう</div>
        </div>
      ):(
        records.map(r=>(
          <div key={r.id} style={{background:"white",borderRadius:"12px",border:"1px solid #f3f4f6",padding:"14px",marginBottom:"10px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"8px"}}>
              <div style={{display:"flex",gap:"10px",alignItems:"center"}}>
                <div style={{fontSize:"22px"}}>🧭</div>
                <div>
                  <div style={{fontSize:"13px",color:"#9ca3af"}}>{r.date}</div>
                  <div style={{fontSize:"15px",fontWeight:"bold",color:"#1f2937"}}>{r.direction}方位 → {r.destination}</div>
                  <div style={{fontSize:"12px",color:"#16a34a"}}>目的：{r.purpose}</div>
                </div>
              </div>
              <button onClick={()=>deleteRecord(r.id)} style={{padding:"4px 8px",background:"#fef2f2",border:"1px solid #fca5a5",borderRadius:"6px",fontSize:"11px",color:"#dc2626",cursor:"pointer"}}>削除</button>
            </div>
            {r.result&&<div style={{fontSize:"13px",color:"#374151",lineHeight:1.8,background:"#f9fafb",borderRadius:"8px",padding:"10px",marginTop:"8px"}}>{r.result}</div>}
          </div>
        ))
      )}
    </div>
  );
}

// ═══ 九星気学カレンダー ═══
function KiCalendarTab({profile,onUnlock,authUser}:{profile:any,onUnlock:any,authUser:any}){
  const[showShareCal,setShowShareCal]=React.useState(false);
  const[shareCalData,setShareCalData]=React.useState(null);
  const[viewYear,setViewYear]=React.useState(new Date().getFullYear());
  const[viewMonth,setViewMonth]=React.useState(new Date().getMonth()+1);
  const[diary,setDiary]=React.useState({});
  const[diaryInput,setDiaryInput]=React.useState("");
  const[selectedDay,setSelectedDay]=React.useState(null);
  const[showSettings,setShowSettings]=React.useState(false);
  const[settings,setSettings]=React.useState({showLucky:true,showSpecial:true,showGraph:false});
  const today=new Date();
  const todayStr=today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate();

  // 日記読み込み：ログイン時はSupabase、未ログイン時はlocalStorage
  React.useEffect(()=>{
    try{const s=JSON.parse(localStorage.getItem("ki_cal_settings")||"{}");if(Object.keys(s).length)setSettings(s);}catch(e){}
  },[]);

  React.useEffect(()=>{
    let cancelled=false;
    async function loadDiary(){
      if(authUser?.id){
        // Supabaseから全件取得してオブジェクトに変換
        const{data}=await supabase.from('diary_entries')
          .select('date_key,memo').eq('user_id',authUser.id);
        if(!cancelled&&data){
          const obj:any={};
          data.forEach((r:any)=>{obj[r.date_key]=r.memo;});
          setDiary(obj);
          // localStorageにキャッシュ
          localStorage.setItem("ki_diary",JSON.stringify(obj));
        }
      }else{
        try{const d=JSON.parse(localStorage.getItem("ki_diary")||"{}");if(!cancelled)setDiary(d);}catch(e){}
      }
    }
    loadDiary();
    return()=>{cancelled=true;};
  },[authUser?.id]);

  const saveDiary=async(dateKey:string,memo:string)=>{
    const next={...diary,[dateKey]:memo};
    setDiary(next);
    localStorage.setItem("ki_diary",JSON.stringify(next));
    if(authUser?.id){
      // Supabaseにupsert（date_key+user_idで一意）
      await supabase.from('diary_entries').upsert(
        {user_id:authUser.id,date_key:dateKey,memo},
        {onConflict:'user_id,date_key'}
      );
    }
  };
  const saveSettings=(s)=>{setSettings(s);localStorage.setItem("ki_cal_settings",JSON.stringify(s));};

  const firstDay=new Date(viewYear,viewMonth-1,1).getDay();
  const daysInMonth=new Date(viewYear,viewMonth,0).getDate();

  const getDayInfo=(y,m,d)=>{
    const dt=new Date(y,m-1,d);
    const dayStar=getDayStar(dt);
    const km=getKiMonthIdx(m,d);
    const kiYear=(km===11||(m===1&&d<6))?y-1:y;
    const yrC=getYearStar(kiYear);
    const moC=getMonthStar(yrC,km);
    const dayS=getStarsFor(dayStar);
    const moS=getStarsFor(moC);
    const hs=profile?.honmeiStar;
    const ts=profile?.tsukimeiStar;
    // 九星気学の吉凶判定
    // 凶方位：五黄殺・暗剣殺・本命殺・本命的殺・月命殺・月命的殺
    const yrS=getStarsFor(yrC);
    let score=5;
    const OPP_IDX=[7,6,3,2,4,8,5,0,1]; // 対冲インデックス
    const REL_SCORE={"相生受":3,"比和":1,"相生生":1,"相剋攻":-1,"相剋受":-2};
    if(hs){
      const g5=dayS.indexOf(5);
      const hPos=dayS.indexOf(hs);
      if(g5!==4&&g5!==-1){
        const opp5=OPP_IDX[g5];
        if(hPos===g5){score-=3;}
        else if(hPos===opp5){score-=3;}
        if(hs===5){score-=2;}
      }
      // ★五行相生相剋による個人化吉凶判定（日盤）
      if(hPos!==-1&&hPos!==4&&hPos!==g5&&hPos!==OPP_IDX[g5]){
        const rel=getStarRel(hs,BASE_POS[hPos]);
        score+=REL_SCORE[rel]||0;
      }
      // ★年盤の影響（±1点）
      const hPosYr=yrS.indexOf(hs);
      if(hPosYr!==-1&&hPosYr!==4){
        const relYr=getStarRel(hs,BASE_POS[hPosYr]);
        if(relYr==="相生受")score+=1;
        else if(relYr==="相剋受")score-=1;
      }
      if(ts){
        const tPos=dayS.indexOf(ts);
        const moG5=moS.indexOf(5);
        if(moG5!==4&&tPos===moG5)score-=2;
        else if(moG5!==4&&tPos===OPP_IDX[moG5])score-=2;
        // ★月命星の五行判定（半重み）
        if(tPos!==-1&&tPos!==4){
          const tRel=getStarRel(ts,BASE_POS[tPos]);
          score+=Math.round((REL_SCORE[tRel]||0)*0.5);
        }
      }
    }
    // プロフィールなしは日盤の中宮星で判断
    if(!hs){
      if(dayStar===5)score=3; // 五黄中宮は注意
      else if([1,9].includes(dayStar))score=6;
      else score=5;
    }
    score=Math.max(1,Math.min(9,score));
    // 理由リスト生成
    const reasons=[];
    const DIR_N=["東南","南","西南","東","中","西","東北","北","西北"];
    if(hs){
      const OPP2=[7,6,3,2,4,8,5,0,1];
      const g5b=dayS.indexOf(5);
      const hPosb=dayS.indexOf(hs);
      const moG5b=moS.indexOf(5);
      const tPosb=ts?dayS.indexOf(ts):-1;
      if(g5b!==4&&g5b!==-1){
        if(hPosb===g5b)reasons.push({type:"凶",text:"本命殺（日盤）"});
        else if(hPosb===OPP2[g5b])reasons.push({type:"凶",text:"暗剣殺（日盤）"});
        if(g5b!==4)reasons.push({type:"注意",text:"五黄殺あり（日盤）"});
      }
      if(moG5b!==4&&moG5b!==-1&&ts){
        if(tPosb===moG5b)reasons.push({type:"凶",text:"月命殺（月盤）"});
        else if(tPosb===OPP2[moG5b])reasons.push({type:"凶",text:"月命的殺（月盤）"});
      }
      // ★五行相生相剋による個人化理由ラベル
      if(hPosb!==-1&&hPosb!==4&&hPosb!==g5b&&hPosb!==OPP2[g5b]){
        const relH=getStarRel(hs,BASE_POS[hPosb]);
        if(relH==="相生受")reasons.push({type:"吉",text:"生気方位・"+DIR_N[hPosb]+"（五行相生・最吉）"});
        else if(relH==="比和")reasons.push({type:"吉",text:"比和方位・"+DIR_N[hPosb]+"（同五行・吉）"});
        else if(relH==="相生生")reasons.push({type:"吉",text:"退気方位・"+DIR_N[hPosb]+"（吉）"});
        else if(relH==="相剋受")reasons.push({type:"凶",text:"殺気方位・"+DIR_N[hPosb]+"（五行相剋）"});
      }
      // ★月命星の五行理由
      if(ts&&tPosb!==-1&&tPosb!==4&&tPosb!==moG5b){
        const relT=getStarRel(ts,BASE_POS[tPosb]);
        if(hPosb===tPosb&&(relT==="相生受"||relT==="比和")){
          reasons.push({type:"吉",text:"⭐二重吉方位・"+DIR_N[tPosb]+"（本命・月命ともに吉）"});
        }else if(relT==="相生受")reasons.push({type:"吉",text:"月命星が生気方位・"+DIR_N[tPosb]});
        else if(relT==="比和")reasons.push({type:"吉",text:"月命星が比和方位・"+DIR_N[tPosb]});
      }
      // ★年盤の影響を理由に追加
      const hPosYr2=yrS.indexOf(hs);
      if(hPosYr2!==-1&&hPosYr2!==4){
        const relYr=getStarRel(hs,BASE_POS[hPosYr2]);
        if(relYr==="相生受")reasons.push({type:"注意",text:"年盤：本命星が生気宮（年運良好）"});
        else if(relYr==="相剋受")reasons.push({type:"注意",text:"年盤：本命星が殺気宮（年運注意）"});
      }
      if(reasons.length===0)reasons.push({type:"普通",text:"特に大きな吉凶なし"});
    }else{
      reasons.push({type:"普通",text:"プロフィール未登録"});
    }
    return{dayStar,moC,yrC,score,reasons};
  };

  const getEmoji=(score)=>{if(score>=8)return"🔴";if(score>=6)return"🟡";if(score<=3)return"⚪";return"🟢";};
  const getColor=(score)=>{if(score>=8)return"#dc2626";if(score>=6)return"#d97706";if(score<=2)return"#9ca3af";return"#16a34a";};

  const prevMonth=()=>{if(viewMonth===1){setViewYear(y=>y-1);setViewMonth(12);}else setViewMonth(m=>m-1);setSelectedDay(null);};
  const nextMonth=()=>{if(viewMonth===12){setViewYear(y=>y+1);setViewMonth(1);}else setViewMonth(m=>m+1);setSelectedDay(null);};

  const STAR_NAMES=["","一白水星","二黒土星","三碧木星","四緑木星","五黄土星","六白金星","七赤金星","八白土星","九紫火星"];
  const LUCKY_ACTIONS={1:"静かな場所での思索・水辺散歩",2:"家事・整理整頓・料理",3:"新しいことを始める・外出",4:"人との交流・SNS発信",5:"内省・慎重な行動",6:"目上の人への連絡・契約",7:"楽しい会食・買い物",8:"不動産・長期計画の検討",9:"芸術活動・自己表現"};

  return(
    <div style={{maxWidth:"900px",margin:"0 auto",padding:"12px",animation:"fadeIn 0.3s"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"16px"}}>
        <div>
          <div style={{fontSize:"11px",color:"#9ca3af",letterSpacing:"2px"}}>KI CALENDAR</div>
          <div style={{fontSize:"18px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>九星気学カレンダー</div>
        </div>
        <button onClick={()=>setShowSettings(!showSettings)} style={{padding:"8px 12px",background:"#f9fafb",border:"1px solid #e5e7eb",borderRadius:"8px",fontSize:"13px",cursor:"pointer",color:"#374151"}}>⚙ 設定</button>
      </div>

      {showSettings&&(
        <div style={{background:"#f9fafb",borderRadius:"12px",border:"1px solid #e5e7eb",padding:"16px",marginBottom:"16px"}}>
          <div style={{fontSize:"14px",fontWeight:"bold",color:"#374151",marginBottom:"12px"}}>表示設定</div>
          {[{key:"showLucky",label:"ラッキーアクション表示"},{key:"showGraph",label:"運勢グラフ表示"}].map(({key,label})=>(
            <label key={key} style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"10px",cursor:"pointer"}}>
              <input type="checkbox" checked={settings[key]} onChange={e=>saveSettings({...settings,[key]:e.target.checked})} style={{width:"16px",height:"16px"}}/>
              <span style={{fontSize:"14px",color:"#374151"}}>{label}</span>
            </label>
          ))}
        </div>
      )}

      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"12px"}}>
        <button onClick={prevMonth} style={{padding:"8px 16px",background:"white",border:"1px solid #e5e7eb",borderRadius:"8px",cursor:"pointer",fontSize:"18px"}}>‹</button>
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:"18px",fontWeight:"bold",color:"#1f2937"}}>{viewYear}年{viewMonth}月</div>
          {profile&&<div style={{fontSize:"12px",color:"#9ca3af"}}>{STAR_NAMES[profile.honmeiStar]}・{STAR_NAMES[profile.tsukimeiStar]}</div>}
        </div>
        <button onClick={nextMonth} style={{padding:"8px 16px",background:"white",border:"1px solid #e5e7eb",borderRadius:"8px",cursor:"pointer",fontSize:"18px"}}>›</button>
      </div>

      <div style={{background:"white",borderRadius:"14px",border:"1px solid #f3f4f6",overflow:"hidden",marginBottom:"16px",boxShadow:"0 1px 4px rgba(0,0,0,0.05)"}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",background:"#f9fafb",borderBottom:"1px solid #f3f4f6"}}>
          {["日","月","火","水","木","金","土"].map((d,i)=>(
            <div key={d} style={{textAlign:"center",padding:"8px 0",fontSize:"12px",fontWeight:"bold",color:i===0?"#dc2626":i===6?"#2563eb":"#6b7280"}}>{d}</div>
          ))}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)"}}>
          {[...Array(firstDay)].map((_,i)=><div key={"e"+i} style={{minHeight:"52px"}}/>)}
          {[...Array(daysInMonth)].map((_,i)=>{
            const d=i+1;
            const dateKey=viewYear+"-"+viewMonth+"-"+d;
            const isToday=dateKey===todayStr;
            const info=getDayInfo(viewYear,viewMonth,d);
            const isSelected=selectedDay===d;
            const dow=new Date(viewYear,viewMonth-1,d).getDay();
            const hasDiary=diary[dateKey];
            return(
              <div key={d} onClick={()=>setSelectedDay(isSelected?null:d)} style={{minHeight:"52px",padding:"4px",border:"1px solid #f9fafb",cursor:"pointer",background:isSelected?"#eff6ff":isToday?"#fffbeb":"white",position:"relative"}}>
                <div style={{fontSize:"13px",fontWeight:isToday?"bold":"normal",color:isToday?"#d97706":dow===0?"#dc2626":dow===6?"#2563eb":"#374151",marginBottom:"1px"}}>{d}</div>
                <div style={{fontSize:"9px",color:STAR_INFO[info.dayStar]?.c||"#6b7280",fontFamily:"serif"}}>{STAR_INFO[info.dayStar]?.k}</div>
                <div style={{fontSize:"10px"}}>{getEmoji(info.score)}</div>
                {hasDiary&&<div style={{position:"absolute",bottom:"2px",right:"3px",width:"5px",height:"5px",background:"#7c3aed",borderRadius:"50%"}}/>}
              </div>
            );
          })}
        </div>
      </div>

      <div style={{display:"flex",gap:"10px",marginBottom:"16px",flexWrap:"wrap"}}>
        {[{e:"🔴",l:"大吉日"},{e:"🟡",l:"吉日"},{e:"🟢",l:"普通"},{e:"⚪",l:"注意日"}].map(({e,l})=>(
          <div key={l} style={{display:"flex",alignItems:"center",gap:"4px",fontSize:"12px",color:"#6b7280"}}><span>{e}</span><span>{l}</span></div>
        ))}
        <div style={{display:"flex",alignItems:"center",gap:"4px",fontSize:"12px",color:"#7c3aed"}}>
          <span style={{width:"6px",height:"6px",background:"#7c3aed",borderRadius:"50%",display:"inline-block"}}/>
          <span>氣日記あり</span>
        </div>
      </div>

      {selectedDay&&(()=>{
        const d=selectedDay;
        const dateKey=viewYear+"-"+viewMonth+"-"+d;
        const info=getDayInfo(viewYear,viewMonth,d);
        const inf=STAR_INFO[info.dayStar];
        const dow=["日","月","火","水","木","金","土"][new Date(viewYear,viewMonth-1,d).getDay()];
        return(
          <div style={{background:"white",borderRadius:"14px",border:"2px solid #e0e7ff",padding:"16px",marginBottom:"16px",boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"12px"}}>
              <div>
                <div style={{fontSize:"16px",fontWeight:"bold",color:"#1f2937"}}>{viewYear}年{viewMonth}月{d}日（{dow}）</div>
                <div style={{fontSize:"13px",color:inf.c,fontFamily:"serif"}}>{inf.name}の日</div>
              </div>
              <div style={{fontSize:"24px"}}>{getEmoji(info.score)}</div>
            </div>
            {/* 吉凶の根拠 */}
            <div style={{marginBottom:"12px"}}>
              <div style={{fontSize:"13px",color:"#374151",fontWeight:"bold",marginBottom:"8px"}}>🔍 今日の九星気学的評価</div>
              {info.reasons&&info.reasons.map((r,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:"8px",padding:"6px 10px",background:r.type==="凶"?"#fef2f2":r.type==="吉"?"#f0fdf4":r.type==="注意"?"#fffbeb":"#f9fafb",borderRadius:"8px",marginBottom:"6px",border:`1px solid ${r.type==="凶"?"#fca5a5":r.type==="吉"?"#86efac":r.type==="注意"?"#fde68a":"#f3f4f6"}`}}>
                  <span style={{fontSize:"14px"}}>{r.type==="凶"?"⚠️":r.type==="吉"?"✦":r.type==="注意"?"🔶":"—"}</span>
                  <span style={{fontSize:"13px",color:r.type==="凶"?"#dc2626":r.type==="吉"?"#16a34a":r.type==="注意"?"#d97706":"#6b7280",fontWeight:"bold"}}>{r.type}</span>
                  <span style={{fontSize:"13px",color:"#374151"}}>{r.text}</span>
                </div>
              ))}
            </div>
            {profile&&settings.showLucky&&(
              <div style={{background:"#f0fdf4",borderRadius:"10px",padding:"12px",marginBottom:"12px",border:"1px solid #86efac"}}>
                <div style={{fontSize:"13px",color:"#166534",fontWeight:"bold",marginBottom:"6px"}}>✦ {profile.name}さんへのラッキーアクション</div>
                <div style={{fontSize:"13px",color:"#1e3a1e",lineHeight:1.8}}>{LUCKY_ACTIONS[info.dayStar]}</div>
              </div>
            )}
            <div style={{borderTop:"1px solid #f3f4f6",paddingTop:"12px"}}>
              <div style={{fontSize:"13px",color:"#6b7280",marginBottom:"8px",fontWeight:"bold"}}>📓 氣日記</div>
              <textarea
                defaultValue={diary[dateKey]||""}
                key={dateKey}
                id={"diary-"+dateKey}
                placeholder="今日の気づき・出来事・体調などを記録..."
                rows={3}
                style={{width:"100%",padding:"10px",borderRadius:"8px",border:"1px solid #e5e7eb",fontSize:"14px",resize:"none",boxSizing:"border-box",fontFamily:"inherit"}}
              />
              <div style={{display:"flex",gap:"8px",marginTop:"8px"}}>
                <button onClick={()=>{
                  const el=document.getElementById("diary-"+dateKey);
                  if(el)saveDiary(dateKey,el.value);
                }} style={{flex:1,padding:"10px 16px",background:"linear-gradient(135deg,#7c3aed,#6d28d9)",color:"white",border:"none",borderRadius:"8px",fontSize:"13px",cursor:"pointer",fontWeight:"bold"}}>
                  💾 保存する
                </button>
                <button onClick={()=>{
                  const[yr,mo,dy]=dateKey.split("-").map(Number);
                  const d=new Date(yr,mo-1,dy);
                  const dc=getDayStar(d);
                  const si=STAR_INFO[dc];
                  const FR=["","中吉","小吉","大吉","変化","注意","大吉","吉","吉","大吉"];
                  setShareCalData({starInfo:si,date:yr+"年"+mo+"月"+dy+"日",message:si?.elem+"の気が流れる日。運勢："+(FR[dc]||"吉")+"。",fortuneRating:FR[dc]||"吉",shareText:"【"+yr+"年"+mo+"月"+dy+"日の気学暦】\n中宮星: "+si?.k+"（"+si?.elem+"）\n運勢: "+(FR[dc]||"吉")+"\n大切な日のご縁と気の流れを\n気ごよみアプリの気学暦で確認しています。\nhttps://kigaku-app.vercel.app"});
                  setShowShareCal(true);
                }} style={{flex:1,padding:"10px 16px",background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",border:"none",borderRadius:"8px",fontSize:"13px",cursor:"pointer",fontWeight:"bold",boxShadow:"0 2px 8px rgba(124,58,237,0.3)"}}>
                  📤 シェア
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {showShareCal&&shareCalData&&<ShareModal type="today" data={{...shareCalData}} onClose={()=>{setShowShareCal(false);setShareCalData(null);}}/>}
      {settings.showGraph&&profile&&(
        <div style={{background:"white",borderRadius:"14px",border:"1px solid #f3f4f6",padding:"16px",marginBottom:"16px"}}>
          <div style={{fontSize:"14px",fontWeight:"bold",color:"#374151",marginBottom:"12px"}}>📊 今月の運勢グラフ</div>
          <div style={{display:"flex",alignItems:"flex-end",gap:"2px",height:"60px"}}>
            {[...Array(daysInMonth)].map((_,i)=>{
              const info=getDayInfo(viewYear,viewMonth,i+1);
              const h=Math.round(info.score*6);
              return<div key={i} style={{flex:1,height:h+"px",background:getColor(info.score),borderRadius:"2px 2px 0 0",opacity:0.8}}/>;
            })}
          </div>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:"10px",color:"#9ca3af",marginTop:"4px"}}>
            <span>1</span><span>{Math.round(daysInMonth/2)}</span><span>{daysInMonth}</span>
          </div>
        </div>
      )}
    </div>
  );
}

function TodayTab({profile,isPremium,onUnlock,onUpdateLocation}:{profile:any,isPremium:any,onUnlock:any,onUpdateLocation?:(id:string,location:string)=>any}){
  // 日付変化検知：バックグラウンドから復帰した時・日付が変わった時に再レンダリング
  const makeDateKey=(d:Date)=>d.getFullYear()+'-'+(d.getMonth()+1)+'-'+d.getDate();
  const[dateKey,setDateKey]=React.useState(()=>makeDateKey(new Date()));
  React.useEffect(()=>{
    const check=()=>{const k=makeDateKey(new Date());setDateKey(prev=>prev!==k?k:prev);};
    const onVisible=()=>{if(document.visibilityState==='visible')check();};
    document.addEventListener('visibilitychange',onVisible);
    const timer=setInterval(check,60000); // 1分ごとにチェック
    return()=>{document.removeEventListener('visibilitychange',onVisible);clearInterval(timer);};
  },[]);
  const today=new Date();
  const yr=today.getFullYear(),mo=today.getMonth()+1,dy=today.getDate();
  const dow=["日","月","火","水","木","金","土"][today.getDay()];
  const km=getKiMonthIdx(mo,dy);
  const kiYear=(km===11||(mo===1&&dy<6))?yr-1:yr;
  const yrC=getYearStar(kiYear),moC=getMonthStar(yrC,km),dayC=getDayStar(today);
  const yrS=getStarsFor(yrC),moS=getStarsFor(moC),dayS=getStarsFor(dayC);
  const hs=profile?profile.honmeiStar:null;
  const STAR_NAMES=["","一白水星","二黒土星","三碧木星","四緑木星","五黄土星","六白金星","七赤金星","八白土星","九紫火星"];
  const STAR_COLORS=["","#1d4ed8","#78350f","#15803d","#16a34a","#92400e","#374151","#b91c1c","#44403c","#dc2626"];
  const LUCKY_COLORS={1:["白","紺","銀"],2:["黄","茶","黒"],3:["緑","青","金"],4:["緑","青","白"],5:["黄","茶","金"],6:["白","銀","金"],7:["赤","ピンク","金"],8:["白","黄","茶"],9:["紫","赤","オレンジ"]};
  const LUCKY_FOODS={1:["魚","豆腐","昆布"],2:["根菜","味噌","芋"],3:["青菜","酢の物","柑橘"],4:["そば","パスタ","ハーブ"],5:["梅","発酵食品","土物"],6:["鶏肉","白米","梨"],7:["スイーツ","果物","酒"],8:["山菜","きのこ","豆"],9:["トマト","赤身肉","辛いもの"]};
  const WORK={1:"対人関係・コミュニケーションに吉の日。会議・交渉は午前中が最高の好機。情報収集や資料整理にも向いており、人との縁が新しいビジネスチャンスをもたらします。柔軟な思考で変化に対応することが成功の鍵。",2:"コツコツ積み上げる地道な作業に最適な日。チームワークを大切にすることで大きな成果が出やすい。サポート役に徹することで周囲からの信頼が厚まります。完成度を高める仕上げ作業や整理整頓にも吉。",3:"新規提案・プレゼン・企画立案に最適な日。行動力が最大に高まり、スピーディーな決断が吉と出ます。新しいプロジェクトのスタートや初回の挨拶・営業訪問に最高の日。アイデアを即座に行動に移すことで道が開けます。",4:"縁をつなぐ仕事に大吉の日。遠方との連絡・出張・オンライン会議に好機。信頼関係を築く商談や、紹介・口コミによる新規開拓が実を結びやすい。SNS発信やメール連絡も効果的に届く日。",5:"大局的な判断が求められる重要な日。慎重さと決断力を同時に持つことが大切。大きな変化の予兆がある日なので、状況をよく観察してから動くことが賢明。重要な決定は熟慮の上で行いましょう。",6:"リーダーシップを発揮する絶好の好機。権威ある人・目上の方との面談や重要な契約に吉。品格と誠実さが信頼を集め、大きなビジネスチャンスを引き寄せます。公的な手続きや申請事項も吉日。",7:"商談・営業・プレゼン・接客に最適な日。口才と発信力が最高に冴え、言葉が相手の心に届きます。楽しい雰囲気を作ることで商談がまとまりやすい。飲食を共にした席での話し合いも吉。",8:"基盤を固める作業・整理整頓・計画立案に吉の日。不動産・資産運用・長期プロジェクトの検討に好機。今日の準備と積み重ねが将来の大きな成果につながります。焦らずじっくり取り組むことが吉。",9:"直感が研ぎ澄まされた特別な日。クリエイティブな仕事・発表・プレゼン・デザイン作業に最適。芸術的感性が高まり、独創的なアイデアが生まれやすい。人前に出て自分を表現することで大きなチャンスが訪れます。"};
  const LOVE={1:"縁が深まる特別な日。新しい出会いに大きな期待が持てます。気になる人への連絡・メッセージが吉。水辺や静かな場所でのデートが縁を深めます。感情を正直に伝えることで心の距離が縮まる日。",2:"じっくり向き合う時間を大切にすることで深い絆が育まれます。家庭的な雰囲気・手料理・家での時間が愛情を育みます。パートナーへの細やかな気遣いが関係を安定させます。",3:"積極的なアプローチが大きな吉。行動力が縁を呼び込みます。デートの計画を立てると好展開が期待できます。新しい場所・初めての体験を共にすることで関係が一気に深まります。",4:"遠距離の縁が近づく特別な日。SNSや手紙でのメッセージが心に届きます。共通の友人を通じた縁や、旅先での出会いに期待。信頼関係を大切にすることが長続きの秘訣です。",5:"感情が高ぶりやすい日なので冷静さを保つことが大切。一歩引いた落ち着いた態度が相手への誠実さを伝えます。感情的な言葉は控え、穏やかなコミュニケーションを心がけて。",6:"誠実さが相手に深く伝わる吉日。真剣な告白・プロポーズ・結婚の話し合いに最適な日。品格ある言動と真摯な姿勢が相手の心を動かします。長期的な関係を見据えた誠実な行動が吉。",7:"楽しい時間を共有することで縁が深まる最高の日。笑顔と明るさが縁を引き寄せます。エンタメ・食事・パーティーなど楽しいシーンで素敵な出会いが。軽やかな会話が相手の心をほぐします。",8:"関係の重要な転換点になりやすい日。素直な気持ちをストレートに伝えることで関係が大きく前進します。長い間温めていた想いを伝える絶好のタイミング。変化を恐れずに行動することが吉。",9:"直感的な出会いと深い縁に期待できる日。美的センスと独特の魅力が輝き、自然と人を引き寄せます。芸術・音楽・文化的な場での出会いに特に吉。自分らしさを表現することが最大の魅力になります。"};
  const HEALTH={1:"腎臓・膀胱・泌尿器系に注意が必要な日。こまめな水分補給を心がけ、冷えを避けることが大切。温かい飲み物や半身浴で体を温めることが吉。耳の不調にも気をつけて。ゆっくりとした入浴でリラックスを。",2:"胃腸・消化器系に特に注意が必要な日。食べ過ぎ・飲み過ぎを避けて規則正しい食生活を心がけましょう。発酵食品・温かいスープが胃腸を整えます。早寝早起きの規則正しい生活リズムが体調を安定させます。",3:"肝臓・神経系・目に注意が必要な日。過度な緊張やストレスを避けてリラックスする時間を意識的に作りましょう。緑の多い場所での散歩や深呼吸が気の流れを整えます。過労・睡眠不足は大敵です。",4:"呼吸器・大腸・腸に注意が必要な日。深呼吸と軽い散歩で気の流れを整えましょう。腸内環境を整える食事（食物繊維・発酵食品）が効果的。鼻・のどのケアも大切です。芳香療法も吉。",5:"全身的に注意が必要な特別な日。無理をせず休養を最優先にしましょう。既存の体の不調が出やすい時期。この日の無理は後に大きく影響することがあります。早めの就寝と十分な睡眠が最高の薬です。",6:"骨・関節・肺に注意が必要な日。正しい姿勢を意識して過ごすことが健康運を高めます。ストレッチや軽い体操で骨格を整えましょう。呼吸を深くすることで肺の気を高めます。白い食材（大根・山芋・豆腐）が吉。",7:"口腔・喉・呼吸器に注意が必要な日。歌うこと・声を出すことで気が活性化します。歯磨き・口腔ケアを丁寧に。甘いものの摂りすぎに注意。楽しく話す時間が免疫力を高めます。",8:"脊椎・関節・筋肉に注意が必要な日。軽いストレッチやウォーキングが体の気の流れを整えます。長時間同じ姿勢は避けて。温かい湿布や入浴で筋肉をほぐしましょう。土に触れることも吉。",9:"心臓・血管・目に注意が必要な日。明るく暖かい場所で過ごすことで活力が湧きます。目の疲れをこまめにケア。情熱的な活動は大吉ですが、過剰な興奮状態は心臓に負担をかけます。赤い食材（トマト・イチゴ）が吉。"};
  const MONEY={1:"臨時収入・思わぬ収入の可能性がある日。情報や知識への投資が将来の大きなリターンをもたらします。水辺や水に関わる場所での出費には注意。流れに乗ったタイミングの良い行動が金運を高めます。",2:"堅実な資産管理・家計管理が最も吉の日。衝動買いを避け、計画的な貯蓄を意識しましょう。食料品・日用品など生活必需品の購入は吉。コツコツした積み立て投資を始めるのにも最適な日です。",3:"投資・新規事業への出資・副業開始に好機の日。スピーディーな判断が吉と出ます。ただし、勢いに任せた大きなリスクは慎重に検討を。小さく始めて大きく育てる戦略が最もうまくいきます。",4:"縁からの収入・紹介・口コミによる収益に期待できる日。遠方や旅行関連の出費が発生しやすいですが、それ以上の収入が返ってきます。人とのつながりを大切にすることが最大の金運アップになります。",5:"大きな金融行動・投資・融資などは今日は慎重に。基本的な収支管理を徹底する日。現状維持を基本に、じっくりと状況を見極めることが吉。堅実な管理が将来の財を守ります。",6:"高品質・高額な買い物に吉の兆しがある日。品質重視の選択が長期的に見て最もコスパの良い選択になります。権威ある機関や信頼できる相手との取引に吉。長期的な契約や定期的な積み立ても好機。",7:"金運が高まる特別な日。お金に関わる交渉・契約・商談に最高の好機。楽しい気持ちで臨む買い物や投資が吉と出ます。西の方角のお店や金融機関との取引が特に吉。",8:"蓄財・資産形成に最適な日。不動産・土地・長期投資の見直しや新規検討に吉。今日始める貯蓄習慣は長続きします。山・高い場所の方角にある金融機関との取引も吉。",9:"センスと直感を活かした投資・購入に吉の日。美しいもの・価値あるものへの出費は資産になります。ただし見栄えや外見だけで判断した衝動的な高額出費には注意。本質的な価値を直感で見極めて。"};

  function StarGrid({stars,centerStar,honmei,size}){
    const POS=[[6,0],[3,0],[0,0],[6,1],[3,1],[0,1],[6,2],[3,2],[0,2]];
    const DIR=["東南","南","西南","東","中","西","東北","北","西北"];
    const cols=STAR_COLORS;
    const names=["","一","二","三","四","五","六","七","八","九"];
    return(
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"2px",width:"100%",maxWidth:"150px",margin:"0 auto",boxSizing:"border-box"}}>
        {stars.map((s,i)=>{
          const isCenter=i===4;
          const isHonmei=honmei&&s===honmei;
          return(
            <div key={i} style={{aspectRatio:"1",background:isCenter?"linear-gradient(135deg,#1f2937,#374151)":isHonmei?"linear-gradient(135deg,"+cols[s]+"dd,"+cols[s]+")":"linear-gradient(135deg,"+cols[s]+"22,"+cols[s]+"11)",border:isHonmei?"2px solid "+cols[s]:"1px solid "+cols[s]+"44",borderRadius:"6px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",position:"relative"}}>
              <div style={{fontSize:size?"10px":"9px",color:isCenter?"#9ca3af":cols[s],opacity:0.7}}>{DIR[i]}</div>
              <div style={{fontSize:size?"16px":"14px",fontWeight:"bold",fontFamily:"serif",color:isCenter?"white":isHonmei?"white":cols[s]}}>{names[s]}</div>
              {isHonmei&&<div style={{fontSize:"8px",color:"white"}}>★</div>}
            </div>
          );
        })}
      </div>
    );
  }

  
  const [tenki, setTenki] = React.useState(null);
  const[showShare,setShowShare]=React.useState(false);
  const [charMsg, setCharMsg] = React.useState("");
  const dayPalaceName = ["乾","坎","艮","震","中","巽","離","坤","兌"][dayS.indexOf(hs||dayC)] || "中";
  const fortuneRating = {"乾":"大吉","坎":"中吉","艮":"吉","震":"大吉","中":"変化","巽":"吉","離":"大吉","坤":"中吉","兌":"吉"}[dayPalaceName] || "吉";
  const OVERVIEW = {
    1:"一白水星が日盤の中心に位置する今日は、水の気が全体を流れる特別な日です。縁・知恵・流動のエネルギーが高まり、人との繋がりが重要な意味を持ちます。北の方位に吉の気が集まり、静かな場所での思索や学びが運気を高めます。対人関係においては誠実さが最大の武器となり、積極的なコミュニケーションが新たな縁を引き寄せます。水の気は柔軟性と適応力を与えてくれます。流れに逆らわず、自然の流れに身を委ねることで、最大の成果が得られる日です。午前中の行動が特に吉で、水に関わる場所（海・川・湖）への訪問も運気を高めます。",
    2:"二黒土星が日盤を支配する今日は、大地の気が深い安定をもたらします。忍耐・育成・協調のエネルギーが最高潮に高まる日です。西南の方位に吉の気が集まり、家庭や職場での地道な努力が確実に実を結びます。焦らず丁寧に物事を進めることが今日の運気の流れに完全に合致しています。誰かのために動くことで、自分自身の運気も大きく上昇します。チームワークを大切にした行動が吉で、料理・整理整頓・世話をするなどの行為が特に運気を高めます。土に触れることや、緑のある場所での休息も効果的です。",
    3:"三碧木星の気が今日を力強く満たします。雷のように突破力・行動力・新規開拓のエネルギーが溢れる最高の日です。東の方位が今日の主要な吉方位となり、新しいことへの挑戦が運気を大きく開きます。停滞していたことが一気に動き出す可能性があります。積極的な行動と発言が今日の開運の鍵です。新規プロジェクトの開始・初対面の人との交流・新しい習慣の開始に最適な日です。朝一番の行動が特に吉で、スポーツや体を動かすことでさらに運気が高まります。",
    4:"四緑木星の風のような気が今日を包みます。縁・信頼・調和・遠方とのつながりのエネルギーが最大に高まります。東南の方位が今日の吉方位で、遠方からの良いニュースや思わぬ縁が期待できます。コミュニケーションと信頼関係の構築に最適な日です。SNSや手紙・電話など言葉を通じた縁が広がります。長距離の移動や旅行にも吉の日で、新しい出会いが人生を変えるきっかけになる可能性があります。芳香・香りを取り入れることも運気を高めます。午後からの活動が特に吉です。",
    5:"五黄土星が日盤の中心に位置する今日は、強大な変革と統率のエネルギーが全方位に流れます。大きな力が動く日であり、慎重さと決断力の両方が同時に求められます。今日は特に大きな行動は控えめにし、内側での準備と計画に専念することが吉です。ただし、必要な決断は迷わず行うことも大切です。五黄土星の日は変化の予兆が多く、周囲の動きをよく観察することが重要です。中央・自分自身の軸を整えることに集中し、瞑想や内省の時間を設けると良いでしょう。",
    6:"六白金星の天のエネルギーが今日を高らかに導きます。権威・決断・天運・指導力のエネルギーが最高に高まる吉日です。西北の方位が今日の主要な吉方位となり、リーダーシップを発揮する絶好の場面が訪れます。目上の人からの支援や、重要な決断の場面で最大の力を発揮できる日です。品格ある行動と誠実な姿勢が天運を引き寄せます。公的な場での活動・契約・申請・重要な会議が吉で、白や金色のものを身につけることで運気がさらに高まります。",
    7:"七赤金星の喜びのエネルギーが今日を包み込みます。財運・喜び・口才・社交のエネルギーが最高潮に高まる特別な日です。西の方位が今日の吉方位で、金運と対人運が共に大きく上昇します。商談・営業・交渉・プレゼンに最適な日であり、楽しい会話や笑顔が縁を引き寄せます。飲食を共にすることで人間関係が深まり、新たなビジネスチャンスも生まれます。エンターテインメント・美食・音楽・カラオケなど楽しいことに積極的に参加することで運気が高まります。赤やピンクのものを取り入れると吉です。",
    8:"八白土星の山のエネルギーが今日をしっかりと支えます。転換・蓄積・不動・変化のエネルギーが流れる非常に重要な日です。東北の方位が今日の吉方位で、変化への備えと基盤固めに最適です。今日の努力と準備が将来の大きな財産となります。不動産・資産・長期的な計画について考える良い機会です。山や丘など高い場所への訪問が運気を高め、古いものを大切にすることも吉です。静かな環境での熟慮と決断が、長期的な成功への道を開きます。",
    9:"九紫火星の輝きが今日を鮮やかに照らします。直感・名誉・美・創造性のエネルギーが最高潮に達する素晴らしい日です。南の方位が今日の吉方位で、才能と個性が力強い輝きを放ちます。芸術・発信・表現活動・パフォーマンスに最適な日であり、あなたの直感を信じた行動が最高の結果をもたらします。人前に出ること・発表すること・目立つことが吉で、注目されることで運気がさらに高まります。赤・紫・オレンジのものを取り入れ、明るい場所で過ごすことで活力が最大化します。"
  };

  // 位置：端末の現在地 → プロフィールの地域（固定都市へのフォールバックはしない）
  const userLoc=useUserLocation(profile?.location);
  React.useEffect(()=>{
    if(!userLoc){setTenki(null);return;}
    const{lat,lng}=userLoc;
    async function fetchWeather(){
      try{
        const res=await fetch("https://api.open-meteo.com/v1/forecast?latitude="+lat+"&longitude="+lng+"&current_weather=true");
        const data=await res.json();
        if(data.current_weather){
          const code=data.current_weather.weathercode;
          const elem=WX_ELEM[code]||"土";
          const desc=WX_DESC[code]||"曇り";
          setTenki({code,elem,desc,temp:Math.round(data.current_weather.temperature)});
        }
      }catch(e){}
    }
    fetchWeather();
  },[userLoc?.lat,userLoc?.lng,dateKey]);
  // プロフィール・天気変化時にcharMsgを更新（依存配列にhsを含む）
  React.useEffect(()=>{
    if(!hs||!profile)return;
    const elem=tenki?.elem||"土";
    const msg=getDailyCharMsg(profile.name||"あなた",hs,S_ELEM[hs],fortuneRating,dayPalaceName,elem,today);
    setCharMsg(msg);
  },[hs,tenki?.elem,fortuneRating,dayPalaceName,dateKey]);
const dcColors=STAR_COLORS[dayC];
  const elemName={1:"水",2:"土",3:"木",4:"木",5:"土",6:"金",7:"金",8:"土",9:"火"}[dayC]||"土";
  const lc=LUCKY_COLORS[dayC]||["白"];
  const lf=LUCKY_FOODS[dayC]||["野菜"];

  return(
    <div style={{maxWidth:"900px",margin:"0 auto",padding:"14px",animation:"fadeIn 0.3s"}}>

      {/* 地域が未登録のプロフィールには登録をお願いする */}
      {/* （登録済みでも地名から場所を特定できず、現在地も取れない場合も表示） */}
      {profile&&onUpdateLocation&&(!String(profile.location||'').trim()||userLoc===null)&&(
        <div id="region-prompt">
          <RegionPrompt name={profile.name} current={String(profile.location||'').trim()} onSave={(loc)=>onUpdateLocation(profile.id,loc)}/>
        </div>
      )}

      {/* 入口：直感に従う／開運で相談する */}
      <div style={{marginBottom:"20px",display:"flex",flexDirection:"column",gap:"8px"}}>
        <button onClick={()=>window.dispatchEvent(new CustomEvent('navigate-tab',{detail:'intuition'}))} style={{width:"100%",minHeight:"64px",padding:"16px",borderRadius:"16px",border:"none",background:"linear-gradient(135deg,#f59e0b,#d97706)",color:"white",fontSize:"20px",fontWeight:"bold",fontFamily:"serif",letterSpacing:"2px",cursor:"pointer",boxShadow:"0 4px 16px rgba(217,119,6,0.3)"}}>
          🌿 直感に従う
          <div style={{fontSize:"13px",fontWeight:"normal",letterSpacing:"0",opacity:0.9,marginTop:"2px"}}>何をしようかな、と思ったら</div>
        </button>
        <button onClick={()=>window.dispatchEvent(new CustomEvent('navigate-tab',{detail:'fortune'}))} style={{width:"100%",minHeight:"48px",padding:"12px",borderRadius:"14px",border:"1px solid #fde68a",background:"white",color:"#78350f",fontSize:"15px",fontWeight:"bold",fontFamily:"serif",cursor:"pointer"}}>
          ✨ 開運で相談する（自分を占う／他の人を占う）
        </button>
      </div>

      {/* ① 今日の運気 */}
      <div style={{marginBottom:"24px"}}>
        <div style={{display:"flex",alignItems:"center",gap:"8px",marginBottom:"12px",borderBottom:"0.5px solid #C9A84C55",paddingBottom:"8px"}}>
          <div style={{width:"4px",height:"20px",background:"linear-gradient(#d97706,#92400e)",borderRadius:"2px"}}/>
          <div style={{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#78350f"}}>今日の運気</div>
          <div style={{fontSize:"16px",color:"#d97706",fontWeight:"bold",fontFamily:"serif"}}>{yr}年{mo}月{dy}日（{dow}）</div>
        </div>

        {charMsg&&(
          <div style={{background:"linear-gradient(135deg,#fffbeb,#fef3c7)",borderRadius:"12px",border:"1px solid #fde68a",padding:"14px",marginBottom:"12px",display:"flex",gap:"12px",alignItems:"flex-start"}}>
            <div style={{width:"52px",height:"52px",flexShrink:0}} dangerouslySetInnerHTML={{__html:STAR_CHARS[dayC]||STAR_CHARS[1]}}/>
            <div>
              <div style={{fontSize:"17px",color:"#92400e",fontWeight:"bold",letterSpacing:"1px",marginBottom:"8px"}}>✨ 今日のひとこと</div>
              <div style={{fontSize:"16px",color:"#78350f",lineHeight:2.0,fontWeight:"bold"}}>{charMsg}</div>
            </div>
          </div>
        )}

        {tenki&&(()=>{
          const isRain=tenki.desc.includes("雨");const isSnow=tenki.desc.includes("雪");const isSun=tenki.desc.includes("晴");
          const wxIcon=isRain?"🌧️":isSnow?"❄️":isSun?"☀️":"⛅";
          const wxBg=isRain?"linear-gradient(135deg,#dbeafe,#bfdbfe)":isSnow?"linear-gradient(135deg,#f0f9ff,#e0f2fe)":isSun?"linear-gradient(135deg,#fef9c3,#fde68a)":"linear-gradient(135deg,#f1f5f9,#e2e8f0)";
          const wxBorder=isRain?"#93c5fd":isSnow?"#7dd3fc":isSun?"#fcd34d":"#cbd5e1";
          const wxTc=isRain?"#1e40af":isSnow?"#0369a1":isSun?"#92400e":"#475569";
          return(<div style={{background:wxBg,borderRadius:"14px",border:"2px solid "+wxBorder,padding:"14px",marginBottom:"14px",display:"flex",gap:"12px",alignItems:"center"}}>
            <div style={{fontSize:"40px"}}>{wxIcon}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:"16px",fontWeight:"bold",color:wxTc,marginBottom:"4px"}}>{tenki.desc.split(" ")[0]}　{tenki.temp}°C</div>
              <div style={{fontSize:"13px",color:wxTc,lineHeight:1.7,opacity:0.9}}>{WX_KI_MSG[tenki.elem]}</div>
            </div>
          </div>);
        })()}

        {/* 今日の宇宙のひとこと */}
        <CosmosCard dateKey={dateKey} loc={userLoc} onOpen={()=>window.dispatchEvent(new CustomEvent('navigate-tab',{detail:'cosmos'}))}/>

        <div style={{background:"white",borderRadius:"12px",border:"1px solid #f3f4f6",padding:"14px",marginBottom:"12px"}}>
          <div style={{fontSize:"17px",fontWeight:"bold",color:"#92400e",marginBottom:"12px",letterSpacing:"1px"}}>📖 今日の気の流れ・全体解説</div>
          <div style={{fontSize:"13px",color:"#374151",lineHeight:1.9}}>{OVERVIEW[dayC]}</div>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr",gap:"8px",marginBottom:"12px"}}>
          {/* 日盤 */}
          <div style={{background:"white",borderRadius:"14px",border:"2px solid "+dcColors+"66",padding:"14px",boxShadow:"0 2px 8px rgba(0,0,0,0.08)"}}>
            <div style={{fontSize:"14px",color:dcColors,fontWeight:"bold",textAlign:"center",marginBottom:"10px"}}>今日の日盤｜中宮：{STAR_NAMES[dayC]}</div>
            <MiniGrid stars={dayS} hl={hs} title="" center={dayC}/>
          </div>
          {/* 今日の運気サマリー */}
          <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
            <div style={{background:"linear-gradient(135deg,"+dcColors+","+dcColors+"bb)",borderRadius:"12px",padding:"14px",textAlign:"center"}}>
              <div style={{fontSize:"13px",color:"#374151",marginBottom:"4px"}}>今日の主星</div>
              <div style={{fontSize:"18px",fontWeight:"bold",color:"white",fontFamily:"serif"}}>{STAR_NAMES[dayC]}</div>
            </div>
            {(()=>{
              const _ds2=getStarsFor(dayC);
              const _D=["東南","南","西南","東","中","西","東北","北","西北"];
              const _O=[2,1,0,5,4,3,8,7,6];
              const gk=[],ak=[];
              _ds2.forEach((s,i)=>{if(i!==4&&s===5){gk.push(_D[i]);ak.push(_D[_O[i]]);}});
              const BP3=[6,1,8,7,5,3,2,9,4];
              const RL3={"相生受":"生気・最吉","比和":"比和・吉","相生生":"退気・吉","相剋攻":"殺気・注意","相剋受":"殺気・凶"};
              const hl=[],hlRel=[],_hIdx=[];
              const tmHL=[],tmRel=[],_tIdx=[];
              if(profile){
                _ds2.forEach((s,i)=>{if(i!==4&&s===profile.honmeiStar){hl.push(_D[i]);hlRel.push(getStarRel(profile.honmeiStar,BP3[i]));_hIdx.push(i);}});
                if(profile.tsukimeiStar)_ds2.forEach((s,i)=>{if(i!==4&&s===profile.tsukimeiStar){tmHL.push(_D[i]);tmRel.push(getStarRel(profile.tsukimeiStar,BP3[i]));_tIdx.push(i);}});
              }
              const _hTeki=_hIdx.length>0?_D[_O[_hIdx[0]]]:null;
              const _tTeki=_tIdx.length>0?_D[_O[_tIdx[0]]]:null;
              const hRelGood=["相生受","比和","相生生"].includes(hlRel[0]);
              const tRelGood=["相生受","比和"].includes(tmRel[0]);
              const isDouble=hl.length>0&&tmHL.length>0&&hl[0]===tmHL[0]&&hRelGood&&tRelGood;
              return(<>
                {hl.length>0&&(
                  <div style={{background:isDouble?"linear-gradient(135deg,#fffbeb,#fef3c7)":"#fffbeb",borderRadius:"12px",border:isDouble?"2px solid #f59e0b":"1px solid #fde68a",padding:"12px",marginBottom:"8px"}}>
                    {isDouble&&<div style={{fontSize:"12px",fontWeight:"bold",color:"#b45309",marginBottom:"4px",textAlign:"center",letterSpacing:"1px"}}>⭐⭐ 二重吉方位 ⭐⭐</div>}
                    <div style={{fontSize:"14px",fontWeight:"bold",color:"#d97706",marginBottom:"4px"}}>{isDouble?"🌟 本命星・月命星ともに吉方位":"⭐ あなたの吉方位（本命星）"}</div>
                    <div style={{fontSize:"16px",color:"#78350f",fontWeight:"bold",marginBottom:"4px"}}>{hl.join("・")}方位</div>
                    {hlRel[0]&&<div style={{fontSize:"12px",color:hRelGood?"#16a34a":"#dc2626",fontWeight:"bold",marginBottom:"2px"}}>本命星：{RL3[hlRel[0]]||hlRel[0]}</div>}
                    {tmHL.length>0&&!isDouble&&<div style={{fontSize:"12px",color:tRelGood?"#16a34a":"#6b7280",marginBottom:"2px"}}>月命星({tmHL[0]}方位)：{RL3[tmRel[0]]||tmRel[0]}</div>}
                    {isDouble&&<div style={{fontSize:"12px",color:"#16a34a",marginBottom:"2px"}}>月命星：{RL3[tmRel[0]]||tmRel[0]}</div>}
                    <div style={{fontSize:"11px",color:"#92400e",marginTop:"4px"}}>{isDouble?"本命星・月命星の双方が吉方向。今日最強の開運方位です":"この方向への外出・旅行が開運につながります"}</div>
                  </div>
                )}
                {!hl.length&&tmHL.length>0&&tRelGood&&(
                  <div style={{background:"#f0fdf4",borderRadius:"12px",border:"1px solid #86efac",padding:"12px",marginBottom:"8px"}}>
                    <div style={{fontSize:"14px",fontWeight:"bold",color:"#16a34a",marginBottom:"4px"}}>🌙 月命星の吉方位</div>
                    <div style={{fontSize:"14px",color:"#166534",fontWeight:"bold",marginBottom:"2px"}}>{tmHL.join("・")}方位</div>
                    <div style={{fontSize:"12px",color:"#16a34a"}}>{RL3[tmRel[0]]||tmRel[0]}</div>
                  </div>
                )}
                {dayC===5?(
                  <div style={{background:"linear-gradient(135deg,#450a0a,#7f1d1d)",borderRadius:"12px",border:"2px solid #dc2626",padding:"16px",marginBottom:"8px",boxShadow:"0 4px 20px rgba(220,38,38,0.35)"}}>
                    <div style={{fontSize:"17px",fontWeight:"bold",color:"#fca5a5",marginBottom:"10px",textAlign:"center",fontFamily:"serif",letterSpacing:"2px"}}>
                      🔴 五黄中宮日（大凶日）
                    </div>
                    <div style={{fontSize:"13px",color:"#fecaca",lineHeight:2.0}}>
                      <div style={{marginBottom:"4px",fontWeight:"bold",color:"white"}}>五黄土星が中宮に入る、最も注意を要する凶日です。</div>
                      <div>・大きな決断・契約・引越しは避ける</div>
                      <div>・新規事業のスタート・手術は控える</div>
                      <div>・重要な移動・旅行は避けることを推奨</div>
                      <div>・静かに内省し、準備・充電に充てる日</div>
                      <div style={{marginTop:"8px",fontSize:"12px",color:"#f87171",borderTop:"1px solid #991b1b",paddingTop:"8px"}}>
                        ※九星気学において最も根拠ある凶日概念。月に1〜2日ほど訪れます。
                      </div>
                    </div>
                  </div>
                ):gk.length>0?(
                  <div style={{background:"#fef2f2",borderRadius:"12px",border:"1px solid #fca5a5",padding:"12px",marginBottom:"8px"}}>
                    <div style={{fontSize:"14px",fontWeight:"bold",color:"#dc2626",marginBottom:"6px"}}>⚠️ 今日の凶方位（要注意）</div>
                    <div style={{fontSize:"13px",color:"#374151",lineHeight:2}}>
                      <div>🔴 五黄殺：<strong style={{color:"#dc2626"}}>{gk.join("・")}方位</strong>（大凶）</div>
                      <div>🔴 暗剣殺：<strong style={{color:"#dc2626"}}>{ak.join("・")}方位</strong>（大凶）</div>
                      <div style={{fontSize:"11px",color:"#6b7280",marginTop:"4px"}}>※ この方向への移動・旅行・引越しは避けましょう</div>
                    </div>
                  </div>
                ):(
                  <div style={{background:"#f0fdf4",borderRadius:"12px",border:"1px solid #86efac",padding:"12px",marginBottom:"8px"}}>
                    <div style={{fontSize:"14px",fontWeight:"bold",color:"#16a34a",marginBottom:"4px"}}>✅ 今日は吉日</div>
                    <div style={{fontSize:"13px",color:"#374151"}}>五黄中宮日・五黄殺・暗剣殺なし。移動・行動に適した吉の日です。</div>
                  </div>
                )}
                {profile&&(_hTeki||_tTeki)&&(
                  <div style={{background:"#fff7ed",borderRadius:"12px",border:"1px solid #fdba74",padding:"12px",marginBottom:"8px"}}>
                    <div style={{fontSize:"13px",fontWeight:"bold",color:"#c2410c",marginBottom:"6px"}}>🚫 あなたの個人凶方位（今日）</div>
                    {_hTeki&&<div style={{fontSize:"13px",color:"#374151",marginBottom:"3px"}}>🔴 本命的殺：<strong style={{color:"#dc2626"}}>{_hTeki}方位</strong>（本命星の対面方位）</div>}
                    {_tTeki&&<div style={{fontSize:"13px",color:"#374151",marginBottom:"3px"}}>🟠 月命的殺：<strong style={{color:"#c2410c"}}>{_tTeki}方位</strong>（月命星の対面方位）</div>}
                    <div style={{fontSize:"11px",color:"#92400e",marginTop:"6px",lineHeight:1.7}}>本命星・月命星の対面方位。個人的に避けるべき方位です。</div>
                  </div>
                )}
                {profile&&(
                  <div style={{background:"white",borderRadius:"12px",border:"1px solid #e5e7eb",padding:"12px",marginBottom:"8px"}}>
                    <div style={{fontSize:"13px",fontWeight:"bold",color:"#374151",marginBottom:"8px"}}>🧭 今日の方位詳細（日盤・五行判定）</div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:"3px"}}>
                      {_ds2.map((s,i)=>{
                        const isC=i===4;
                        const hR=isC?"中立":getStarRel(profile.honmeiStar,_ds2[i]);
                        const tR=isC?null:(profile.tsukimeiStar?getStarRel(profile.tsukimeiStar,_ds2[i]):null);
                        const good=!isC&&["相生受","比和","相生生"].includes(hR);
                        const dbl=good&&tR&&["相生受","比和"].includes(tR);
                        const bad=!isC&&["相剋受","相剋攻"].includes(hR);
                        return(
                          <div key={i} style={{padding:"5px 3px",background:isC?"#fef9c3":dbl?"#fffbeb":good?"#f0fdf4":bad?"#fef2f2":"#fafafa",borderRadius:"6px",border:`1px solid ${isC?"#fcd34d":dbl?"#f59e0b":good?"#86efac":bad?"#fca5a5":"#f3f4f6"}`,textAlign:"center"}}>
                            <div style={{fontSize:"10px",color:isC?"#92400e":"#6b7280",marginBottom:"1px",fontWeight:isC?"bold":"normal"}}>{isC?"中宮":_D[i]}</div>
                            <div style={{fontSize:"9px",color:isC?"#b45309":dbl?"#b45309":good?"#16a34a":bad?"#ef4444":"#9ca3af",fontWeight:"bold"}}>{isC?"基点（中）":RL3[hR]?RL3[hR].split("・")[0]:hR}</div>
                            {!isC&&tR&&<div style={{fontSize:"8px",color:["相生受","比和"].includes(tR)?"#16a34a":"#d1d5db"}}>月:{RL3[tR]?RL3[tR].split("・")[0]:tR}</div>}
                            {dbl&&<div style={{fontSize:"8px",color:"#b45309",fontWeight:"bold"}}>⭐二重</div>}
                          </div>
                        );
                      })}
                    </div>
                    <div style={{fontSize:"10px",color:"#9ca3af",marginTop:"6px",textAlign:"center"}}>今日の星との五行関係。月命星も併記（プロフィール登録済）</div>
                  </div>
                )}
              </>);
            })()}

            {profile&&(()=>{
              const _sb4=getSanbanInfo(profile.honmeiStar,profile.tsukimeiStar,new Date());
              const _l4=_sb4.split("\n");
              return(
                <div style={{background:"#f8fafc",borderRadius:"12px",border:"1px solid #e2e8f0",padding:"12px",marginBottom:"8px"}}>
                  <div style={{fontSize:"13px",fontWeight:"bold",color:"#374151",marginBottom:"8px"}}>📊 今日の三盤鑑定根拠</div>
                  <div style={{fontSize:"10px",color:"#6b7280",lineHeight:1.8,fontFamily:"monospace",whiteSpace:"pre-wrap"}}>{_l4.slice(1).join("\n")}</div>
                </div>
              );
            })()}
            <div style={{background:"linear-gradient(135deg,#fef9c3,#fde68a)",borderRadius:"12px",padding:"12px",border:"1px solid #fcd34d"}}>
              <div style={{fontSize:"13px",color:"#854d0e",marginBottom:"6px",fontWeight:"bold"}}>🎨 今日のラッキーカラー</div>
              <div style={{display:"flex",gap:"4px",flexWrap:"wrap",marginBottom:"8px"}}> 
                {lc.map(col=><span key={col} style={{padding:"5px 12px",background:"white",borderRadius:"20px",fontSize:"16px",color:"#374151",fontWeight:"bold"}}>{col}</span>)}
              </div>
              <div style={{paddingTop:"8px",borderTop:"1px solid #fcd34d66",fontSize:"11px",color:"#854d0e",lineHeight:1.7}}>📎 根拠：中宮星{STAR_NAMES[dayC]}は{elemName}の気を持ちます。この五行と共鳴する色が今日の開運カラーです。着用・視界に取り入れると気の流れが整います。</div>
            </div>
            <div style={{background:"linear-gradient(135deg,#f0fdf4,#dcfce7)",borderRadius:"12px",padding:"12px",border:"1px solid #86efac"}}>
              <div style={{fontSize:"13px",color:"#166534",marginBottom:"6px",fontWeight:"bold"}}>🍀 今日のラッキーフード</div>
              <div style={{display:"flex",gap:"4px",flexWrap:"wrap",marginBottom:"8px"}}>
                {lf.map(food=><span key={food} style={{padding:"5px 12px",background:"white",borderRadius:"20px",fontSize:"16px",color:"#15803d",fontWeight:"bold"}}>{food}</span>)}
              </div>
              <div style={{paddingTop:"8px",borderTop:"1px solid #86efac66",fontSize:"11px",color:"#166534",lineHeight:1.7}}>📎 根拠：{elemName}の気と親和する食材が今日の開運フードです。積極的に取り入れることで体内の気のバランスが整い、運気が安定します。</div>
            </div>
          </div>
        </div>

        {/* 運気詳細 */}
        <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
          {[
            {icon:"💼",label:"仕事運",text:WORK[dayC],bg:"#eff6ff",bc:"#bfdbfe",tc:"#1e40af",
             reason:`${STAR_NAMES[dayC]}が中宮に入ることで${elemName}の性質が仕事運を支配。積極性・判断力・対人関係に${elemName}特有の傾向が現れます。`},
            {icon:"💕",label:"恋愛・対人運",text:LOVE[dayC],bg:"#fdf2f8",bc:"#f9a8d4",tc:"#9d174d",
             reason:`${elemName}の気が縁・感情・対人場面に影響します。今日の気の流れが恋愛・人間関係の引き寄せ方を決定します。`},
            {icon:"💪",label:"健康運",text:HEALTH[dayC],bg:"#f0fdf4",bc:"#86efac",tc:"#166534",
             reason:`${elemName}の気は身体の特定部位・臓器と関連します。中宮星${STAR_NAMES[dayC]}の特性が今日の健康傾向を左右します。`},
            {icon:"💰",label:"金運",text:MONEY[dayC],bg:"#fffbeb",bc:"#fde68a",tc:"#92400e",
             reason:`${elemName}の気と財運・金銭運の関係。今日の${STAR_NAMES[dayC]}の気が金運の流れを決定します。`},
          ].map(({icon,label,text,bg,bc,tc,reason})=>(
            <div key={label} style={{background:bg,borderRadius:"12px",border:"1px solid "+bc,padding:"14px"}}>
              <div style={{fontSize:"15px",fontWeight:"bold",color:tc,marginBottom:"8px"}}>{icon} {label}</div>
              <div style={{fontSize:"14px",color:"#374151",lineHeight:1.8,marginBottom:"10px"}}>{text}</div>
              <div style={{paddingTop:"8px",borderTop:`1px solid ${bc}88`,fontSize:"11px",color:tc,lineHeight:1.7,opacity:0.85}}>📎 根拠：{reason}</div>
            </div>
          ))}
        </div>


      </div>

      {/* ② 今月の運気 */}
      <div style={{marginBottom:"24px"}}>
        <div style={{display:"flex",alignItems:"center",gap:"8px",marginBottom:"12px",borderBottom:"0.5px solid #C9A84C55",paddingBottom:"8px"}}>
          <div style={{width:"4px",height:"20px",background:"linear-gradient(#16a34a,#15803d)",borderRadius:"2px"}}/>
          <div style={{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#166534"}}>今月の運気</div>
          <div style={{fontSize:"13px",color:"#9ca3af"}}>{yr}年{mo}月</div>
        </div>
        <div style={{background:"white",borderRadius:"14px",border:"2px solid #86efac",padding:"14px",marginBottom:"10px",boxShadow:"0 2px 6px rgba(0,0,0,0.06)"}}>
          <div style={{fontSize:"13px",color:"#166534",fontWeight:"bold",textAlign:"center",marginBottom:"8px"}}>今月の月盤（中宮：{STAR_NAMES[moC]}）</div>
          <MiniGrid stars={moS} hl={hs} title="" center={moC}/>
        </div>
        <div style={{background:"#f0fdf4",borderRadius:"12px",padding:"14px",border:"1px solid #86efac"}}>
          <div style={{fontSize:"14px",fontWeight:"bold",color:"#166534",marginBottom:"10px"}}>📅 今月のテーマと運勢</div>
          <div style={{fontSize:"13px",color:"#166534",marginBottom:"8px",fontWeight:"bold"}}>月の主星：{STAR_NAMES[moC]}</div>
          <div style={{fontSize:"13px",color:"#1e3a1e",lineHeight:1.9,marginBottom:"6px"}}>💼 {adaptText(WORK[moC],'month')}</div>
          <div style={{fontSize:"13px",color:"#1e3a1e",lineHeight:1.9,marginBottom:"6px"}}>💕 {adaptText(LOVE[moC],'month')}</div>
          <div style={{fontSize:"13px",color:"#1e3a1e",lineHeight:1.9,marginBottom:"6px"}}>💪 {adaptText(HEALTH[moC],'month')}</div>
          <div style={{fontSize:"13px",color:"#1e3a1e",lineHeight:1.9}}>💰 {adaptText(MONEY[moC],'month')}</div>
        </div>
      </div>

      {/* ③ 今年の運気 */}
      <div style={{marginBottom:"24px"}}>
        <div style={{display:"flex",alignItems:"center",gap:"8px",marginBottom:"12px",borderBottom:"0.5px solid #C9A84C55",paddingBottom:"8px"}}>
          <div style={{width:"4px",height:"20px",background:"linear-gradient(#2563eb,#1d4ed8)",borderRadius:"2px"}}/>
          <div style={{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#1e40af"}}>今年の運気</div>
          <div style={{fontSize:"13px",color:"#9ca3af"}}>{kiYear}年</div>
        </div>
        <div style={{background:"white",borderRadius:"14px",border:"2px solid #bfdbfe",padding:"14px",marginBottom:"10px",boxShadow:"0 2px 6px rgba(0,0,0,0.06)"}}>
          <div style={{fontSize:"13px",color:"#1e40af",fontWeight:"bold",textAlign:"center",marginBottom:"8px"}}>今年の年盤（中宮：{STAR_NAMES[yrC]}）</div>
          <MiniGrid stars={yrS} hl={hs} title="" center={yrC}/>
        </div>
        <div style={{background:"#eff6ff",borderRadius:"12px",padding:"14px",border:"1px solid #bfdbfe"}}>
          <div style={{fontSize:"14px",fontWeight:"bold",color:"#1e40af",marginBottom:"10px"}}>🌟 今年のテーマと運勢</div>
          <div style={{fontSize:"13px",color:"#1e40af",marginBottom:"8px",fontWeight:"bold"}}>年の主星：{STAR_NAMES[yrC]}</div>
          <div style={{fontSize:"13px",color:"#1e3a5f",lineHeight:1.9,marginBottom:"6px"}}>💼 {adaptText(WORK[yrC],'year')}</div>
          <div style={{fontSize:"13px",color:"#1e3a5f",lineHeight:1.9,marginBottom:"6px"}}>💕 {adaptText(LOVE[yrC],'year')}</div>
          <div style={{fontSize:"13px",color:"#1e3a5f",lineHeight:1.9,marginBottom:"6px"}}>💪 {adaptText(HEALTH[yrC],'year')}</div>
          <div style={{fontSize:"13px",color:"#1e3a5f",lineHeight:1.9}}>💰 {adaptText(MONEY[yrC],'year')}</div>
        </div>
      </div>


      {showShare&&<ShareModal type="today" data={{starInfo:STAR_INFO[dayC],date:today.getFullYear()+"年"+(today.getMonth()+1)+"月"+today.getDate()+"日",message:(OVERVIEW[dayC]||"").slice(0,60),fortuneRating:fortuneRating,shareText:"【今日の気学暦】\n📅 "+today.getFullYear()+"年"+(today.getMonth()+1)+"月"+today.getDate()+"日\n⭐ 中宮星: "+STAR_NAMES[dayC]+"\n🎯 運勢: "+fortuneRating+"\n\n"+(OVERVIEW[dayC]||"").slice(0,60)+"\n\n九星気学の暦アプリ「氣ごよみ」で毎日の氣を確認しています。"}} onClose={()=>setShowShare(false)}/>}
      <div style={{textAlign:"center",padding:"8px 0 20px"}}>
        <button onClick={()=>setShowShare(true)} style={{padding:"12px 28px",background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",border:"none",borderRadius:"14px",fontSize:"15px",fontWeight:"bold",fontFamily:"serif",cursor:"pointer",boxShadow:"0 4px 16px rgba(0,0,0,0.2)"}}>
          📤 今日の運勢をシェア
        </button>
      </div>
    </div>
  );
}

function ProfileTab({profiles,activeId,onAdd,onSwitch,onDelete,isPremium,onUnlock}){
  const[showKisoInProfile,setShowKisoInProfile]=React.useState(false);
  const[mode,setMode]=useState(profiles.length===0?"new":"list");
  const[showShareProf,setShowShareProf]=useState(false);
  const[name,setName]=useState("");const[by,setBY]=useState("");const[bm,setBM]=useState("");const[bd,setBD]=useState("");const[err,setErr]=useState("");
  const[locInput,setLocInput]=useState("");const[locLoading,setLocLoading]=useState(false);const[locErr,setLocErr]=useState("");
  const[showStarId,setShowStarId]=useState(null);
  if(showKisoInProfile)return<KisoPage onBack={()=>setShowKisoInProfile(false)}/>;
  function getGeoLocation(){
    if(!navigator.geolocation){setLocErr("位置情報が利用できません");return;}
    setLocLoading(true);setLocErr("");
    navigator.geolocation.getCurrentPosition(
      async pos=>{
        try{
          const r=await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${pos.coords.latitude}&lon=${pos.coords.longitude}&format=json&accept-language=ja`);
          const d=await r.json();
          const city=d.address?.city||d.address?.town||d.address?.village||d.address?.county||"";
          const pref=d.address?.state||"";
          setLocInput(city?`${pref}${city}`:(pref||"取得済み"));
        }catch{setLocInput("現在地");}
        setLocLoading(false);
      },
      ()=>{setLocErr("位置情報の取得に失敗しました");setLocLoading(false);}
    );
  }
  function submit(){
    const y=parseInt(by),m=parseInt(bm),d=parseInt(bd)||15;
    if(!y||!m||y<1920||y>2010||m<1||m>12){setErr("生年(1920〜2010)と生月(1〜12)を正しく入力してください");return;}
    if(!name.trim()){setErr("お名前を入力してください");return;}
    if(!locInput.trim()||locInput.trim()==="取得済み"||locInput.trim()==="現在地"){setErr("お住まいの地域を入力してください（例：東京都新宿区）");return;}
    const hs=getHonmei(y,m,d);const km=getKiMonthIdx(m,d);const ts=getMonthStar(hs,km);
    const kqS=getStarsFor(hs);const kq=kqS.indexOf(ts);
    const id=Date.now().toString();
    onAdd({id,name:name.trim(),birthYear:y,birthMonth:m,birthDay:d,honmeiStar:hs,tsukimeiStar:ts,keishaKyu:kq<0?4:kq,kiMonth:km,location:locInput.trim()});
    setName("");setBY("");setBM("");setBD("");setErr("");setLocInput("");setLocErr("");setMode("list");
  }
  return(
    <div>
      <div style={{display:"flex",gap:"6px",marginBottom:"14px"}}>
        {[["list","登録済みプロフィール"],["new","＋ 新規登録"]].map(([m,l])=>(
          <button key={m} onClick={()=>{
            // if(m==="new"&&!isPremium&&profiles.length>=1){onUnlock();return;}
            setMode(m);
          }} style={{...CS.ghost,...(mode===m?{background:"#fffbeb",borderColor:"#fde68a",color:"#92400e"}:{})}}>
            {l}
          </button>
        ))}
      </div>
      {mode==="new"&&(
        <div style={{...CS.card,borderLeft:"3px solid #d97706"}}>
          <div style={{padding:"12px 16px",background:"linear-gradient(90deg,#fffbeb,transparent)",borderBottom:"1px solid #f3f4f6"}}>
            <div style={{fontSize:"15px",fontWeight:"bold",fontFamily:"serif",color:"#92400e"}}>✦ 新規プロフィール登録</div>
          </div>
          <div style={{padding:"16px",display:"flex",flexDirection:"column",gap:"10px"}}>
            <div><label style={{fontSize:"14px",color:"#6b7280",display:"block",marginBottom:"4px"}}>お名前</label><input value={name} onChange={e=>setName(e.target.value)} placeholder="例：鈴木太郎" style={CS.inp}/></div>
            <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
              <div style={{flex:"2 1 110px"}}><label style={{fontSize:"14px",color:"#6b7280",display:"block",marginBottom:"4px"}}>生年（西暦）</label>
                <select value={by} onChange={e=>setBY(e.target.value)} style={{...CS.inp,appearance:"auto"}}>
                  <option value="">選択</option>
                  {Array.from({length:100},(_,i)=>new Date().getFullYear()-i).map(y=><option key={y} value={y}>{y}年</option>)}
                </select></div>
              <div style={{flex:"1 1 70px"}}><label style={{fontSize:"14px",color:"#6b7280",display:"block",marginBottom:"4px"}}>生月</label>
                <select value={bm} onChange={e=>setBM(e.target.value)} style={{...CS.inp,appearance:"auto"}}>
                  <option value="">選択</option>
                  {Array.from({length:12},(_,i)=>i+1).map(m=><option key={m} value={m}>{m}月</option>)}
                </select></div>
              <div style={{flex:"1 1 70px"}}><label style={{fontSize:"14px",color:"#6b7280",display:"block",marginBottom:"4px"}}>生日（任意）</label>
                <select value={bd} onChange={e=>setBD(e.target.value)} style={{...CS.inp,appearance:"auto"}}>
                  <option value="">選択</option>
                  {Array.from({length:31},(_,i)=>i+1).map(d=><option key={d} value={d}>{d}日</option>)}
                </select></div>
            </div>
            <div>
              <label style={{fontSize:"14px",color:"#6b7280",display:"block",marginBottom:"6px"}}>🏠 住んでいる場所 <span style={{color:"#dc2626",fontSize:"12px"}}>（必須）</span></label>
                <>
                  <div style={{display:"flex",gap:"6px",marginBottom:"6px"}}>
                    <button type="button" onClick={getGeoLocation} disabled={locLoading} style={{...CS.ghost,fontSize:"15px",padding:"7px 10px",flex:"0 0 auto",background:locLoading?"#f9fafb":"white"}}>
                      {locLoading?"📡 取得中...":"📍 現在地から入力"}
                    </button>
                  </div>
                  <input value={locInput} onChange={e=>{setLocInput(e.target.value);setLocErr("");}} placeholder="例：東京都新宿区、大阪府、北海道など" style={CS.inp}/>
                  {locErr&&<div style={{fontSize:"14px",color:"#dc2626",marginTop:"4px"}}>{locErr}</div>}
                  <div style={{fontSize:"14px",color:"#6b7280",marginTop:"3px"}}>現在地ボタンで自動入力、または直接テキスト入力できます</div>
                </>
            </div>
            {err&&<div style={{fontSize:"15px",color:"#dc2626",padding:"7px 10px",background:"#fef2f2",borderRadius:"7px"}}>{err}</div>}
            <div style={{fontSize:"14px",color:"#6b7280",lineHeight:1.7}}>※ 1月・2月4日以前生まれは前年の本命星になります。</div>
            <button onClick={submit} style={{...CS.btn("#d97706"),padding:"12px"}}>✦ 登録して鑑定を始める</button>
          </div>
        </div>
      )}
      {mode==="list"&&(
        profiles.length===0?(
          <div style={{textAlign:"center",padding:"40px 20px",color:"#6b7280",fontSize:"15px"}}>登録されたプロフィールがありません<br/>「新規登録」から追加してください</div>
        ):(
          <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
            {profiles.map(p=>{const hs=STAR_INFO[p.honmeiStar];const isA=p.id===activeId;const showStar=true;const si=hs;const ts2=STAR_INFO[p.tsukimeiStar];const kq=p.keishaKyu;return(
              <div key={p.id} style={{...CS.card,marginBottom:0,border:`1.5px solid ${isA?hs.br:"#e5e7eb"}`,background:isA?hs.bg:"#1C1C1C"}}>
                <div style={{padding:"12px 14px",display:"flex",alignItems:"center",gap:"12px"}}>
                  <div style={{width:"42px",height:"42px",borderRadius:"50%",flexShrink:0,background:hs.bg,border:`2px solid ${hs.br}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"24px"}}>{hs.g}</div>
                  <div style={{flex:1}}>
                    <div style={{display:"flex",alignItems:"center",gap:"7px"}}>
                      <span onClick={()=>setShowStarId(showStar?null:p.id)} style={{fontSize:"17px",fontWeight:"bold",color:hs.c,fontFamily:"serif",cursor:"pointer",borderBottom:`1px dashed ${hs.br}`,paddingBottom:"1px"}}>{p.name}</span>
                      {isA&&<span style={{fontSize:"14px",padding:"1px 8px",borderRadius:"10px",background:"#fffbeb",border:"1px solid #fde68a",color:"#92400e"}}>選択中</span>}
                      <span onClick={()=>setShowStarId(showStar?null:p.id)} style={{fontSize:"14px",color:"#6b7280",cursor:"pointer"}}>{showStar?"▲":"▼"}</span>
                    </div>
                    <div style={{fontSize:"15px",color:"#6b7280"}}>{p.birthYear}年{p.birthMonth}月{p.birthDay}日生 · {hs.name}</div>
                    <div style={{fontSize:"14px",color:"#6b7280"}}>月命:{STAR_INFO[p.tsukimeiStar]?.k} · 傾斜:{PALACES[p.keishaKyu]?.d}宮</div>
                    {p.location&&<div style={{fontSize:"14px",color:"#6b7280"}}>🏠 {p.location}</div>}
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:"4px"}}>
                    {!isA&&<button onClick={()=>onSwitch(p.id)} style={{...CS.ghost,fontSize:"14px",padding:"5px 10px"}}>選択</button>}
                    <button onClick={()=>onDelete(p.id)} style={{...CS.ghost,fontSize:"14px",padding:"5px 10px",borderColor:"#fca5a5",color:"#dc2626"}}>削除</button>
                  </div>
                </div>
                {showStar&&(
                  <div style={{borderTop:`1px solid ${hs.br}`,padding:"14px 16px",background:"white",display:"flex",flexDirection:"column",gap:"12px",animation:"fadeIn 0.3s ease"}}>
                    <div style={{padding:"12px 14px",background:si.bg,borderRadius:"10px",border:`1px solid ${si.br}`}}>
                      <div style={{fontSize:"14px",color:"#6b7280",marginBottom:"6px",fontWeight:"bold",letterSpacing:"1px"}}>⭐ 本命星</div>
                      <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"8px"}}>
                        <StarBadge star={p.honmeiStar} size={40}/>
                        <div>
                          <div style={{fontSize:"15px",fontWeight:"bold",color:si.c,fontFamily:"serif"}}>{si.name}</div>
                          <div style={{fontSize:"14px",color:"#6b7280"}}>{si.elem}の気 · {si.g}</div>
                        </div>
                      </div>
                      <div style={{fontSize:"15px",color:"#6b7280",lineHeight:1.75,marginBottom:"8px"}}>{si.desc}</div>
                      <div style={{display:"flex",gap:"4px",flexWrap:"wrap",marginBottom:"6px"}}>
                        {si.traits.map(t=>(<span key={t} style={{padding:"2px 8px",borderRadius:"10px",fontSize:"14px",background:si.bg,border:`1px solid ${si.br}`,color:si.c}}>{t}</span>))}
                      </div>
                      <div style={{padding:"10px 12px",background:"white",borderRadius:"9px",border:"1px solid #f3f4f6",marginTop:"8px",marginBottom:"8px"}}>
                        <div style={{fontSize:"13px",fontWeight:"bold",color:si.c,marginBottom:"6px"}}>あなたの氣の性質</div>
                        {(STAR_NATURE[p.honmeiStar]||[]).map((n,i)=>(
                          <div key={i} style={{fontSize:"13px",color:"#374151",lineHeight:1.7,marginBottom:"2px"}}>→ {n}</div>
                        ))}
                      </div>

                      {/* 本命星・月命星の関係 */}
                      {p.tsukimeiStar&&(()=>{
                        const he=STAR_ELEM_NAME[p.honmeiStar]||"土";
                        const te=STAR_ELEM_NAME[p.tsukimeiStar]||"土";
                        const relKey=he+te;
                        const rel=GOGYOU_REL[relKey]||"";
                        const relDesc=GOGYOU_REL_DESC[rel]||"";
                        const bodyDesc=GOGYOU_BODY[relKey]||"";
                        const ts2n=STAR_INFO[p.tsukimeiStar];
                        return(
                          <div style={{padding:"10px 12px",background:"#f8fafc",borderRadius:"9px",border:"1px solid #e2e8f0",marginBottom:"8px"}}>
                            <div style={{fontSize:"13px",fontWeight:"bold",color:"#1e40af",marginBottom:"8px"}}>本命星と月命星の関係</div>
                            <div style={{marginBottom:"6px"}}>
                              <div style={{fontSize:"13px",fontWeight:"bold",color:si.c,marginBottom:"2px"}}>本命星：{si.name}（{he}）</div>
                              {(STAR_NATURE[p.honmeiStar]||[]).slice(0,2).map((n,i)=>(
                                <div key={i} style={{fontSize:"12px",color:"#374151",lineHeight:1.6,paddingLeft:"8px"}}>→ {n}</div>
                              ))}
                            </div>
                            <div style={{marginBottom:"6px"}}>
                              <div style={{fontSize:"13px",fontWeight:"bold",color:ts2n?.c||"#6b7280",marginBottom:"2px"}}>月命星：{ts2n?.name||""}（{te}）</div>
                              {(TSUKI_NATURE[p.tsukimeiStar]||[]).map((n,i)=>(
                                <div key={i} style={{fontSize:"12px",color:"#374151",lineHeight:1.6,paddingLeft:"8px"}}>→ {n}</div>
                              ))}
                            </div>
                            <div style={{padding:"8px 10px",background:"white",borderRadius:"7px",border:"1px solid #dbeafe",marginTop:"4px"}}>
                              <div style={{fontSize:"13px",fontWeight:"bold",color:"#1e40af",marginBottom:"4px"}}>{he}と{te}の関係：{rel}</div>
                              <div style={{fontSize:"12px",color:"#374151",lineHeight:1.7,marginBottom:"4px"}}>{relDesc}</div>
                              {bodyDesc&&<div style={{fontSize:"12px",color:"#6b7280",lineHeight:1.6}}>→ {bodyDesc}</div>}
                            </div>
                          </div>
                        );
                      })()}

                      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"6px",marginTop:"8px"}}>
                        {[["💼 仕事",si.work],["💕 恋愛",si.love],["🌿 健康",si.health],["💰 金運",si.money]].map(([l,v])=>(
                          <div key={l} style={{padding:"7px 10px",background:"white",borderRadius:"7px",border:"1px solid #f3f4f6"}}>
                            <div style={{fontSize:"14px",color:"#6b7280",marginBottom:"3px",fontWeight:"bold"}}>{l}</div>
                            <div style={{fontSize:"14px",color:"#374151",lineHeight:1.6}}>{v}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div style={{padding:"12px 14px",background:ts2?.bg||"#f9fafb",borderRadius:"10px",border:`1px solid ${ts2?.br||"#e5e7eb"}`}}>
                      <div style={{fontSize:"14px",color:"#6b7280",marginBottom:"8px",fontWeight:"bold",letterSpacing:"1px"}}>🌙 月命星・傾斜宮</div>
                      <div style={{display:"flex",gap:"12px",flexWrap:"wrap"}}>
                        <div style={{flex:"1 1 120px"}}>
                          <div style={{fontSize:"14px",color:"#6b7280",marginBottom:"5px"}}>月命星</div>
                          <StarBadge star={p.tsukimeiStar} size={34}/>
                          <div style={{fontSize:"14px",color:"#6b7280",marginTop:"4px"}}>{ts2?.desc?.slice(0,40)||""}</div>
                        </div>
                        <div style={{flex:"1 1 140px",padding:"10px 12px",background:"#f9fafb",borderRadius:"9px",border:"1px solid #f3f4f6"}}>
                          <div style={{fontSize:"14px",color:"#6b7280",marginBottom:"4px"}}>傾斜宮 — {PALACES[kq]?.d}（{PALACES[kq]?.n}）</div>
                          <div style={{fontSize:"15px",color:"#6b7280",lineHeight:1.65}}>{KEISHA_DESC[kq]}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );})}

          </div>
        )
      )}
      {(()=>{const ap=profiles.find(p=>p.id===activeId);return ap?(<React.Fragment>
        {showShareProf&&<ShareModal type="honmei" data={{starInfo:STAR_INFO[ap.honmeiStar],starFullName:STAR_NAMES[ap.honmeiStar],message:"",shareText:"【九星気学 本命星鑑定】\n⭐ "+STAR_NAMES[ap.honmeiStar]+"\n\n本命星は生まれ年から定まる、あなたの気質と運命の根幹を示す星。\n九星気学の暦アプリ「氣ごよみ」で本命星を鑑定しました。"}} onClose={()=>setShowShareProf(false)}/>}
        <div style={{textAlign:"center",padding:"8px 0 16px"}}>
          <button onClick={()=>setShowShareProf(true)} style={{padding:"10px 24px",background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",border:"none",borderRadius:"12px",fontSize:"14px",fontWeight:"bold",cursor:"pointer",boxShadow:"0 4px 14px rgba(0,0,0,0.2)"}}>📤 本命星をシェア</button>
        </div>
      </React.Fragment>):null;})()}
      <button onClick={()=>setShowKisoInProfile(true)} style={{width:"100%",padding:"14px 18px",background:"linear-gradient(135deg,#fffbeb,#fef3c7)",border:"1px solid #fde68a",borderRadius:"14px",fontSize:"15px",fontWeight:"bold",color:"#78350f",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"16px"}}><span>📚 九星気学・方位・吉日とは？</span><span>→</span></button>
    </div>
  );
}


// ─── Direction Compat (standalone component, no shared state) ───
function DirCompatPanel({hs,ts,myE,location}){
  const[sd,setSd]=React.useState("E");
  const[sdt,setSdt]=React.useState("");
  const[res,setRes]=React.useState(null);
  if(!location){
    return(
      <div style={{...CS.card,borderLeft:"3px solid #f59e0b",textAlign:"center",padding:"28px 20px"}}>
        <div style={{fontSize:"34px",marginBottom:"12px"}}>🏠</div>
        <div style={{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#92400e",marginBottom:"10px"}}>住んでいる場所が未登録です</div>
        <div style={{fontSize:"14px",color:"#6b7280",lineHeight:1.8,marginBottom:"14px"}}>
          方角の相性を診断するには、<br/>プロフィールに住んでいる場所を<br/>入力してください。
        </div>
        <div style={{fontSize:"15px",color:"#a16207",background:"#fffbeb",border:"1px solid #fde68a",borderRadius:"10px",padding:"10px 16px",display:"inline-block"}}>
          「プロフィール」タブ → プロフィールを選択 → 場所を登録
        </div>
      </div>
    );
  }
  var DGRID=[["NW","西北"],["N","北"],["NE","東北"],["W","西"],[null,"中"],["E","東"],["SW","西南"],["S","南"],["SE","東南"]];
  function go(){
    var ab=sd;
    var el=DIR_ELEM[ab]||"土";
    var rl=getElemRel(myE,el);
    var ri=COMPAT_REL[rl]||COMPAT_REL["比和"];
    var ch=PLACE_CHARS[ab]||"複合的なエネルギーの方角です。";
    var di=null;
    if(sdt){
      try{
        var dt=new Date(sdt+"T12:00:00");
        var y=dt.getFullYear(),m=dt.getMonth()+1,d=dt.getDate();
        var km=getKiMonthIdx(m,d);
        var kiYear=(km===11||(m===1&&d<6))?y-1:y;
        var yC=getYearStar(kiYear),mC=getMonthStar(yC,km),dC=getDayStar(dt);
        var yS=getStarsFor(yC),mS=getStarsFor(mC),dS=getStarsFor(dC);
        var ky=buildKyohoi(yS,mS,hs,ts);
        var te=TENDO[km]||0;
        var pi=ABBR_IDX.indexOf(ab);
        di={y:y,m:m,d:d,isk:pi>=0&&ky.filter(function(k){return k.pi===pi;}).length>0,ist:pi>=0&&te===pi};
      }catch(e){}
    }
    setRes({ab:ab,el:el,rl:rl,ri:ri,ch:ch,di:di});
  }
  var pi2=ABBR_IDX.indexOf(sd);
  var pn=(PALACES[pi2]&&PALACES[pi2].d)||sd;
  return React.createElement("div",null,
    React.createElement("div",{style:CS.card},
      React.createElement("div",{style:{padding:"12px 16px",borderBottom:"1px solid #f3f4f6",fontSize:"15px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}},"🧭 方角・方位の相性診断"),
      React.createElement("div",{style:{padding:"14px 16px",display:"flex",flexDirection:"column",gap:"10px"}},
        React.createElement("div",null,
          React.createElement("div",{style:{fontSize:"14px",color:"#6b7280",marginBottom:"6px"}},"方角を選択"),
          React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"5px"}},
            DGRID.map(function(p,i){
              if(!p[0])return React.createElement("div",{key:i});
              var active=sd===p[0];
              return React.createElement("button",{
                key:p[0],
                onClick:function(){setSd(p[0]);},
                style:Object.assign({},CS.ghost,{padding:"8px 4px",textAlign:"center",fontSize:"15px"},active?{background:"#eff6ff",borderColor:"#93c5fd",color:"#1e40af"}:{})
              },p[1]);
            })
          )
        ),
        React.createElement("div",null,
          React.createElement("label",{style:{fontSize:"14px",color:"#6b7280",display:"block",marginBottom:"4px"}},"日付指定（任意）— この方角へ向かう予定日"),
          React.createElement("input",{type:"date",value:sdt,onChange:function(e){setSdt(e.target.value);},style:CS.inp})
        ),
        React.createElement("button",{onClick:go,style:CS.btn("#1e40af")},"方角との相性を診断する")
      )
    ),
    res&&React.createElement("div",{style:Object.assign({},CS.card,{borderLeft:"3px solid "+(res.ri.c||"#6b7280"),animation:"fadeIn 0.4s ease"})},
      React.createElement("div",{style:{padding:"12px 16px",background:"linear-gradient(90deg,"+(res.ri.bg||"#f9fafb")+",transparent)",borderBottom:"1px solid #f3f4f6"}},
        React.createElement("div",{style:{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}},pn+"（"+res.ab+"）との相性"),
        React.createElement("div",{style:{display:"flex",alignItems:"center",gap:"8px",marginTop:"6px"}},
          React.createElement("span",{style:{fontSize:"22px"}},res.ri.i||"☯"),
          React.createElement("div",null,
            React.createElement("div",{style:{fontSize:"20px",fontWeight:"bold",color:res.ri.c||"#6b7280",fontFamily:"serif"}},"【"+(res.ri.lv||"")+"】"+res.rl),
            React.createElement("div",{style:{fontSize:"15px",color:"#6b7280"}},res.el+"の気")
          )
        )
      ),
      React.createElement("div",{style:{padding:"14px 16px",display:"flex",flexDirection:"column",gap:"8px"}},
        React.createElement(InfoBlock,{label:"この方角の特性",value:res.ch}),
        React.createElement(InfoBlock,{label:"あなたとの気の関係",value:res.ri.msg||""}),
        res.di&&React.createElement("div",{style:{padding:"10px 12px",background:res.di.ist?"#fffbeb":"#f9fafb",borderRadius:"9px",border:"1px solid "+(res.di.ist?"#fde68a":"#f3f4f6")}},
          React.createElement("div",{style:{fontSize:"14px",color:"#6b7280",marginBottom:"4px"}},res.di.y+"年"+res.di.m+"月"+res.di.d+"日の吉凶"),
          res.di.ist&&React.createElement("div",{style:{fontSize:"15px",color:"#d97706",fontWeight:"bold",marginBottom:"4px"}},"🌟 この日はこの方角が天道吉方！最吉の日取りです。"),
          res.di.isk&&React.createElement("div",{style:{fontSize:"15px",color:"#dc2626",fontWeight:"bold",marginBottom:"4px"}},"⚠️ この方角に凶方位の影響があります。日程の変更を検討してください。"),
          !res.di.ist&&!res.di.isk&&React.createElement("div",{style:{fontSize:"15px",color:"#374151"}},"この方角への移動に大きな凶方位の影響はありません。")
        )
      )
    )
  );
}

// ═══ COMPAT TAB ═══
function CompatModBtn({m,l,mode,setMode}){
  return(<button onClick={()=>setMode(m)} style={{...CS.ghost,flex:1,textAlign:"center",...(mode===m?{background:"#fffbeb",borderColor:"#fde68a",color:"#92400e"}:{})}}>{l}</button>);
}

function CompatibilityTab({profile,isPremium,onUnlock}){
  const[showShareCompat,setShowShareCompat]=useState(false);
  const[mode,setMode]=useState("person");
  // Person
  const[oName,setOName]=useState("");const[oBy,setOBy]=useState("");const[oBm,setOBm]=useState("");const[oBd,setOBd]=useState("");
  // Place
  const[placeName,setPlaceName]=useState("");const[placeResult,setPlaceResult]=useState(null);
  // Direction
  // Direction state moved to DirCompatPanel
  // Date compat
  const[dateTarget,setDateTarget]=useState("");const[dateResult,setDateResult]=useState(null);
  const[personResult,setPersonResult]=useState(null);

  if(!profile){
    return(
      <div style={{textAlign:"center",padding:"48px 20px 32px"}}>
        <div style={{fontSize:"54px",marginBottom:"14px",lineHeight:1,color:"#1f2937"}}>☯</div>
        <div style={{fontSize:"17px",fontWeight:"bold",fontFamily:"serif",color:"#78350f",marginBottom:"10px"}}>プロフィールを登録してください</div>
        <div style={{fontSize:"15px",color:"#6b7280",lineHeight:1.8}}>プロフィールを登録すると<br/>あなただけの相性・方位鑑定が表示されます。</div>
        <div style={{marginTop:"18px",fontSize:"15px",color:"#a16207",background:"#fffbeb",border:"1px solid #fde68a",borderRadius:"10px",padding:"10px 16px",display:"inline-block"}}>
          右端の「プロフィール」タブから登録できます
        </div>
      </div>
    );
  }
  const hs=profile.honmeiStar,ts=profile.tsukimeiStar;
  const myE=S_ELEM[hs];

  // Person diagnosis
  function diagnosePerson(){
    // if(!isPremium){onUnlock();return;}
    const y=parseInt(oBy),m=parseInt(oBm),d=parseInt(oBd)||15;
    if(!y||!m||y<1920||y>2010)return;
    const oHs=getHonmei(y,m,d);const km=getKiMonthIdx(m,d);const oTs=getMonthStar(oHs,km);
    setPersonResult(buildPersonCompat(hs,ts,oHs,oTs));
  }

  // Place diagnosis
  function diagnosePlace(){
    // if(!isPremium){onUnlock();return;}
    if(!placeName.trim())return;
    const lc=placeName.trim();
    // 都市名マッチング
    let dirIdx=4;
    for(const[city,idx]of Object.entries(CITY_DIR)){
      if(lc.includes(city)){dirIdx=idx;break;}
    }
    const dirAbbr=ABBR_IDX[dirIdx];
    const plElem=DIR_ELEM[dirAbbr]||"土";
    const rel=getElemRel(myE,plElem);
    const ri=COMPAT_REL[rel];
    const char=PLACE_CHARS[dirAbbr]||"多方面のエネルギーが混在する場所。";
    setPlaceResult({placeName:lc,dirIdx,dirAbbr,plElem,rel,ri,char});
  }


  // Date diagnosis
  function diagnoseDate(){
    // if(!isPremium){onUnlock();return;}
    if(!dateTarget)return;
    const d=new Date(dateTarget+"T12:00:00");
    const yr=d.getFullYear(),mo=d.getMonth()+1,dy=d.getDate();
    const km=getKiMonthIdx(mo,dy);
    const kiYear=(km===11||(mo===1&&dy<6))?yr-1:yr;
    const yrC=getYearStar(kiYear),moC=getMonthStar(yrC,km),dayC=getDayStar(d);
    const yrS=getStarsFor(yrC),moS=getStarsFor(moC),dayS=getStarsFor(dayC);
    const kyohoi=buildKyohoi(yrS,moS,hs,ts);
    const hsDay=dayS.indexOf(hs),hsYr=yrS.indexOf(hs),hsMo=moS.indexOf(hs);
    const dayFort=PAL_FORTUNE[hsDay]??PAL_FORTUNE[4];
    const tendo=TENDO[km]??0;
    const dayScore2={変化:5,養生:4,小吉:5,中吉:7,吉:8,大吉:9}[dayFort.r]??6;
    const yrFort2=PAL_FORTUNE[hsYr]??PAL_FORTUNE[4];const moFort2=PAL_FORTUNE[hsMo]??PAL_FORTUNE[4];
    const yrB2=["吉","大吉"].includes(yrFort2.r)?1:["養生","変化"].includes(yrFort2.r)?-1:0;
    const moB2=["吉","大吉"].includes(moFort2.r)?1:["養生","変化"].includes(moFort2.r)?-1:0;
    const dayGK2=dayS.indexOf(5)===4;const tendoB2=hsDay===tendo?1:0;
    const score=Math.min(10,Math.max(1,dayScore2+yrB2+moB2+tendoB2-(dayGK2?2:0)));
    const dow=["日","月","火","水","木","金","土"][d.getDay()];
    setDateResult({yr,mo,dy,dow,km,dayFort,kyohoi,tendo,score,yrS,moS,dayS,yrC,moC,dayC,hsDay,hsYr,hsMo});
  }

  

  return(
    <div>
      <div style={{padding:"10px 14px",marginBottom:"12px",background:STAR_INFO[hs].bg,borderRadius:"10px",border:`1px solid ${STAR_INFO[hs].br}`,display:"flex",alignItems:"center",gap:"10px"}}>
        <div style={{fontSize:"24px"}}>{STAR_INFO[hs].g}</div>
        <div><div style={{fontSize:"14px",color:"#6b7280"}}>あなた（{profile.name}）</div><div style={{fontSize:"17px",fontWeight:"bold",color:STAR_INFO[hs].c,fontFamily:"serif"}}>{STAR_INFO[hs].name}</div><div style={{fontSize:"14px",color:"#6b7280"}}>{myE}の気</div></div>
      </div>

      <div style={{display:"flex",gap:"4px",marginBottom:"14px",overflowX:"auto"}}>
        <CompatModBtn m="person" l="👤 人との相性" mode={mode} setMode={setMode}/>
        <CompatModBtn m="place"  l="📍 場所の相性" mode={mode} setMode={setMode}/>
        <CompatModBtn m="dir"    l="🧭 方角の相性" mode={mode} setMode={setMode}/>
        <CompatModBtn m="date"   l="📅 日付の相性" mode={mode} setMode={setMode}/>
      </div>

      {/* 人との相性 */}
      {mode==="person"&&(
        <div>
          <div style={CS.card}>
            <div style={{padding:"12px 16px",borderBottom:"1px solid #f3f4f6",fontSize:"15px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>相手の生年月日を入力</div>
            <div style={{padding:"14px 16px",display:"flex",flexDirection:"column",gap:"8px"}}>
              <input value={oName} onChange={e=>setOName(e.target.value)} placeholder="相手のお名前（任意）" style={CS.inp}/>
              <div style={{display:"flex",gap:"8px"}}>
                <select value={oBy} onChange={e=>setOBy(e.target.value)} style={{...CS.inp,flex:2,appearance:"auto"}}>
                  <option value="">生年</option>
                  {Array.from({length:100},(_,i)=>new Date().getFullYear()-i).map(y=><option key={y} value={y}>{y}年</option>)}
                </select>
                <select value={oBm} onChange={e=>setOBm(e.target.value)} style={{...CS.inp,flex:1,appearance:"auto"}}>
                  <option value="">生月</option>
                  {Array.from({length:12},(_,i)=>i+1).map(m=><option key={m} value={m}>{m}月</option>)}
                </select>
                <select value={oBd} onChange={e=>setOBd(e.target.value)} style={{...CS.inp,flex:1,appearance:"auto"}}>
                  <option value="">生日</option>
                  {Array.from({length:31},(_,i)=>i+1).map(d=><option key={d} value={d}>{d}日</option>)}
                </select>
              </div>
              <button onClick={diagnosePerson} style={CS.btn("#7c3aed")}>相性を診断する</button>
            </div>
          </div>
          {personResult&&(
            <div style={{animation:"fadeIn 0.4s ease"}}>
              <div style={{...CS.card,borderLeft:`3px solid ${personResult.ri.c}`}}>
                <div style={{padding:"12px 16px",background:`linear-gradient(90deg,${personResult.ri.bg},transparent)`,borderBottom:"1px solid #f3f4f6"}}>
                  <div style={{fontSize:"14px",color:"#6b7280",marginBottom:"4px"}}>「{oName||"相手"}」との気学相性</div>
                  <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
                    <span style={{fontSize:"26px"}}>{personResult.ri.i}</span>
                    <div><div style={{fontSize:"22px",fontWeight:"bold",color:personResult.ri.c,fontFamily:"serif"}}>【{personResult.ri.lv}】{personResult.rel}</div><div style={{fontSize:"15px",color:"#6b7280"}}>{myE}の気 × {personResult.oE}の気</div></div>
                  </div>
                </div>
                <div style={{padding:"14px 16px",display:"flex",flexDirection:"column",gap:"8px"}}>
                  <SectionTitle>💫 総合相性</SectionTitle>
                  <InfoBlock label="二人の気の関係" value={personResult.overall}/>
                  <SectionTitle>💼 仕事・協力関係</SectionTitle>
                  <InfoBlock label="仕事上のパートナーシップ" value={personResult.work}/>
                  <SectionTitle>💬 コミュニケーション</SectionTitle>
                  <InfoBlock label="会話・対話スタイル" value={personResult.comm}/>
                  <SectionTitle>💖 感情・情緒面</SectionTitle>
                  <InfoBlock label="感情的なつながり" value={personResult.emot}/>
                  <SectionTitle>🌱 長期的展望</SectionTitle>
                  <InfoBlock label="年月を重ねた先の関係" value={personResult.longterm}/>
                  <SectionTitle>⭐ 月命星との相性（深層）</SectionTitle>
                  <div style={{padding:"10px 12px",background:COMPAT_REL[personResult.tsRel]?.bg||"#f9fafb",borderRadius:"9px",border:`1px solid ${COMPAT_REL[personResult.tsRel]?.c||"#e5e7eb"}33`}}>
                    <div style={{display:"flex",alignItems:"center",gap:"7px",marginBottom:"5px"}}><span style={{fontSize:"18px"}}>{personResult.tsRelInfo?.i}</span><span style={{fontSize:"15px",color:personResult.tsRelInfo?.c,fontWeight:"bold"}}>{personResult.tsRel}</span><span style={{fontSize:"15px",color:"#6b7280"}}> — 深層の気質的関係</span></div>
                    <div style={{fontSize:"15px",color:"#374151",lineHeight:1.65}}>{personResult.tsRelInfo?.msg}</div>
                  </div>
                  <SectionTitle>🔮 今日の二人のエネルギー</SectionTitle>
                  <InfoBlock label="今日の相互作用" value={personResult.todayMsg}/>
                  <SectionTitle>✦ 関係を深めるアドバイス</SectionTitle>
                  <div style={{padding:"12px",background:"#fffbeb",borderRadius:"9px",border:"1px solid #fde68a",fontSize:"14px",color:"#374151",lineHeight:1.75}}>{personResult.advice}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* 場所との相性 */}
      {mode==="place"&&(
        <div>
          <div style={CS.card}>
            <div style={{padding:"12px 16px",borderBottom:"1px solid #f3f4f6",fontSize:"15px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>📍 場所の相性診断</div>
            <div style={{padding:"14px 16px",display:"flex",flexDirection:"column",gap:"8px"}}>
              <div style={{fontSize:"15px",color:"#6b7280",lineHeight:1.65}}>都道府県・市区町村・都市名・施設名を入力してください。<br/>現在地の場合は「大津」「滋賀」など最寄りの地名を入力。</div>
              <input value={placeName} onChange={e=>setPlaceName(e.target.value)} placeholder="例：東京、大阪、海外出張先..." style={CS.inp}/>
              <button onClick={diagnosePlace} style={CS.btn("#16a34a")}>この場所との相性を診断</button>
            </div>
          </div>
          {placeResult&&(
            <div style={{...CS.card,borderLeft:`3px solid ${placeResult.ri.c}`,animation:"fadeIn 0.4s ease"}}>
              <div style={{padding:"12px 16px",background:`linear-gradient(90deg,${placeResult.ri.bg},transparent)`,borderBottom:"1px solid #f3f4f6"}}>
                <div style={{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>「{placeResult.placeName}」との相性</div>
                <div style={{display:"flex",alignItems:"center",gap:"8px",marginTop:"6px"}}>
                  <span style={{fontSize:"22px"}}>{placeResult.ri.i}</span>
                  <div><div style={{fontSize:"20px",fontWeight:"bold",color:placeResult.ri.c,fontFamily:"serif"}}>【{placeResult.ri.lv}】{placeResult.rel}</div>
                  <div style={{fontSize:"15px",color:"#6b7280"}}>大津市基準の方位: {placeResult.dirAbbr}（{PALACES[["SE","S","SW","E","C","W","NE","N","NW"].indexOf(placeResult.dirAbbr)]?.d||"不明"}）· {placeResult.plElem}の気</div></div>
                </div>
              </div>
              <div style={{padding:"14px 16px",display:"flex",flexDirection:"column",gap:"8px"}}>
                <InfoBlock label="この方位の特性" value={placeResult.char}/>
                <InfoBlock label="あなたとの気の関係" value={placeResult.ri.msg}/>
                <div style={{padding:"12px",background:"#f0fdf4",borderRadius:"9px",border:"1px solid #86efac",fontSize:"14px",color:"#374151",lineHeight:1.75}}>
                  ✦ {placeResult.rel==="相生受"?"この場所はあなたのエネルギーを最大限に引き出す吉方位。移住・通勤・旅行先として積極的に活用することをお勧めします。":placeResult.rel==="相生生"?"あなたのエネルギーがこの場所を活性化します。長く関わることでこの場所があなたの力の発揮の場になります。":placeResult.rel==="比和"?"あなたの気質と共鳴する場所。良い面も悪い面も増幅されるので、コンディションが良い時に活用するのが吉。":placeResult.rel==="相剋受"?"エネルギーの消耗に注意が必要な方位。短期の滞在は問題ありませんが、長期的な居住・就職先としては慎重に検討を。":"慎重な検討が必要な方位。特に重要な決断をする場所や長期滞在には他の吉方位を優先することをお勧めします。"}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* 方角との相性 */}
      {mode==="dir"&&<DirCompatPanel hs={hs} ts={ts} myE={myE} location={profile.location}/>}

      {/* 日付との相性 */}
      {mode==="date"&&(
        <div>
          <div style={CS.card}>
            <div style={{padding:"12px 16px",borderBottom:"1px solid #f3f4f6",fontSize:"15px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>📅 日付との相性診断</div>
            <div style={{padding:"14px 16px",display:"flex",flexDirection:"column",gap:"8px"}}>
              <div style={{fontSize:"15px",color:"#6b7280"}}>診断したい日付を選択してください。空欄の場合は今日を診断します。</div>
              <input type="date" value={dateTarget} onChange={e=>setDateTarget(e.target.value)} style={CS.inp}/>
              <button onClick={()=>{const t=dateTarget||new Date().toISOString().split("T")[0];setDateTarget(t);diagnoseDate();}} style={CS.btn("#7c3aed")}>この日との相性を診断する</button>
            </div>
          </div>
          {dateResult&&(
            <div style={{...CS.card,animation:"fadeIn 0.4s ease"}}>
              <div style={{padding:"12px 16px",background:"linear-gradient(135deg,#faf5ff,#ede9fe)",borderBottom:"1px solid #ddd6fe"}}>
                <div style={{fontSize:"15px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>{dateResult.yr}年{dateResult.mo}月{dateResult.dy}日（{dateResult.dow}）との相性</div>
                <div style={{marginTop:"8px"}}><ScoreBar score={dateResult.score}/></div>
              </div>
              <div style={{padding:"14px 16px",display:"flex",flexDirection:"column",gap:"10px"}}>
                <div style={{display:"flex",gap:"5px",flexWrap:"wrap"}}><MiniGrid stars={dateResult.yrS} hl={hs} title="年盤" center={dateResult.yrC}/><MiniGrid stars={dateResult.moS} hl={hs} title="月盤" center={dateResult.moC}/><MiniGrid stars={dateResult.dayS} hl={hs} title="日盤" center={dateResult.dayC}/></div>
                <div style={{display:"flex",gap:"6px",flexWrap:"wrap"}}>
                  {[{l:"年",p:dateResult.hsYr,c:"#d97706"},{l:"月",p:dateResult.hsMo,c:"#16a34a"},{l:"日",p:dateResult.hsDay,c:"#7c3aed"}].map(({l,p,c})=>(
                    <div key={l} style={{flex:"1 1 80px",padding:"7px 10px",background:"#f9fafb",borderRadius:"8px",border:"1px solid #f3f4f6",textAlign:"center"}}>
                      <div style={{fontSize:"14px",color:c,fontWeight:"bold"}}>{l}盤</div>
                      <div style={{fontSize:"14px",fontFamily:"serif",color:"#1f2937"}}>{PALACES[p]?.d||"中央"}</div>
                      <div style={{fontSize:"14px",color:"#6b7280"}}>{PAL_FORTUNE[p]?.r}</div>
                    </div>
                  ))}
                </div>
                <div style={{padding:"9px 13px",background:"#fffbeb",borderRadius:"9px",border:"1px solid #fde68a",fontSize:"14px",color:"#374151"}}>
                  🌟 <strong style={{color:"#d97706"}}>天道吉方（{KI_NAMES[dateResult.km]}月）：{PALACES[dateResult.tendo]?.d}</strong>
                </div>
                <div style={{padding:"12px",borderRadius:"10px",background:dateResult.score<=3?"#fef2f2":dateResult.score<=5?"#fffbeb":"#f0fdf4",border:`1px solid ${dateResult.score<=3?"#fca5a5":dateResult.score<=5?"#fde68a":"#86efac"}`,fontSize:"14px",color:"#374151",lineHeight:1.75}}>
                  {dateResult.score<=3&&"⚠️ 大凶方位が作用しています。重要な行事・移動は避けることを強く推奨します。"}
                  {dateResult.score===4&&"⚡ 凶方位の影響があります。準備を整え、慎重に進めることをお勧めします。"}
                  {dateResult.score>=5&&`✦ 大きな凶方位の影響はありません。${dateResult.dayFort.t}`}
                </div>
                {dateResult.kyohoi.length>0&&(
                  <div>
                    <SectionTitle>この日の凶方位</SectionTitle>
                    {dateResult.kyohoi.map((k,i)=>(<div key={i} style={{display:"flex",alignItems:"center",gap:"7px",fontSize:"15px",marginBottom:"4px"}}><RatingBadge r={k.lv}/><span style={{color:"#6b7280"}}>{k.type}：<strong style={{color:"#1f2937"}}>{PALACES[k.pi]?.d}</strong></span></div>))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      {showShareCompat&&<ShareModal type="compat" data={{starInfo1:STAR_INFO[profile?.honmeiStar||1],starInfo2:STAR_INFO[profile?.tsukimeiStar||1],result:"相性診断",message:"氣ごよみで相性を鑑定しました。",shareText:"【九星気学 相性診断】\n二人の気の相性を鑑定しました。\n\n九星気学では本命星の組み合わせで、二人の気の流れと相性の傾向が分かります。\n氣ごよみアプリで鑑定。"}} onClose={()=>setShowShareCompat(false)}/>}
      <div style={{textAlign:"center",padding:"8px 0 16px"}}>
        <button onClick={()=>setShowShareCompat(true)} style={{padding:"10px 24px",background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",border:"none",borderRadius:"12px",fontSize:"14px",fontWeight:"bold",cursor:"pointer",boxShadow:"0 4px 14px rgba(0,0,0,0.2)"}}>📤 相性診断をシェア</button>
      </div>
    </div>
  );
}

// ═══ EVENT TAB ═══
function EventTab({profile,isPremium,isPremiumPlus,onUnlock}){
  const[showShareEvent,setShowShareEvent]=useState(false);
  const[evName,setEvName]=useState("");const[evDate,setEvDate]=useState("");const[evType,setEvType]=useState("会議・交渉");const[result,setResult]=useState(null);
  if(!profile){
    return(
      <div style={{textAlign:"center",padding:"48px 20px 32px"}}>
        <div style={{fontSize:"50px",marginBottom:"14px"}}>📅</div>
        <div style={{fontSize:"17px",fontWeight:"bold",fontFamily:"serif",color:"#78350f",marginBottom:"10px"}}>プロフィールを登録してください</div>
        <div style={{fontSize:"15px",color:"#6b7280",lineHeight:1.8}}>プロフィールを登録すると<br/>あなただけのイベント・吉日鑑定が表示されます。</div>
        <div style={{marginTop:"18px",fontSize:"15px",color:"#a16207",background:"#fffbeb",border:"1px solid #fde68a",borderRadius:"10px",padding:"10px 16px",display:"inline-block"}}>
          右端の「プロフィール」タブから登録できます
        </div>
      </div>
    );
  }
  const today=new Date();
  const todayStr=`${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,"0")}-${String(today.getDate()).padStart(2,"0")}`;
  function analyze(){
    if(!evDate)return;
    const d=new Date(evDate+"T12:00:00");
    const yr=d.getFullYear(),mo=d.getMonth()+1,dy=d.getDate();
    const km=getKiMonthIdx(mo,dy);
    const kiYear=(km===11||(mo===1&&dy<6))?yr-1:yr;
    const yrC=getYearStar(kiYear),moC=getMonthStar(yrC,km),dayC=getDayStar(d);
    const yrS=getStarsFor(yrC),moS=getStarsFor(moC),dayS=getStarsFor(dayC);
    const hs=profile.honmeiStar,ts=profile.tsukimeiStar;
    const kyohoi=buildKyohoi(yrS,moS,hs,ts);
    const hsDay=dayS.indexOf(hs),hsYr=yrS.indexOf(hs),hsMo=moS.indexOf(hs);
    const dayFort=PAL_FORTUNE[hsDay]??PAL_FORTUNE[4];
    const tendo=TENDO[km]??0;const dow=["日","月","火","水","木","金","土"][d.getDay()];
    // スコア：日盤の本命星宮位置を主軸に、年盤・月盤の位置で補正
    const dayScore={変化:5,養生:4,小吉:5,中吉:7,吉:8,大吉:9}[dayFort.r]??6;
    const yrFort=PAL_FORTUNE[hsYr]??PAL_FORTUNE[4];
    const moFort=PAL_FORTUNE[hsMo]??PAL_FORTUNE[4];
    const yrBonus=["吉","大吉"].includes(yrFort.r)?1:["養生","変化"].includes(yrFort.r)?-1:0;
    const moBonus=["吉","大吉"].includes(moFort.r)?1:["養生","変化"].includes(moFort.r)?-1:0;
    // 天道方位を使う日はボーナス、五黄が日盤中宮の時のみ大幅減点
    const dayGK=dayS.indexOf(5)===4;
    const tendoBonus=hsDay===tendo?1:0;
    const score=Math.min(10,Math.max(1,dayScore+yrBonus+moBonus+tendoBonus-(dayGK?2:0)));
    setResult({evName:evName||evType,evType,yr,mo,dy,dow,km,dayFort,kyohoi,tendo,score,yrS,moS,dayS,yrC,moC,dayC,hsDay,hsYr,hsMo});
  }
  return(
    <div>
      <div style={CS.card}>
        <div style={{padding:"12px 16px",background:"linear-gradient(90deg,#fffbeb,transparent)",borderBottom:"1px solid #f3f4f6"}}><div style={{fontSize:"14px",letterSpacing:"2px",color:"#92400e",marginBottom:"2px"}}>EVENT & WORK</div><div style={{fontSize:"17px",fontWeight:"bold",fontFamily:"serif",color:"#78350f"}}>イベント・仕事の吉日診断</div></div>
        <div style={{padding:"16px",display:"flex",flexDirection:"column",gap:"10px"}}>
          <div><label style={{fontSize:"14px",color:"#6b7280",display:"block",marginBottom:"4px"}}>イベント名（任意）</label><input value={evName} onChange={e=>setEvName(e.target.value)} placeholder="例：大阪出張、新規契約..." style={CS.inp}/></div>
          <div><label style={{fontSize:"14px",color:"#6b7280",display:"block",marginBottom:"4px"}}>予定日</label>
              <input type="date" value={evDate} onChange={e=>setEvDate(e.target.value)} min={todayStr} style={CS.inp}/>
          </div>
          <div><label style={{fontSize:"14px",color:"#6b7280",display:"block",marginBottom:"6px"}}>イベント種別</label>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"5px"}}>
              {EVENT_TYPES.map(t=>(<button key={t} onClick={()=>{setEvType(t);setEvName(t);}} style={{...CS.ghost,padding:"7px 4px",textAlign:"center",fontSize:"14px",...(evType===t?{background:"#fffbeb",borderColor:"#fde68a",color:"#92400e"}:{})}}>{t}</button>))}

            </div>
          </div>
          <button onClick={()=>{analyze();}} style={{...CS.btn("#d97706"),padding:"12px"}}>✦ この日を鑑定する</button>
        </div>
      </div>
      {result&&(
        <div style={{...CS.card,animation:"fadeIn 0.4s ease"}}>
          <div style={{padding:"12px 16px",background:"#f9fafb",borderBottom:"1px solid #f3f4f6"}}>
            <div style={{fontSize:"14px",color:"#6b7280"}}>{result.yr}年{result.mo}月{result.dy}日（{result.dow}） / {result.evName}</div>
            <div style={{marginTop:"8px"}}><ScoreBar score={result.score}/></div>
          </div>
          <div style={{padding:"14px 16px",display:"flex",flexDirection:"column",gap:"12px"}}>
            <div style={{display:"flex",gap:"5px",flexWrap:"wrap"}}><MiniGrid stars={result.yrS} hl={profile.honmeiStar} title="年盤" center={result.yrC}/><MiniGrid stars={result.moS} hl={profile.honmeiStar} title="月盤" center={result.moC}/><MiniGrid stars={result.dayS} hl={profile.honmeiStar} title="日盤" center={result.dayC}/></div>
            <div style={{display:"flex",gap:"6px",flexWrap:"wrap"}}>
              {[{l:"年",p:result.hsYr,c:"#d97706"},{l:"月",p:result.hsMo,c:"#16a34a"},{l:"日",p:result.hsDay,c:"#7c3aed"}].map(({l,p,c})=>(
                <div key={l} style={{flex:"1 1 80px",padding:"7px 10px",background:"#f9fafb",borderRadius:"8px",border:"1px solid #f3f4f6",textAlign:"center"}}>
                  <div style={{fontSize:"14px",color:c,fontWeight:"bold"}}>{l}盤</div>
                  <div style={{fontSize:"14px",fontFamily:"serif",color:"#1f2937"}}>{PALACES[p]?.d||"中央"}</div>
                </div>
              ))}
            </div>
            <div style={{padding:"9px 13px",background:"#fffbeb",borderRadius:"9px",border:"1px solid #fde68a",fontSize:"14px",color:"#374151"}}>🌟 <strong style={{color:"#d97706"}}>天道吉方（{KI_NAMES[result.km]}月）：{PALACES[result.tendo]?.d}</strong> — この方位への移動・活動が月全体で吉。</div>
            <div style={{padding:"12px",borderRadius:"10px",background:result.score<=3?"#fef2f2":result.score<=4?"#fffbeb":"#f0fdf4",border:`1px solid ${result.score<=3?"#fca5a5":result.score<=4?"#fde68a":"#86efac"}`,fontSize:"14px",color:"#374151",lineHeight:1.8}}>
              {result.score<=3&&"⚠️ 大凶方位が作用しています。重要な行事・移動は避けることを強く推奨します。"}
              {result.score===4&&"⚡ 凶方位の影響があります。事前準備を整え、慎重に進めることをお勧めします。"}
              {result.score>=5&&`✦ 大きな凶方位の影響はありません。${result.dayFort.t}`}
            </div>
            <div><SectionTitle>{result.evType}のアドバイス</SectionTitle>
              {(EVENT_ADVICE[result.evType]||["凶方位・凶日を避け本命星が旺盛な宮にある日を選ぶ","天道方位への移動を活用すると吉"]).map((a,i)=>(
                <div key={i} style={{display:"flex",gap:"8px",padding:"7px 0",borderBottom:i<1?"1px solid #f3f4f6":"none"}}>
                  <span style={{color:"#d97706",fontSize:"15px",minWidth:"14px"}}>✦</span>
                  <span style={{fontSize:"14px",color:"#6b7280",lineHeight:1.65}}>{a}</span>
                </div>
              ))}
            </div>
            {showShareEvent&&<ShareModal type="kichinichi" data={{starInfo:STAR_INFO[result.dayC],date:result.yr+"年"+result.mo+"月"+result.dy+"日（"+result.dow+"）",goodDir:PALACES[result.tendo]?.d||"−",message:result.evName+" 吉日鑑定。スコア: "+result.score+"/10。天道吉方: "+PALACES[result.tendo]?.d+"。",fortuneRating:result.score>=7?"大吉":result.score>=5?"吉":result.score>=4?"小吉":result.score>=3?"注意":"凶",shareText:"【イベント吉日鑑定】\n⭐ "+result.evName+"\n日付: "+result.yr+"年"+result.mo+"月"+result.dy+"日（"+result.dow+"）\n中宮星: "+STAR_INFO[result.dayC]?.k+"（"+STAR_INFO[result.dayC]?.elem+"）\n吉凶スコア: "+result.score+"/10\n天道吉方: "+PALACES[result.tendo]?.d+"\n\n大切なイベントの吉日選びは\n氣ごよみアプリで。\nhttps://kigaku-app.vercel.app"}} onClose={()=>setShowShareEvent(false)}/>}
            <div style={{textAlign:"center",marginBottom:"12px"}}>
              <button onClick={()=>setShowShareEvent(true)} style={{padding:"10px 28px",background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",border:"none",borderRadius:"12px",fontSize:"14px",fontWeight:"bold",cursor:"pointer",boxShadow:"0 4px 14px rgba(124,58,237,0.3)"}}>📤 この鑑定をシェア</button>
            </div>
            <button onClick={()=>{
              const evTitle=encodeURIComponent("⭐"+( result.evName||"イベント")+"【九星気学吉日】");
              const yr=String(result.yr);
              const mo=String(result.mo).padStart(2,"0");
              const dy=String(result.dy).padStart(2,"0");
              const dateStr=yr+mo+dy;
              const advices=(window._evAdvices||[]).join("／");
              const detailText="【九星気学吉日鑑定】\n"
                +"イベント："+( result.evName||"")+"\n"
                +"日付："+result.yr+"年"+result.mo+"月"+result.dy+"日（"+result.dow+"）\n"
                +"吉凶スコア："+result.score+"/10\n"
                +"本命星の位置：年盤"+( result.hsYr||"")+"・月盤"+(result.hsMo||"")+"・日盤"+(result.hsDay||"")+"\n"
                +"アドバイス："+advices+"\n"
                +"※氣ごよみアプリによる九星気学鑑定";
              const details=encodeURIComponent(detailText);
              const url="https://calendar.google.com/calendar/render?action=TEMPLATE"
                +"&text="+evTitle
                +"&dates="+dateStr+"T090000/"+dateStr+"T100000"
                +"&details="+details;
              window.open(url,"_blank");
            }} style={{marginTop:"12px",width:"100%",padding:"14px",background:"linear-gradient(135deg,#1d4ed8,#2563eb)",color:"white",border:"none",borderRadius:"12px",fontSize:"15px",fontWeight:"bold",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:"8px"}}>
              <span>📅</span><span>Googleカレンダーに登録する</span>
            </button>
            {result.kyohoi.length>0&&<div><SectionTitle>この期間の凶方位</SectionTitle>{result.kyohoi.map((k,i)=>(<div key={i} style={{display:"flex",alignItems:"center",gap:"7px",fontSize:"15px",marginBottom:"4px"}}><RatingBadge r={k.lv}/><span style={{color:"#6b7280"}}>{k.type}：<strong style={{color:"#1f2937"}}>{PALACES[k.pi]?.d}</strong></span></div>))}</div>}
          </div>
        </div>
      )}
    </div>
  );
}

// ═══ 気学基礎知識 参照セクション ═══
function KigakuReference(){
  const[open,setOpen]=useState({hakkei:false,sangen:false,sokoku:false,bansho:false,kisogaku:false,kyusei:false,hoiban:false,honmei:false,gogyo:false,kicchou:false,rekishi:false});
  const toggle=k=>setOpen(p=>({...p,[k]:!p[k]}));
  const S={
    wrap:{background:"#fffdf5",border:"1px solid #fde68a",borderRadius:"14px",padding:"16px",marginTop:"16px"},
    h:{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#78350f",marginBottom:"12px",display:"flex",alignItems:"center",gap:"6px"},
    sec:{marginBottom:"10px",border:"1px solid #fde68a",borderRadius:"10px",overflow:"hidden"},
    sh:{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 14px",background:"#fffbeb",cursor:"pointer",userSelect:"none",fontSize:"15px",fontWeight:"bold",color:"#78350f",fontFamily:"serif"},
    sb:{padding:"14px",background:"white",fontSize:"14px",color:"#374151",lineHeight:1.8},
    grid:{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"4px",margin:"8px 0"},
    cell:{border:"1px solid #fde68a",borderRadius:"6px",padding:"8px 4px",textAlign:"center",background:"#fffbeb"},
    cn:{fontSize:"15px",fontWeight:"bold",color:"#78350f"},
    cd:{fontSize:"14px",color:"#92400e"},
    row:{display:"flex",gap:"8px",flexWrap:"wrap",margin:"6px 0"},
    badge:{padding:"3px 10px",borderRadius:"20px",fontSize:"15px",fontWeight:"bold"},
  };
  // 八卦図 (9宮配置 3×3)
  const BAGUA=[
    {n:"巽☴",d:"東南",e:"木",s:4,c:"#14532d"},{n:"離☲",d:"南",e:"火",s:9,c:"#4c1d95"},{n:"坤☷",d:"西南",e:"土",s:2,c:"#374151"},
    {n:"震☳",d:"東",e:"木",s:3,c:"#065f46"},{n:"中⊕",d:"中央",e:"土",s:5,c:"#78350f"},{n:"兌☱",d:"西",e:"金",s:7,c:"#7f1d1d"},
    {n:"艮☶",d:"東北",e:"土",s:8,c:"#44403c"},{n:"坎☵",d:"北",e:"水",s:1,c:"#1d4ed8"},{n:"乾☰",d:"西北",e:"金",s:6,c:"#374151"},
  ];
  // 五行相生・相剋
  const GOKYO=[
    {e:"木",c:"#065f46",bg:"#ecfdf5",gen:"火",ovr:"土"},
    {e:"火",c:"#7f1d1d",bg:"#fff1f2",gen:"土",ovr:"金"},
    {e:"土",c:"#78350f",bg:"#fffbeb",gen:"金",ovr:"水"},
    {e:"金",c:"#374151",bg:"#f8fafc",gen:"水",ovr:"木"},
    {e:"水",c:"#1d4ed8",bg:"#eff6ff",gen:"木",ovr:"火"},
  ];
  // 万物対応表
  const BANBUTSU=[
    {cat:"方位・宮",items:[["一白・坎","北/水の方位"],["二黒・坤","西南/母の方位"],["三碧・震","東/春の方位"],["四緑・巽","東南/縁の方位"],["五黄・中","中央/帝王の方位"],["六白・乾","西北/父の方位"],["七赤・兌","西/秋の方位"],["八白・艮","東北/変化の方位"],["九紫・離","南/火の方位"]]},
    {cat:"五行と体",items:[["木（三碧・四緑）","肝臓・神経・腱・目"],["火（九紫）","心臓・血管・目・小腸"],["土（二黒・五黄・八白）","胃腸・脾臓・筋肉・口"],["金（六白・七赤）","肺・大腸・皮膚・鼻"],["水（一白）","腎臓・膀胱・耳・骨"]]},
    {cat:"五行と感情",items:[["木","怒り・決断・創造"],["火","喜び・情熱・礼節"],["土","思慮・信頼・包容"],["金","悲しみ・義・規律"],["水","恐れ・知恵・流動"]]},
    {cat:"五行と季節",items:[["木","春（立春〜）"],["火","夏（立夏〜）"],["土","土用（各季節の変わり目）"],["金","秋（立秋〜）"],["水","冬（立冬〜）"]]},
    {cat:"五行と方位",items:[["木","東・東南"],["火","南"],["土","中央・東北・西南"],["金","西・西北"],["水","北"]]},
    {cat:"五行と色",items:[["木","青・緑"],["火","赤・紫"],["土","黄・茶"],["金","白・銀・金"],["水","黒・紺"]]},
    {cat:"五行と数",items:[["木","3・4"],["火","9"],["土","2・5・8"],["金","6・7"],["水","1"]]},
    {cat:"五行と味",items:[["木","酸"],["火","苦"],["土","甘"],["金","辛"],["水","塩（鹹）"]]},
  ];

  return(
    <div style={S.wrap}>
      <div style={S.h}>📚 気学 基礎知識 参照</div>

      {/* 八卦図 */}
      <div style={S.sec}>
        <div style={S.sh} onClick={()=>toggle("hakkei")}>
          <span>☯ 八卦図・九星宮配置</span><span>{open.hakkei?"▲":"▼"}</span>
        </div>
        {open.hakkei&&(
          <div style={S.sb}>
            <div style={{fontSize:"15px",color:"#6b7280",marginBottom:"8px"}}>後天定位盤（洛書）：九宮の基本配置</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"4px",maxWidth:"320px",margin:"0 auto"}}>
              {BAGUA.map((b,i)=>(
                <div key={i} style={{border:`1.5px solid ${b.c}20`,borderRadius:"8px",padding:"8px 4px",textAlign:"center",background:`${b.c}08`}}>
                  <div style={{fontSize:"18px",fontWeight:"bold",color:b.c}}>{b.n}</div>
                  <div style={{fontSize:"14px",color:"#6b7280"}}>{b.d}</div>
                  <div style={{fontSize:"14px",fontWeight:"bold",color:b.c}}>【{b.e}】</div>
                  <div style={{fontSize:"14px",color:b.c}}>{b.s}宮</div>
                </div>
              ))}
            </div>
            <div style={{marginTop:"10px",fontSize:"15px",color:"#6b7280",lineHeight:1.7}}>
              ※ 北が下・南が上の伝統的な配置。各宮は対応する自然の象意（八卦）と結びつく。
            </div>
          </div>
        )}
      </div>

      {/* 五行相生図 ― ペンタゴン星形 */}
      <div style={S.sec}>
        <div style={S.sh} onClick={()=>toggle("sangen")}>
          <span>⭕ 五行相生図（星形）</span><span>{open.sangen?"▲":"▼"}</span>
        </div>
        {open.sangen&&(
          <div style={S.sb}>
            <div style={{fontSize:"15px",color:"#6b7280",marginBottom:"4px"}}>相生（そうじょう）：生み出す・助ける関係 ▶ 吉の関係</div>
            {(()=>{
              const cx=150,cy=140,r=90;
              // 五角形頂点：木=上, 火=右上, 土=右下, 金=左下, 水=左上
              const ELEMS=[
                {e:"木",c:"#16a34a",bg:"#dcfce7",ang:-90},
                {e:"火",c:"#dc2626",bg:"#fee2e2",ang:-18},
                {e:"土",c:"#d97706",bg:"#fef3c7",ang:54},
                {e:"金",c:"#6b7280",bg:"#f3f4f6",ang:126},
                {e:"水",c:"#2563eb",bg:"#dbeafe",ang:198},
              ];
              const pts=ELEMS.map(el=>({
                ...el,
                x:cx+r*Math.cos(el.ang*Math.PI/180),
                y:cy+r*Math.sin(el.ang*Math.PI/180),
              }));
              // 相生: 0→1→2→3→4→0
              const arrows=pts.map((p,i)=>{
                const nxt=pts[(i+1)%5];
                const dx=nxt.x-p.x,dy=nxt.y-p.y,len=Math.sqrt(dx*dx+dy*dy);
                const ux=dx/len,uy=dy/len,rn=24;
                const sx=p.x+ux*rn,sy=p.y+uy*rn,ex=nxt.x-ux*rn,ey=nxt.y-uy*rn;
                return{sx,sy,ex,ey,key:i};
              });
              return(
                <svg width="100%" viewBox="0 0 300 280" style={{maxWidth:"300px",display:"block",margin:"0 auto"}}>
                  <defs>
                    <marker id="ag" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
                      <polygon points="0 0, 8 3, 0 6" fill="#16a34a"/>
                    </marker>
                  </defs>
                  {/* 相生の矢印（外周ペンタゴン） */}
                  {arrows.map(a=>(
                    <line key={a.key} x1={a.sx} y1={a.sy} x2={a.ex} y2={a.ey}
                      stroke="#16a34a" strokeWidth="2" markerEnd="url(#ag)" opacity="0.85"/>
                  ))}
                  {/* 五行ノード */}
                  {pts.map((p,i)=>(
                    <g key={i}>
                      <circle cx={p.x} cy={p.y} r="22" fill={p.bg} stroke={p.c} strokeWidth="2"/>
                      <text x={p.x} y={p.y+5} textAnchor="middle" fontSize="16" fontWeight="bold" fill={p.c}>{p.e}</text>
                    </g>
                  ))}
                  {/* 中央ラベル */}
                  <text x="150" y="136" textAnchor="middle" fontSize="12" fill="#6b7280">相生</text>
                  <text x="150" y="150" textAnchor="middle" fontSize="12" fill="#16a34a">（生む・助ける）</text>
                </svg>
              );
            })()}
            <div style={{fontSize:"15px",color:"#6b7280",marginTop:"4px",lineHeight:1.7}}>
              木生火 → 火生土 → 土生金 → 金生水 → 水生木
            </div>
          </div>
        )}
      </div>

      {/* 五行相剋図 ― 五芒星（ペンタグラム） */}
      <div style={S.sec}>
        <div style={S.sh} onClick={()=>toggle("sokoku")}>
          <span>✕ 五行相剋図（星形）</span><span>{open.sokoku?"▲":"▼"}</span>
        </div>
        {open.sokoku&&(
          <div style={S.sb}>
            <div style={{fontSize:"15px",color:"#6b7280",marginBottom:"4px"}}>相剋（そうこく）：抑える・克する関係 ▶ 注意の関係</div>
            {(()=>{
              const cx=150,cy=140,r=90;
              const ELEMS=[
                {e:"木",c:"#16a34a",bg:"#dcfce7",ang:-90},
                {e:"火",c:"#dc2626",bg:"#fee2e2",ang:-18},
                {e:"土",c:"#d97706",bg:"#fef3c7",ang:54},
                {e:"金",c:"#6b7280",bg:"#f3f4f6",ang:126},
                {e:"水",c:"#2563eb",bg:"#dbeafe",ang:198},
              ];
              const pts=ELEMS.map(el=>({
                ...el,
                x:cx+r*Math.cos(el.ang*Math.PI/180),
                y:cy+r*Math.sin(el.ang*Math.PI/180),
              }));
              // 相剋: 木→土→水→火→金→木 = idx 0→2→4→1→3→0
              const SOKOKU_IDX=[[0,2],[2,4],[4,1],[1,3],[3,0]];
              const arrows=SOKOKU_IDX.map(([fi,ti],i)=>{
                const p=pts[fi],nxt=pts[ti];
                const dx=nxt.x-p.x,dy=nxt.y-p.y,len=Math.sqrt(dx*dx+dy*dy);
                const ux=dx/len,uy=dy/len,rn=24;
                return{sx:p.x+ux*rn,sy:p.y+uy*rn,ex:nxt.x-ux*rn,ey:nxt.y-uy*rn,key:i};
              });
              return(
                <svg width="100%" viewBox="0 0 300 280" style={{maxWidth:"300px",display:"block",margin:"0 auto"}}>
                  <defs>
                    <marker id="ar" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
                      <polygon points="0 0, 8 3, 0 6" fill="#dc2626"/>
                    </marker>
                  </defs>
                  {/* 相剋の矢印（五芒星の線） */}
                  {arrows.map(a=>(
                    <line key={a.key} x1={a.sx} y1={a.sy} x2={a.ex} y2={a.ey}
                      stroke="#dc2626" strokeWidth="2" markerEnd="url(#ar)" opacity="0.8" strokeDasharray="4 2"/>
                  ))}
                  {/* 五行ノード */}
                  {pts.map((p,i)=>(
                    <g key={i}>
                      <circle cx={p.x} cy={p.y} r="22" fill={p.bg} stroke={p.c} strokeWidth="2"/>
                      <text x={p.x} y={p.y+5} textAnchor="middle" fontSize="16" fontWeight="bold" fill={p.c}>{p.e}</text>
                    </g>
                  ))}
                  {/* 中央ラベル */}
                  <text x="150" y="136" textAnchor="middle" fontSize="12" fill="#6b7280">相剋</text>
                  <text x="150" y="150" textAnchor="middle" fontSize="12" fill="#dc2626">（抑える・克す）</text>
                </svg>
              );
            })()}
            <div style={{fontSize:"15px",color:"#6b7280",marginTop:"4px",lineHeight:1.7}}>
              木剋土 → 土剋水 → 水剋火 → 火剋金 → 金剋木
            </div>
            <div style={{marginTop:"12px",display:"flex",flexWrap:"wrap",gap:"6px"}}>
              {GOKYO.map((g,i)=>(
                <div key={i} style={{border:`1px solid ${g.c}30`,borderRadius:"8px",padding:"8px 10px",background:g.bg,flex:"1",minWidth:"80px",textAlign:"center"}}>
                  <div style={{fontWeight:"bold",color:g.c,fontSize:"15px"}}>{g.e}</div>
                  <div style={{fontSize:"14px",color:"#6b7280",marginTop:"2px"}}>生：{g.gen}</div>
                  <div style={{fontSize:"14px",color:"#dc2626"}}>剋：{g.ovr}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* 万物対応表 */}
      <div style={S.sec}>
        <div style={S.sh} onClick={()=>toggle("bansho")}>
          <span>📖 万物象意・対応表</span><span>{open.bansho?"▲":"▼"}</span>
        </div>
        {open.bansho&&(
          <div style={S.sb}>
            <div style={{fontSize:"15px",color:"#6b7280",marginBottom:"10px"}}>気学では万物を五行・九星に配当し、象意として鑑定に活用します。</div>
            {BANBUTSU.map((cat,ci)=>(
              <div key={ci} style={{marginBottom:"12px"}}>
                <div style={{fontSize:"15px",fontWeight:"bold",color:"#78350f",fontFamily:"serif",marginBottom:"4px",padding:"3px 8px",background:"#fffbeb",borderRadius:"4px",display:"inline-block"}}>【{cat.cat}】</div>
                <div style={{display:"flex",flexDirection:"column",gap:"2px"}}>
                  {cat.items.map((item,ii)=>(
                    <div key={ii} style={{display:"flex",gap:"8px",fontSize:"15px",padding:"3px 6px",borderRadius:"4px",background:"#fafaf9"}}>
                      <span style={{color:"#78350f",fontWeight:"bold",minWidth:"120px",flexShrink:0}}>{item[0]}</span>
                      <span style={{color:"#374151"}}>{item[1]}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
            <div style={{marginTop:"10px",padding:"10px",background:"#fffbeb",borderRadius:"8px",border:"1px solid #fde68a"}}>
              <div style={{fontSize:"15px",fontWeight:"bold",color:"#78350f",marginBottom:"4px"}}>🌟 気学の基本的な考え方</div>
              <div style={{fontSize:"15px",color:"#374151",lineHeight:1.8}}>
                気学は「宇宙の気の流れ」を読み解く学問です。すべての物事・現象・人間は五行（木・火・土・金・水）のいずれかの「気」を帯びており、それらの関係（相生・相剋・比和）によって吉凶・縁起を判断します。<br/>
                ● <strong>相生（そうじょう）</strong>：互いに助け合い生かし合う関係 ▶ 吉<br/>
                ● <strong>相剋（そうこく）</strong>：一方が他方を抑制する関係 ▶ 注意<br/>
                ● <strong>比和（ひわ）</strong>：同じ五行が重なる関係 ▶ 結果が拡大<br/>
                ● <strong>方位</strong>：九星の本命星に基づき、吉方位・凶方位を読み取ることで運気の流れを活用します。
              </div>
            </div>
          </div>
        )}

      {/* 九星気学とは */}
      <div style={S.sec}>
        <div style={S.sh} onClick={()=>toggle("kisogaku")}><span>☯ 九星気学とは</span><span>{open.kisogaku?"▲":"▼"}</span></div>
        {open.kisogaku&&(
          <div style={S.sb}>
            <p style={{marginBottom:"10px"}}>九星気学は、古代中国の<strong>陰陽五行説・易・洛書（らくしょ）</strong>に基づく占術・哲学体系です。約4000年の歴史を持ち、日本には奈良・平安時代に伝来しました。</p>
            <p style={{marginBottom:"10px"}}>人が生まれた年・月の「気」を九つの星（九星）に分類し、<strong>方位・時期・人間関係</strong>を読み解くことで、日常の決断や行動の指針とします。</p>
            <p style={{marginBottom:"10px"}}><strong>「気」</strong>とは宇宙を貫くエネルギーの流れであり、万物はこの気の影響を絶えず受けています。気学はその流れを読み、吉方位・吉日・吉期を活用することで運気を高める実践的な学問です。</p>
            <div style={{background:"#fffbeb",borderRadius:"8px",padding:"10px",border:"1px solid #fde68a",fontSize:"14px",color:"#78350f"}}>
              <strong>気学の三本柱：</strong>①本命星（生まれ年の星）　②方位学（吉凶方位の活用）　③九星暦（吉日・時期の読み方）
            </div>
          </div>
        )}
      </div>

      {/* 九星とは何か */}
      <div style={S.sec}>
        <div style={S.sh} onClick={()=>toggle("kyusei")}><span>⭐ 九星とは何か</span><span>{open.kyusei?"▲":"▼"}</span></div>
        {open.kyusei&&(
          <div style={S.sb}>
            <p style={{marginBottom:"10px"}}>九星とは、宇宙の気を九種類に分類した星です。人は生まれた年によっていずれかの星に属し、その星の性質が基本的な気質・運命に影響します。</p>
            <div style={{display:"flex",flexDirection:"column",gap:"6px",marginTop:"8px"}}>
              {[
                {star:"一白水星",color:"#1d4ed8",bg:"#eff6ff",trait:"流動・知恵・内省。柔軟性があり、流れに乗る力を持つ。"},
                {star:"二黒土星",color:"#78350f",bg:"#fffbeb",trait:"母性・忍耐・蓄積。大地のような包容力と粘り強さ。"},
                {star:"三碧木星",color:"#065f46",bg:"#ecfdf5",trait:"行動・発展・雷。積極性があり、新しいことへの挑戦が吉。"},
                {star:"四緑木星",color:"#14532d",bg:"#f0fdf4",trait:"縁・信用・風。人との縁を育て、コミュニケーションに優れる。"},
                {star:"五黄土星",color:"#92400e",bg:"#fef3c7",trait:"帝王・中心・腐敗と再生。強大な力を持ち、変化の核となる。"},
                {star:"六白金星",color:"#374151",bg:"#f8fafc",trait:"天・権威・完璧主義。高い理想と品格を持ち、統率力がある。"},
                {star:"七赤金星",color:"#7f1d1d",bg:"#fff1f2",trait:"喜悦・言語・収穫。社交的で楽しいことへの感性が鋭い。"},
                {star:"八白土星",color:"#44403c",bg:"#fafaf9",trait:"変化・蓄財・山。変革期に強く、転換のエネルギーを持つ。"},
                {star:"九紫火星",color:"#4c1d95",bg:"#f5f3ff",trait:"直感・名誉・光明。洗練された感性と強い直感力を持つ。"},
              ].map((s,i)=>(
                <div key={i} style={{display:"flex",gap:"8px",alignItems:"flex-start",padding:"8px",borderRadius:"8px",background:s.bg,border:`1px solid ${s.color}22`}}>
                  <div style={{minWidth:"90px",fontSize:"13px",fontWeight:"bold",color:s.color,fontFamily:"serif"}}>{s.star}</div>
                  <div style={{fontSize:"12px",color:"#4a3728",flex:1,lineHeight:1.7}}>{s.trait}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* 方位盤の読み方 */}
      <div style={S.sec}>
        <div style={S.sh} onClick={()=>toggle("hoiban")}><span>🧭 方位盤の読み方</span><span>{open.hoiban?"▲":"▼"}</span></div>
        {open.hoiban&&(
          <div style={S.sb}>
            <p style={{marginBottom:"10px"}}><strong>後天定位盤（こうてんていいばん）</strong>は気学の基本となる方位盤で、洛書の数理に基づき九星を配置したものです。</p>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"4px",maxWidth:"280px",margin:"0 auto 14px",textAlign:"center"}}>
              {[{s:"四緑",d:"東南"},{s:"九紫",d:"南"},{s:"二黒",d:"西南"},{s:"三碧",d:"東"},{s:"五黄",d:"中央"},{s:"七赤",d:"西"},{s:"八白",d:"東北"},{s:"一白",d:"北"},{s:"六白",d:"西北"}].map((c,i)=>(
                <div key={i} style={{padding:"8px 4px",border:"1px solid #fde68a",borderRadius:"6px",background:i===4?"#fef3c7":"#fffbeb"}}>
                  <div style={{fontSize:"13px",fontWeight:"bold",color:"#78350f",fontFamily:"serif"}}>{c.s}</div>
                  <div style={{fontSize:"11px",color:"#9ca3af"}}>{c.d}</div>
                </div>
              ))}
            </div>
            <div style={{fontSize:"14px",color:"#374151",lineHeight:1.8}}>
              <p style={{marginBottom:"6px"}}>📅 <strong>年盤・月盤・日盤</strong>：その年・月・日の中宮星を中心に九星が配置され、各方位の吉凶が変わります。</p>
              <p style={{marginBottom:"6px"}}>🔄 <strong>定位置との比較</strong>：中宮に入った星によって全ての星が移動します。吉方位は本命星との関係（相生・比和）で判断します。</p>
              <p>📐 <strong>実用</strong>：旅行・引越・転職など方向を伴う行動の前に吉方位を確認することで運気を活用します。</p>
            </div>
          </div>
        )}
      </div>

      {/* 本命星・月命星とは */}
      <div style={S.sec}>
        <div style={S.sh} onClick={()=>toggle("honmei")}><span>🌟 本命星・月命星とは</span><span>{open.honmei?"▲":"▼"}</span></div>
        {open.honmei&&(
          <div style={S.sb}>
            <div style={{marginBottom:"12px"}}>
              <div style={{fontSize:"15px",fontWeight:"bold",color:"#78350f",fontFamily:"serif",marginBottom:"6px"}}>本命星（ほんめいせい）</div>
              <p>生まれた<strong>年</strong>から算出する主星。根本的な気質・人生のテーマ・体質・運命の骨格を示します。気学鑑定の中心となる最も重要な星です。</p>
            </div>
            <div style={{marginBottom:"12px"}}>
              <div style={{fontSize:"15px",fontWeight:"bold",color:"#78350f",fontFamily:"serif",marginBottom:"6px"}}>月命星（つきめいせい）</div>
              <p>生まれた<strong>月</strong>から算出する星。本命星を補完し、より細かな性質・感情・対人関係のパターンを表します。表面的な性格や行動様式に現れやすい星です。</p>
            </div>
            <div style={{background:"#fffbeb",borderRadius:"8px",padding:"10px",border:"1px solid #fde68a"}}>
              <div style={{fontSize:"14px",fontWeight:"bold",color:"#78350f",marginBottom:"4px"}}>⚠️ 気学年の起点</div>
              <p style={{fontSize:"14px",lineHeight:1.8}}>気学では<strong>2月4日（立春）</strong>を一年の始まりとします。1月1日〜2月3日生まれの方は、前の年の本命星・月命星が適用されます。</p>
            </div>
          </div>
        )}
      </div>

      {/* 五行と九星の関係 */}
      <div style={S.sec}>
        <div style={S.sh} onClick={()=>toggle("gogyo")}><span>🌊 五行と九星の関係</span><span>{open.gogyo?"▲":"▼"}</span></div>
        {open.gogyo&&(
          <div style={S.sb}>
            <p style={{marginBottom:"10px"}}>九星はそれぞれ五行（木・火・土・金・水）のいずれかに属し、五行の性質がその星の本質的な気を表します。</p>
            <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
              {[
                {elem:"木",color:"#065f46",bg:"#ecfdf5",stars:"三碧木星・四緑木星",nature:"成長・発展・縁・春・東",body:"肝臓・神経・目"},
                {elem:"火",color:"#7f1d1d",bg:"#fff1f2",stars:"九紫火星",nature:"情熱・直感・礼節・夏・南",body:"心臓・血管・小腸"},
                {elem:"土",color:"#78350f",bg:"#fffbeb",stars:"二黒・五黄・八白土星",nature:"安定・中心・信頼・土用",body:"胃腸・脾臓・口"},
                {elem:"金",color:"#374151",bg:"#f8fafc",stars:"六白・七赤金星",nature:"規律・収穫・義・秋・西",body:"肺・大腸・鼻"},
                {elem:"水",color:"#1d4ed8",bg:"#eff6ff",stars:"一白水星",nature:"流動・知恵・内省・冬・北",body:"腎臓・膀胱・耳"},
              ].map((g,i)=>(
                <div key={i} style={{padding:"10px",borderRadius:"8px",background:g.bg,border:`1px solid ${g.color}33`}}>
                  <div style={{display:"flex",gap:"8px",alignItems:"center",marginBottom:"4px"}}>
                    <span style={{fontSize:"16px",fontWeight:"bold",color:g.color,fontFamily:"serif"}}>{g.elem}</span>
                    <span style={{fontSize:"13px",fontWeight:"bold",color:g.color}}>{g.stars}</span>
                  </div>
                  <div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>性質：{g.nature}</div>
                  <div style={{fontSize:"13px",color:"#6b7280"}}>対応する体：{g.body}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* 吉凶方位の種類 */}
      <div style={S.sec}>
        <div style={S.sh} onClick={()=>toggle("kicchou")}><span>⚡ 吉凶方位の種類</span><span>{open.kicchou?"▲":"▼"}</span></div>
        {open.kicchou&&(
          <div style={S.sb}>
            <div style={{fontSize:"15px",fontWeight:"bold",color:"#dc2626",fontFamily:"serif",marginBottom:"8px"}}>🔴 四大凶方位</div>
            <div style={{display:"flex",flexDirection:"column",gap:"6px",marginBottom:"14px"}}>
              {[
                {name:"五黄殺（ごおうさつ）",desc:"その年・月の五黄土星がある方位。最大の凶。病気・事故・損失を招く。"},
                {name:"暗剣殺（あんけんさつ）",desc:"五黄土星の反対方位。突発的な災難・裏切り・予期せぬ不運。"},
                {name:"五黄中宮日（ごおうちゅうぐうにち）",desc:"五黄土星が日盤の中宮に入る日。月に1〜2日ほど訪れる、九星気学で最も根拠ある凶日概念。大きな決断・契約・引越し・手術は避け、静かに内省・充電に充てる日。"},
                {name:"本命殺（ほんめいさつ）",desc:"自分の本命星がある方位の反対。健康・財産・人間関係に打撃。"},
                {name:"月命殺（つきめいさつ）",desc:"自分の月命星がある方位への移動。月命星を直接攻撃する方位で、短期的な悪影響が出やすい。"},
                {name:"月命的殺（つきめいてきさつ）",desc:"自分の月命星がある方位の反対。月命星の対面方位で、月命殺と並ぶ個人的な凶方位。"},
                {name:"本命的殺（ほんめいてきさつ）",desc:"自分の本命星がある方位そのもの。長期的な凶作用。"},
              ].map((b,i)=>(
                <div key={i} style={{padding:"8px 10px",borderRadius:"8px",background:"#fff1f2",border:"1px solid #fecaca"}}>
                  <div style={{fontSize:"14px",fontWeight:"bold",color:"#dc2626",marginBottom:"2px"}}>{b.name}</div>
                  <div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>{b.desc}</div>
                </div>
              ))}
            </div>
            <div style={{fontSize:"15px",fontWeight:"bold",color:"#16a34a",fontFamily:"serif",marginBottom:"8px"}}>🟢 吉方位の判断基準</div>
            <div style={{padding:"10px",borderRadius:"8px",background:"#f0fdf4",border:"1px solid #86efac",fontSize:"14px",lineHeight:1.8,color:"#374151"}}>
              <p>✅ <strong>相生（そうじょう）</strong>：その方位の星が本命星を生かす関係 → 大吉</p>
              <p>✅ <strong>比和（ひわ）</strong>：その方位の星と本命星が同じ五行 → 吉</p>
              <p>⚠️ <strong>相剋（そうこく）</strong>：一方が他方を抑制する関係 → 凶方位</p>
            </div>
          </div>
        )}
      </div>

      {/* 気学の歴史 */}
      <div style={S.sec}>
        <div style={S.sh} onClick={()=>toggle("rekishi")}><span>📜 気学の歴史</span><span>{open.rekishi?"▲":"▼"}</span></div>
        {open.rekishi&&(
          <div style={S.sb}>
            <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
              {[
                {era:"紀元前2800年頃",event:"伏羲（ふっき）が八卦を創案（伝説）。天地自然の法則を八つの卦に象徴化。"},
                {era:"紀元前1000年頃",event:"文王（ぶんのう）が後天八卦を整備。周易の基礎が確立される。"},
                {era:"漢　代",event:"洛書・河図の数理が体系化。陰陽五行説と易が融合し、気学の原型が生まれる。"},
                {era:"奈良・平安時代",event:"日本に陰陽道として伝来。陰陽師による方位・吉凶の鑑定が行われる。"},
                {era:"江戸時代",event:"民間に普及。日常の方位取り・家相・引越の吉凶判断として庶民に広まる。"},
                {era:"明治時代",event:"園田真次郎が日本独自の「九星気学」として体系化・著述。現代気学の祖とされる。"},
                {era:"大正〜昭和",event:"気学の普及が全国規模に拡大。方位学・家相学として多くの流派が生まれる。"},
                {era:"現　代",event:"デジタル化により気学アプリが普及。伝統と現代技術が融合した新しい形で継承されている。"},
              ].map((h,i)=>(
                <div key={i} style={{display:"flex",gap:"10px",alignItems:"flex-start"}}>
                  <div style={{minWidth:"100px",fontSize:"12px",fontWeight:"bold",color:"#b8860b",padding:"3px 6px",background:"#fffbeb",borderRadius:"4px",textAlign:"center",flexShrink:0}}>{h.era}</div>
                  <div style={{fontSize:"14px",color:"#374151",lineHeight:1.8,borderLeft:"2px solid #fde68a",paddingLeft:"10px"}}>{h.event}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      </div>
    </div>
  );
}

// ═══ ORACLE TAB (THING/KEYWORD) ═══




function AuthModal({onClose,onSuccess}){
  const[mode,setMode]=React.useState("login"); // login/signup
  const[email,setEmail]=React.useState("");
  const[password,setPassword]=React.useState("");
  const[loading,setLoading]=React.useState(false);
  const[error,setError]=React.useState("");
  const[sent,setSent]=React.useState(false);

  async function handleSubmit(){
    if(!email||!password){setError("メールアドレスとパスワードを入力してください");return;}
    setLoading(true);setError("");
    try{
      if(mode==="signup"){
        const{error}=await supabase.auth.signUp({email,password,options:{emailRedirectTo:process.env.REACT_APP_SITE_URL||window.location.origin}});
        if(error)throw error;
        setSent(true);
      }else{
        const{error,data}=await supabase.auth.signInWithPassword({email,password});
        if(error)throw error;
        onSuccess(data.user);
        onClose();
      }
    }catch(e){
      setError(e.message==="Invalid login credentials"?"メールアドレスまたはパスワードが違います":e.message);
    }
    setLoading(false);
  }

  if(sent)return(
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}}>
      <div style={{background:"white",borderRadius:"16px",padding:"32px 24px",maxWidth:"360px",width:"100%",textAlign:"center"}}>
        <div style={{fontSize:"48px",marginBottom:"16px"}}>📧</div>
        <div style={{fontSize:"18px",fontWeight:"bold",color:"#1f2937",marginBottom:"8px"}}>確認メールを送信しました</div>
        <div style={{fontSize:"14px",color:"#6b7280",marginBottom:"20px",lineHeight:1.7}}>{email}に確認メールを送りました。メール内のリンクをクリックして登録を完了してください。</div>
        <button onClick={onClose} style={{...CS.btn("#d97706"),padding:"12px 24px"}}>閉じる</button>
      </div>
    </div>
  );

  return(
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}}>
      <div style={{background:"white",borderRadius:"16px",padding:"24px",maxWidth:"360px",width:"100%"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"20px"}}>
          <div style={{fontSize:"18px",fontWeight:"bold",fontFamily:"serif",color:"#78350f"}}>{mode==="login"?"🔑 ログイン":"📝 新規登録"}</div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:"20px",cursor:"pointer",color:"#6b7280"}}>×</button>
        </div>
        <div style={{display:"flex",gap:"8px",marginBottom:"20px"}}>
          <button onClick={()=>setMode("login")} style={{flex:1,padding:"10px",borderRadius:"8px",border:"1px solid",cursor:"pointer",background:mode==="login"?"#fffbeb":"white",borderColor:mode==="login"?"#f59e0b":"#e5e7eb",color:mode==="login"?"#92400e":"#6b7280",fontWeight:mode==="login"?"bold":"normal"}}>ログイン</button>
          <button onClick={()=>setMode("signup")} style={{flex:1,padding:"10px",borderRadius:"8px",border:"1px solid",cursor:"pointer",background:mode==="signup"?"#fffbeb":"white",borderColor:mode==="signup"?"#f59e0b":"#e5e7eb",color:mode==="signup"?"#92400e":"#6b7280",fontWeight:mode==="signup"?"bold":"normal"}}>新規登録</button>
        </div>
        {error&&<div style={{padding:"10px",background:"#fef2f2",border:"1px solid #fecaca",borderRadius:"8px",fontSize:"13px",color:"#dc2626",marginBottom:"12px"}}>{error}</div>}
        <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="メールアドレス" type="email" style={{width:"100%",padding:"12px",borderRadius:"8px",border:"1px solid #e5e7eb",fontSize:"15px",marginBottom:"10px",boxSizing:"border-box"}}/>
        <input value={password} onChange={e=>setPassword(e.target.value)} placeholder="パスワード（6文字以上）" type="password" style={{width:"100%",padding:"12px",borderRadius:"8px",border:"1px solid #e5e7eb",fontSize:"15px",marginBottom:"16px",boxSizing:"border-box"}}/>
        <button onClick={handleSubmit} disabled={loading} style={{...CS.btn("#d97706"),padding:"14px",width:"100%",fontSize:"16px",opacity:loading?0.7:1}}>
          {loading?"処理中...":(mode==="login"?"ログイン":"登録する")}
        </button>
        {mode==="login"&&<div style={{textAlign:"center",marginTop:"12px",fontSize:"13px",color:"#6b7280"}}>アカウントをお持ちでない方は「新規登録」を選択してください</div>}
      </div>
    </div>
  );
}

function KisoTab(){
  return(
    <div style={{maxWidth:"560px",margin:"0 auto",padding:"14px 14px 80px"}}>
      <div style={{fontSize:"17px",fontWeight:"bold",fontFamily:"serif",color:"#78350f",marginBottom:"16px",paddingTop:"8px"}}>📚 九星気学・方位・吉日とは</div>
      <KigakuReference/>
    </div>
  );
}

function FortuneTab({profile,isPremium,isPremiumPlus,onUnlock,authUser}){
  const LIMIT=isPremiumPlus?30:isPremium?10:0;
  const month=new Date().getFullYear()+'_'+(new Date().getMonth()+1);
  const mKey='ki_fortune_'+new Date().getFullYear()+'_'+new Date().getMonth();
  const [used,setUsed]=useState(0);
  // sGetは非同期なので読み込み後に反映（ローカル保存分）
  useEffect(()=>{sGet(mKey,0).then(v=>setUsed(parseInt(v)||0));},[mKey]);
  // DB同期: ログイン済みの場合はSupabaseから使用回数を読み込む
  useEffect(()=>{
    if(!authUser?.id)return;
    supabase.from('usage_counts').select('fortune_count').eq('user_id',authUser.id).eq('month',month).single()
      .then(({data})=>{if(data?.fortune_count!=null)setUsed(data.fortune_count);});
  },[authUser?.id]);
  const [step,setStep]=useState('summon');
  // 相談対象：自分 or 他の人
  const [target,setTarget]=useState<'self'|'other'>('self');
  const [other,setOther]=useState({name:'',by:'',bm:'',bd:'',rel:'',loc:''});
  const [concern,setConcern]=useState('');
  const [goal,setGoal]=useState('');
  const [deadlineDate,setDeadlineDate]=useState('');
  const [consultAt,setConsultAt]=useState<Date|null>(null);
  const [result,setResult]=useState(null);
  const [showShareFort,setShowShareFort]=useState(false);
  const [tick,setTick]=useState(0);
  const [rokkoLines,setRokkoLines]=useState<number[]>([]);
  const [rokkoAnimating,setRokkoAnimating]=useState(false);
  const [rokkoHex,setRokkoHex]=useState<any>(null);
  const [rokkoMode,setRokkoMode]=useState<'auto'|'manual'>('auto');
  const [manualCoins,setManualCoins]=useState<boolean[][]>([]);
  const today=new Date();
  const selfHs=profile?.honmeiStar||5;
  // 他の人の本命星・月命星（生年月日から算出）
  const oy=parseInt(other.by),om=parseInt(other.bm),odRaw=parseInt(other.bd);
  const odKnown=odRaw>=1&&odRaw<=31;
  const od=odKnown?odRaw:15;
  const otherValid=!!other.name.trim()&&oy>=1900&&oy<=today.getFullYear()&&om>=1&&om<=12;
  const otherHs=otherValid?getHonmei(oy,om,od):0;
  const otherTs=otherValid?getMonthStar(otherHs,getKiMonthIdx(om,od)):0;
  const isOther=target==='other'&&otherValid;
  const hs=isOther?otherHs:selfHs;
  const ts=isOther?otherTs:(profile?.tsukimeiStar||hs);
  const si=STAR_INFO[hs];
  const subjectName=isOther?`${other.name.trim()}さん`:'あなた';
  // 現在地：自分はプロフィール登録地、他の人は任意入力
  const location=isOther?other.loc.trim():(profile?.location||'');
  useEffect(()=>{const id=setInterval(()=>setTick(t=>t+1),80);return()=>clearInterval(id);},[]);

  // 相談内容から分野を推定（ジャンル選択の代わり。六爻の用神選びに使う）
  const FIELDS=[
    {id:'love',label:'恋愛・結婚',icon:'💕',kw:['恋','彼氏','彼女','結婚','婚活','片思い','復縁','離婚','夫','妻','パートナー','交際','出会い','浮気']},
    {id:'work',label:'仕事・出世',icon:'💼',kw:['仕事','転職','職場','上司','部下','会社','昇進','就職','起業','独立','事業','退職','キャリア','異動','商売','店']},
    {id:'money',label:'財運・金運',icon:'💰',kw:['お金','収入','借金','貯金','投資','売上','金運','給料','資金','ローン','支払','家計','副業']},
    {id:'health',label:'健康・長寿',icon:'🌿',kw:['体調','病','健康','不調','眠','疲れ','治療','手術','痛','メンタル','うつ','入院','ダイエット']},
    {id:'study',label:'学業・試験',icon:'📚',kw:['試験','受験','合格','資格','勉強','学校','進学','入試','成績']},
    {id:'human',label:'人間関係',icon:'🤝',kw:['人間関係','友人','友達','家族','親','父','母','子供','息子','娘','近所','同僚','義母','義父','トラブル','喧嘩','いじめ','同居','介護','実家']},
  ];
  function inferField(text:string){
    let best={id:'all',n:0};
    for(const f of FIELDS){const n=f.kw.filter(k=>text.includes(k)).length;if(n>best.n)best={id:f.id,n};}
    return best.id;
  }
  // 他の人を占う場合、六爻の用神はその人との関係で決まる
  function inferRelation(rel:string){
    if(/父|母|親|祖/.test(rel))return'parent';
    if(/息子|娘|子供|子ども|孫/.test(rel))return'child';
    if(/兄|弟|姉|妹|友/.test(rel))return'sibling';
    if(/夫|妻|恋人|彼氏|彼女|パートナー|婚約/.test(rel))return'love';
    if(/上司|社長|先生|師/.test(rel))return'work';
    return'human';
  }
  const field=inferField(concern+' '+goal);
  const fieldLabel=FIELDS.find(f=>f.id===field)?.label||'総合開運';
  const yongKey=isOther?inferRelation(other.rel):field;

  const STAR_NAMES=["","一白水星","二黒土星","三碧木星","四緑木星","五黄土星","六白金星","七赤金星","八白土星","九紫火星"];
  const SHIKI_BY_STAR={1:{name:'白狐',emoji:'🦊'},2:{name:'土蛇',emoji:'🐍'},3:{name:'雷鳥',emoji:'⚡'},4:{name:'翠鳥',emoji:'🦜'},5:{name:'黄龍',emoji:'🐉'},6:{name:'白虎',emoji:'🐯'},7:{name:'赤狐',emoji:'🦊'},8:{name:'山神',emoji:'🏔️'},9:{name:'火鳥',emoji:'🦅'}};
  const shiki=SHIKI_BY_STAR[selfHs]||SHIKI_BY_STAR[5];
  const km=getKiMonthIdx(today.getMonth()+1,today.getDate());
  const dayC=getDayStar(today);
  const yrC=getYearStar(today.getFullYear());
  const moC=hs?getMonthStar(hs,km):dayC;

  // 数霊回数 per honmei star
  const NUMEROLOGY={1:[1,6],2:[2,5,8],3:[3,8],4:[4,3,9],5:[5,2,8],6:[6,1,7],7:[7,6],8:[8,2,5],9:[9,3,4]};

  // Direction names (index 0-8: SE,S,SW,E,C,W,NE,N,NW)
  const DN=["東南","南","西南","東","中","西","東北","北","西北"];

  function calcTripleGoodDirs(targetDate){
    const dt=targetDate||today;
    const yr=dt.getFullYear(),mo=dt.getMonth()+1,dy=dt.getDate();
    const kmi=getKiMonthIdx(mo,dy);
    const kiY=(kmi===11||(mo===1&&dy<6))?yr-1:yr;
    const yrC2=getYearStar(kiY);
    const moC2=getMonthStar(yrC2,kmi);
    const dayC2=getDayStar(dt);
    const yrS=getStarsFor(yrC2),moS=getStarsFor(moC2),dayS=getStarsFor(dayC2);
    const kyohoi=buildKyohoi(yrS,moS,hs,ts);
    const badPosSet=new Set(kyohoi.map(k=>k.pi));
    const results=[];
    for(let i=0;i<9;i++){
      if(i===4)continue; // skip center
      if(badPosSet.has(i))continue;
      const yrGood=yrS[i]===hs||getStarRel(hs,BASE_POS[i])==='相生受'||getStarRel(hs,BASE_POS[i])==='比和';
      const moGood=moS[i]===hs||getStarRel(hs,BASE_POS[i])==='相生受'||getStarRel(hs,BASE_POS[i])==='比和';
      const dayGood=dayS[i]===hs||getStarRel(hs,BASE_POS[i])==='相生受'||getStarRel(hs,BASE_POS[i])==='比和';
      const allThree=yrS[i]===hs&&moS[i]===hs&&dayS[i]===hs;
      const twoBoards=(yrS[i]===hs&&moS[i]===hs)||(yrS[i]===hs&&dayS[i]===hs)||(moS[i]===hs&&dayS[i]===hs);
      const score=(yrS[i]===hs?3:yrGood?1:0)+(moS[i]===hs?3:moGood?1:0)+(dayS[i]===hs?3:dayGood?1:0);
      if(score>=3)results.push({pos:i,dir:DN[i],score,allThree,twoBoards,yrHit:yrS[i]===hs,moHit:moS[i]===hs,dayHit:dayS[i]===hs});
    }
    return results.sort((a,b)=>b.score-a.score);
  }

  function calc30DayCalendar(){
    const calendar=[];
    for(let d=0;d<30;d++){
      const dt=new Date(today);
      dt.setDate(today.getDate()+d);
      const dirs=calcTripleGoodDirs(dt);
      const best=dirs[0];
      calendar.push({date:dt,dirs:dirs.slice(0,2),best});
    }
    return calendar;
  }

  function getPrayerTiming(honmeiStar,targetDate){
    const dt=targetDate||today;
    const moonAge=((dt.getTime()-new Date(2000,0,6).getTime())/(1000*60*60*24*29.5))%1;
    const moonPhase=moonAge<0.1?'新月直後':moonAge<0.25?'三日月〜上弦':moonAge<0.45?'上弦〜満月前':moonAge<0.55?'満月':moonAge<0.75?'満月〜下弦':'下弦〜新月前';
    const isGoodMoon=moonAge<0.1||Math.abs(moonAge-0.5)<0.05;
    const dayE=S_ELEM[getDayStar(dt)]||'土';
    const myE=S_ELEM[honmeiStar]||'土';
    const rel=getElemRel(myE,dayE);
    const isGoodDay=rel==='相生受'||rel==='比和';
    return{moonPhase,isGoodMoon,isGoodDay,dayE,rel};
  }

  function getPurificationDays(count=7){
    const good=[];
    for(let d=0;d<60;d++){
      const dt=new Date(today);
      dt.setDate(today.getDate()+d);
      const yr=dt.getFullYear(),mo=dt.getMonth()+1,dy=dt.getDate();
      const kmi=getKiMonthIdx(mo,dy);
      const kiY=(kmi===11||(mo===1&&dy<6))?yr-1:yr;
      const yrC2=getYearStar(kiY);
      const moC2=getMonthStar(yrC2,kmi);
      const dayC2=getDayStar(dt);
      const yrS=getStarsFor(yrC2),moS=getStarsFor(moC2),dayS=getStarsFor(dayC2);
      const ky=buildKyohoi(yrS,moS,hs,ts);
      // 浄化日 = 今日の暗剣殺・五黄殺が中宮または自分の方位に影響しない日
      const hasStrongKyo=ky.some(k=>k.lv==='大凶');
      if(!hasStrongKyo){
        const dayE=S_ELEM[dayC2]||'土';
        const myE=S_ELEM[hs]||'土';
        const rel=getElemRel(myE,dayE);
        if(rel==='相生受'||rel==='比和'){
          good.push({date:dt,reason:'日盤の氣が整い、浄化・結界に最適'});
          if(good.length>=count)break;
        }
      }
    }
    return good;
  }

  async function doRokkoAuto(){
    setStep('rokko_auto');
    setRokkoLines([]);
    const newLines:number[]=[];
    for(let i=0;i<6;i++){
      setRokkoAnimating(true);
      await new Promise(r=>setTimeout(r,600));
      setRokkoAnimating(false);
      const v=flipCoins();
      newLines.push(v);
      setRokkoLines([...newLines]);
      await new Promise(r=>setTimeout(r,250));
    }
    const hex=calcHex(newLines);
    setRokkoHex(hex);
    setConsultAt(new Date());
    setTimeout(()=>setStep('rokko_hex'),500);
  }

  async function callAI(){
    setStep('loading');
    const dirs=calcTripleGoodDirs(today);
    const tripleDir=dirs.filter(d=>d.allThree);
    const doubleDir=dirs.filter(d=>d.twoBoards&&!d.allThree);
    const prayer=getPrayerTiming(hs,today);
    const purifyDaysAI=getPurificationDays(3);
    const nums=NUMEROLOGY[hs]||[1];
    // 現在地の方位計算
    const TOKYO:[number,number]=[35.6762,139.6503];
    let locationBearingInfo='';
    if(location){
      try{
        const lCoords=await geocodeCity(resolveCityName(location));
        if(lCoords){
          const lb=calcBearingCoords(TOKYO,lCoords);
          const myE=S_ELEM[hs]||'土';
          const lbRel=getElemRel(myE,lb.elem);
          locationBearingInfo=`現在地「${location}」の九宮：東京より${lb.dir8}方位・第${lb.palace}宮・${STAR_NAMES[lb.star]}（五行：${lb.elem}）\n本命星との気の関係：${lbRel}（${lbRel==='相生受'?'地場の気があなたを生かす・最吉':lbRel==='相生生'?'あなたの気が地場を養う・吉':lbRel==='比和'?'同気相合・安定':lbRel==='相剋受'?'地場の気があなたを剋す・注意':lbRel==='相剋攻'?'あなたが地場を剋す・消耗注意':''}）`;
        }
      }catch(_){}
    }
    // ── 入力情報の整理（すべてプロンプトに渡す） ──
    const at=consultAt||new Date();
    const fmtD=(d:Date)=>`${d.getFullYear()}年${d.getMonth()+1}月${d.getDate()}日`;
    // 期限は任意。未指定なら3ヶ月を計画の目安にする
    const deadline=deadlineDate?new Date(deadlineDate+'T00:00:00'):new Date(at.getFullYear(),at.getMonth()+3,at.getDate());
    const daysLeft=Math.max(1,Math.round((deadline.getTime()-at.getTime())/86400000));
    const ageAt=(y:number,m:number,d:number)=>at.getFullYear()-y-((at.getMonth()+1<m||(at.getMonth()+1===m&&at.getDate()<d))?1:0);
    const birthTxt=isOther
      ?`${oy}年${om}月${odKnown?od+'日':'（日不明）'}生（${ageAt(oy,om,od)}歳）`
      :profile?.birthYear?`${profile.birthYear}年${profile.birthMonth}月${profile.birthDay}日生（${ageAt(profile.birthYear,profile.birthMonth,profile.birthDay)}歳）`:'未登録';
    const subjectTxt=isOther
      ?`他の人：${other.name.trim()}さん（相談者との関係：${other.rel.trim()||'未記入'}）／相談者本人の本命星は${STAR_NAMES[selfHs]}`
      :'相談者本人';
    const goodDaysToDeadline=getTripleAuspiciousDays(hs,at,Math.min(daysLeft,60)).slice(0,8);
    const rokkoInfo=rokkoHex?buildFortuneRokkoInfo(rokkoHex.lines,yongKey,at):'【六爻占術の卦象データ】未取得';
    const prompt=`あなたは九星気学と六爻占術に通じた式神「${shiki.name}」です。入力情報をすべて使い、「占って終わり」ではなく、ゴール達成までの行動計画を示す開運鑑定を行います。
${isOther?`
※今回は相談者が「${other.name.trim()}さん」のことを占います。九星気学の計算はすべて${other.name.trim()}さんの生年月日によるものです。六爻では世爻＝相談者、用神＝${other.name.trim()}さん（関係から選定）として読み、行動計画は「相談者が${other.name.trim()}さんのためにできること」と「${other.name.trim()}さん自身に勧めること」を分けて示してください。
`:''}
━━ 入力情報チェックリスト（すべて鑑定文に反映すること） ━━
✓ 相談対象：${subjectTxt}
✓ 生年月日：${birthTxt}／本命星${STAR_NAMES[hs]}（五行${S_ELEM[hs]||'土'}）・月命星${STAR_NAMES[ts]}
✓ 相談日時：${fmtD(at)} ${at.getHours()}時${String(at.getMinutes()).padStart(2,'0')}分（この時刻で日盤・時盤・六爻の卦を立てた）
✓ 悩みの具体的内容（本文から推定した分野：${fieldLabel}）：
${concern.trim()}
✓ ゴール：${goal.trim()}
✓ 期限：${deadlineDate?`${fmtD(deadline)}まで（残り${daysLeft}日）`:`指定なし（${fmtD(deadline)}までの約3ヶ月を目安に計画）`}
現在地：${location||'未登録'}${locationBearingInfo?'\n'+locationBearingInfo:''}

━━ 計算済みデータ ━━
${getSanbanInfo(hs,ts,at)}

${buildMonthFlowInfo(hs,ts,at,deadline)}

${buildHourBoardInfo(hs,at)}

【本日の吉方位】
三重吉方位：${tripleDir.length>0?tripleDir.map(d=>d.dir).join('、'):'なし'}／二重吉方位：${doubleDir.length>0?doubleDir.map(d=>d.dir).join('、'):'なし'}
【期限までの三重・二重吉方位日（最大60日先まで）】
${goodDaysToDeadline.map(d=>`${d.date}：${d.directions.map((x:any)=>x.direction+'（'+x.strength+'）').join('・')}`).join('\n')||'該当なし'}

${rokkoInfo}

【祈祷の補助データ】月相：${prayer.moonPhase}${prayer.isGoodMoon?'（吉）':''}／日盤五行${prayer.dayE}と本命五行の気：${prayer.rel}／数霊${nums.join('・')}回
浄化推奨日：${purifyDaysAI.map(p=>`${p.date.getMonth()+1}/${p.date.getDate()}`).join('、')||'なし'}

━━ あなたの6つの役割 ━━
① 九星気学の年盤解釈：年盤での本命星・月命星の宮位と生気/退気/殺気から、今年この相談に与えられた「大きな追い風・向かい風」を読む。
② 月盤から運気の流れ把握：【月盤の流れ】の各月を使い、期限までのどの月が攻め時・守り時・仕込み時かを判定する。
③ 日盤・時盤から吉時吉方位の抽出：日盤・時盤・吉方位日データから、具体的な日付・時間帯・方位を選ぶ（データにない日時や方位を作らない）。
④ 六爻の卦象を「現状分析」として使う：本卦の象・世爻と応爻の関係・用神の旺衰（月建/日辰）・動爻から、相談者の悩みが「なぜ今こうなっているか」を診断する。六爻は参考情報ではなく、現状診断の主たる根拠である。
⑤ 卦象から「取るべき行動」を導く：変卦（事の行き着く先）と用神を強める五行から、ゴールに向けて「すべきこと・避けるべきこと」を決める。
⑥ 具体的な行動計画に落とし込む：①〜⑤を統合し、相談日から期限日までを段階に分け、日付・時間帯・方位・行動を結びつけた計画にする。

━━ 書き方のルール ━━
・一般論は禁止。悩みとゴールの文言を引用しながら、この人だけの鑑定にする。
・推定した分野が悩みの本文と合わない場合は、本文を優先し、六親の五行一覧から適切な用神を選び直して理由を書く。
・各セクションで、根拠にしたデータ（例「年盤で本命星は西宮・生気」「用神妻財は月令で囚」）を明示する。
・期限日を過ぎた日付を行動計画に入れない。

以下の見出し・順番で必ず答えてください（見出しは【】で囲み、他の見出しは作らない）：

【古語】
（40〜60文字の古語・文語体。卦象とゴールを踏まえた一句）

【鑑定の前提】
・相談対象：（自分か他の人か。他の人なら名前と関係）
・生年月日：（生年月日と本命星・月命星を一行で）
・相談日時：（相談日時と、その時刻の時盤中宮・本卦名を一行で）
・悩みの内容：（悩みを20〜40文字で要約）
・ゴール：（ゴールを一行で）
・期限：（期限日と残り日数を一行で）

【年盤の解釈】
（役割①。120〜160文字）

【月盤の流れ】
（役割②。期限までの月ごとに「◯月：攻め/守り/仕込み＋理由」を箇条書き。最大6行）

【吉時・吉方位】
（役割③。日付・時間帯・方位を具体的に3〜5項目の箇条書き）

【卦象による現状分析】
（役割④。本卦名・世応・用神の旺衰・動爻を使い、悩みの原因を160〜220文字で診断）

【卦が示す取るべき行動】
すべきこと：（2〜3項目。どの卦象・五行が根拠か付記）
避けるべきこと：（1〜2項目）

【行動計画】
（役割⑥。「◯月◯日〜◯月◯日：行動（時間帯・方位）」の形式で、今日から期限日${fmtD(deadline)}までを3〜5段階に。最終段階は期限日にゴールがどうなっているべきかで締める）

【今日の開運アクション】
・（今日すぐできること1。本日の吉時・吉方位を使う）
・（今日すぐできること2）
・（今日すぐできること3）

【祈祷法】
■ 方角：（祈祷で向く方角と理由を40文字で）
■ 回数：（数霊${nums.join('・')}回を使った唱え方を40文字で）
■ 祈祷文：（ゴール達成を願う祈祷の言葉を古語・和語で2〜3行）
■ タイミング：（吉時・月相に基づく時間帯を40文字で）
■ 禁忌：（避けるべき日・方位・行動を40文字で）`;
    try{
      const _ctrl=new AbortController();setTimeout(()=>_ctrl.abort(),60000);const res=await fetch('/api/claude',{signal:_ctrl.signal,method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({model:'claude-haiku-4-5-20251001',max_tokens:4000,messages:[{role:'user',content:prompt}]})});
      const data=await res.json();
      const text=data.content?.[0]?.text||'鑑定に失敗しました。';
      const nu=used+1; sSet(mKey,String(nu)); setUsed(nu);
      // DB同期: ログイン済みの場合はSupabaseに使用回数を保存
      if(authUser?.id){
        const month2=new Date().getFullYear()+'_'+(new Date().getMonth()+1);
        supabase.from('usage_counts').upsert({user_id:authUser.id,month:month2,fortune_count:nu},{onConflict:'user_id,month'}).then(()=>{});
      }
      // 相談履歴に保存（localStorage + Supabase）
      try{
        const now=new Date().toISOString();
        const title=(isOther?`${other.name.trim()}さん：`:'')+fieldLabel;
        const entry={id:Date.now(),date:now,title,type:'開運',star:hs,answer:text};
        const prev=JSON.parse(localStorage.getItem('ki_consult_history')||'[]');
        localStorage.setItem('ki_consult_history',JSON.stringify([entry,...prev].slice(0,50)));
        if(authUser?.id){
          supabase.from('consult_history').insert({user_id:authUser.id,created_at:now,title,type:'開運',star:hs,answer:text}).then(()=>{});
        }
      }catch(_){}
      // 開運プログラムに保存
      try{
        const prog={id:Date.now(),startDate:new Date().toISOString(),theme:isOther?`${other.name.trim()}さん`:'自分',field:fieldLabel,concern:concern.trim(),goal:goal.trim(),deadline:deadline.toISOString(),hexagram:rokkoHex?{main:rokkoHex.main.name,change:rokkoHex.change?.name||'なし',lines:rokkoHex.lines}:null,program:text,checkIns:[],status:'active'};
        const progs=JSON.parse(localStorage.getItem('ki_fortune_programs')||'[]');
        localStorage.setItem('ki_fortune_programs',JSON.stringify([prog,...progs].slice(0,20)));
      }catch(_){}
      setResult(text.replace(/##\s*/g,'')); setStep('result');
    }catch(e){setResult('通信エラーが発生しました。再度お試しください。');setStep('result');}
  }

  const CS2={card:{background:"white",borderRadius:"14px",border:"1px solid #f3f4f6",padding:"18px",marginBottom:"14px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}};

  if(!isPremium&&!isPremiumPlus){
    return(
      <div style={{padding:"24px"}}>
        <div style={{textAlign:"center",padding:"32px 20px",background:"linear-gradient(135deg,#faf5ff,#f5f3ff)",borderRadius:"20px",border:"2px solid #ddd6fe",margin:"12px"}}>
          <div style={{fontSize:"44px",marginBottom:"10px"}}>🔮</div>
          <div style={{fontSize:"17px",fontWeight:"bold",color:"#4c1d95",fontFamily:"serif",marginBottom:"8px",lineHeight:1.5}}>今月の無料体験は終了しました</div>
          <div style={{fontSize:"14px",color:"#6b7280",marginBottom:"20px",lineHeight:1.7}}>続きの開運プログラムを受け取るには<br/>プランへのご登録が必要です</div>
          <div style={{display:"flex",gap:"10px",maxWidth:"300px",margin:"0 auto 16px"}}>
            <button onClick={()=>onUnlock&&onUnlock('basic')} style={{flex:1,padding:"14px 8px",borderRadius:"12px",border:"2px solid #f59e0b",background:"#fffbeb",cursor:"pointer"}}>
              <div style={{fontSize:"13px",fontWeight:"bold",color:"#b45309"}}>💛 ベーシック</div>
              <div style={{fontSize:"22px",fontWeight:"bold",color:"#1f2937"}}>¥180</div>
              <div style={{fontSize:"11px",color:"#6b7280"}}>/月 · 月10回</div>
            </button>
            <button onClick={()=>onUnlock&&onUnlock('premium')} style={{flex:1,padding:"14px 8px",borderRadius:"12px",border:"2px solid #7c3aed",background:"#ede9fe",cursor:"pointer"}}>
              <div style={{fontSize:"13px",fontWeight:"bold",color:"#4c1d95"}}>👑 プレミアム</div>
              <div style={{fontSize:"22px",fontWeight:"bold",color:"#1f2937"}}>¥480</div>
              <div style={{fontSize:"11px",color:"#6b7280"}}>/月 · 月30回</div>
            </button>
          </div>
        </div>
      </div>
    );
  }

  if(used>=LIMIT&&LIMIT>0)return(
    <div style={{textAlign:"center",padding:"48px 20px"}}>
      <div style={{fontSize:"48px",marginBottom:"16px"}}>🔮</div>
      <div style={{fontSize:"19px",fontWeight:"bold",fontFamily:"serif",color:"#374151",marginBottom:"10px"}}>今月の開運相談回数に達しました</div>
      <div style={{fontSize:"15px",color:"#6b7280",marginBottom:"6px"}}>今月の使用：{used}/{LIMIT}回</div>
      <div style={{fontSize:"14px",color:"#9ca3af"}}>来月またご相談ください</div>
    </div>
  );

  const UsageBar=()=>(
    <div style={{display:"flex",alignItems:"center",gap:"8px",padding:"8px 14px",background:"#f8f9fa",borderRadius:"8px",marginBottom:"14px",fontSize:"13px",color:"#6b7280"}}>
      <span>今月の開運相談：残{LIMIT-used}回</span>
      <div style={{flex:1,height:"4px",background:"#e5e7eb",borderRadius:"2px"}}>
        <div style={{width:`${(used/LIMIT)*100}%`,height:"100%",background:"#7c3aed",borderRadius:"2px",transition:"width 0.3s"}}/>
      </div>
    </div>
  );

  const inputSt={width:"100%",padding:"10px 12px",borderRadius:"8px",border:"1px solid #e5e7eb",fontSize:"15px",boxSizing:"border-box",fontFamily:"inherit"} as const;

  if(step==='summon')return(
    <div style={{minHeight:"60vh",background:"#f8f9fa",padding:"32px 20px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"serif"}}>
      <div style={{fontSize:"80px",marginBottom:"16px",display:"inline-block",animation:"shikiFloat2 2s ease-in-out infinite alternate"}}>{shiki.emoji}</div>
      <div style={{fontSize:"18px",color:"#b8860b",letterSpacing:"3px",marginBottom:"8px",textAlign:"center"}}>開運の氣を読みます</div>
      <div style={{fontSize:"16px",color:"#78716c",marginBottom:"28px",textAlign:"center"}}>式神「{shiki.name}」が占います。<br/>誰のことを占いますか？</div>
      <div style={{display:"flex",flexDirection:"column",gap:"12px",width:"100%",maxWidth:"340px"}}>
        <button onClick={()=>{setTarget('self');setStep('consult');}} style={{padding:"18px 20px",background:"linear-gradient(135deg,#b8860b,#d4a017)",color:"white",border:"none",borderRadius:"14px",cursor:"pointer",textAlign:"left",boxShadow:"0 4px 20px rgba(184,134,11,0.35)"}}>
          <div style={{fontSize:"17px",fontWeight:"bold",letterSpacing:"1px"}}>🙋 自分のことを占う</div>
          <div style={{fontSize:"13px",opacity:0.9,marginTop:"4px"}}>本命星：{STAR_NAMES[selfHs]}{profile?.location?` ／ ${profile.location}`:''}</div>
        </button>
        <button onClick={()=>{setTarget('other');setStep('other_info');}} style={{padding:"18px 20px",background:"white",color:"#92400e",border:"2px solid #fcd34d",borderRadius:"14px",cursor:"pointer",textAlign:"left"}}>
          <div style={{fontSize:"17px",fontWeight:"bold",letterSpacing:"1px"}}>👥 他の人のことを占う</div>
          <div style={{fontSize:"13px",color:"#a16207",marginTop:"4px"}}>家族・恋人・友人・同僚など</div>
        </button>
      </div>
      <style>{`@keyframes shikiFloat2{from{transform:translateY(0) scale(1)}to{transform:translateY(-12px) scale(1.05)}}`}</style>
    </div>
  );

  if(step==='other_info')return(
    <div style={{padding:"16px",maxWidth:"560px",margin:"0 auto"}}>
      <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"16px"}}>
        <button onClick={()=>setStep('summon')} style={{background:"none",border:"none",color:"#6b7280",cursor:"pointer",fontSize:"15px",padding:"4px"}}>← 戻る</button>
        <div style={{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>占う人の情報</div>
      </div>
      <div style={{...CS2.card,display:"flex",flexDirection:"column",gap:"14px"}}>
        <div>
          <div style={{fontSize:"14px",fontWeight:"bold",color:"#374151",marginBottom:"6px"}}>お名前（呼び名でOK）</div>
          <input value={other.name} onChange={e=>setOther({...other,name:e.target.value})} placeholder="例：母、たろう" style={inputSt}/>
        </div>
        <div>
          <div style={{fontSize:"14px",fontWeight:"bold",color:"#374151",marginBottom:"6px"}}>あなたとの関係</div>
          <input value={other.rel} onChange={e=>setOther({...other,rel:e.target.value})} placeholder="例：母・息子・恋人・友人・上司" style={inputSt}/>
        </div>
        <div>
          <div style={{fontSize:"14px",fontWeight:"bold",color:"#374151",marginBottom:"6px"}}>生年月日<span style={{fontSize:"12px",color:"#9ca3af",fontWeight:"normal"}}>（日は不明なら空欄）</span></div>
          <div style={{display:"flex",gap:"6px",alignItems:"center"}}>
            <input inputMode="numeric" maxLength={4} value={other.by} onChange={e=>setOther({...other,by:e.target.value.replace(/\D/g,'')})} placeholder="1970" style={{...inputSt,flex:2,minWidth:0}}/><span>年</span>
            <input inputMode="numeric" maxLength={2} value={other.bm} onChange={e=>setOther({...other,bm:e.target.value.replace(/\D/g,'')})} placeholder="5" style={{...inputSt,flex:1,minWidth:0}}/><span>月</span>
            <input inputMode="numeric" maxLength={2} value={other.bd} onChange={e=>setOther({...other,bd:e.target.value.replace(/\D/g,'')})} placeholder="10" style={{...inputSt,flex:1,minWidth:0}}/><span>日</span>
          </div>
          {otherValid&&<div style={{fontSize:"13px",color:"#b8860b",marginTop:"8px"}}>本命星：{STAR_NAMES[otherHs]} ／ 月命星：{STAR_NAMES[otherTs]}</div>}
        </div>
        <div>
          <div style={{fontSize:"14px",fontWeight:"bold",color:"#374151",marginBottom:"6px"}}>住んでいる所<span style={{fontSize:"12px",color:"#9ca3af",fontWeight:"normal"}}>（任意・都市名）</span></div>
          <input value={other.loc} onChange={e=>setOther({...other,loc:e.target.value})} placeholder="例：大阪" style={inputSt}/>
        </div>
      </div>
      <button onClick={()=>setStep('consult')} disabled={!otherValid}
        style={{width:"100%",padding:"16px",background:otherValid?"linear-gradient(135deg,#b8860b,#d4a017)":"#e5e7eb",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:otherValid?"pointer":"not-allowed",letterSpacing:"1px"}}>
        相談内容へ進む →
      </button>
    </div>
  );

  if(step==='consult'){
    const canNext=!!concern.trim()&&!!goal.trim();
    return(
    <div style={{padding:"16px",maxWidth:"560px",margin:"0 auto"}}>
      <UsageBar/>
      <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"16px"}}>
        <button onClick={()=>setStep(isOther?'other_info':'summon')} style={{background:"none",border:"none",color:"#6b7280",cursor:"pointer",fontSize:"15px",padding:"4px"}}>← 戻る</button>
        <div style={{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>{isOther?`${other.name.trim()}さんについて`:'あなたのご相談'}</div>
      </div>
      <div style={{background:"#fffbeb",borderRadius:"14px",padding:"18px",marginBottom:"16px",border:"1px solid #fde68a"}}>
        <div style={{fontSize:"14px",fontWeight:"bold",color:"#92400e",marginBottom:"4px"}}>何を占いますか？</div>
        <div style={{fontSize:"12px",color:"#a16207",marginBottom:"10px"}}>ジャンル分けは不要です。どんな悩みでも、状況や経緯をそのまま書いてください</div>
        <textarea value={concern} onChange={e=>setConcern(e.target.value)}
          placeholder={isOther?"例：母が最近ふさぎ込んでいて、実家に帰るべきか迷っている":"例：同僚との関係がぎくしゃくして職場に行くのがつらい。異動を願い出るべきか迷っている"}
          style={{...inputSt,border:"1px solid #fde68a",minHeight:"130px",resize:"none",lineHeight:1.7}}/>
      </div>
      <div style={{background:"#fdf4ff",borderRadius:"14px",padding:"18px",marginBottom:"16px",border:"1px solid #e9d5ff"}}>
        <div style={{fontSize:"14px",fontWeight:"bold",color:"#7c3aed",marginBottom:"4px"}}>どうなりたいですか？（ゴール）</div>
        <div style={{fontSize:"12px",color:"#9ca3af",marginBottom:"10px"}}>鑑定と行動計画はこのゴールに向けて組み立てます</div>
        <textarea value={goal} onChange={e=>setGoal(e.target.value)} placeholder={isOther?"例：母が元気を取り戻し、笑顔で過ごせるようになる":"例：気持ちよく働ける環境を手に入れる"}
          style={{...inputSt,border:"1px solid #e9d5ff",minHeight:"70px",resize:"none",lineHeight:1.6}}/>
      </div>
      <div style={{background:"#f0fdf4",borderRadius:"14px",padding:"14px 18px",marginBottom:"16px",border:"1px solid #86efac",display:"flex",alignItems:"center",gap:"8px",flexWrap:"wrap"}}>
        <span style={{fontSize:"14px",fontWeight:"bold",color:"#16a34a"}}>期限</span>
        <span style={{fontSize:"12px",color:"#9ca3af"}}>（決まっている場合のみ）</span>
        <input type="date" value={deadlineDate} min={today.toISOString().slice(0,10)} onChange={e=>setDeadlineDate(e.target.value)}
          style={{flex:1,minWidth:"140px",padding:"8px 10px",borderRadius:"8px",border:"1px solid #86efac",fontSize:"14px",fontFamily:"inherit"}}/>
        {deadlineDate&&<button onClick={()=>setDeadlineDate('')} style={{background:"none",border:"none",color:"#6b7280",cursor:"pointer",fontSize:"13px"}}>クリア</button>}
      </div>
      <div style={{fontSize:"12px",color:"#6b7280",marginBottom:"14px",padding:"0 4px"}}>
        📍 {isOther?(location?`${other.name.trim()}さんの住まい：${location}`:'住まい未入力（方位の地場分析は省略）'):(location?`お住まい：${location}（プロフィール登録地）`:'プロフィールに住まいが未登録です（登録すると地場の分析が加わります）')}
      </div>
      <button onClick={()=>setStep('rokko_select')} disabled={!canNext}
        style={{width:"100%",padding:"16px",background:canNext?"linear-gradient(135deg,#b8860b,#d4a017)":"#e5e7eb",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:canNext?"pointer":"not-allowed",letterSpacing:"1px"}}>
        卦を立てる ✦
      </button>
    </div>
  );}

  if(step==='rokko_select')return(
    <div style={{minHeight:"60vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"serif",padding:"24px",background:"#0a0e1a"}}>
      <div style={{fontSize:"48px",marginBottom:"12px"}}>{shiki.emoji}</div>
      <div style={{fontSize:"20px",color:"#d4a017",marginBottom:"8px",letterSpacing:"2px"}}>六爻占術</div>
      <div style={{fontSize:"13px",color:"#9ca3af",marginBottom:"32px",textAlign:"center"}}>卦の立て方を選んでください</div>
      <div style={{display:"flex",flexDirection:"column",gap:"16px",width:"100%",maxWidth:"320px"}}>
        <button onClick={()=>doRokkoAuto()}
          style={{padding:"20px",background:"linear-gradient(135deg,#1a1a3e,#2a2a5e)",border:"1px solid #d4a01766",borderRadius:"16px",color:"#fef3c7",textAlign:"left",cursor:"pointer"}}>
          <div style={{fontSize:"24px",marginBottom:"6px"}}>⚡ 自動投銭</div>
          <div style={{fontSize:"13px",color:"#d4a017",marginBottom:"4px"}}>AIが自動でコインを投げて卦を立てます</div>
          <div style={{fontSize:"11px",color:"#9ca3af"}}>素早く鑑定したいときに</div>
        </button>
        <button onClick={()=>{setManualCoins([]);setRokkoLines([]);setRokkoHex(null);setStep('rokko_manual');}}
          style={{padding:"20px",background:"linear-gradient(135deg,#1a2e1a,#2a4a2a)",border:"1px solid #4ade8066",borderRadius:"16px",color:"#fef3c7",textAlign:"left",cursor:"pointer"}}>
          <div style={{fontSize:"24px",marginBottom:"6px"}}>🪙 手動投銭（5円玉）</div>
          <div style={{fontSize:"13px",color:"#4ade80",marginBottom:"4px"}}>実際に5円玉を3枚振って入力します</div>
          <div style={{fontSize:"11px",color:"#9ca3af"}}>気を込めて丁寧に占いたいときに</div>
        </button>
      </div>
    </div>
  );

  if(step==='rokko_manual'){
    const coinCount=rokkoLines.length;
    const currentLineCoins:boolean[]=manualCoins[coinCount]||[];
    function addCoin(isHeads:boolean){
      const next=[...currentLineCoins,isHeads];
      const updated=[...manualCoins.slice(0,coinCount),next,...manualCoins.slice(coinCount+1)];
      if(next.length===3){
        const yang=next.filter(Boolean).length;
        const val=yang===3?9:yang===2?7:yang===1?8:6;
        const newLineVals=[...rokkoLines,val];
        setManualCoins([...manualCoins.slice(0,coinCount),next]);
        setRokkoLines(newLineVals);
        if(newLineVals.length===6){
          const hex=calcHex(newLineVals);
          setRokkoHex(hex);
          setConsultAt(new Date());
          setTimeout(()=>setStep('rokko_hex'),400);
        }
      } else {
        setManualCoins(updated);
      }
    }
    return(
      <div style={{minHeight:"60vh",display:"flex",flexDirection:"column",alignItems:"center",padding:"24px",background:"#0a0e1a",fontFamily:"serif"}}>
        <div style={{fontSize:"36px",marginBottom:"8px"}}>{shiki.emoji}</div>
        <div style={{fontSize:"17px",color:"#d4a017",marginBottom:"4px",letterSpacing:"2px"}}>5円玉を3枚投げてください</div>
        <div style={{fontSize:"13px",color:"#9ca3af",marginBottom:"20px"}}>{coinCount+1}爻目 / コイン {currentLineCoins.length+1}枚目</div>
        {/* 上爻が上・初爻が下になるよう逆順表示 */}
        <div style={{display:"flex",flexDirection:"column",gap:"8px",width:"220px",marginBottom:"24px"}}>
          {[5,4,3,2,1,0].map(i=>{
            const v=rokkoLines[i];
            const isYang=v===7||v===9;const isChg=v===6||v===9;
            const isCurrent=i===coinCount;
            return(
              <div key={i} style={{display:"flex",alignItems:"center",gap:"12px",opacity:v!=null?1:isCurrent?0.7:0.2,transition:"opacity 0.3s"}}>
                <span style={{fontSize:"11px",color:isCurrent?"#d4a017":"#9ca3af",width:"24px",textAlign:"right"}}>{i===5?'上爻':i===0?'初爻':`${i+1}爻`}</span>
                {v!=null?(
                  <div style={{flex:1,display:"flex",gap:"4px",justifyContent:"center"}}>
                    {isYang?<div style={{height:"10px",flex:1,background:isChg?"#f59e0b":"#d4a017",borderRadius:"2px"}}/>:(<><div style={{height:"10px",flex:"0 0 42%",background:isChg?"#60a5fa":"#6b7280",borderRadius:"2px"}}/><div style={{width:"8px"}}/><div style={{height:"10px",flex:"0 0 42%",background:isChg?"#60a5fa":"#6b7280",borderRadius:"2px"}}/></>)}
                  </div>
                ):(
                  <div style={{flex:1,height:"10px",background:isCurrent?"#374151":"#1f2937",borderRadius:"2px"}}/>
                )}
              </div>
            );
          })}
        </div>
        <div style={{display:"flex",gap:"12px",marginBottom:"24px"}}>
          {[0,1,2].map(ci=>(
            <div key={ci} style={{width:"52px",height:"52px",borderRadius:"50%",border:"2px solid",borderColor:ci<currentLineCoins.length?"#d4a017":"#374151",background:ci<currentLineCoins.length?(currentLineCoins[ci]?"#d4a017":"#4b5563"):"#1f2937",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"18px",transition:"all 0.2s",color:"#fef3c7"}}>
              {ci<currentLineCoins.length?(currentLineCoins[ci]?'表':'裏'):'?'}
            </div>
          ))}
        </div>
        <div style={{fontSize:"13px",color:"#9ca3af",marginBottom:"20px"}}>{currentLineCoins.length+1}枚目のコインの結果を入力</div>
        <div style={{display:"flex",gap:"16px",width:"100%",maxWidth:"320px",marginBottom:"20px"}}>
          <button onClick={()=>addCoin(true)}
            style={{flex:1,padding:"18px",background:"linear-gradient(135deg,#d4a017,#b8860b)",color:"#0a0e1a",border:"none",borderRadius:"12px",fontSize:"20px",fontWeight:"bold",cursor:"pointer"}}>
            🌕 表
          </button>
          <button onClick={()=>addCoin(false)}
            style={{flex:1,padding:"18px",background:"linear-gradient(135deg,#374151,#4b5563)",color:"#e5e7eb",border:"none",borderRadius:"12px",fontSize:"20px",fontWeight:"bold",cursor:"pointer"}}>
            🌑 裏
          </button>
        </div>
        <div style={{display:"flex",gap:"12px"}}>
          {currentLineCoins.length>0&&(
            <button onClick={()=>{const u=[...manualCoins];u[coinCount]=currentLineCoins.slice(0,-1);setManualCoins(u);}}
              style={{background:"none",border:"1px solid #374151",color:"#9ca3af",padding:"8px 16px",borderRadius:"8px",cursor:"pointer",fontSize:"13px"}}>
              ← 1枚戻す
            </button>
          )}
          {coinCount>0&&currentLineCoins.length===0&&(
            <button onClick={()=>{const nl=rokkoLines.slice(0,-1);setRokkoLines(nl);const mc=manualCoins.slice(0,-1);setManualCoins(mc);}}
              style={{background:"none",border:"1px solid #374151",color:"#9ca3af",padding:"8px 16px",borderRadius:"8px",cursor:"pointer",fontSize:"13px"}}>
              ← 前の爻に戻す
            </button>
          )}
        </div>
      </div>
    );
  }

  if(step==='rokko_auto')return(
    <div style={{minHeight:"60vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"serif",padding:"24px",background:"#0a0e1a"}}>
      <div style={{fontSize:"48px",marginBottom:"16px"}}>{shiki.emoji}</div>
      <div style={{fontSize:"18px",color:"#d4a017",marginBottom:"24px",letterSpacing:"2px"}}>六爻占術で卦を立てています…</div>
      {/* 上爻が上・初爻が下になるよう逆順表示 */}
      <div style={{display:"flex",flexDirection:"column",gap:"8px",width:"220px"}}>
        {[5,4,3,2,1,0].map(i=>{
          const v=rokkoLines[i];
          const isYang=v===7||v===9;const isChg=v===6||v===9;
          return(
            <div key={i} style={{display:"flex",alignItems:"center",gap:"12px",opacity:v!=null?1:i===rokkoLines.length?0.5:0.2,transition:"opacity 0.3s"}}>
              <span style={{fontSize:"11px",color:"#9ca3af",width:"24px",textAlign:"right"}}>{i===5?'上爻':i===0?'初爻':`${i+1}爻`}</span>
              {v!=null?(
                <div style={{flex:1,display:"flex",gap:"4px",justifyContent:"center"}}>
                  {isYang?(
                    <div style={{height:"10px",flex:1,background:isChg?"#f59e0b":"#d4a017",borderRadius:"2px"}}/>
                  ):(
                    <>
                      <div style={{height:"10px",flex:"0 0 42%",background:isChg?"#60a5fa":"#6b7280",borderRadius:"2px"}}/>
                      <div style={{width:"8px"}}/>
                      <div style={{height:"10px",flex:"0 0 42%",background:isChg?"#60a5fa":"#6b7280",borderRadius:"2px"}}/>
                    </>
                  )}
                </div>
              ):(
                <div style={{flex:1,height:"10px",background:"#374151",borderRadius:"2px",animation:rokkoAnimating&&i===rokkoLines.length?"pulse 0.5s infinite":undefined}}/>
              )}
              {v!=null&&<span style={{fontSize:"11px",color:isChg?"#f59e0b":"#9ca3af",width:"14px"}}>{v}</span>}
            </div>
          );
        })}
      </div>
    </div>
  );

  if(step==='rokko_hex'&&rokkoHex)return(
    <div style={{minHeight:"60vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"serif",padding:"24px",background:"#0a0e1a"}}>
      <div style={{fontSize:"48px",marginBottom:"8px"}}>{shiki.emoji}</div>
      <div style={{fontSize:"18px",color:"#d4a017",marginBottom:"24px",letterSpacing:"2px"}}>卦が立ちました</div>
      <div style={{background:"#1a1a2e",borderRadius:"16px",padding:"24px",width:"100%",maxWidth:"320px",marginBottom:"24px"}}>
        <div style={{marginBottom:"16px",textAlign:"center"}}>
          <div style={{fontSize:"12px",color:"#9ca3af",marginBottom:"4px",letterSpacing:"2px"}}>本卦</div>
          <div style={{fontSize:"22px",fontWeight:"bold",color:"#fef3c7"}}>{rokkoHex.main.name}</div>
          <div style={{fontSize:"13px",color:"#d4a017"}}>{rokkoHex.main.elem}</div>
        </div>
        {rokkoHex.change&&(
          <div style={{marginBottom:"16px",textAlign:"center",borderTop:"1px solid #374151",paddingTop:"16px"}}>
            <div style={{fontSize:"12px",color:"#9ca3af",marginBottom:"4px",letterSpacing:"2px"}}>変卦</div>
            <div style={{fontSize:"22px",fontWeight:"bold",color:"#93c5fd"}}>{rokkoHex.change.name}</div>
            <div style={{fontSize:"13px",color:"#60a5fa"}}>{rokkoHex.change.elem}</div>
          </div>
        )}
        <div style={{display:"flex",flexDirection:"column",gap:"6px",marginTop:"8px"}}>
          {[...rokkoHex.lines].reverse().map((v:number,ri:number)=>{
            const i=5-ri;
            const isYang=v===7||v===9;const isChg=v===6||v===9;
            return(
              <div key={i} style={{display:"flex",alignItems:"center",gap:"10px"}}>
                <span style={{fontSize:"11px",color:"#9ca3af",width:"24px",textAlign:"right"}}>{i===5?'上爻':i===0?'初爻':`${i+1}爻`}</span>
                <div style={{flex:1,display:"flex",gap:"4px",justifyContent:"center"}}>
                  {isYang?(
                    <div style={{height:"8px",flex:1,background:isChg?"#f59e0b":"#d4a017",borderRadius:"2px"}}/>
                  ):(
                    <>
                      <div style={{height:"8px",flex:"0 0 42%",background:isChg?"#60a5fa":"#6b7280",borderRadius:"2px"}}/>
                      <div style={{width:"6px"}}/>
                      <div style={{height:"8px",flex:"0 0 42%",background:isChg?"#60a5fa":"#6b7280",borderRadius:"2px"}}/>
                    </>
                  )}
                </div>
                {isChg&&<span style={{fontSize:"11px",color:"#f59e0b"}}>動</span>}
              </div>
            );
          })}
        </div>
      </div>
      <button onClick={()=>{setStep('loading');callAI();}}
        style={{width:"100%",maxWidth:"320px",padding:"16px",background:"linear-gradient(135deg,#d4a017,#b8860b)",color:"#0a0e1a",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:"pointer",letterSpacing:"2px"}}>
        AI鑑定へ進む ✦
      </button>
    </div>
  );

  if(step==='loading')return(
    <div style={{minHeight:"60vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"serif",background:"#f8f9fa"}}>
      <div style={{fontSize:"64px",marginBottom:"20px",animation:"shikiFloat2 1.2s ease-in-out infinite alternate"}}>{shiki.emoji}</div>
      <div style={{fontSize:"18px",color:"#b8860b",marginBottom:"8px"}}>「{shiki.name}」が鑑定中...</div>
      <div style={{fontSize:"14px",color:"#9ca3af"}}>九星気学の氣を読んでいます</div>
    </div>
  );

  if(step==='result'&&result){
    const secs={};
    const parts=result.split(/【(.+?)】/);
    for(let i=1;i<parts.length;i+=2)secs[parts[i]]=(parts[i+1]||'').trim();
    const triDirs=calcTripleGoodDirs(today);
    const calendar30=calc30DayCalendar();
    const purifyDays=getPurificationDays(5);
    const prayer=getPrayerTiming(hs,today);
    const nums=NUMEROLOGY[hs]||[1];
    const deadlineLabel=deadlineDate?deadlineDate.replace(/-/g,'/')+'まで':'指定なし';
    return(
      <div style={{padding:"16px",maxWidth:"560px",margin:"0 auto"}}>
        {showShareFort&&<ShareModal type="shikigami" data={{emoji:shiki.emoji,shikigamiName:shiki.name,message:(secs['古語']||result).slice(0,80),shareText:`【開運鑑定】${shiki.name}より\nテーマ：${fieldLabel}\n\n${(secs['古語']||'').slice(0,60)}\n\n${(secs['今日の開運アクション']||'').slice(0,100)}\n\n氣ごよみアプリで鑑定しました。\nhttps://kigaku-app.vercel.app`}} onClose={()=>setShowShareFort(false)}/>}
        <div style={{background:"linear-gradient(135deg,#0a0e1a,#1a0a0e)",borderRadius:"18px",padding:"24px",marginBottom:"16px",textAlign:"center",border:"1px solid #b8860b33"}}>
          <div style={{fontSize:"64px",marginBottom:"8px"}}>{shiki.emoji}</div>
          <div style={{fontSize:"20px",fontWeight:"bold",color:"#d4a017",fontFamily:"serif",marginBottom:"4px"}}>{shiki.name}</div>
          <div style={{fontSize:"13px",color:"#9ca3af",letterSpacing:"2px"}}>{subjectName}の開運鑑定 / {fieldLabel} / 期限：{deadlineLabel}</div>
        </div>

        {/* 分野別アドバイス */}
        {fieldLabel&&(
          <div style={{background:"linear-gradient(135deg,#f0f9ff,#e0f2fe)",borderRadius:"14px",padding:"16px",marginBottom:"14px",border:"2px solid #38bdf8"}}>
            <div style={{fontSize:"14px",fontWeight:"bold",color:"#0369a1",marginBottom:"10px"}}>
              ✦ {fieldLabel}の開運ポイント
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:"6px"}}>
              {fieldLabel.includes('恋愛')||fieldLabel.includes('結婚')?(<><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>💑 縁結びの吉方位に向かい、{getKotodamaCount(hs).join('・')}回の祈願を。</div><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>🌹 {S_ELEM[hs]}行の色（{S_ELEM[hs]==='水'?'黒・紺':S_ELEM[hs]==='木'?'緑・青':S_ELEM[hs]==='火'?'赤・紫':S_ELEM[hs]==='土'?'黄・茶':S_ELEM[hs]==='金'?'白・銀':''}）のアイテムを身につけると縁が深まります。</div></>)
              :fieldLabel.includes('仕事')||fieldLabel.includes('出世')?(<><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>💼 仕事運の方位で活動し、実力をアピールする好機。</div><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>📈 {getKotodamaCount(hs).join('・')}回の感謝の祈願が昇進運を高めます。</div></>)
              :fieldLabel.includes('財')||fieldLabel.includes('金')?(<><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>💰 金運吉方位に財布を向け、{getKotodamaCount(hs).join('・')}回の豊穣祈願を。</div><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>🪙 土の方位（東北・西南）で地に足ついた財を築く。</div></>)
              :fieldLabel.includes('健康')||fieldLabel.includes('長寿')?(<><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>🌿 水行の方位（北）で身体の浄化を。{getKotodamaCount(hs).join('・')}回の呼吸法が効果的。</div><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>🍃 早朝の吉方位散歩で気を取り込む習慣を。</div></>)
              :fieldLabel.includes('人間')?(<><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>🤝 対人運の吉方位から人と会うと縁が深まります。</div><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>✨ {getKotodamaCount(hs).join('・')}回の感謝の言葉が人間関係を好転させます。</div></>)
              :fieldLabel.includes('学業')||fieldLabel.includes('試験')?(<><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>📚 木行の方位（東・東南）で学びの気が高まります。</div><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>✏️ {getKotodamaCount(hs).join('・')}回の集中祈願で試験合格運を引き寄せます。</div></>)
              :(<><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>🌟 総合開運には三重吉方位への移動・旅行が最も効果的です。</div><div style={{fontSize:"13px",color:"#374151",lineHeight:1.7}}>✦ {getKotodamaCount(hs).join('・')}回の祈願で全体運を底上げします。</div></>)}
            </div>
            {location&&<div style={{fontSize:"12px",color:"#0369a1",marginTop:"8px",padding:"6px 10px",background:"rgba(14,165,233,0.08)",borderRadius:"6px"}}>📍 {location} ／ 期限：{deadlineLabel}</div>}
          </div>
        )}

        {/* 三重吉方位 */}
        <div style={{background:"linear-gradient(135deg,#fffbeb,#fef3c7)",borderRadius:"14px",padding:"18px",marginBottom:"14px",border:"2px solid #fbbf24"}}>
          <div style={{fontSize:"14px",fontWeight:"bold",color:"#92400e",marginBottom:"12px"}}>🧭 三重吉方位（年盤×月盤×日盤）</div>
          {triDirs.filter(d=>d.allThree).length>0?(
            <div>
              <div style={{fontSize:"13px",color:"#6b7280",marginBottom:"8px"}}>本日の最強吉方位（3盤完全一致）</div>
              {triDirs.filter(d=>d.allThree).map((d,i)=>(
                <div key={i} style={{background:"#fef9c3",borderRadius:"10px",padding:"10px 14px",marginBottom:"6px",border:"2px solid #fbbf24",display:"flex",alignItems:"center",gap:"10px"}}>
                  <span style={{fontSize:"24px"}}>⭐</span>
                  <div>
                    <div style={{fontSize:"16px",fontWeight:"bold",color:"#92400e"}}>{d.dir}</div>
                    <div style={{fontSize:"12px",color:"#a16207"}}>年盤・月盤・日盤すべて一致 — 最強の吉方位</div>
                  </div>
                </div>
              ))}
            </div>
          ):(
            <div>
              <div style={{fontSize:"13px",color:"#92400e",marginBottom:"8px"}}>本日の吉方位（スコア順）</div>
              {triDirs.slice(0,3).map((d,i)=>(
                <div key={i} style={{background:"white",borderRadius:"8px",padding:"8px 12px",marginBottom:"6px",border:"1px solid #fde68a",display:"flex",alignItems:"center",gap:"8px"}}>
                  <span style={{fontSize:"16px"}}>{i===0?'🥇':i===1?'🥈':'🥉'}</span>
                  <div style={{flex:1}}>
                    <span style={{fontWeight:"bold",color:"#92400e"}}>{d.dir}</span>
                    <span style={{fontSize:"12px",color:"#a16207",marginLeft:"8px"}}>
                      {[d.yrHit&&'年盤',d.moHit&&'月盤',d.dayHit&&'日盤'].filter(Boolean).join('・')}一致
                    </span>
                  </div>
                  <span style={{fontSize:"12px",color:"#d97706",fontWeight:"bold"}}>スコア{d.score}</span>
                </div>
              ))}
              {triDirs.length===0&&<div style={{fontSize:"13px",color:"#a16207",textAlign:"center",padding:"10px"}}>本日は吉方位が限定的です。明日以降のカレンダーを参照ください。</div>}
            </div>
          )}
        </div>

        {/* 30日吉方位カレンダー */}
        <div style={CS2.card}>
          <div style={{fontSize:"14px",fontWeight:"bold",color:"#b8860b",marginBottom:"12px"}}>📅 推奨吉方位カレンダー（今後30日間）</div>
          <div style={{display:"flex",flexDirection:"column",gap:"4px",maxHeight:"200px",overflowY:"auto"}}>
            {calendar30.map((c,i)=>{
              const m=c.date.getMonth()+1,d=c.date.getDate();
              const dow=['日','月','火','水','木','金','土'][c.date.getDay()];
              const isWeekend=c.date.getDay()===0||c.date.getDay()===6;
              if(!c.best)return null;
              return(
                <div key={i} style={{display:"flex",alignItems:"center",gap:"8px",padding:"6px 10px",borderRadius:"6px",background:c.best.allThree?"#fef9c3":c.best.twoBoards?"#f0fdf4":"white",border:`1px solid ${c.best.allThree?"#fbbf24":c.best.twoBoards?"#86efac":"#f3f4f6"}`}}>
                  <div style={{minWidth:"60px",fontSize:"13px",color:isWeekend?'#dc2626':'#374151',fontWeight:"bold"}}>{m}/{d}({dow})</div>
                  <div style={{fontSize:"13px",color:"#374151",flex:1}}>{c.dirs.slice(0,2).map(d=>d.dir).join('・')}</div>
                  {c.best.allThree&&<span style={{fontSize:"11px",color:"#d97706",fontWeight:"bold"}}>★三重</span>}
                  {c.best.twoBoards&&!c.best.allThree&&<span style={{fontSize:"11px",color:"#16a34a",fontWeight:"bold"}}>◎二重</span>}
                </div>
              );
            })}
          </div>
        </div>

        {/* 三重吉方位カレンダー（getTripleAuspiciousDays） */}
        {(()=>{const triDays=getTripleAuspiciousDays(hs,today,30).filter(d=>d.strength==='三重');return triDays.length>0&&(
          <div style={{background:"#fffbeb",borderRadius:"12px",padding:"14px",marginBottom:"14px",border:"2px solid #fbbf24"}}>
            <div style={{fontSize:"13px",fontWeight:"bold",color:"#92400e",marginBottom:"10px"}}>⭐ 今後30日の三重吉方位日</div>
            <div style={{display:"flex",flexDirection:"column",gap:"4px"}}>
              {triDays.slice(0,8).map((d,i)=>{
                const dow=['日','月','火','水','木','金','土'][d.dateObj.getDay()];
                const isWeekend=d.dateObj.getDay()===0||d.dateObj.getDay()===6;
                return(
                  <div key={i} style={{display:"flex",alignItems:"center",gap:"8px",padding:"6px 10px",borderRadius:"8px",background:"#fef9c3",border:"1px solid #fbbf24"}}>
                    <div style={{fontSize:"13px",fontWeight:"bold",color:isWeekend?'#dc2626':'#374151',minWidth:"60px"}}>{d.date}({dow})</div>
                    <div style={{flex:1,fontSize:"13px",color:"#92400e"}}>{d.directions.map(x=>x.direction).join('・')}</div>
                    <span style={{fontSize:"11px",fontWeight:"bold",color:"#d97706",background:"#fef3c7",padding:"2px 6px",borderRadius:"4px"}}>三重★</span>
                  </div>
                );
              })}
            </div>
          </div>
        );})()}

        {secs['古語']&&(
          <div style={{background:"linear-gradient(135deg,#1a0a0e,#2a1a0a)",borderRadius:"14px",padding:"20px",marginBottom:"14px",border:"1px solid #b8860b66"}}>
            <div style={{fontSize:"11px",color:"#b8860b",letterSpacing:"3px",marginBottom:"10px"}}>━━ 式神の言葉 ━━</div>
            <div style={{fontSize:"17px",color:"#fef3c7",lineHeight:2.1,fontFamily:"serif",fontWeight:"bold"}}>{secs['古語']}</div>
          </div>
        )}

        {/* 入力反映チェック：鑑定の前提に5項目がそろっているか */}
        {(()=>{
          const pre=secs['鑑定の前提']||'';
          const items=['相談対象','生年月日','相談日時','悩みの内容','ゴール','期限'].map(k=>{
            const m=pre.match(new RegExp(k+'[：:]\\s*(.+)'));
            return{k,v:m?m[1].trim():''};
          });
          const ok=items.filter(i=>i.v).length;const all=items.length;
          return(
            <div style={{...CS2.card,border:`1px solid ${ok===all?'#86efac':'#fca5a5'}`}}>
              <div style={{fontSize:"14px",fontWeight:"bold",color:ok===all?"#16a34a":"#dc2626",marginBottom:"10px"}}>📋 鑑定に反映した入力情報（{ok}/{all}）</div>
              {items.map(i=>(
                <div key={i.k} style={{display:"flex",gap:"8px",fontSize:"13px",lineHeight:1.7,marginBottom:"4px"}}>
                  <span style={{color:i.v?"#16a34a":"#dc2626",fontWeight:"bold"}}>{i.v?'✓':'✗'}</span>
                  <span style={{color:"#6b7280",minWidth:"70px"}}>{i.k}</span>
                  <span style={{color:"#374151",flex:1}}>{i.v||'鑑定文に反映されていません'}</span>
                </div>
              ))}
            </div>
          );
        })()}

        {[
          {key:'年盤の解釈',icon:'①',label:'年盤の解釈 — 今年の追い風・向かい風',bg:'white',bd:'#f3f4f6',tc:'#78350f'},
          {key:'月盤の流れ',icon:'②',label:'月盤の流れ — 期限までの攻め時・守り時',bg:'white',bd:'#f3f4f6',tc:'#78350f'},
          {key:'吉時・吉方位',icon:'③',label:'吉時・吉方位（日盤・時盤）',bg:'#fffbeb',bd:'#fbbf24',tc:'#d97706'},
          {key:'卦象による現状分析',icon:'④',label:'卦象による現状分析（六爻）',bg:'#f5f3ff',bd:'#c4b5fd',tc:'#6d28d9'},
          {key:'卦が示す取るべき行動',icon:'⑤',label:'卦が示す取るべき行動',bg:'#f5f3ff',bd:'#c4b5fd',tc:'#6d28d9'},
          {key:'行動計画',icon:'⑥',label:'期限までの行動計画',bg:'#f0fdf4',bd:'#86efac',tc:'#16a34a'},
        ].map(s=>secs[s.key]&&(
          <div key={s.key} style={{...CS2.card,background:s.bg,border:`1px solid ${s.bd}`}}>
            <div style={{fontSize:"14px",fontWeight:"bold",color:s.tc,marginBottom:"10px"}}>{s.icon} {s.label}</div>
            <div style={{fontSize:"15px",color:"#374151",lineHeight:1.9,whiteSpace:"pre-wrap"}}>{secs[s.key]}</div>
          </div>
        ))}

        {/* 祈祷法セクション */}
        {secs['祈祷法']&&(
          <div style={{background:"linear-gradient(135deg,#0a1a0e,#0e2a16)",borderRadius:"16px",padding:"20px",marginBottom:"14px",border:"2px solid #16a34a55"}}>
            <div style={{fontSize:"15px",fontWeight:"bold",color:"#4ade80",marginBottom:"16px",letterSpacing:"2px",fontFamily:"serif"}}>🙏 九星気学に基づく祈祷法</div>
            {(()=>{
              const pText=secs['祈祷法'];
              const pLines=pText.split('\n').filter((l:string)=>l.trim());
              return(
                <div style={{display:"flex",flexDirection:"column",gap:"12px"}}>
                  {pLines.map((line:string,i:number)=>{
                    const match=line.match(/^■\s*(.+?)：(.+)$/);
                    if(match){
                      const label=match[1];
                      const val=match[2];
                      const iconMap:any={'方角':'🧭','回数':'🔢','祈祷文':'📿','タイミング':'⏰','場所・準備':'🏛️','禁忌':'⚠️'};
                      const colorMap:any={'方角':'#86efac','回数':'#a5f3fc','祈祷文':'#fde68a','タイミング':'#c4b5fd','場所・準備':'#fdba74','禁忌':'#fca5a5'};
                      const bgMap:any={'方角':'rgba(134,239,172,0.08)','回数':'rgba(165,243,252,0.08)','祈祷文':'rgba(253,230,138,0.12)','タイミング':'rgba(196,181,253,0.08)','場所・準備':'rgba(253,186,116,0.08)','禁忌':'rgba(252,165,165,0.08)'};
                      const icon=iconMap[label]||'✦';
                      const color=colorMap[label]||'#e2e8f0';
                      const bg=bgMap[label]||'rgba(255,255,255,0.05)';
                      const isPrayer=label==='祈祷文';
                      return(
                        <div key={i} style={{background:bg,borderRadius:"10px",padding:"12px 14px",border:`1px solid ${color}33`}}>
                          <div style={{fontSize:"12px",color:color,fontWeight:"bold",marginBottom:"6px",letterSpacing:"1px"}}>{icon} {label}</div>
                          <div style={{fontSize:isPrayer?"16px":"14px",color:"#e2e8f0",lineHeight:isPrayer?2.2:1.8,whiteSpace:"pre-wrap",fontFamily:isPrayer?"serif":"inherit",fontWeight:isPrayer?"bold":"normal"}}>{val}</div>
                        </div>
                      );
                    }
                    return <div key={i} style={{fontSize:"14px",color:"#d1fae5",lineHeight:1.8,whiteSpace:"pre-wrap"}}>{line}</div>;
                  })}
                </div>
              );
            })()}
          </div>
        )}

        {/* 開運儀式ガイド */}
        <div style={{background:"linear-gradient(135deg,#0f0e1a,#1a0f2e)",borderRadius:"16px",padding:"20px",marginBottom:"14px",border:"1px solid #7c3aed44"}}>
          <div style={{fontSize:"15px",fontWeight:"bold",color:"#a78bfa",marginBottom:"16px",letterSpacing:"2px"}}>🔮 開運儀式ガイド</div>
          <div style={{background:"rgba(255,255,255,0.05)",borderRadius:"10px",padding:"14px",marginBottom:"12px"}}>
            <div style={{fontSize:"13px",color:"#c4b5fd",fontWeight:"bold",marginBottom:"8px"}}>最適な祈祷タイミング</div>
            <div style={{fontSize:"14px",color:"#e2e8f0",lineHeight:1.8}}>
              月相：{prayer.moonPhase}{prayer.isGoodMoon?' ✨（吉）':''}
              <br/>日盤五行：{prayer.dayE} / 本命五行との気：{prayer.rel}
              <br/>{prayer.isGoodDay?'今日は祈祷・開運行動に吉日です。':'今日は準備と心の整えに集中しましょう。'}
            </div>
          </div>
          <div style={{background:"rgba(255,255,255,0.05)",borderRadius:"10px",padding:"14px",marginBottom:"12px"}}>
            <div style={{fontSize:"13px",color:"#c4b5fd",fontWeight:"bold",marginBottom:"8px"}}>{STAR_NAMES[hs]}の数霊回数</div>
            <div style={{display:"flex",gap:"10px",flexWrap:"wrap"}}>
              {nums.map((n,i)=>(
                <div key={i} style={{background:"linear-gradient(135deg,#4c1d95,#7c3aed)",borderRadius:"10px",padding:"10px 16px",textAlign:"center",minWidth:"50px"}}>
                  <div style={{fontSize:"22px",fontWeight:"bold",color:"white"}}>{n}</div>
                  <div style={{fontSize:"11px",color:"#c4b5fd"}}>回</div>
                </div>
              ))}
            </div>
            <div style={{fontSize:"12px",color:"#9ca3af",marginTop:"8px"}}>祈祷・瞑想・感謝の言葉を上記の回数繰り返すと{fieldLabel}の気が高まります。</div>
          </div>
          <div style={{background:"rgba(255,255,255,0.05)",borderRadius:"10px",padding:"14px",marginBottom:"12px"}}>
            <div style={{fontSize:"13px",color:"#c4b5fd",fontWeight:"bold",marginBottom:"8px"}}>浄化推奨日（今後）</div>
            {purifyDays.slice(0,4).map((p,i)=>(
              <div key={i} style={{display:"flex",gap:"8px",alignItems:"center",padding:"4px 0",borderBottom:i<3?"1px solid rgba(255,255,255,0.08)":"none"}}>
                <span style={{fontSize:"12px",color:"#e2e8f0",minWidth:"60px"}}>{(p.date.getMonth()+1)+'/'+(p.date.getDate())}</span>
                <span style={{fontSize:"12px",color:"#9ca3af"}}>{p.reason}</span>
              </div>
            ))}
          </div>
          <div style={{background:"rgba(255,255,255,0.05)",borderRadius:"10px",padding:"14px"}}>
            <div style={{fontSize:"13px",color:"#c4b5fd",fontWeight:"bold",marginBottom:"8px"}}>結界設定の推奨</div>
            {triDirs.slice(0,2).length>0?(
              <div style={{fontSize:"14px",color:"#e2e8f0",lineHeight:1.9}}>
                推奨方位：{triDirs.slice(0,2).map(d=>d.dir).join(' / ')}
                <br/>推奨タイミング：{purifyDays[0]?`${(purifyDays[0].date.getMonth()+1)}/${purifyDays[0].date.getDate()}（浄化日）`:'浄化日と合わせて実施'}
                <br/><span style={{fontSize:"12px",color:"#9ca3af"}}>推奨方位の窓を開け、数霊回数に合わせ祈願してください。</span>
              </div>
            ):(
              <div style={{fontSize:"13px",color:"#9ca3af"}}>現在の方位状況を確認し、凶方位を避けて設定してください。</div>
            )}
          </div>
        </div>

        {secs['今日の開運アクション']&&(
          <div style={{background:"linear-gradient(135deg,#0a0e1a,#0d1535)",borderRadius:"14px",padding:"20px",marginBottom:"16px",border:"1px solid #b8860b33"}}>
            <div style={{fontSize:"14px",fontWeight:"bold",color:"#b8860b",letterSpacing:"2px",marginBottom:"10px"}}>🌟 今日の開運アクション</div>
            <div style={{fontSize:"15px",color:"#e2e8f0",lineHeight:2.1,whiteSpace:"pre-wrap"}}>{secs['今日の開運アクション']}</div>
          </div>
        )}
        {Object.keys(secs).length===0&&(
          <div style={{background:"white",borderRadius:"14px",border:"1px solid #e5e7eb",padding:"20px",marginBottom:"16px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
            <div style={{fontSize:"14px",fontWeight:"bold",color:"#b8860b",marginBottom:"10px"}}>✦ 鑑定結果</div>
            <div style={{fontSize:"15px",color:"#374151",lineHeight:1.9,whiteSpace:"pre-wrap"}}>{result}</div>
          </div>
        )}
        <div style={{display:"flex",alignItems:"center",gap:"6px",marginBottom:"12px",padding:"10px 14px",background:"#f0fdf4",borderRadius:"10px",border:"1px solid #86efac"}}>
          <span style={{fontSize:"14px"}}>✅</span>
          <span style={{fontSize:"13px",color:"#16a34a",fontWeight:"bold"}}>この鑑定結果は履歴に保存されました</span>
          <button onClick={()=>{window.dispatchEvent(new CustomEvent('navigate-tab',{detail:'history'}));}} style={{marginLeft:"auto",padding:"4px 10px",background:"#16a34a",color:"white",border:"none",borderRadius:"6px",fontSize:"12px",cursor:"pointer"}}>履歴を見る</button>
        </div>
        {/* 開運プログラム チェックインUI */}
        {(()=>{
          const progs=JSON.parse(localStorage.getItem('ki_fortune_programs')||'[]');
          const active=progs.filter((p:any)=>p.status==='active');
          if(active.length===0)return null;
          const latest=active[0];
          const checkinCount=latest.checkIns?.length||0;
          const startDate=new Date(latest.startDate);
          const daysSince=Math.floor((Date.now()-startDate.getTime())/(1000*60*60*24));
          return(
            <div style={{background:"linear-gradient(135deg,#f0fdf4,#dcfce7)",borderRadius:"14px",padding:"16px",marginBottom:"14px",border:"2px solid #86efac"}}>
              <div style={{fontSize:"14px",fontWeight:"bold",color:"#16a34a",marginBottom:"10px"}}>📋 開運プログラム進捗</div>
              <div style={{fontSize:"13px",color:"#374151",marginBottom:"8px"}}>
                テーマ：{latest.theme}　分野：{latest.field}
                <br/>開始から{daysSince}日目　チェックイン：{checkinCount}回
              </div>
              <div style={{display:"flex",gap:"8px"}}>
                <button onClick={()=>{
                  try{
                    const ps=JSON.parse(localStorage.getItem('ki_fortune_programs')||'[]');
                    const now=new Date().toISOString();
                    const updated=ps.map((p:any,i:number)=>i===0?{...p,checkIns:[...(p.checkIns||[]),{date:now,note:'鑑定後チェックイン'}]}:p);
                    localStorage.setItem('ki_fortune_programs',JSON.stringify(updated));
                    alert('チェックインしました！継続は力なりです。');
                  }catch(_){}
                }} style={{flex:1,padding:"10px",background:"#16a34a",color:"white",border:"none",borderRadius:"8px",fontSize:"13px",fontWeight:"bold",cursor:"pointer"}}>
                  ✅ チェックイン
                </button>
                <button onClick={()=>{
                  try{
                    const ps=JSON.parse(localStorage.getItem('ki_fortune_programs')||'[]');
                    const updated=ps.map((p:any,i:number)=>i===0?{...p,status:'completed'}:p);
                    localStorage.setItem('ki_fortune_programs',JSON.stringify(updated));
                    alert('プログラムを完了にしました。お疲れ様でした！');
                  }catch(_){}
                }} style={{flex:1,padding:"10px",background:"white",color:"#6b7280",border:"1px solid #d1d5db",borderRadius:"8px",fontSize:"13px",cursor:"pointer"}}>
                  完了にする
                </button>
              </div>
            </div>
          );
        })()}

        <div style={{display:"flex",gap:"10px",marginBottom:"24px"}}>
          <button onClick={()=>setShowShareFort(true)} style={{flex:1,padding:"14px",background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",border:"none",borderRadius:"12px",fontSize:"15px",fontWeight:"bold",cursor:"pointer"}}>📤 シェア</button>
          <button onClick={()=>{setStep('summon');setResult(null);setTarget('self');setOther({name:'',by:'',bm:'',bd:'',rel:'',loc:''});setConcern('');setGoal('');setDeadlineDate('');setConsultAt(null);setRokkoHex(null);setRokkoLines([]);}} style={{flex:1,padding:"14px",background:"#f3f4f6",color:"#374151",border:"none",borderRadius:"12px",fontSize:"15px",fontWeight:"bold",cursor:"pointer"}}>🔄 もう一度</button>
        </div>
      </div>
    );
  }
  return null;
}

function BattleInp({label,value,onChange,type='text',placeholder=''}){
  const[local,setLocal]=React.useState(value);
  const composing=React.useRef(false);
  React.useEffect(()=>{if(!composing.current)setLocal(value);},[value]);
  return(
    <div style={{marginBottom:"12px"}}>
      <div style={{fontSize:"13px",fontWeight:"bold",color:"#374151",marginBottom:"5px"}}>{label}</div>
      <input type={type} value={local}
        onChange={e=>{setLocal(e.target.value);if(!composing.current)onChange(e.target.value);}}
        onCompositionStart={()=>{composing.current=true;}}
        onCompositionEnd={e=>{composing.current=false;const v=(e.target as HTMLInputElement).value;setLocal(v);onChange(v);}}
        placeholder={placeholder}
        style={{width:"100%",padding:"10px 12px",borderRadius:"8px",border:"1px solid #e5e7eb",fontSize:"14px",boxSizing:"border-box"}}/>
    </div>
  );
}
function BattleSel({label,value,onChange,opts,accentColor='#1d4ed8'}){
  return(
    <div style={{marginBottom:"12px"}}>
      <div style={{fontSize:"13px",fontWeight:"bold",color:"#374151",marginBottom:"5px"}}>{label}</div>
      <div style={{display:"flex",flexWrap:"wrap",gap:"6px"}}>
        {opts.map(o=>(
          <button key={o} onClick={()=>onChange(o)}
            style={{padding:"7px 12px",borderRadius:"8px",border:`1.5px solid ${value===o?accentColor:'#e5e7eb'}`,background:value===o?`${accentColor}15`:"white",color:value===o?accentColor:"#374151",fontSize:"13px",cursor:"pointer",fontWeight:value===o?"bold":"normal"}}>
            {value===o?'✓ ':''}{o}
          </button>
        ))}
      </div>
    </div>
  );
}
function BattleTab({profile,isPremium,isPremiumPlus,onUnlock,authUser}){
  const LIMIT=isPremiumPlus?30:0;
  const month=new Date().getFullYear()+'_'+(new Date().getMonth()+1);
  const mKey='ki_battle_'+new Date().getFullYear()+'_'+new Date().getMonth();
  const [used,setUsed]=useState(()=>parseInt(sGet(mKey)||'0'));
  // DB同期
  useEffect(()=>{
    if(!authUser?.id)return;
    supabase.from('usage_counts').select('battle_count').eq('user_id',authUser.id).eq('month',month).single()
      .then(({data})=>{if(data?.battle_count!=null)setUsed(data.battle_count);});
  },[authUser?.id]);
  const STAR_NAMES=["","一白水星","二黒土星","三碧木星","四緑木星","五黄土星","六白金星","七赤金星","八白土星","九紫火星"];

  // 占種選択
  const [battleMode,setBattleMode]=useState(null); // 'soccer' | 'other'
  const [step,setStep]=useState('summon');
  const [result,setResult]=useState(null);
  const [showShareBat,setShowShareBat]=useState(false);
  const [tick,setTick]=useState(0);
  const [kigakuResult,setKigakuResult]=useState(null);
  const [lines,setLines]=useState([]);
  const [animating,setAnimating]=useState(false);
  const [liuYaoScore,setLiuYaoScore]=useState(null);
  const [executionTime,setExecutionTime]=useState(null);
  const [manualBattleCoins,setManualBattleCoins]=useState<boolean[][]>([]);

  // サッカー専用フィールド
  const [matchDate,setMatchDate]=useState('');
  const [matchKickoffJst,setMatchKickoffJst]=useState(''); // キックオフ時刻（日本時間）
  const [matchCity,setMatchCity]=useState('');
  const [matchCountry,setMatchCountry]=useState('');
  const [matchLeague,setMatchLeague]=useState('');
  const [matchStage,setMatchStage]=useState('');
  const [teamAStrength,setTeamAStrength]=useState(50); // チームA実力(1-100)
  const [teamBStrength,setTeamBStrength]=useState(50); // チームB実力(1-100)
  const [teamAHomeCity,setTeamAHomeCity]=useState('');
  const [teamBHomeCity,setTeamBHomeCity]=useState('');
  const [teamAName,setTeamAName]=useState('');
  const [teamACountry,setTeamACountry]=useState('');
  const [teamAFounded,setTeamAFounded]=useState('');
  const [teamAHome,setTeamAHome]=useState('ホーム');
  const [managerAName,setManagerAName]=useState('');
  const [managerABirth,setManagerABirth]=useState('');
  const [teamBName,setTeamBName]=useState('');
  const [teamBCountry,setTeamBCountry]=useState('');
  const [teamBFounded,setTeamBFounded]=useState('');
  const [teamBHome,setTeamBHome]=useState('アウェイ');
  const [managerBName,setManagerBName]=useState('');
  const [managerBBirth,setManagerBBirth]=useState('');
  // チーム選択
  const [teamAId,setTeamAId]=useState('');
  const [teamBId,setTeamBId]=useState('');
  const [leagueTabA,setLeagueTabA]=useState<'J1'|'J2'>('J1');
  const [leagueTabB,setLeagueTabB]=useState<'J1'|'J2'>('J1');
  const [editMgrA,setEditMgrA]=useState(false);
  const [editMgrB,setEditMgrB]=useState(false);
  const applyTeam=(id:string,side:'A'|'B')=>{
    const t=[...J1_TEAMS,...J2_TEAMS].find(x=>x.id===id);
    if(!t)return;
    if(side==='A'){setTeamAId(id);setTeamAName(t.name);setTeamACountry('日本');setTeamAFounded(String(t.kiYear));setTeamAHomeCity(t.city);setManagerAName(t.manager||'');setManagerABirth(t.managerBirth||'');}
    else{setTeamBId(id);setTeamBName(t.name);setTeamBCountry('日本');setTeamBFounded(String(t.kiYear));setTeamBHomeCity(t.city);setManagerBName(t.manager||'');setManagerBBirth(t.managerBirth||'');}
  };

  // 既存勝負フィールド
  const [battleType,setBattleType]=useState(null);
  const [qIdx,setQIdx]=useState(0);
  const [answers,setAnswers]=useState(['','','']);
  const [curAns,setCurAns]=useState('');
  const [battleDate,setBattleDate]=useState('');
  const [battleTime,setBattleTime]=useState('');
  const [battleLocation,setBattleLocation]=useState('');
  const [personA,setPersonA]=useState({name:'',birthdate:'',role:''});
  const [personB,setPersonB]=useState({name:'',birthdate:'',role:''});

  const today=new Date();
  const hs=profile?.honmeiStar||5;
  const ts=profile?.tsukimeiStar||hs;
  const km=getKiMonthIdx(today.getMonth()+1,today.getDate());
  const dayC=getDayStar(today);
  const todayYrC=getYearStar(today.getFullYear());
  // 月盤中宮星（占断実行日基準）
  const kiYearToday=(km===11||(today.getMonth()===0&&today.getDate()<6))?today.getFullYear()-1:today.getFullYear();
  const yrC=getYearStar(kiYearToday);
  const moC=getMonthStar(yrC,km);
  useEffect(()=>{const id=setInterval(()=>setTick(t=>t+1),60);return()=>clearInterval(id);},[]);

  function isYang(v){return v===7||v===9;}
  function flipCoins(){const c=[Math.random()>.5,Math.random()>.5,Math.random()>.5];const n=c.filter(Boolean).length;return n===3?9:n===2?7:n===1?8:6;}



  function calcKigakuForTeam(foundedYear, managerBirth, targetDayStar?:number){
    if(!foundedYear&&!managerBirth)return null;
    const useDayStar=targetDayStar||dayC;
    const teamStar=foundedYear?getYearStar(parseInt(foundedYear)):null;
    const mgrStar=managerBirth?getHonmei(...managerBirth.split('-').map(Number)):null;
    const dayE=S_ELEM[useDayStar]||'土';
    const teamE=teamStar?S_ELEM[teamStar]||'土':null;
    const mgrE=mgrStar?S_ELEM[mgrStar]||'土':null;
    const teamRel=teamE?getElemRel(teamE,dayE):null;
    const mgrRel=mgrE?getElemRel(mgrE,dayE):null;
    const relScore=(r:string|null)=>r==='相生受'?3:r==='比和'?2:r==='相生生'?1:r==='相剋攻'?-1:r==='相剋受'?-3:0;
    const score=relScore(teamRel)+relScore(mgrRel);
    return{teamStar,mgrStar,teamE,mgrE,teamRel,mgrRel,score,dayE};
  }

  async function doAutoRokko(){
    setStep('rokko_auto');
    const newLines=[];
    for(let i=0;i<6;i++){
      setAnimating(true);
      await new Promise(r=>setTimeout(r,700));
      setAnimating(false);
      const v=flipCoins();
      newLines.push(v);
      setLines([...newLines]);
      await new Promise(r=>setTimeout(r,300));
    }
    setTimeout(()=>setStep('hexagram'),500);
  }

  function calcKigakuOther(){
    const myE=S_ELEM?.[hs]||'土';
    const dayE=S_ELEM?.[dayC]||'土';
    const rel=getElemRel?getElemRel(myE,dayE):'比和';
    const jMap={'相生受':'今がまさに動き時！最高の追い風が吹いています。','相生生':'積極的な行動が縁を深めます。主体的に動くことで勝機が開けます。','比和':'結果が拡大しやすい。丁寧な準備で大きな成果が期待できます。','相剋受':'慎重に進めることが吉。十分な準備を整えてから動いてください。','相剋攻':'今は力を蓄える時期。最良のタイミングを見極めて行動することが重要です。'};
    return{rel,judgment:jMap[rel]||'氣の流れを見極めて行動してください。',dayC,dayE,myE,isGood:rel==='相生受'||rel==='比和'};
  }

  async function callAISoccer(){
    setStep('loading');
    try{
    const hex=buildHexFromLines(lines);
    const execT=executionTime||new Date();
    // 試合日の三盤を計算
    const matchDayObj=matchDate?new Date(matchDate+'T12:00:00'):execT;
    const matchDayStar=getDayStar(matchDayObj);
    const matchKmIdx=getKiMonthIdx(matchDayObj.getMonth()+1,matchDayObj.getDate());
    const matchKiYear=(matchKmIdx===11||(matchDayObj.getMonth()===0&&matchDayObj.getDate()<6))?matchDayObj.getFullYear()-1:matchDayObj.getFullYear();
    const matchYrC=getYearStar(matchKiYear);
    const matchMoC=getMonthStar(matchYrC,matchKmIdx);
    const STAR_NAMES_LOCAL=["","一白水星","二黒土星","三碧木星","四緑木星","五黄土星","六白金星","七赤金星","八白土星","九紫火星"];
    const kgA=calcKigakuForTeam(teamAFounded,managerABirth,matchDayStar);
    const kgB=calcKigakuForTeam(teamBFounded,managerBBirth,matchDayStar);
    const teamAIsHome=teamAHome==='ホーム';
    // 時盤
    const kickoffHour=matchKickoffJst?parseInt(matchKickoffJst.split(':')[0]):12;
    const hourStar=getHourStar(kickoffHour,matchDayStar);
    const hourElem=S_ELEM[hourStar]||'土';
    const hourRelA=kgA?.teamE?getElemRel(kgA.teamE,hourElem):'不明';
    const hourRelB=kgB?.teamE?getElemRel(kgB.teamE,hourElem):'不明';
    // 方位（本拠地→会場）
    const resolvedMatchCity=resolveCityName(matchCity);
    const resolvedTeamACity=resolveCityName(teamAHomeCity);
    const resolvedTeamBCity=resolveCityName(teamBHomeCity);
    console.log('[kigaku] bearingA start',resolvedTeamACity,'->',resolvedMatchCity);
    const bearingA=(resolvedMatchCity&&resolvedTeamACity)?await calcBearingAsync(resolvedTeamACity,resolvedMatchCity):null;
    console.log('[kigaku] bearingA done',bearingA);
    const bearingB=(resolvedMatchCity&&resolvedTeamBCity)?await calcBearingAsync(resolvedTeamBCity,resolvedMatchCity):null;
    console.log('[kigaku] bearingB done',bearingB);
    const bearingRelA=bearingA&&kgA?.teamE?getElemRel(kgA.teamE,bearingA.elem):'不明';
    const bearingRelB=bearingB&&kgB?.teamE?getElemRel(kgB.teamE,bearingB.elem):'不明';
    // 年盤・月盤
    const yearRelA=kgA?.teamE?getElemRel(kgA.teamE,S_ELEM[matchYrC]||'土'):'不明';
    const yearRelB=kgB?.teamE?getElemRel(kgB.teamE,S_ELEM[matchYrC]||'土'):'不明';
    const monthRelA=kgA?.teamE?getElemRel(kgA.teamE,S_ELEM[matchMoC]||'土'):'不明';
    const monthRelB=kgB?.teamE?getElemRel(kgB.teamE,S_ELEM[matchMoC]||'土'):'不明';
    // 日盤補正（試合日の中宮星五行とクラブ本命星の関係）
    const dayRelA=kgA?.teamE?getElemRel(kgA.teamE,S_ELEM[matchDayStar]||'土'):'不明';
    const dayRelB=kgB?.teamE?getElemRel(kgB.teamE,S_ELEM[matchDayStar]||'土'):'不明';
    // 五黄殺・暗剣殺・歳破・天道方位
    const goouYrDir=getGoouDir8(matchYrC);
    const goouMoDir=getGoouDir8(matchMoC);
    const ankenYrDir=goouYrDir?OPP_DIR8[goouYrDir]:null;
    const ankenMoDir=goouMoDir?OPP_DIR8[goouMoDir]:null;
    const saihaDir=getSaihaDir8(matchKiYear);
    const tendoDir=getTendoDir8(matchMoC); // 月盤の六白方位
    function kyoLabel(d:string):string{
      const hits=[];
      if(d===goouYrDir)hits.push('年五黄殺');
      if(d===goouMoDir)hits.push('月五黄殺');
      if(d===ankenYrDir)hits.push('年暗剣殺');
      if(d===ankenMoDir)hits.push('月暗剣殺');
      if(d===saihaDir)hits.push('歳破');
      return hits.join('・');
    }
    const kyoDirs=new Set([goouYrDir,goouMoDir,ankenYrDir,ankenMoDir,saihaDir].filter(Boolean) as string[]);
    const kyoHoiA=!!(bearingA&&kyoDirs.has(bearingA.dir8));
    const kyoHoiB=!!(bearingB&&kyoDirs.has(bearingB.dir8));
    const kyoLabelA=bearingA?kyoLabel(bearingA.dir8):'';
    const kyoLabelB=bearingB?kyoLabel(bearingB.dir8):'';
    const tendoA=!!(bearingA&&tendoDir&&bearingA.dir8===tendoDir);
    const tendoB=!!(bearingB&&tendoDir&&bearingB.dir8===tendoDir);
    // チーム間の九星相生剋：A本命星からみたB本命星との関係
    const teamKigakuRel=(kgA?.teamE&&kgB?.teamE)?getElemRel(kgA.teamE,kgB.teamE):null;
    // 開催地の九宮：東京（日本の中心）から開催地への方位で宮位・五行を算出
    const TOKYO:[number,number]=[35.6762,139.6503];
    console.log('[kigaku] venueCoords start',resolvedMatchCity);
    const venueCoords=resolvedMatchCity?await geocodeCity(resolvedMatchCity):null;
    console.log('[kigaku] venueCoords done',venueCoords);
    const venueBearing=venueCoords?calcBearingCoords(TOKYO,venueCoords):null;
    console.log('[kigaku] score calc start');
    // 開催地の地の気（地場五行 × クラブ本命星）
    const venueRelA=venueBearing&&kgA?.teamE?getElemRel(kgA.teamE,venueBearing.elem):'不明';
    const venueRelB=venueBearing&&kgB?.teamE?getElemRel(kgB.teamE,venueBearing.elem):'不明';
    const score=calcBattleScore({hexagram:hex,sideAElement:kgA?.teamE||'',sideBElement:kgB?.teamE||'',mgrAElement:kgA?.mgrE||'',mgrBElement:kgB?.mgrE||'',battleDate:matchDate?new Date(matchDate):today,occupationDate:execT,kigakuRel:teamKigakuRel,teamAIsHome,hourRelA,hourRelB,bearingRelA,bearingRelB,yearRelA,yearRelB,monthRelA,monthRelB,dayRelA,dayRelB,kyoHoiA,kyoHoiB,kyoLabelA,kyoLabelB,tendoA,tendoB,venueRelA,venueRelB,teamStrA:teamAStrength,teamStrB:teamBStrength});
    console.log('[kigaku] score done, calling API');
    setLiuYaoScore(score);
    const mgrAHonmeiName=kgA?.mgrStar?STAR_NAMES[kgA.mgrStar]:'不明';
    const mgrBHonmeiName=kgB?.mgrStar?STAR_NAMES[kgB.mgrStar]:'不明';
    const teamAStarName=kgA?.teamStar?STAR_NAMES[kgA.teamStar]:'不明';
    const teamBStarName=kgB?.teamStar?STAR_NAMES[kgB.teamStar]:'不明';
    const prompt=`あなたは六爻占術を主軸とし、九星気学で補佐する占術師です。
問い：「${teamAIsHome?teamAName||'ホームチーム':teamBName||'ホームチーム'}は今回の試合に勝利するか？」

━━━━━━━━━━━━━━━━━━━━━━━━
【占断情報】
占断日時：${execT.toLocaleString('ja-JP')}
試合：${teamAName||'A'}【${teamAHome}】vs ${teamBName||'B'}【${teamBHome}】
日時：${matchDate||'未定'} ${matchKickoffJst||''} ／ 開催地：${matchCity||'未指定'}
大会：${matchLeague||'未指定'} ${matchStage||''}

━━━━━━━━━━━━━━━━━━━━━━━━
🎯【主軸：六爻占術による判定】（判断比重 70〜80%）

▼ 本卦・変卦
本卦：${hex?.main?.name||'不明'}（上卦${LIUYAO_TRIG_NAMES[hex?.main?.up??0]}・下卦${LIUYAO_TRIG_NAMES[hex?.main?.lo??0]}）
変卦：${hex?.change?.name||'なし'}
動爻：${(hex?.movingLines||[]).map(i=>`第${i+1}爻`).join('・')||'なし'}（${(hex?.movingLines||[]).length}本）

▼ 合成スコア基本設定（実力45% + 六爻用神30% + 九星方位15% + ホーム10%）
チーム実力：${teamAName||'A'}=${teamAStrength} vs ${teamBName||'B'}=${teamBStrength}（差${teamAStrength-teamBStrength>=0?'+':''}${teamAStrength-teamBStrength}）
${score.reasoning.filter(r=>r.includes('官鬼爻')||r.includes('ベースP')).map(r=>`・${r}`).join('\n')||'・官鬼爻情報なし'}

▼ 用神の状態（世爻＝ホーム / 応爻＝アウェイ）
世爻（ホーム）：第${score.worldLine}爻 五行「${score.worldElem}」― 月建旺相：【${score.wStrength}】
応爻（アウェイ）：第${score.responseLine}爻 五行「${score.responseElem}」― 月建旺相：【${score.rStrength}】

▼ 日辰（地支五行：${DAY_BRANCH_ELEM[getDayBranchIndex(execT)]}）の世爻・応爻への作用
${score.reasoning.filter(r=>r.includes('日辰')).map(r=>`・${r}`).join('\n')||'・日辰との特記事項なし'}

▼ 動爻の世爻・応爻への作用
${score.reasoning.filter(r=>r.includes('爻（世爻）動')||r.includes('爻（応爻）動')||r.includes('が世爻')||r.includes('が応爻')||r.includes('変卦')).map(r=>`・${r}`).join('\n')||'・動爻による特記事項なし'}

▼ 六爻占術によるスコア根拠（全項目）
${score.reasoning.map(r=>`・${r}`).join('\n')}

▼ 六爻統合スコア
ホーム ${teamAIsHome?teamAName||'A':teamBName||'B'}：${teamAIsHome?score.sideAScore:score.sideBScore}%
アウェイ ${teamAIsHome?teamBName||'B':teamAName||'A'}：${teamAIsHome?score.sideBScore:score.sideAScore}%
判定：${score.verdict}（信頼度${score.confidence}%）

━━━━━━━━━━━━━━━━━━━━━━━━
🌟【補助：九星気学による補強情報】（判断比重 20〜30%）

▼ 占断者の三盤（占断実行日）
本命星：${STAR_NAMES[hs]}／月命星：${STAR_NAMES[ts]}
占断日三盤 — 年盤：${STAR_NAMES[yrC]}／月盤：${STAR_NAMES[moC]}／日盤：${STAR_NAMES[dayC]}（${S_ELEM[dayC]||'土'}）
${getSanbanInfo(hs,ts)}

▼ 試合日の三盤（四盤）
年盤：${STAR_NAMES_LOCAL[matchYrC]}（${S_ELEM[matchYrC]||'土'}）／月盤：${STAR_NAMES_LOCAL[matchMoC]}（${S_ELEM[matchMoC]||'土'}）／日盤：${STAR_NAMES_LOCAL[matchDayStar]}（${S_ELEM[matchDayStar]||'土'}）
時盤（キックオフ）：${STAR_NAMES[hourStar]}（五行：${hourElem}）

▼ ホーム（${teamAIsHome?teamAName||'A':teamBName||'B'}）の九星気学
本命星：${teamAIsHome?teamAStarName:teamBStarName}（五行：${teamAIsHome?kgA?.teamE||'不明':kgB?.teamE||'不明'}）
年盤との関係：${teamAIsHome?yearRelA:yearRelB} ／ 月盤：${teamAIsHome?monthRelA:monthRelB} ／ 日盤：${teamAIsHome?dayRelA:dayRelB} ／ 時盤：${teamAIsHome?hourRelA:hourRelB}
監督本命星：${teamAIsHome?mgrAHonmeiName:mgrBHonmeiName}（五行：${teamAIsHome?kgA?.mgrE||'不明':kgB?.mgrE||'不明'}）／ 監督と日盤：${teamAIsHome?kgA?.mgrRel||'不明':kgB?.mgrRel||'不明'}
総合気学スコア：${teamAIsHome?kgA?.score||0:kgB?.score||0}点
移動方位：${teamAIsHome?(bearingA?`${bearingA.dir8}（${bearingA.deg}°・第${bearingA.palace}宮・${STAR_NAMES[bearingA.star]}・五行:${bearingA.elem}）→${bearingRelA}`:bearingRelA):(bearingB?`${bearingB.dir8}（${bearingB.deg}°・第${bearingB.palace}宮・${STAR_NAMES[bearingB.star]}・五行:${bearingB.elem}）→${bearingRelB}`:bearingRelB)}
${teamAIsHome&&kyoHoiA?`⚠ 凶方位（${kyoLabelA}）あり`:''}${teamAIsHome&&tendoA?'✨ 天道方位一致':''}${!teamAIsHome&&kyoHoiB?`⚠ 凶方位（${kyoLabelB}）あり`:''}${!teamAIsHome&&tendoB?'✨ 天道方位一致':''}

▼ アウェイ（${teamAIsHome?teamBName||'B':teamAName||'A'}）の九星気学
本命星：${teamAIsHome?teamBStarName:teamAStarName}（五行：${teamAIsHome?kgB?.teamE||'不明':kgA?.teamE||'不明'}）
年盤との関係：${teamAIsHome?yearRelB:yearRelA} ／ 月盤：${teamAIsHome?monthRelB:monthRelA} ／ 日盤：${teamAIsHome?dayRelB:dayRelA} ／ 時盤：${teamAIsHome?hourRelB:hourRelA}
監督本命星：${teamAIsHome?mgrBHonmeiName:mgrAHonmeiName}（五行：${teamAIsHome?kgB?.mgrE||'不明':kgA?.mgrE||'不明'}）／ 監督と日盤：${teamAIsHome?kgB?.mgrRel||'不明':kgA?.mgrRel||'不明'}
総合気学スコア：${teamAIsHome?kgB?.score||0:kgA?.score||0}点
移動方位：${teamAIsHome?(bearingB?`${bearingB.dir8}（${bearingB.deg}°・第${bearingB.palace}宮・${STAR_NAMES[bearingB.star]}・五行:${bearingB.elem}）→${bearingRelB}`:bearingRelB):(bearingA?`${bearingA.dir8}（${bearingA.deg}°・第${bearingA.palace}宮・${STAR_NAMES[bearingA.star]}・五行:${bearingA.elem}）→${bearingRelA}`:bearingRelA)}
${!teamAIsHome&&kyoHoiA?`⚠ 凶方位（${kyoLabelA}）あり`:''}${!teamAIsHome&&tendoA?'✨ 天道方位一致':''}${teamAIsHome&&kyoHoiB?`⚠ 凶方位（${kyoLabelB}）あり`:''}${teamAIsHome&&tendoB?'✨ 天道方位一致':''}

▼ 開催地の地の気
${matchCity||'（開催地未指定）'}：${venueBearing?`東京より${venueBearing.dir8}方位・第${venueBearing.palace}宮・${STAR_NAMES[venueBearing.star]}（五行：${venueBearing.elem}）`:'座標データなし'}
${score.reasoning.filter(r=>r.includes('開催地地気')).map(r=>`・${r}`).join('\n')||''}

▼ 両チーム本命星の五行関係
${score.reasoning.filter(r=>r.includes('九星')).map(r=>`・${r}`).join('\n')||'・九星相生剋なし（比和）'}

▼ 三盤一致ボーナス
${score.reasoning.filter(r=>r.includes('三盤')).map(r=>`・${r}`).join('\n')||'・三盤一致なし'}
${score.skillGapLabel&&score.skillGapLabel!=='互角・拮抗（実力補正なし）'?`▼ 実力差補正：${score.skillGapLabel}`:''}
▼ 予想スコア帯（算出値）：${score.scoreBand}（${score.scoreBandDetail}）

━━━━━━━━━━━━━━━━━━━━━━━━
以下の形式で必ず鑑定してください（見出し行は変更しないこと）：

【古語】
（天地の気の流れを詠む40〜60文字の文語体）

【六爻占術の判定】
世爻（ホーム）と応爻（アウェイ）の月建旺相の比較・動爻の世爻応爻への作用・変卦の意味を中心に、勝敗の六爻的根拠を200文字で述べよ

【九星気学の補強】
試合日の三盤・時盤・移動方位・凶方位・天道方位を踏まえ、両チームの気の有利不利を100文字で補足せよ

【総合判定】
「ホーム優勢」「アウェイ優勢」「互角」のいずれかで始め、六爻を主・九星を従とした最終判断を100文字で

【試合展開予測】
卦象・動爻の象意から予想される試合の流れを60文字で

【警告・注意点】
占断上で注意すべき点があれば50文字。なければ「なし」

【行動指針】
・（占断結果に基づく具体的アドバイス1）
・（占断結果に基づく具体的アドバイス2）
・（観戦・投票の最良タイミングや心構え）`;
    try{
      const _ctrl=new AbortController();setTimeout(()=>_ctrl.abort(),60000);const res=await fetch('/api/claude',{signal:_ctrl.signal,method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({model:'claude-haiku-4-5-20251001',max_tokens:1800,messages:[{role:'user',content:prompt}]})});
      const data=await res.json();
      const text=data.content?.[0]?.text||'鑑定に失敗しました。';
      const nu=used+1;sSet(mKey,String(nu));setUsed(nu);
      if(authUser?.id){const month2=new Date().getFullYear()+'_'+(new Date().getMonth()+1);supabase.from('usage_counts').upsert({user_id:authUser.id,month:month2,battle_count:nu},{onConflict:'user_id,month'}).then(()=>{});}
      try{
        const now2=new Date().toISOString();
        const t2=`${teamAName||'A'} vs ${teamBName||'B'}`;
        const scoreHeader=[
          `━━━━━━━━━━━━━━━━━━━━━━━━`,
          `【試合情報】${matchDate||'日付未定'} ${matchKickoffJst||''} ${matchCity||''}`,
          `　${teamAName||'A'}【${teamAHome}】vs ${teamBName||'B'}【${teamBHome}】`,
          `　大会：${matchLeague||'未指定'} ${matchStage||''}`,
          ``,
          `【六爻統合スコア】`,
          `　${teamAName||'A'}：${score.sideAScore}%　${teamBName||'B'}：${score.sideBScore}%`,
          `　判定：${score.verdict}　信頼度：${score.confidence}%`,
          score.skillGapLabel&&score.skillGapLabel!=='互角・拮抗（実力補正なし）'?`　実力補正：${score.skillGapLabel}`:'',
          ``,
          `【スコア計算根拠】`,
          ...(score.reasoning||[]).map(r=>`　・${r}`),
          `━━━━━━━━━━━━━━━━━━━━━━━━`,
          ``
        ].filter(l=>l!==undefined).join('\n');
        const fullAnswer=scoreHeader+text;
        const entry={id:Date.now(),date:now2,title:t2,type:'勝負',star:hs,answer:fullAnswer};
        const prev=JSON.parse(localStorage.getItem('ki_consult_history')||'[]');
        localStorage.setItem('ki_consult_history',JSON.stringify([entry,...prev].slice(0,50)));
        if(authUser?.id){supabase.from('consult_history').insert({user_id:authUser.id,created_at:now2,title:t2,type:'勝負',star:hs,answer:fullAnswer}).then(()=>{});}
      }catch(_){}
      setResult(text.replace(/##\s*/g,''));setStep('result');
    }catch(e){setResult('通信エラーが発生しました。再度お試しください。');setStep('result');}
    }catch(e:any){setResult('鑑定中にエラーが発生しました：'+e?.message);setStep('result');}
  }

  async function callAIOther(){
    setStep('loading');
    try{
    const hex=buildHexFromLines(lines);
    const kg=kigakuResult;
    const execT=executionTime||new Date();
    const aHonmei=personA.birthdate?getHonmei(...personA.birthdate.split('-').map(Number)):null;
    const bHonmei=personB.birthdate?getHonmei(...personB.birthdate.split('-').map(Number)):null;
    const score=calcBattleScore({hexagram:hex,sideAElement:aHonmei?S_ELEM[aHonmei]||'':'',sideBElement:bHonmei?S_ELEM[bHonmei]||'':'',battleDate:battleDate?new Date(battleDate):today,occupationDate:execT,kigakuRel:kg?.rel});
    setLiuYaoScore(score);
    const prompt=`あなたは九星気学と六爻占術の式神です。勝負の総合鑑定を行います。

【ユーザー情報】
本命星：${STAR_NAMES[hs]}／月命星：${STAR_NAMES[ts]}
今日の中宮星：${STAR_NAMES[dayC]}（${kg?.dayE||''}）
今年の氣：${STAR_NAMES[yrC]}
${getSanbanInfo(hs,ts)}

【占断実行日時】${execT.toLocaleString('ja-JP')}
【勝負カテゴリ】${battleType?.label||'勝負'}
【勝負日時】${battleDate||'未定'} ${battleTime||''}
【場所】${battleLocation||'未指定'}

【対象者A】${personA.name||'A'} / 生年月日：${personA.birthdate||'不明'} / 本命星：${aHonmei?STAR_NAMES[aHonmei]:'不明'} / 役割：${personA.role||''}
【対象者B】${personB.name||'B'} / 生年月日：${personB.birthdate||'不明'} / 本命星：${bHonmei?STAR_NAMES[bHonmei]:'不明'} / 役割：${personB.role||''}

【質問回答】
${answers[0]}
${answers[1]}
${answers[2]}

【九星気学】気の関係：${kg?.rel} / ${kg?.judgment}

【六爻占術】
本卦：${hex?.main?.name||'不明'} 変卦：${hex?.change?.name||'なし'}
世爻A：第${score.worldLine}爻（${score.worldElem}・${score.wStrength}）
応爻B：第${score.responseLine}爻（${score.responseElem}・${score.rStrength}）
統合スコア A:${score.sideAScore}% B:${score.sideBScore}% — ${score.verdict}

以下の形式で鑑定してください：

【古語】（40〜60文字の文語体）

【九星気学の判断】（三盤を参照し100文字で解説）

【六爻占術の解釈】（世爻・応爻・動爻から150文字で解釈）

【総合判定】（「勝機あり」「要注意」「凶」で始め80文字で）

【警告】（凶・要注意の場合50文字。勝機ありの場合は「なし」）

【最良のタイミング】（具体的な時期を50文字で）

【行動指針】
・（行動1）
・（行動2）
・（行動3）`;
    try{
      const _ctrl=new AbortController();setTimeout(()=>_ctrl.abort(),60000);const res=await fetch('/api/claude',{signal:_ctrl.signal,method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({model:'claude-haiku-4-5-20251001',max_tokens:1800,messages:[{role:'user',content:prompt}]})});
      const data=await res.json();
      const text=data.content?.[0]?.text||'鑑定に失敗しました。';
      const nu=used+1;sSet(mKey,String(nu));setUsed(nu);
      if(authUser?.id){const month2=new Date().getFullYear()+'_'+(new Date().getMonth()+1);supabase.from('usage_counts').upsert({user_id:authUser.id,month:month2,battle_count:nu},{onConflict:'user_id,month'}).then(()=>{});}
      try{const now3=new Date().toISOString();const t3=battleType?.label||'勝負鑑定';const entry={id:Date.now(),date:now3,title:t3,type:'勝負',star:hs,answer:text};const prev=JSON.parse(localStorage.getItem('ki_consult_history')||'[]');localStorage.setItem('ki_consult_history',JSON.stringify([entry,...prev].slice(0,50)));if(authUser?.id){supabase.from('consult_history').insert({user_id:authUser.id,created_at:now3,title:t3,type:'勝負',star:hs,answer:text}).then(()=>{});}}catch(_){}
      setResult(text.replace(/##\s*/g,''));setStep('result');
    }catch(e){setResult('通信エラーが発生しました。再度お試しください。');setStep('result');}
    }catch(e:any){setResult('鑑定中にエラーが発生しました：'+e?.message);setStep('result');}
  }

  const BATTLE_TYPES=[
    {id:'individual',label:'個人競技',icon:'🏃',c:'#dc2626',qs:[
      {q:'競技・種目を教えてください',t:'text',hint:'例：剣道・テニス・水泳'},
      {q:'相手の特徴・強みは？',t:'text',hint:'例：スピード型・技巧派'},
      {q:'あなたの現在の調子は？',t:'sel',opts:['絶好調','好調','普通','不調','わからない']},
    ]},
    {id:'exam',label:'試験・資格',icon:'📝',c:'#7c3aed',qs:[
      {q:'何の試験・審査ですか？',t:'text',hint:'例：〇〇資格試験'},
      {q:'試験の形式は？',t:'sel',opts:['筆記のみ','実技のみ','筆記+実技','面接・口頭試問','その他']},
      {q:'今の準備状況は？',t:'sel',opts:['万全','ほぼ準備できた','不安が残る','準備不足']},
    ]},
    {id:'election',label:'選挙・交渉',icon:'🗳️',c:'#059669',qs:[
      {q:'何についての選挙・交渉ですか？',t:'text',hint:'例：選挙出馬・給与交渉'},
      {q:'相手・状況を教えてください',t:'text',hint:'例：現職との争い・難しい取引先'},
      {q:'勝負の雰囲気は？',t:'sel',opts:['有利','互角','やや不利','不利','わからない']},
    ]},
    {id:'other',label:'その他の勝負',icon:'⚡',c:'#6b7280',qs:[
      {q:'どんな勝負ですか？',t:'text',hint:'例：コンテスト・オーディション'},
      {q:'相手・状況を教えてください',t:'text'},
      {q:'勝負への意気込みは？',t:'sel',opts:['全力で臨む','できる限り頑張る','やれるだけやる','とにかくやってみる']},
    ]},
  ];

  const LineRow=({value,idx})=>{
    const yang=isYang(value);const chg=value===6||value===9;
    return(
      <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"10px"}}>
        <div style={{fontSize:"12px",color:"#9ca3af",width:"28px",textAlign:"right"}}>第{idx+1}</div>
        <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:"4px",height:"14px"}}>
          {yang?<div style={{width:"90px",height:"8px",background:chg?"#ef4444":"#374151",borderRadius:"4px"}}/>
           :<><div style={{width:"40px",height:"8px",background:chg?"#ef4444":"#374151",borderRadius:"4px"}}/><div style={{width:"10px"}}/><div style={{width:"40px",height:"8px",background:chg?"#ef4444":"#374151",borderRadius:"4px"}}/></>}
          {chg&&<span style={{fontSize:"11px",color:"#ef4444",marginLeft:"4px"}}>変</span>}
        </div>
        <div style={{fontSize:"12px",color:chg?"#ef4444":"#6b7280",width:"36px"}}>{value===9?'老陽':value===7?'少陽':value===8?'少陰':'老陰'}</div>
      </div>
    );
  };

  if(!isPremiumPlus){
    return(
      <div style={{padding:"24px"}}>
        <div style={{textAlign:"center",padding:"32px 20px",background:"linear-gradient(135deg,#eff6ff,#dbeafe)",borderRadius:"20px",border:"2px solid #93c5fd",margin:"12px"}}>
          <div style={{fontSize:"44px",marginBottom:"10px"}}>⚡</div>
          <div style={{fontSize:"17px",fontWeight:"bold",color:"#1d4ed8",fontFamily:"serif",marginBottom:"8px",lineHeight:1.5}}>勝負相談はプレミアムプランで</div>
          <div style={{fontSize:"14px",color:"#6b7280",marginBottom:"20px",lineHeight:1.7}}>九星気学×六爻占術で<br/>試合・勝負の結果を占断します</div>
          <button onClick={()=>onUnlock&&onUnlock('premium')} style={{width:"100%",maxWidth:"240px",padding:"14px",background:"linear-gradient(135deg,#1d4ed8,#3b82f6)",color:"white",border:"none",borderRadius:"12px",fontSize:"15px",fontWeight:"bold",cursor:"pointer",letterSpacing:"1px"}}>
            👑 ¥480/月 プレミアムへ
          </button>
          <div style={{marginTop:"12px",fontSize:"12px",color:"#9ca3af"}}>月30回 · 勝負相談 · 全機能利用可</div>
        </div>
      </div>
    );
  }

  if(used>=LIMIT)return(
    <div style={{textAlign:"center",padding:"48px 20px"}}>
      <div style={{fontSize:"48px",marginBottom:"16px"}}>⚡</div>
      <div style={{fontSize:"19px",fontWeight:"bold",fontFamily:"serif",color:"#374151",marginBottom:"10px"}}>今月の勝負相談回数に達しました</div>
      <div style={{fontSize:"15px",color:"#6b7280"}}>今月の使用：{used}/{LIMIT}回 / 来月またご相談ください</div>
    </div>
  );

  const UsageBar=()=>(
    <div style={{display:"flex",alignItems:"center",gap:"8px",padding:"8px 14px",background:"#f8f9fa",borderRadius:"8px",marginBottom:"14px",fontSize:"13px",color:"#6b7280"}}>
      <span>今月の勝負相談：残{LIMIT-used}回</span>
      <div style={{flex:1,height:"4px",background:"#e5e7eb",borderRadius:"2px"}}>
        <div style={{width:`${(used/LIMIT)*100}%`,height:"100%",background:"#1d4ed8",borderRadius:"2px"}}/>
      </div>
    </div>
  );

  function resetAll(){
    setStep('summon');setBattleMode(null);setResult(null);setLines([]);
    setKigakuResult(null);setLiuYaoScore(null);setExecutionTime(null);
    setBattleType(null);setQIdx(0);setAnswers(['','','']);setCurAns('');
    setBattleDate('');setBattleTime('');setBattleLocation('');
    setPersonA({name:'',birthdate:'',role:''});setPersonB({name:'',birthdate:'',role:''});
    setMatchDate('');setMatchTime('');setMatchCity('');setMatchCountry('');
    setMatchLeague('');setMatchStage('');
    setTeamAName('');setTeamACountry('');setTeamAFounded('');setTeamAHome('ホーム');
    setManagerAName('');setManagerABirth('');
    setTeamBName('');setTeamBCountry('');setTeamBFounded('');setTeamBHome('アウェイ');
    setManagerBName('');setManagerBBirth('');
  }

  // ── 召喚画面 ──
  if(step==='summon')return(
    <div style={{minHeight:"60vh",background:"#f8f9fa",padding:"32px 20px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"serif"}}>
      <div style={{fontSize:"80px",marginBottom:"16px",animation:"shikiFloat2 2s ease-in-out infinite alternate"}}>⚡</div>
      <div style={{fontSize:"18px",color:"#3b82f6",letterSpacing:"3px",marginBottom:"8px",textAlign:"center"}}>勝負の氣を読みます</div>
      <div style={{fontSize:"15px",color:"#6b7280",marginBottom:"6px",textAlign:"center"}}>式神が九星気学×六爻占術で鑑定します</div>
      <div style={{fontSize:"13px",color:"#9ca3af",marginBottom:"32px"}}>本命星：{STAR_NAMES[hs]}</div>
      <button onClick={()=>setStep('mode')} style={{padding:"16px 40px",background:"linear-gradient(135deg,#1d4ed8,#2563eb)",color:"white",border:"none",borderRadius:"14px",fontSize:"16px",fontWeight:"bold",cursor:"pointer",letterSpacing:"2px",boxShadow:"0 4px 20px rgba(37,99,235,0.4)"}}>
        勝負相談を始める →
      </button>
      <style>{`@keyframes shikiFloat2{from{transform:translateY(0) scale(1)}to{transform:translateY(-12px) scale(1.05)}}`}</style>
    </div>
  );

  // ── 占種選択 ──
  if(step==='mode')return(
    <div style={{padding:"16px",maxWidth:"560px",margin:"0 auto"}}>
      <UsageBar/>
      <div style={{textAlign:"center",marginBottom:"24px"}}>
        <div style={{fontSize:"20px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937",marginBottom:"4px"}}>何を占いますか？</div>
        <div style={{fontSize:"14px",color:"#6b7280"}}>占いたい勝負の種類を選んでください</div>
      </div>
      <button onClick={()=>{setBattleMode('soccer');setStep('soccer_match');}}
        style={{width:"100%",marginBottom:"14px",padding:"22px 20px",background:"linear-gradient(135deg,#0f172a,#1e3a5f)",border:"2px solid #3b82f6",borderRadius:"16px",cursor:"pointer",display:"flex",alignItems:"center",gap:"16px",textAlign:"left",boxShadow:"0 4px 16px rgba(59,130,246,0.2)"}}>
        <span style={{fontSize:"40px"}}>⚽</span>
        <div style={{flex:1}}>
          <div style={{fontSize:"18px",fontWeight:"bold",color:"white",fontFamily:"serif",marginBottom:"4px"}}>サッカー試合予測</div>
          <div style={{fontSize:"13px",color:"#93c5fd"}}>国内・海外問わず試合結果を九星気学×六爻で占断</div>
          <div style={{fontSize:"12px",color:"#60a5fa",marginTop:"4px"}}>チーム創設年・監督生年月日から精密鑑定</div>
        </div>
        <span style={{color:"#3b82f6",fontSize:"20px"}}>→</span>
      </button>
      <div style={{marginBottom:"10px",fontSize:"13px",color:"#9ca3af",textAlign:"center"}}>── その他の勝負 ──</div>
      <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
        {BATTLE_TYPES.map(t=>(
          <button key={t.id} onClick={()=>{setBattleMode('other');setBattleType(t);setQIdx(0);setAnswers(['','','']);setCurAns('');setStep('q');}}
            style={{padding:"16px 20px",background:"white",border:`2px solid ${t.c}33`,borderRadius:"12px",cursor:"pointer",display:"flex",alignItems:"center",gap:"14px",textAlign:"left",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
            <span style={{fontSize:"26px"}}>{t.icon}</span>
            <div style={{flex:1,fontSize:"16px",fontWeight:"bold",color:t.c,fontFamily:"serif"}}>{t.label}</div>
            <span style={{color:t.c}}>→</span>
          </button>
        ))}
      </div>
    </div>
  );

  // ── サッカー: 試合基本情報 ──
  if(step==='soccer_match'){
    const Inp=BattleInp;
    const Sel=({label,value,onChange,opts})=><BattleSel label={label} value={value} onChange={onChange} opts={opts} accentColor="#1d4ed8"/>;
    return(
      <div style={{padding:"16px",maxWidth:"560px",margin:"0 auto"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"16px"}}>
          <button onClick={()=>setStep('mode')} style={{background:"none",border:"none",color:"#6b7280",cursor:"pointer",fontSize:"15px"}}>← 戻る</button>
          <div style={{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>⚽ 試合情報</div>
        </div>
        <div style={{background:"#eff6ff",borderRadius:"14px",padding:"16px",marginBottom:"14px",border:"1px solid #93c5fd"}}>
          <div style={{fontSize:"13px",fontWeight:"bold",color:"#1d4ed8",marginBottom:"12px"}}>大会・試合</div>
          <Inp label="大会・リーグ名" value={matchLeague} onChange={setMatchLeague} placeholder="例：Jリーグ・UEFA CL・プレミアリーグ"/>
          <Inp label="ステージ・節" value={matchStage} onChange={setMatchStage} placeholder="例：第18節・準決勝・グループリーグ"/>
          <Inp label="試合日" value={matchDate} onChange={setMatchDate} type="date"/>
          <Inp label="キックオフ時刻（日本時間）" value={matchKickoffJst} onChange={setMatchKickoffJst} type="time"/>
          <Inp label="開催都市" value={matchCity} onChange={setMatchCity} placeholder="例：東京・鹿嶋・ロンドン"/>
          {matchCity&&(()=>{const c=findCity(matchCity);return c?(<div style={{background:"#dcfce7",borderRadius:"6px",padding:"5px 10px",fontSize:"11px",color:"#166534",marginTop:"-8px",marginBottom:"10px"}}>✅ 座標取得済：{c[0].toFixed(3)}, {c[1].toFixed(3)}（鑑定に反映）</div>):(<div style={{background:"#fef9c3",borderRadius:"6px",padding:"5px 10px",fontSize:"11px",color:"#854d0e",marginTop:"-8px",marginBottom:"10px"}}>⚠️ テーブル未登録 → 鑑定時にNominatim APIで自動取得します</div>);})()}
          <Inp label="開催国" value={matchCountry} onChange={setMatchCountry} placeholder="例：日本・イングランド・スペイン"/>
          {/* チーム実力スコア（v3.0: 合成スコアの基礎） */}
          <div style={{marginBottom:"14px"}}>
            <div style={{fontSize:"13px",fontWeight:"bold",color:"#374151",marginBottom:"4px"}}>チーム実力スコア</div>
            <div style={{fontSize:"11px",color:"#6b7280",marginBottom:"10px"}}>1=最弱 / 50=平均 / 100=最強　（Jリーグ目安：1位≈90, 中位≈50, 最下位≈15）</div>
            {[['A',teamAStrength,setTeamAStrength],['B',teamBStrength,setTeamBStrength]].map(([label,val,setter])=>(
              <div key={label as string} style={{display:"flex",alignItems:"center",gap:"8px",marginBottom:"8px"}}>
                <div style={{fontSize:"13px",fontWeight:"bold",color:"#374151",minWidth:"28px"}}>チーム{label as string}</div>
                <button onClick={()=>(setter as any)(v=>Math.max(1,v-1))}
                  style={{width:"28px",height:"28px",borderRadius:"6px",border:"1px solid #e5e7eb",background:"white",fontSize:"16px",cursor:"pointer",fontWeight:"bold",color:"#374151",lineHeight:1}}>－</button>
                <input type="range" min={1} max={100} value={val as number}
                  onChange={e=>(setter as any)(Number(e.target.value))}
                  style={{flex:1,height:"4px",accentColor:"#2563eb"}}/>
                <button onClick={()=>(setter as any)(v=>Math.min(100,v+1))}
                  style={{width:"28px",height:"28px",borderRadius:"6px",border:"1px solid #e5e7eb",background:"white",fontSize:"16px",cursor:"pointer",fontWeight:"bold",color:"#374151",lineHeight:1}}>＋</button>
                <div style={{fontSize:"18px",fontWeight:"bold",color:"#1d4ed8",minWidth:"36px",textAlign:"center"}}>{val as number}</div>
              </div>
            ))}
            {(()=>{
              const diff=teamAStrength-teamBStrength;
              if(Math.abs(diff)<5) return <div style={{padding:"5px 10px",borderRadius:"6px",fontSize:"11px",background:"#f3f4f6",color:"#374151"}}>⚖️ 両チームほぼ互角（差{diff>=0?'+':''}{diff}）</div>;
              const stronger=diff>0?teamAName||'チームA':teamBName||'チームB';
              return <div style={{padding:"5px 10px",borderRadius:"6px",fontSize:"11px",background:diff>0?'#eff6ff':'#fef2f2',color:diff>0?'#1e40af':'#991b1b'}}>
                {diff>0?'🏠':'✈️'} {stronger}が実力優勢（差{diff>=0?'+':''}{diff}pt）
              </div>;
            })()}
          </div>
          {matchKickoffJst&&matchDate&&(
            <div style={{background:"#dbeafe",borderRadius:"8px",padding:"8px 12px",fontSize:"12px",color:"#1d4ed8",marginTop:"6px"}}>
              ⏰ 占断時刻（JST）：{matchDate} {matchKickoffJst}
              {(()=>{const h=parseInt(matchKickoffJst.split(':')[0]||'12');const d=getDayStar(matchDate?new Date(matchDate+'T12:00:00'):new Date());const hs2=getHourStar(h,d);return ` / 時盤中宮：${["","一白","二黒","三碧","四緑","五黄","六白","七赤","八白","九紫"][hs2]}星`;})()}
            </div>
          )}
        </div>
        <button onClick={()=>setStep('soccer_teamA')} disabled={!matchLeague&&!matchDate}
          style={{width:"100%",padding:"16px",background:"linear-gradient(135deg,#1d4ed8,#2563eb)",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:"pointer",letterSpacing:"1px"}}>
          チームA情報へ →
        </button>
      </div>
    );
  }

  // ── サッカー: チームA ──
  if(step==='soccer_teamA'){
    const Inp=BattleInp;
    const kgA=teamAFounded||managerABirth?calcKigakuForTeam(teamAFounded,managerABirth):null;
    const j1StarA=teamAId?getTeamKiStar(teamAId):null;
    return(
      <div style={{padding:"16px",maxWidth:"560px",margin:"0 auto"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"16px"}}>
          <button onClick={()=>setStep('soccer_match')} style={{background:"none",border:"none",color:"#6b7280",cursor:"pointer",fontSize:"15px"}}>← 戻る</button>
          <div style={{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#16a34a"}}>🟢 チームA</div>
        </div>
        {/* リーグ選択 */}
        <div style={{background:"#ecfdf5",borderRadius:"14px",padding:"16px",marginBottom:"14px",border:"2px solid #6ee7b7"}}>
          <div style={{fontSize:"13px",fontWeight:"bold",color:"#065f46",marginBottom:"10px"}}>⚡ Jリーグから選択（自動入力）</div>
          <div style={{display:"flex",gap:"6px",marginBottom:"10px"}}>
            {(['J1','J2'] as const).map(lg=>(
              <button key={lg} onClick={()=>{setLeagueTabA(lg);setTeamAId('');setTeamAName('');setTeamACountry('');setTeamAFounded('');setTeamAHomeCity('');}}
                style={{flex:1,padding:"7px 0",borderRadius:"8px",border:`2px solid ${leagueTabA===lg?'#16a34a':'#d1fae5'}`,background:leagueTabA===lg?'#16a34a':'white',color:leagueTabA===lg?'white':'#16a34a',fontSize:"13px",fontWeight:leagueTabA===lg?'bold':'normal',cursor:"pointer"}}>
                {lg}
              </button>
            ))}
          </div>
          <select value={teamAId} onChange={e=>{const v=e.target.value;if(v)applyTeam(v,'A');else{setTeamAId('');setTeamAName('');setTeamACountry('');setTeamAFounded('');setTeamAHomeCity('');}}}
            style={{width:"100%",padding:"10px 12px",borderRadius:"8px",border:"1px solid #6ee7b7",fontSize:"14px",background:"white",color:"#1f2937",cursor:"pointer"}}>
            <option value="">── 手動入力（海外等）──</option>
            {(leagueTabA==='J1'?J1_TEAMS:J2_TEAMS).map(t=><option key={t.id} value={t.id}>{t.name}（{t.city}）</option>)}
          </select>
          {j1StarA&&(()=>{
            const tA=[...J1_TEAMS,...J2_TEAMS].find(x=>x.id===teamAId)!;
            const mgrBirthYearA=managerABirth?parseInt(managerABirth.slice(0,4)):null;
            const mgrStarA=mgrBirthYearA?getYearStar(mgrBirthYearA):null;
            return(
              <div style={{marginTop:"10px",background:"white",borderRadius:"8px",padding:"10px 12px",border:"1px solid #a7f3d0"}}>
                <div style={{fontSize:"13px",fontWeight:"bold",color:"#065f46",marginBottom:"4px"}}>📊 {tA.name} の本命星</div>
                <div style={{fontSize:"14px",color:"#047857"}}>⭐ {STAR_NAMES[j1StarA]}（{S_ELEM[j1StarA]}行）</div>
                <div style={{fontSize:"11px",color:"#6b7280",marginTop:"2px"}}>気学年：{tA.kiYear}年 / 本拠：{tA.city}</div>
                <div style={{marginTop:"8px",paddingTop:"8px",borderTop:"1px solid #d1fae5"}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"4px"}}>
                    <div style={{fontSize:"12px",fontWeight:"bold",color:"#065f46"}}>監督</div>
                    <button onClick={()=>setEditMgrA(v=>!v)} style={{background:"none",border:"none",cursor:"pointer",color:"#6b7280",fontSize:"14px",padding:"0 2px"}} title="監督情報を編集">✏️</button>
                  </div>
                  {editMgrA?(
                    <div style={{display:"flex",flexDirection:"column",gap:"6px"}}>
                      <input value={managerAName} onChange={e=>setManagerAName(e.target.value)} placeholder="監督氏名" style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #6ee7b7",fontSize:"13px",boxSizing:"border-box"}}/>
                      <input type="date" value={managerABirth} onChange={e=>setManagerABirth(e.target.value)} style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #6ee7b7",fontSize:"13px",boxSizing:"border-box"}}/>
                      <button onClick={()=>setEditMgrA(false)} style={{alignSelf:"flex-end",padding:"4px 12px",background:"#16a34a",color:"white",border:"none",borderRadius:"6px",fontSize:"12px",cursor:"pointer"}}>確定</button>
                    </div>
                  ):(
                    <div>
                      <div style={{fontSize:"13px",color:"#374151"}}>{managerAName||'（未設定）'}{!managerABirth&&<span style={{color:"#f59e0b",fontSize:"11px",marginLeft:"6px"}}>生年月日：要確認</span>}</div>
                      {mgrStarA&&<div style={{fontSize:"11px",color:"#047857",marginTop:"2px"}}>本命星：{STAR_NAMES[mgrStarA]}（{S_ELEM[mgrStarA]}行）/ 生：{managerABirth}</div>}
                    </div>
                  )}
                </div>
              </div>
            );
          })()}
        </div>
        <div style={{background:"#f0fdf4",borderRadius:"14px",padding:"16px",marginBottom:"14px",border:"1px solid #86efac"}}>
          <div style={{fontSize:"13px",fontWeight:"bold",color:"#16a34a",marginBottom:"12px"}}>チーム情報{teamAId&&<span style={{fontSize:"11px",fontWeight:"normal",color:"#6b7280",marginLeft:"8px"}}>（{leagueTabA}選択から自動入力済み・修正可）</span>}</div>
          <Inp label="チーム名" value={teamAName} onChange={v=>{setTeamAName(v);if(teamAId)setTeamAId('');}} placeholder="例：浦和レッズ・マンチェスター・U"/>
          <Inp label="国籍・所属国" value={teamACountry} onChange={setTeamACountry} placeholder="例：日本・イングランド"/>
          <Inp label="クラブ気学年（4桁）" value={teamAFounded} onChange={v=>{setTeamAFounded(v);if(teamAId)setTeamAId('');}} placeholder="例：1950"/>
          <Inp label="本拠地都市" value={teamAHomeCity} onChange={v=>{setTeamAHomeCity(v);if(teamAId)setTeamAId('');}} placeholder="例：埼玉県さいたま市・Manchester"/>
          {teamAHomeCity&&(()=>{const c=findCity(teamAHomeCity);return c?<div style={{fontSize:"11px",color:"#16a34a",marginTop:"-6px",marginBottom:"8px"}}>✓ 座標確認（{c[0].toFixed(2)},{c[1].toFixed(2)}）</div>:<div style={{fontSize:"11px",color:"#ef4444",marginTop:"-6px",marginBottom:"8px"}}>⚠ 都市が見つかりません（方位計算に影響）</div>;})()}
          <div style={{marginBottom:"10px"}}>
            <div style={{fontSize:"12px",color:"#6b7280",marginBottom:"4px"}}>ホーム/アウェイ</div>
            <div style={{display:"flex",gap:"8px"}}>
              {['ホーム','アウェイ','中立地'].map(opt=>(
                <button key={opt} onClick={()=>{setTeamAHome(opt);if(opt==='ホーム')setTeamBHome('アウェイ');else if(opt==='アウェイ')setTeamBHome('ホーム');else setTeamBHome('中立地');}}
                  style={{flex:1,padding:"10px 6px",borderRadius:"8px",border:`2px solid ${teamAHome===opt?'#16a34a':'#e5e7eb'}`,background:teamAHome===opt?'#f0fdf4':'white',color:teamAHome===opt?'#16a34a':'#374151',fontSize:"13px",cursor:"pointer",fontWeight:teamAHome===opt?"bold":"normal",textAlign:"center"}}>
                  {opt==='ホーム'?'🏠 ホーム':opt==='アウェイ'?'✈️ アウェイ':'⚖️ 中立地'}
                </button>
              ))}
            </div>
          </div>
          {kgA?.teamStar&&<div style={{fontSize:"12px",color:"#16a34a",padding:"6px 10px",background:"rgba(22,163,74,0.08)",borderRadius:"6px",marginTop:"4px"}}>クラブ本命星：{STAR_NAMES[kgA.teamStar]}（{kgA.teamE}）→ 日盤との関係：{kgA.teamRel}</div>}
        </div>
        <div style={{background:"#f0fdf4",borderRadius:"14px",padding:"16px",marginBottom:"14px",border:"1px solid #86efac"}}>
          <div style={{fontSize:"13px",fontWeight:"bold",color:"#16a34a",marginBottom:"12px"}}>監督情報</div>
          <Inp label="監督氏名" value={managerAName} onChange={setManagerAName} placeholder="例：ミシャ・アルテタ"/>
          <Inp label="監督生年月日" value={managerABirth} onChange={setManagerABirth} type="date"/>
          {kgA?.mgrStar&&<div style={{fontSize:"12px",color:"#16a34a",padding:"6px 10px",background:"rgba(22,163,74,0.08)",borderRadius:"6px",marginTop:"4px"}}>監督本命星：{STAR_NAMES[kgA.mgrStar]}（{kgA.mgrE}）→ 日盤との関係：{kgA.mgrRel}</div>}
        </div>
        <button onClick={()=>setStep('soccer_teamB')} disabled={!teamAName}
          style={{width:"100%",padding:"16px",background:"linear-gradient(135deg,#16a34a,#22c55e)",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:teamAName?"pointer":"not-allowed",letterSpacing:"1px"}}>
          チームB情報へ →
        </button>
      </div>
    );
  }

  // ── サッカー: チームB ──
  if(step==='soccer_teamB'){
    const Inp=BattleInp;
    const kgB=teamBFounded||managerBBirth?calcKigakuForTeam(teamBFounded,managerBBirth):null;
    const j1StarB=teamBId?getTeamKiStar(teamBId):null;
    return(
      <div style={{padding:"16px",maxWidth:"560px",margin:"0 auto"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"16px"}}>
          <button onClick={()=>setStep('soccer_teamA')} style={{background:"none",border:"none",color:"#6b7280",cursor:"pointer",fontSize:"15px"}}>← 戻る</button>
          <div style={{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#dc2626"}}>🔴 チームB</div>
        </div>
        {/* リーグ選択 */}
        <div style={{background:"#fff1f2",borderRadius:"14px",padding:"16px",marginBottom:"14px",border:"2px solid #fda4af"}}>
          <div style={{fontSize:"13px",fontWeight:"bold",color:"#9f1239",marginBottom:"10px"}}>⚡ Jリーグから選択（自動入力）</div>
          <div style={{display:"flex",gap:"6px",marginBottom:"10px"}}>
            {(['J1','J2'] as const).map(lg=>(
              <button key={lg} onClick={()=>{setLeagueTabB(lg);setTeamBId('');setTeamBName('');setTeamBCountry('');setTeamBFounded('');setTeamBHomeCity('');}}
                style={{flex:1,padding:"7px 0",borderRadius:"8px",border:`2px solid ${leagueTabB===lg?'#dc2626':'#fecdd3'}`,background:leagueTabB===lg?'#dc2626':'white',color:leagueTabB===lg?'white':'#dc2626',fontSize:"13px",fontWeight:leagueTabB===lg?'bold':'normal',cursor:"pointer"}}>
                {lg}
              </button>
            ))}
          </div>
          <select value={teamBId} onChange={e=>{const v=e.target.value;if(v)applyTeam(v,'B');else{setTeamBId('');setTeamBName('');setTeamBCountry('');setTeamBFounded('');setTeamBHomeCity('');}}}
            style={{width:"100%",padding:"10px 12px",borderRadius:"8px",border:"1px solid #fda4af",fontSize:"14px",background:"white",color:"#1f2937",cursor:"pointer"}}>
            <option value="">── 手動入力（海外等）──</option>
            {(leagueTabB==='J1'?J1_TEAMS:J2_TEAMS).map(t=><option key={t.id} value={t.id}>{t.name}（{t.city}）</option>)}
          </select>
          {j1StarB&&(()=>{
            const tB=[...J1_TEAMS,...J2_TEAMS].find(x=>x.id===teamBId)!;
            const mgrBirthYearB=managerBBirth?parseInt(managerBBirth.slice(0,4)):null;
            const mgrStarB=mgrBirthYearB?getYearStar(mgrBirthYearB):null;
            return(
              <div style={{marginTop:"10px",background:"white",borderRadius:"8px",padding:"10px 12px",border:"1px solid #fecdd3"}}>
                <div style={{fontSize:"13px",fontWeight:"bold",color:"#9f1239",marginBottom:"4px"}}>📊 {tB.name} の本命星</div>
                <div style={{fontSize:"14px",color:"#dc2626"}}>⭐ {STAR_NAMES[j1StarB]}（{S_ELEM[j1StarB]}行）</div>
                <div style={{fontSize:"11px",color:"#6b7280",marginTop:"2px"}}>気学年：{tB.kiYear}年 / 本拠：{tB.city}</div>
                <div style={{marginTop:"8px",paddingTop:"8px",borderTop:"1px solid #fecdd3"}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"4px"}}>
                    <div style={{fontSize:"12px",fontWeight:"bold",color:"#9f1239"}}>監督</div>
                    <button onClick={()=>setEditMgrB(v=>!v)} style={{background:"none",border:"none",cursor:"pointer",color:"#6b7280",fontSize:"14px",padding:"0 2px"}} title="監督情報を編集">✏️</button>
                  </div>
                  {editMgrB?(
                    <div style={{display:"flex",flexDirection:"column",gap:"6px"}}>
                      <input value={managerBName} onChange={e=>setManagerBName(e.target.value)} placeholder="監督氏名" style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #fda4af",fontSize:"13px",boxSizing:"border-box"}}/>
                      <input type="date" value={managerBBirth} onChange={e=>setManagerBBirth(e.target.value)} style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #fda4af",fontSize:"13px",boxSizing:"border-box"}}/>
                      <button onClick={()=>setEditMgrB(false)} style={{alignSelf:"flex-end",padding:"4px 12px",background:"#dc2626",color:"white",border:"none",borderRadius:"6px",fontSize:"12px",cursor:"pointer"}}>確定</button>
                    </div>
                  ):(
                    <div>
                      <div style={{fontSize:"13px",color:"#374151"}}>{managerBName||'（未設定）'}{!managerBBirth&&<span style={{color:"#f59e0b",fontSize:"11px",marginLeft:"6px"}}>生年月日：要確認</span>}</div>
                      {mgrStarB&&<div style={{fontSize:"11px",color:"#dc2626",marginTop:"2px"}}>本命星：{STAR_NAMES[mgrStarB]}（{S_ELEM[mgrStarB]}行）/ 生：{managerBBirth}</div>}
                    </div>
                  )}
                </div>
              </div>
            );
          })()}
        </div>
        <div style={{background:"#fef2f2",borderRadius:"14px",padding:"16px",marginBottom:"14px",border:"1px solid #fca5a5"}}>
          <div style={{fontSize:"13px",fontWeight:"bold",color:"#dc2626",marginBottom:"12px"}}>チーム情報{teamBId&&<span style={{fontSize:"11px",fontWeight:"normal",color:"#6b7280",marginLeft:"8px"}}>（{leagueTabB}選択から自動入力済み・修正可）</span>}</div>
          <Inp label="チーム名" value={teamBName} onChange={v=>{setTeamBName(v);if(teamBId)setTeamBId('');}} placeholder="例：鹿島アントラーズ・リバプール"/>
          <Inp label="国籍・所属国" value={teamBCountry} onChange={setTeamBCountry} placeholder="例：日本・イングランド"/>
          <Inp label="クラブ気学年（4桁）" value={teamBFounded} onChange={v=>{setTeamBFounded(v);if(teamBId)setTeamBId('');}} placeholder="例：1947"/>
          <Inp label="本拠地都市" value={teamBHomeCity} onChange={v=>{setTeamBHomeCity(v);if(teamBId)setTeamBId('');}} placeholder="例：茨城県鹿嶋市・London"/>
          {teamBHomeCity&&(()=>{const c=findCity(teamBHomeCity);return c?<div style={{fontSize:"11px",color:"#dc2626",marginTop:"-6px",marginBottom:"8px"}}>✓ 座標確認（{c[0].toFixed(2)},{c[1].toFixed(2)}）</div>:<div style={{fontSize:"11px",color:"#ef4444",marginTop:"-6px",marginBottom:"8px"}}>⚠ 都市が見つかりません（方位計算に影響）</div>;})()}
          <div style={{marginBottom:"10px"}}>
            <div style={{fontSize:"12px",color:"#6b7280",marginBottom:"4px"}}>ホーム/アウェイ</div>
            <div style={{display:"flex",gap:"8px"}}>
              {['ホーム','アウェイ','中立地'].map(opt=>(
                <button key={opt} onClick={()=>{setTeamBHome(opt);if(opt==='ホーム')setTeamAHome('アウェイ');else if(opt==='アウェイ')setTeamAHome('ホーム');else setTeamAHome('中立地');}}
                  style={{flex:1,padding:"10px 6px",borderRadius:"8px",border:`2px solid ${teamBHome===opt?'#dc2626':'#e5e7eb'}`,background:teamBHome===opt?'#fef2f2':'white',color:teamBHome===opt?'#dc2626':'#374151',fontSize:"13px",cursor:"pointer",fontWeight:teamBHome===opt?"bold":"normal",textAlign:"center"}}>
                  {opt==='ホーム'?'🏠 ホーム':opt==='アウェイ'?'✈️ アウェイ':'⚖️ 中立地'}
                </button>
              ))}
            </div>
          </div>
          {kgB?.teamStar&&<div style={{fontSize:"12px",color:"#dc2626",padding:"6px 10px",background:"rgba(220,38,38,0.08)",borderRadius:"6px",marginTop:"4px"}}>クラブ本命星：{STAR_NAMES[kgB.teamStar]}（{kgB.teamE}）→ 日盤との関係：{kgB.teamRel}</div>}
        </div>
        <div style={{background:"#fef2f2",borderRadius:"14px",padding:"16px",marginBottom:"14px",border:"1px solid #fca5a5"}}>
          <div style={{fontSize:"13px",fontWeight:"bold",color:"#dc2626",marginBottom:"12px"}}>監督情報</div>
          <Inp label="監督氏名" value={managerBName} onChange={setManagerBName} placeholder="例：スロット・クロップ"/>
          <Inp label="監督生年月日" value={managerBBirth} onChange={setManagerBBirth} type="date"/>
          {kgB?.mgrStar&&<div style={{fontSize:"12px",color:"#dc2626",padding:"6px 10px",background:"rgba(220,38,38,0.08)",borderRadius:"6px",marginTop:"4px"}}>監督本命星：{STAR_NAMES[kgB.mgrStar]}（{kgB.mgrE}）→ 日盤との関係：{kgB.mgrRel}</div>}
        </div>
        <button onClick={()=>{setExecutionTime(new Date());setLines([]);setManualBattleCoins([]);setStep('battle_rokko_select');}} disabled={!teamBName}
          style={{width:"100%",padding:"16px",background:teamBName?"linear-gradient(135deg,#dc2626,#ef4444)":"#e5e7eb",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:teamBName?"pointer":"not-allowed",letterSpacing:"1px"}}>
          六爻占術へ進む ✦
        </button>
      </div>
    );
  }

  // ── 既存勝負: 質問フロー ──
  const bt=battleType;
  const curQ=bt?.qs[qIdx];
  if(step==='q'&&curQ){
    return(
      <div style={{padding:"16px",maxWidth:"560px",margin:"0 auto"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"20px"}}>
          <button onClick={()=>qIdx===0?setStep('mode'):(()=>{setQIdx(qIdx-1);setCurAns(answers[qIdx-1]);})()}
            style={{background:"none",border:"none",color:"#6b7280",cursor:"pointer",fontSize:"15px"}}>← 戻る</button>
          <div style={{flex:1,height:"5px",background:"#f3f4f6",borderRadius:"3px"}}>
            <div style={{width:`${((qIdx+1)/3)*100}%`,height:"100%",background:bt.c,borderRadius:"3px",transition:"width 0.3s"}}/>
          </div>
          <div style={{fontSize:"13px",color:"#9ca3af"}}>{qIdx+1}/3</div>
        </div>
        <div style={{background:"white",border:`2px solid ${bt.c}22`,borderRadius:"14px",padding:"18px",marginBottom:"18px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
          <div style={{fontSize:"12px",color:bt.c,letterSpacing:"2px",marginBottom:"6px"}}>質問{qIdx+1} / {bt.label}</div>
          <div style={{fontSize:"16px",fontWeight:"bold",color:"#1f2937",fontFamily:"serif",lineHeight:1.65}}>{curQ.q}</div>
          {curQ.hint&&<div style={{fontSize:"13px",color:"#9ca3af",marginTop:"5px"}}>{curQ.hint}</div>}
        </div>
        {curQ.t==='text'?(
          <textarea value={curAns} onChange={e=>setCurAns(e.target.value)} placeholder="詳しく教えてください..."
            style={{width:"100%",padding:"14px",borderRadius:"10px",border:"1px solid #e5e7eb",fontSize:"15px",minHeight:"100px",resize:"none",boxSizing:"border-box",fontFamily:"inherit",lineHeight:1.7}}/>
        ):(
          <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
            {curQ.opts.map(opt=>(
              <button key={opt} onClick={()=>setCurAns(opt)}
                style={{padding:"13px 16px",borderRadius:"10px",border:`2px solid ${curAns===opt?bt.c:'#e5e7eb'}`,background:curAns===opt?"#eff6ff":"white",color:curAns===opt?bt.c:"#374151",fontSize:"15px",cursor:"pointer",textAlign:"left",fontWeight:curAns===opt?"bold":"normal"}}>
                {curAns===opt?'✓ ':''}{opt}
              </button>
            ))}
          </div>
        )}
        <button onClick={()=>{
          if(!curAns.trim())return;
          const na=[...answers];na[qIdx]=curAns;setAnswers(na);
          if(qIdx<2){setQIdx(qIdx+1);setCurAns(na[qIdx+1]||'');}
          else{setStep('detail');}
        }} disabled={!curAns.trim()}
          style={{width:"100%",marginTop:"16px",padding:"16px",background:curAns.trim()?`linear-gradient(135deg,${bt.c},${bt.c}cc)`:"#e5e7eb",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:curAns.trim()?"pointer":"not-allowed"}}>
          {qIdx<2?'次の質問へ →':'詳細情報を入力 →'}
        </button>
      </div>
    );
  }

  // ── 既存勝負: 詳細情報 ──
  if(step==='detail'){
    const Inp=BattleInp;
    const Sel=({label,value,onChange,opts})=><BattleSel label={label} value={value} onChange={onChange} opts={opts} accentColor={bt?.c||'#1d4ed8'}/>;
    return(
      <div style={{padding:"16px",maxWidth:"560px",margin:"0 auto"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"16px"}}>
          <button onClick={()=>setStep('q')} style={{background:"none",border:"none",color:"#6b7280",cursor:"pointer",fontSize:"15px"}}>← 戻る</button>
          <div style={{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937"}}>詳細情報の入力</div>
        </div>
        <div style={{background:"#eff6ff",borderRadius:"12px",padding:"14px",marginBottom:"14px",border:"1px solid #93c5fd"}}>
          <div style={{fontSize:"13px",fontWeight:"bold",color:"#1d4ed8",marginBottom:"10px"}}>勝負日時・場所</div>
          <Inp label="勝負の日付" value={battleDate} onChange={setBattleDate} type="date"/>
          <Inp label="勝負の時刻（任意）" value={battleTime} onChange={setBattleTime} type="time" placeholder="例：14:00"/>
          <Inp label="勝負の場所（都市名）" value={battleLocation} onChange={setBattleLocation} placeholder="例：東京・大阪"/>
        </div>
        <div style={{background:"#f0fdf4",borderRadius:"12px",padding:"14px",marginBottom:"14px",border:"1px solid #86efac"}}>
          <div style={{fontSize:"13px",fontWeight:"bold",color:"#16a34a",marginBottom:"10px"}}>対象者A（自分）</div>
          <Inp label="氏名（任意）" value={personA.name} onChange={v=>setPersonA(p=>({...p,name:v}))} placeholder="例：山田太郎"/>
          <Inp label="生年月日" value={personA.birthdate} onChange={v=>setPersonA(p=>({...p,birthdate:v}))} type="date"/>
          <Sel label="役割" value={personA.role} onChange={v=>setPersonA(p=>({...p,role:v}))} opts={['選手','監督','代表者','受験者','候補者']}/>
        </div>
        <div style={{background:"#fef2f2",borderRadius:"12px",padding:"14px",marginBottom:"14px",border:"1px solid #fca5a5"}}>
          <div style={{fontSize:"13px",fontWeight:"bold",color:"#dc2626",marginBottom:"10px"}}>対象者B（相手）</div>
          <Inp label="氏名（任意）" value={personB.name} onChange={v=>setPersonB(p=>({...p,name:v}))} placeholder="例：相手の名前"/>
          <Inp label="生年月日（任意）" value={personB.birthdate} onChange={v=>setPersonB(p=>({...p,birthdate:v}))} type="date"/>
          <Sel label="役割" value={personB.role} onChange={v=>setPersonB(p=>({...p,role:v}))} opts={['選手','監督','代表者','受験者','候補者']}/>
        </div>
        <div style={{background:"#fffbeb",borderRadius:"10px",padding:"10px 14px",marginBottom:"14px",border:"1px solid #fde68a",fontSize:"13px",color:"#92400e"}}>
          <span style={{fontWeight:"bold"}}>占断実行時刻：</span>{new Date().toLocaleString('ja-JP')}（自動取得）
        </div>
        <button onClick={()=>{setExecutionTime(new Date());const kg=calcKigakuOther();setKigakuResult(kg);setStep('kigaku');}}
          style={{width:"100%",padding:"16px",background:`linear-gradient(135deg,${bt?.c||'#1d4ed8'},${bt?.c||'#1d4ed8'}cc)`,color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:"pointer",letterSpacing:"1px"}}>
          九星気学で診断する ✦
        </button>
      </div>
    );
  }

  // ── 九星気学結果（既存勝負用） ──
  if(step==='kigaku'&&kigakuResult){
    const kg=kigakuResult;
    return(
      <div style={{padding:"16px",maxWidth:"560px",margin:"0 auto"}}>
        <div style={{background:kg.isGood?"linear-gradient(135deg,#f0fdf4,#dcfce7)":"linear-gradient(135deg,#fff7ed,#fef3c7)",borderRadius:"18px",padding:"24px",marginBottom:"16px",border:`2px solid ${kg.isGood?"#86efac":"#fde68a"}`}}>
          <div style={{textAlign:"center",marginBottom:"16px"}}>
            <div style={{fontSize:"48px",marginBottom:"8px"}}>{kg.isGood?'✨':'⚠️'}</div>
            <div style={{fontSize:"20px",fontWeight:"bold",fontFamily:"serif",color:kg.isGood?"#166534":"#92400e"}}>{kg.isGood?'勝機あり':'慎重に'}</div>
            <div style={{fontSize:"14px",color:"#6b7280",marginTop:"4px"}}>気の関係：{kg.rel}</div>
          </div>
          <div style={{background:"rgba(255,255,255,0.7)",borderRadius:"10px",padding:"14px"}}>
            <div style={{fontSize:"14px",color:"#374151",lineHeight:1.8}}>{kg.judgment}</div>
          </div>
          <div style={{display:"flex",justifyContent:"center",gap:"20px",marginTop:"14px",fontSize:"13px",color:"#6b7280"}}>
            <span>あなた：{kg.myE}行</span>
            <span>今日：{kg.dayE}行</span>
          </div>
        </div>
        <button onClick={()=>{setLines([]);setManualBattleCoins([]);setStep('battle_rokko_select');}}
          style={{width:"100%",padding:"16px",background:"linear-gradient(135deg,#0a0e1a,#1a1040)",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:"pointer",letterSpacing:"1px"}}>
          六爻占術へ進む ✦
        </button>
      </div>
    );
  }

  // ── 六爻占術: 方式選択 ──
  if(step==='battle_rokko_select')return(
    <div style={{minHeight:"60vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"serif",padding:"24px",background:"linear-gradient(135deg,#0a0e1a,#1a1040)"}}>
      <div style={{fontSize:"48px",marginBottom:"12px"}}>⚡</div>
      <div style={{fontSize:"20px",color:"#93c5fd",marginBottom:"8px",letterSpacing:"2px"}}>六爻占術</div>
      <div style={{fontSize:"13px",color:"#9ca3af",marginBottom:"32px",textAlign:"center"}}>卦の立て方を選んでください</div>
      <div style={{display:"flex",flexDirection:"column",gap:"16px",width:"100%",maxWidth:"320px"}}>
        <button onClick={()=>doAutoRokko()}
          style={{padding:"20px",background:"rgba(30,30,80,0.8)",border:"1px solid #3b82f666",borderRadius:"16px",color:"#e0e7ff",textAlign:"left",cursor:"pointer"}}>
          <div style={{fontSize:"22px",marginBottom:"6px"}}>⚡ 自動投銭</div>
          <div style={{fontSize:"13px",color:"#93c5fd",marginBottom:"4px"}}>AIが自動でコインを投げて卦を立てます</div>
          <div style={{fontSize:"11px",color:"#6b7280"}}>素早く鑑定したいときに</div>
        </button>
        <button onClick={()=>setStep('battle_rokko_manual')}
          style={{padding:"20px",background:"rgba(20,40,20,0.8)",border:"1px solid #4ade8066",borderRadius:"16px",color:"#e0e7ff",textAlign:"left",cursor:"pointer"}}>
          <div style={{fontSize:"22px",marginBottom:"6px"}}>🪙 手動投銭（5円玉）</div>
          <div style={{fontSize:"13px",color:"#4ade80",marginBottom:"4px"}}>実際に5円玉を3枚振って入力します</div>
          <div style={{fontSize:"11px",color:"#6b7280"}}>気を込めて丁寧に占いたいときに</div>
        </button>
      </div>
    </div>
  );

  // ── 六爻占術: 手動投銭 ──
  if(step==='battle_rokko_manual'){
    const coinCount=lines.length;
    const currentLineCoins:boolean[]=manualBattleCoins[coinCount]||[];
    function addBattleCoin(isHeads:boolean){
      const next=[...currentLineCoins,isHeads];
      const updated=[...manualBattleCoins.slice(0,coinCount),next,...manualBattleCoins.slice(coinCount+1)];
      if(next.length===3){
        const yang=next.filter(Boolean).length;
        const val=yang===3?9:yang===2?7:yang===1?8:6;
        const newLineVals=[...lines,val];
        setManualBattleCoins([...manualBattleCoins.slice(0,coinCount),next]);
        setLines(newLineVals);
        if(newLineVals.length===6){
          setTimeout(()=>setStep('hexagram'),400);
        }
      } else {
        setManualBattleCoins(updated);
      }
    }
    return(
      <div style={{minHeight:"60vh",display:"flex",flexDirection:"column",alignItems:"center",padding:"24px",background:"linear-gradient(135deg,#0a0e1a,#1a1040)",fontFamily:"serif"}}>
        <div style={{fontSize:"36px",marginBottom:"8px"}}>🪙</div>
        <div style={{fontSize:"17px",color:"#93c5fd",marginBottom:"4px",letterSpacing:"2px"}}>5円玉を3枚投げてください</div>
        <div style={{fontSize:"13px",color:"#9ca3af",marginBottom:"20px"}}>{coinCount+1}爻目 / コイン {currentLineCoins.length+1}枚目</div>
        {/* 上爻（6）が上・初爻（1）が下になるよう逆順表示 */}
        <div style={{display:"flex",flexDirection:"column",gap:"8px",width:"220px",marginBottom:"24px"}}>
          {[5,4,3,2,1,0].map(i=>{
            const v=lines[i];
            const isDone=v!=null;
            const isYang=v===7||v===9;const isChg=v===6||v===9;
            const isCurrent=i===coinCount;
            return(
              <div key={i} style={{display:"flex",alignItems:"center",gap:"12px",opacity:isDone?1:isCurrent?0.7:0.2,transition:"opacity 0.3s"}}>
                <span style={{fontSize:"11px",color:isCurrent?"#93c5fd":"#9ca3af",width:"24px",textAlign:"right"}}>{i===5?'上爻':i===0?'初爻':`${i+1}爻`}</span>
                {isDone?(
                  <div style={{flex:1,display:"flex",gap:"4px",justifyContent:"center"}}>
                    {isYang?<div style={{height:"10px",flex:1,background:isChg?"#f59e0b":"#60a5fa",borderRadius:"2px"}}/>:(<><div style={{height:"10px",flex:"0 0 42%",background:isChg?"#f59e0b":"#4b5563",borderRadius:"2px"}}/><div style={{width:"8px"}}/><div style={{height:"10px",flex:"0 0 42%",background:isChg?"#f59e0b":"#4b5563",borderRadius:"2px"}}/></>)}
                  </div>
                ):(
                  <div style={{flex:1,height:"10px",background:isCurrent?"#374151":"#1f2937",borderRadius:"2px",animation:isCurrent?"pulse 1s ease-in-out infinite":undefined}}/>
                )}
              </div>
            );
          })}
        </div>
        <div style={{display:"flex",gap:"12px",marginBottom:"20px"}}>
          {[0,1,2].map(ci=>(
            <div key={ci} style={{width:"52px",height:"52px",borderRadius:"50%",border:"2px solid",borderColor:ci<currentLineCoins.length?"#60a5fa":"#374151",background:ci<currentLineCoins.length?(currentLineCoins[ci]?"#60a5fa":"#4b5563"):"#1f2937",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"18px",transition:"all 0.2s",color:"#e0e7ff"}}>
              {ci<currentLineCoins.length?(currentLineCoins[ci]?'表':'裏'):'?'}
            </div>
          ))}
        </div>
        <div style={{fontSize:"13px",color:"#9ca3af",marginBottom:"20px"}}>{currentLineCoins.length+1}枚目のコインの結果を入力</div>
        <div style={{display:"flex",gap:"16px",width:"100%",maxWidth:"320px",marginBottom:"20px"}}>
          <button onClick={()=>addBattleCoin(true)}
            style={{flex:1,padding:"18px",background:"linear-gradient(135deg,#1d4ed8,#3b82f6)",color:"white",border:"none",borderRadius:"12px",fontSize:"20px",fontWeight:"bold",cursor:"pointer"}}>
            🌕 表
          </button>
          <button onClick={()=>addBattleCoin(false)}
            style={{flex:1,padding:"18px",background:"linear-gradient(135deg,#374151,#4b5563)",color:"#e5e7eb",border:"none",borderRadius:"12px",fontSize:"20px",fontWeight:"bold",cursor:"pointer"}}>
            🌑 裏
          </button>
        </div>
        <div style={{display:"flex",gap:"12px"}}>
          {currentLineCoins.length>0&&(
            <button onClick={()=>{const u=[...manualBattleCoins];u[coinCount]=currentLineCoins.slice(0,-1);setManualBattleCoins(u);}}
              style={{background:"none",border:"1px solid #374151",color:"#9ca3af",padding:"8px 16px",borderRadius:"8px",cursor:"pointer",fontSize:"13px"}}>
              ← 1枚戻す
            </button>
          )}
          {coinCount>0&&currentLineCoins.length===0&&(
            <button onClick={()=>{setLines(lines.slice(0,-1));setManualBattleCoins(manualBattleCoins.slice(0,-1));}}
              style={{background:"none",border:"1px solid #374151",color:"#9ca3af",padding:"8px 16px",borderRadius:"8px",cursor:"pointer",fontSize:"13px"}}>
              ← 前の爻に戻す
            </button>
          )}
        </div>
      </div>
    );
  }

  // ── 六爻占術: 自動投銭 ──
  if(step==='rokko_auto')return(
    <div style={{padding:"32px 20px",maxWidth:"560px",margin:"0 auto",textAlign:"center",fontFamily:"serif"}}>
      <div style={{fontSize:"18px",color:"#1d4ed8",marginBottom:"24px",letterSpacing:"2px"}}>六爻占術 — 氣を読む</div>
      <div style={{marginBottom:"24px"}}>
        {/* 上爻が上・初爻が下になるよう逆順表示（ただし入力中の爻は下に追加されていく） */}
        {lines.length<6&&(
          <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:"12px",padding:"16px",background:"#f8faff",borderRadius:"10px",border:"1px dashed #93c5fd",marginBottom:"8px"}}>
            <div style={{width:"16px",height:"16px",borderRadius:"50%",border:"3px solid #3b82f6",borderTopColor:"transparent",animation:"spin 0.8s linear infinite"}}/>
            <div style={{fontSize:"15px",color:"#1d4ed8"}}>第{lines.length+1}爻を投銭中...</div>
          </div>
        )}
        {[...lines].reverse().map((v,i)=><LineRow key={i} value={v} idx={lines.length-1-i}/>)}
      </div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  // ── 六爻占術: 卦表示 ──
  if(step==='hexagram'&&lines.length===6){
    const hex=buildHexFromLines(lines);
    return(
      <div style={{padding:"16px",maxWidth:"560px",margin:"0 auto"}}>
        <div style={{background:"linear-gradient(135deg,#0a0e1a,#1a1040)",borderRadius:"18px",padding:"24px",marginBottom:"16px",textAlign:"center",border:"1px solid #3b82f633"}}>
          <div style={{fontSize:"14px",color:"#93c5fd",letterSpacing:"2px",marginBottom:"12px"}}>六爻占術 — 卦の結果</div>
          <div style={{display:"flex",justifyContent:"center",gap:"40px",marginBottom:"16px"}}>
            <div>
              <div style={{fontSize:"12px",color:"#60a5fa",marginBottom:"6px"}}>本卦</div>
              <div style={{fontSize:"22px",fontWeight:"bold",color:"white",fontFamily:"serif"}}>{hex?.main?.name||'不明'}</div>
              <div style={{fontSize:"12px",color:"#9ca3af"}}>{hex?.main?.elem||''}</div>
            </div>
            {hex?.change&&<div>
              <div style={{fontSize:"12px",color:"#f87171",marginBottom:"6px"}}>変卦</div>
              <div style={{fontSize:"22px",fontWeight:"bold",color:"#fca5a5",fontFamily:"serif"}}>{hex.change.name}</div>
              <div style={{fontSize:"12px",color:"#9ca3af"}}>{hex.change.elem||''}</div>
            </div>}
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:"6px",maxWidth:"280px",margin:"0 auto"}}>
            {[...lines].reverse().map((v,i)=><LineRow key={i} value={v} idx={5-i}/>)}
          </div>
        </div>
        <button onClick={()=>battleMode==='soccer'?callAISoccer():callAIOther()}
          style={{width:"100%",padding:"16px",background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:"pointer",letterSpacing:"1px"}}>
          AI鑑定を開始する ✦
        </button>
      </div>
    );
  }

  // ── ローディング ──
  if(step==='loading')return(
    <div style={{minHeight:"60vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"serif",background:"#f8f9fa"}}>
      <div style={{fontSize:"64px",marginBottom:"20px",animation:"shikiFloat2 1.2s ease-in-out infinite alternate"}}>⚡</div>
      <div style={{fontSize:"18px",color:"#1d4ed8",marginBottom:"8px"}}>式神が鑑定中...</div>
      <div style={{fontSize:"14px",color:"#9ca3af"}}>九星気学×六爻占術で占断しています</div>
    </div>
  );

  // ── 結果表示 ──
  if(step==='result'&&result){
    const secs={};
    const parts=result.split(/【(.+?)】/);
    for(let i=1;i<parts.length;i+=2)secs[parts[i]]=(parts[i+1]||'').trim();
    const isSoccer=battleMode==='soccer';
    const titleA=isSoccer?teamAName:'対象者A';
    const titleB=isSoccer?teamBName:'対象者B';
    const verdict=secs['総合判定']||'';
    const isGood=verdict.includes('優勢')||verdict.includes('勝機あり');
    const isWarn=verdict.includes('要注意')||verdict.includes('互角');
    const isBad=verdict.includes('凶');
    const verdictColor=isGood?'#166534':isWarn?'#92400e':'#991b1b';
    const verdictBg=isGood?'linear-gradient(135deg,#f0fdf4,#dcfce7)':isWarn?'linear-gradient(135deg,#fffbeb,#fef3c7)':'linear-gradient(135deg,#fef2f2,#fee2e2)';
    return(
      <div style={{padding:"16px",maxWidth:"560px",margin:"0 auto"}}>
        {showShareBat&&<ShareModal type="shikigami" data={{emoji:'⚡',shikigamiName:'式神',message:(secs['古語']||result).slice(0,80),shareText:`【勝負鑑定】${isSoccer?`${teamAName} vs ${teamBName}`:battleType?.label}\n\n${(secs['古語']||'').slice(0,60)}\n\n${(secs['総合判定']||'').slice(0,80)}\n\n氣ごよみアプリで鑑定しました。\nhttps://kigaku-app.vercel.app`}} onClose={()=>setShowShareBat(false)}/>}

        {/* ヘッダー */}
        <div style={{background:"linear-gradient(135deg,#0a0e1a,#1a1040)",borderRadius:"18px",padding:"20px",marginBottom:"14px",textAlign:"center",border:"1px solid #3b82f633"}}>
          <div style={{fontSize:"36px",marginBottom:"6px"}}>⚡</div>
          {isSoccer?(
            <div style={{fontSize:"16px",fontWeight:"bold",color:"white",fontFamily:"serif"}}>
              <span style={{color:"#86efac"}}>{teamAName}</span>
              <span style={{color:"#9ca3af",margin:"0 8px"}}>vs</span>
              <span style={{color:"#fca5a5"}}>{teamBName}</span>
            </div>
          ):(
            <div style={{fontSize:"16px",fontWeight:"bold",color:"white",fontFamily:"serif"}}>{battleType?.label||'勝負鑑定'}</div>
          )}
          <div style={{fontSize:"12px",color:"#6b7280",marginTop:"4px"}}>{isSoccer?`${matchLeague} ${matchStage}`:''}</div>
        </div>

        {/* 古語 */}
        {secs['古語']&&(
          <div style={{background:"linear-gradient(135deg,#1a0a0e,#0a1a0a)",borderRadius:"14px",padding:"18px",marginBottom:"14px",border:"1px solid #b8860b33",textAlign:"center"}}>
            <div style={{fontSize:"11px",color:"#d4a017",letterSpacing:"3px",marginBottom:"8px"}}>式神より告げる</div>
            <div style={{fontSize:"16px",color:"#fef3c7",fontFamily:"serif",lineHeight:1.9,fontWeight:"bold"}}>{secs['古語']}</div>
          </div>
        )}

        {/* 総合判定 */}
        <div style={{background:verdictBg,borderRadius:"14px",padding:"18px",marginBottom:"14px",border:`2px solid ${verdictColor}44`}}>
          <div style={{fontSize:"13px",fontWeight:"bold",color:verdictColor,marginBottom:"8px"}}>⚔️ 総合判定</div>
          <div style={{fontSize:"15px",color:"#1f2937",lineHeight:1.8}}>{secs['総合判定']}</div>
          {isSoccer&&secs['得点予測']&&(
            <div style={{marginTop:"10px",padding:"8px 12px",background:"rgba(255,255,255,0.6)",borderRadius:"8px",fontSize:"14px",color:"#374151"}}>
              📊 {secs['得点予測']}
            </div>
          )}
        </div>

        {/* スコアバー */}
        {liuYaoScore&&(
          <div style={{background:"white",borderRadius:"14px",border:"1px solid #e5e7eb",padding:"16px",marginBottom:"14px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
            <div style={{fontSize:"13px",fontWeight:"bold",color:"#374151",marginBottom:"10px"}}>📊 六爻スコア</div>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:"13px",marginBottom:"6px"}}>
              <span style={{color:"#16a34a",fontWeight:"bold"}}>{titleA} {liuYaoScore.sideAScore}%</span>
              <span style={{color:"#dc2626",fontWeight:"bold"}}>{liuYaoScore.sideBScore}% {titleB}</span>
            </div>
            <div style={{height:"10px",background:"#f3f4f6",borderRadius:"5px",overflow:"hidden",display:"flex"}}>
              <div style={{width:`${liuYaoScore.sideAScore}%`,background:"linear-gradient(90deg,#22c55e,#16a34a)",transition:"width 0.5s"}}/>
              <div style={{width:`${liuYaoScore.sideBScore}%`,background:"linear-gradient(90deg,#ef4444,#dc2626)",transition:"width 0.5s"}}/>
            </div>
            <div style={{fontSize:"12px",color:"#6b7280",marginTop:"6px",textAlign:"center"}}>信頼度 {liuYaoScore.confidence}%</div>
            {liuYaoScore.scoreBand&&(
              <div style={{marginTop:"10px",padding:"8px 12px",borderRadius:"8px",background:"linear-gradient(135deg,#fef9c3,#fef08a)",border:"1px solid #fbbf24",display:"flex",alignItems:"center",gap:"8px"}}>
                <span style={{fontSize:"16px"}}>⚽</span>
                <div>
                  <div style={{fontSize:"13px",fontWeight:"bold",color:"#92400e"}}>予想スコア帯：{liuYaoScore.scoreBand}</div>
                  <div style={{fontSize:"11px",color:"#78350f",marginTop:"2px"}}>{liuYaoScore.scoreBandDetail}</div>
                </div>
              </div>
            )}
            {liuYaoScore.skillGapLabel&&liuYaoScore.skillGapLabel!=='互角・拮抗（実力補正なし）'&&(
              <div style={{marginTop:"8px",padding:"5px 10px",borderRadius:"6px",fontSize:"11px",background:"#f0f9ff",color:"#0369a1",border:"1px solid #bae6fd"}}>
                ⚖️ 実力補正：{liuYaoScore.skillGapLabel}
              </div>
            )}
          </div>
        )}

        {/* 六爻占術の判定（主軸） */}
        {(secs['六爻占術の判定']||secs['六爻占術の解釈'])&&(
          <div style={{background:"linear-gradient(135deg,#0d0a1a,#1a1040)",borderRadius:"14px",border:"1px solid #7c3aed44",padding:"16px",marginBottom:"14px"}}>
            <div style={{fontSize:"13px",fontWeight:"bold",color:"#c4b5fd",marginBottom:"8px"}}>🎯 六爻占術の判定（主軸）</div>
            <div style={{fontSize:"14px",color:"#e2e8f0",lineHeight:1.9,whiteSpace:"pre-wrap"}}>{secs['六爻占術の判定']||secs['六爻占術の解釈']}</div>
          </div>
        )}

        {/* スコア計算根拠（折りたたみ） */}
        {liuYaoScore&&liuYaoScore.reasoning&&liuYaoScore.reasoning.length>0&&(
          <ReasoningPanel reasoning={liuYaoScore.reasoning}/>
        )}

        {/* 九星気学の補強 */}
        {(secs['九星気学の補強']||secs['九星気学の判断'])&&(
          <div style={{background:"white",borderRadius:"14px",border:"1px solid #e5e7eb",padding:"16px",marginBottom:"14px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
            <div style={{fontSize:"13px",fontWeight:"bold",color:"#1d4ed8",marginBottom:"8px"}}>🌟 九星気学の補強（補助）</div>
            <div style={{fontSize:"14px",color:"#374151",lineHeight:1.8}}>{secs['九星気学の補強']||secs['九星気学の判断']}</div>
          </div>
        )}

        {/* 時盤・方位（旧形式との後方互換） */}
        {secs['時盤・方位の吉凶']&&(
          <div style={{background:"linear-gradient(135deg,#f0fdf4,#dcfce7)",borderRadius:"14px",padding:"16px",marginBottom:"14px",border:"1px solid #86efac"}}>
            <div style={{fontSize:"13px",fontWeight:"bold",color:"#15803d",marginBottom:"8px"}}>🧭 時盤・方位の吉凶</div>
            <div style={{fontSize:"14px",color:"#14532d",lineHeight:1.8}}>{secs['時盤・方位の吉凶']}</div>
          </div>
        )}

        {/* 試合展開予測 */}
        {secs['試合展開予測']&&(
          <div style={{background:"linear-gradient(135deg,#fffbeb,#fef3c7)",borderRadius:"14px",padding:"16px",marginBottom:"14px",border:"1px solid #fde68a"}}>
            <div style={{fontSize:"13px",fontWeight:"bold",color:"#92400e",marginBottom:"8px"}}>⚽ 試合展開予測</div>
            <div style={{fontSize:"14px",color:"#78350f",lineHeight:1.8}}>{secs['試合展開予測']}</div>
          </div>
        )}

        {/* 警告・注意点 */}
        {(secs['警告・注意点']||secs['警告'])&&(secs['警告・注意点']||secs['警告'])!=='なし'&&(
          <div style={{background:"#fef2f2",borderRadius:"14px",border:"2px solid #fca5a5",padding:"16px",marginBottom:"14px"}}>
            <div style={{fontSize:"13px",fontWeight:"bold",color:"#dc2626",marginBottom:"6px"}}>⚠️ 警告・注意点</div>
            <div style={{fontSize:"14px",color:"#991b1b",lineHeight:1.8}}>{secs['警告・注意点']||secs['警告']}</div>
          </div>
        )}

        {/* 行動指針 */}
        {secs['行動指針']&&(
          <div style={{background:"white",borderRadius:"14px",border:"1px solid #e5e7eb",padding:"16px",marginBottom:"14px",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
            <div style={{fontSize:"13px",fontWeight:"bold",color:"#374151",marginBottom:"8px"}}>📋 行動指針</div>
            <div style={{fontSize:"14px",color:"#374151",lineHeight:2,whiteSpace:"pre-wrap"}}>{secs['行動指針']}</div>
          </div>
        )}

        {/* 履歴保存通知 */}
        <div style={{display:"flex",alignItems:"center",gap:"6px",marginBottom:"12px",padding:"10px 14px",background:"#eff6ff",borderRadius:"10px",border:"1px solid #93c5fd"}}>
          <span style={{fontSize:"14px"}}>✅</span>
          <span style={{fontSize:"13px",color:"#1d4ed8",fontWeight:"bold"}}>この鑑定結果は履歴に保存されました</span>
          <button onClick={()=>window.dispatchEvent(new CustomEvent('navigate-tab',{detail:'history'}))} style={{marginLeft:"auto",padding:"4px 10px",background:"#1d4ed8",color:"white",border:"none",borderRadius:"6px",fontSize:"12px",cursor:"pointer"}}>履歴を見る</button>
        </div>

        {/* ボタン */}
        <div style={{display:"flex",gap:"10px",marginBottom:"24px"}}>
          <button onClick={()=>setShowShareBat(true)} style={{flex:1,padding:"14px",background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",border:"none",borderRadius:"12px",fontSize:"15px",fontWeight:"bold",cursor:"pointer"}}>📤 シェア</button>
          <button onClick={resetAll} style={{flex:1,padding:"14px",background:"#f3f4f6",color:"#374151",border:"none",borderRadius:"12px",fontSize:"15px",fontWeight:"bold",cursor:"pointer"}}>🔄 もう一度</button>
        </div>
      </div>
    );
  }

  return null;
}
function NearbyShrine({userLat,userLng}){
  const[shrines,setShrines]=React.useState([]);
  const[loading,setLoading]=React.useState(false);
  const[loaded,setLoaded]=React.useState(false);
  const[radius,setRadius]=React.useState(3000);

  async function fetchNearby(r){
    if(!userLat||!userLng)return;
    setLoading(true);
    const key=process.env.REACT_APP_GOOGLE_MAPS_KEY;
    try{
      const res=await fetch("/api/places?lat="+userLat+"&lng="+userLng+"&radius="+(r||radius)+"&key="+key);
      const data=await res.json();
      if(data.results){
        setShrines(data.results.slice(0,20));
        setLoaded(true);
      }
    }catch(e){
      console.error(e);
    }
    setLoading(false);
  }

  if(!userLat)return null;

  return(
    <div>
      <div style={{fontSize:"17px",fontWeight:"bold",color:"#374151",marginBottom:"4px"}}>⛩ 現在地周辺の神社</div>
      <div style={{fontSize:"12px",color:"#6b7280",marginBottom:"10px"}}>現在地を取得済み · 半径内の神社を地図表示します</div>
      <div style={{display:"flex",gap:"6px",marginBottom:"8px"}}>
        {[3000,5000,10000,20000].map(r=>(
          <button key={r} onClick={()=>{setRadius(r);fetchNearby(r);}} style={{flex:1,padding:"6px 4px",borderRadius:"8px",border:"1px solid",fontSize:"12px",cursor:"pointer",background:radius===r?"#eff6ff":"white",borderColor:radius===r?"#2563eb":"#e5e7eb",color:radius===r?"#2563eb":"#6b7280"}}>
            {r/1000+"km"}
          </button>
        ))}
      </div>
      {!loaded&&(
        <button onClick={()=>fetchNearby(radius)} style={{width:"100%",padding:"10px",background:"white",border:"1px solid #e5e7eb",borderRadius:"10px",fontSize:"14px",cursor:"pointer",color:"#374151"}}>
          {loading?"🔍 検索中...":"📍 現在地周辺の神社を検索する"}
        </button>
      )}
      {shrines.map((s,i)=>{
          // 方位計算（インライン）
          const shrLat=typeof s.geometry?.location?.lat==="function"?s.geometry.location.lat():s.geometry?.location?.lat||0;
          const shrLng=typeof s.geometry?.location?.lng==="function"?s.geometry.location.lng():s.geometry?.location?.lng||0;
          let dirLabel="";
          if(userLat&&userLng&&shrLat&&shrLng){
            const R=6371;
            const dLat=(shrLat-userLat)*Math.PI/180;
            const dLng=(shrLng-userLng)*Math.PI/180;
            const a=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(userLat*Math.PI/180)*Math.cos(shrLat*Math.PI/180)*Math.sin(dLng/2)*Math.sin(dLng/2);
            const dist=R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
            const dLng2=shrLng-userLng;
            const dLat2=shrLat-userLat;
            const angle=Math.atan2(dLng2,dLat2)*180/Math.PI;
            const dirs=["北","北東","東","南東","南","南西","西","北西","北"];
            const dir=dirs[Math.round(((angle+360)%360)/45)];
            dirLabel=`現在地から${dist.toFixed(1)}km・${dir}方向`;
          }
          return(
            <div key={i} onClick={()=>window.open("https://www.google.com/maps/place/?q=place_id:"+s.place_id,"_blank")} style={{background:"white",borderRadius:"10px",border:"1px solid #f3f4f6",padding:"10px 12px",marginBottom:"6px",cursor:"pointer",display:"flex",alignItems:"center",gap:"10px"}}>
              <span style={{fontSize:"20px"}}>⛩</span>
              <div style={{flex:1}}>
                <div style={{fontSize:"14px",fontWeight:"bold",color:"#1f2937"}}>{s.name}</div>
                <div style={{fontSize:"11px",color:"#9ca3af"}}>{s.vicinity}</div>
                {dirLabel&&<div style={{fontSize:"11px",color:"#16a34a"}}>📍 {dirLabel}</div>}
                {s.rating&&<div style={{fontSize:"11px",color:"#f59e0b"}}>★ {s.rating} ({s.user_ratings_total}件)</div>}
              </div>
              <span style={{fontSize:"12px",color:"#6b7280"}}>→</span>
            </div>
          );
      })}
    </div>
  );
}

function PowerSpotTab({profile,isPremium}){
  const[showShareSpot,setShowShareSpot]=React.useState(false);
  const[shareSpotData,setShareSpotData]=React.useState(null);
  const SPOTS=[
    {id:1,name:"伊勢神宮（内宮）",pref:"三重県",region:"東海",star:9,elem:"火",dir:"南",desc:"天照大御神を祀る日本最高峰の聖地。九紫火星の方に特に縁が深い。",tags:["縁結び","開運","仕事運"],lat:34.4554,lng:136.7267},
    {id:2,name:"出雲大社",pref:"島根県",region:"中国",star:1,elem:"水",dir:"北",desc:"縁結びの神・大国主命を祀る。一白水星の方の縁を結ぶパワーが強い。",tags:["縁結び","恋愛","人間関係"],lat:35.4017,lng:132.6853},
    {id:3,name:"富士山本宮浅間大社",pref:"静岡県",region:"東海",star:3,elem:"木",dir:"東",desc:"木花咲耶姫を祀る。三碧木星の突破力と行動力を高める聖地。",tags:["仕事運","健康","勝負"],lat:35.1264,lng:138.6365},
    {id:4,name:"春日大社",pref:"奈良県",region:"近畿",star:6,elem:"金",dir:"西北",desc:"武甕槌命を祀る。六白金星の権威・決断力を高める。",tags:["出世","権威","決断"],lat:34.6814,lng:135.8450},
    {id:5,name:"住吉大社",pref:"大阪府",region:"近畿",star:7,elem:"金",dir:"西",desc:"航海・商売の神を祀る。七赤金星の財運・口才を高める。",tags:["財運","商売","縁"],lat:34.6127,lng:135.4930},
    {id:6,name:"諏訪大社",pref:"長野県",region:"中部",star:8,elem:"土",dir:"東北",desc:"建御名方命を祀る。八白土星の転換・不動産運に縁が深い。",tags:["転換","不動産","健康"],lat:36.0157,lng:138.0706},
    {id:7,name:"熊野本宮大社",pref:"和歌山県",region:"近畿",star:2,elem:"土",dir:"西南",desc:"家都美御子神を祀る。二黒土星の忍耐・家庭運を高める聖地。",tags:["家庭","健康","縁"],lat:33.8397,lng:135.7811},
    {id:8,name:"鶴岡八幡宮",pref:"神奈川県",region:"関東",star:4,elem:"木",dir:"東南",desc:"応神天皇を祀る。四緑木星の縁・信頼運に特に縁が深い。",tags:["縁結び","信頼","出世"],lat:35.3258,lng:139.5560},
    {id:9,name:"日光東照宮",pref:"栃木県",region:"関東",star:5,elem:"土",dir:"中央",desc:"徳川家康を祀る。五黄土星の帝王運・変革力を高める最強の聖地。",tags:["権威","変革","勝負"],lat:36.7581,lng:139.5994},
    {id:10,name:"北野天満宮",pref:"京都府",region:"近畿",star:4,elem:"木",dir:"東南",desc:"学問の神・菅原道真を祀る。四緑木星の縁と知性を高める。",tags:["学業","合格","縁結び"],lat:35.0253,lng:135.7354},
    {id:11,name:"伏見稲荷大社",pref:"京都府",region:"近畿",star:7,elem:"金",dir:"西",desc:"全国に3万社ある稲荷神社の総本社。七赤金星の財運・商売繁盛に最強。",tags:["財運","商売","出世"],lat:34.9671,lng:135.7727},
    {id:12,name:"賀茂別雷神社（上賀茂神社）",pref:"京都府",region:"近畿",star:3,elem:"木",dir:"東",desc:"雷の神を祀る。三碧木星の行動力・突破力を最大に高める。",tags:["仕事運","勝負","健康"],lat:35.0591,lng:135.7522},
    {id:13,name:"厳島神社",pref:"広島県",region:"中国",star:4,elem:"木",dir:"東南",desc:"市杵島姫命を祀る。四緑木星の縁・芸術・美の守護神。",tags:["縁結び","芸術","財運"],lat:34.2960,lng:132.3194},
    {id:14,name:"金刀比羅宮",pref:"香川県",region:"四国",star:7,elem:"金",dir:"西",desc:"海の神・大物主神を祀る。七赤金星の財運と旅の安全に縁が深い。",tags:["財運","旅行","健康"],lat:34.2132,lng:133.8247},
    {id:15,name:"太宰府天満宮",pref:"福岡県",region:"九州",star:4,elem:"木",dir:"東南",desc:"菅原道真を祀る九州最大の天満宮。学業・縁結びに強い聖地。",tags:["学業","合格","縁結び"],lat:33.5214,lng:130.5342},
    {id:16,name:"宮地嶽神社",pref:"福岡県",region:"九州",star:9,elem:"火",dir:"南",desc:"全国に鎮座する宮地嶽神社の総本社。九紫火星の名誉・直感を高める。",tags:["開運","財運","勝負"],lat:33.7714,lng:130.4758},
    {id:17,name:"熱田神宮",pref:"愛知県",region:"東海",star:6,elem:"金",dir:"西北",desc:"草薙剣を祀る。六白金星の権威・決断・天運に縁が深い。",tags:["出世","勝負","決断"],lat:35.1279,lng:136.9078},
    {id:18,name:"三嶋大社",pref:"静岡県",region:"東海",star:8,elem:"土",dir:"東北",desc:"大山祇命を祀る。八白土星の転換・蓄積・不動産運に縁が深い。",tags:["転換","健康","財運"],lat:35.1167,lng:138.9167},
    {id:19,name:"明治神宮",pref:"東京都",region:"関東",star:6,elem:"金",dir:"西北",desc:"明治天皇を祀る。六白金星の権威・父性・リーダーシップを高める。",tags:["出世","権威","縁結び"],lat:35.6763,lng:139.6993},
    {id:20,name:"浅草神社",pref:"東京都",region:"関東",star:7,elem:"金",dir:"西",desc:"三社様として親しまれる。七赤金星の喜び・財運・縁に強い。",tags:["財運","縁結び","開運"],lat:35.7148,lng:139.7967},
    {id:21,name:"鹿島神宮",pref:"茨城県",region:"関東",star:3,elem:"木",dir:"東",desc:"武甕槌命を祀る関東最強の勝負神社。三碧木星の突破力を高める。",tags:["勝負","仕事運","健康"],lat:35.9673,lng:140.6347},
    {id:22,name:"香取神宮",pref:"千葉県",region:"関東",star:6,elem:"金",dir:"西北",desc:"経津主命を祀る。六白金星の権威・決断・天運の守護神。",tags:["勝負","出世","決断"],lat:35.8983,lng:140.5317},
    {id:23,name:"白山比咩神社",pref:"石川県",region:"北陸",star:1,elem:"水",dir:"北",desc:"菊理媛神を祀る白山信仰の総本宮。一白水星の知恵・縁・浄化に強い。",tags:["縁結び","健康","浄化"],lat:36.5122,lng:136.7722},
    {id:24,name:"気多大社",pref:"石川県",region:"北陸",star:4,elem:"木",dir:"東南",desc:"大己貴命を祀る。四緑木星の縁結び・信頼・遠方の縁に強い。",tags:["縁結び","恋愛","人間関係"],lat:36.7833,lng:136.8167},
    {id:25,name:"諏訪大社（下社秋宮）",pref:"長野県",region:"中部",star:8,elem:"土",dir:"東北",desc:"建御名方命を祀る。八白土星の転換・蓄積・不動産運に縁が深い。",tags:["転換","健康","財運"],lat:36.1583,lng:137.9917},
    {id:26,name:"霧島神宮",pref:"鹿児島県",region:"九州",star:3,elem:"木",dir:"東",desc:"ニニギノミコトを祀る。三碧木星の新規スタート・突破力を高める。",tags:["仕事運","開運","勝負"],lat:31.9000,lng:130.8667},
    {id:27,name:"宇佐神宮",pref:"大分県",region:"九州",star:6,elem:"金",dir:"西北",desc:"八幡神を祀る全国4万社の八幡宮総本社。六白金星の権威・天運に最強。",tags:["出世","権威","勝負"],lat:33.5333,lng:131.3833},
    {id:28,name:"愛宕神社（京都）",pref:"京都府",region:"近畿",star:9,elem:"火",dir:"南",desc:"火之迦具土神を祀る。九紫火星の直感・名誉・美の守護神。",tags:["開運","勝負","名誉"],lat:35.0667,lng:135.6333},
    {id:29,name:"貴船神社",pref:"京都府",region:"近畿",star:1,elem:"水",dir:"北",desc:"水の神・高龗神を祀る。一白水星の縁・知恵・流動の気を高める。",tags:["縁結び","恋愛","浄化"],lat:35.1167,lng:135.7583},
    {id:30,name:"大神神社",pref:"奈良県",region:"近畿",star:5,elem:"土",dir:"中央",desc:"三輪山を御神体とする日本最古の神社。五黄土星の変革・大局運に強い。",tags:["開運","健康","変革"],lat:34.5267,lng:135.8533},
  ];
  const[filter,setFilter]=React.useState("すべて");
  const[search,setSearch]=React.useState("");
  const[selected,setSelected]=React.useState(null);
  const[userLat,setUserLat]=React.useState(null);
  const[userLng,setUserLng]=React.useState(null);
  const[regionFilter,setRegionFilter]=React.useState("すべて");
  const[sortBy,setSortBy]=React.useState("default");

  React.useEffect(()=>{
    // 位置：端末の現在地 → プロフィールの地域
    let alive=true;
    resolveUserLocation(profile?.location).then(l=>{
      if(alive&&l){setUserLat(l.lat);setUserLng(l.lng);}
    });
    return()=>{alive=false;};
  },[profile?.location]);

  function calcDist(lat1,lng1,lat2,lng2){
    const R=6371;
    const dLat=(lat2-lat1)*Math.PI/180;
    const dLng=(lng2-lng1)*Math.PI/180;
    const a=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLng/2)*Math.sin(dLng/2);
    return Math.round(R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a)));
  }

  function calcDir(lat1,lng1,lat2,lng2){
    const dLng=(lng2-lng1)*Math.PI/180;
    const y=Math.sin(dLng)*Math.cos(lat2*Math.PI/180);
    const x=Math.cos(lat1*Math.PI/180)*Math.sin(lat2*Math.PI/180)-Math.sin(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.cos(dLng);
    const deg=(Math.atan2(y,x)*180/Math.PI+360)%360;
    const dirs=["北","北東","東","南東","南","南西","西","北西"];
    return dirs[Math.round(deg/45)%8];
  }
  const FILTERS=["すべて","縁結び","仕事運","財運","健康","勝負","転換"];
  const STAR_NAMES=["","一白水星","二黒土星","三碧木星","四緑木星","五黄土星","六白金星","七赤金星","八白土星","九紫火星"];
  const STAR_COLORS=["","#1d4ed8","#78350f","#15803d","#16a34a","#92400e","#374151","#b91c1c","#44403c","#dc2626"];
  const myHonmei=profile?profile.honmeiStar:null;
  const REGIONS=["すべて","関東","近畿","東海","中部","中国","九州","北陸","四国"];
  const spotsWithDist=SPOTS.map(s=>{
    const dist=userLat?calcDist(userLat,userLng,s.lat,s.lng):null;
    const fromDir=userLat?calcDir(userLat,userLng,s.lat,s.lng):null;
    return {...s,dist,fromDir};
  });
  const filtered=spotsWithDist.filter(s=>{
    const matchFilter=filter==="すべて"||s.tags.includes(filter);
    const matchRegion=regionFilter==="すべて"||s.region===regionFilter;
    const matchSearch=search===""||s.name.includes(search)||s.pref.includes(search)||s.tags.some(t=>t.includes(search));
    return matchFilter&&matchRegion&&matchSearch;
  }).sort((a,b)=>{
    // 吉方位（本命星と一致）を最優先
    const aIsLucky=myHonmei&&a.star===myHonmei?0:1;
    const bIsLucky=myHonmei&&b.star===myHonmei?0:1;
    if(aIsLucky!==bIsLucky)return aIsLucky-bIsLucky;
    if(sortBy==="distance"&&a.dist&&b.dist)return a.dist-b.dist;
    return 0;
  });
  if(selected){
    const s=selected;
    const isMyHonmei=myHonmei===s.star;
    const mapUrl="https://www.google.com/maps/search/?api=1&query="+s.lat+","+s.lng;
    return(
      <div style={{padding:"14px",animation:"fadeIn 0.3s"}}>
        <button onClick={()=>setSelected(null)} style={{background:"none",border:"none",cursor:"pointer",fontSize:"14px",color:"#6b7280",marginBottom:"12px"}}>← 戻る</button>
        <div style={{background:"white",borderRadius:"14px",border:"1px solid #f3f4f6",overflow:"hidden",marginBottom:"12px"}}>
          <div style={{padding:"16px",background:"linear-gradient(135deg,"+STAR_COLORS[s.star]+"22,transparent)"}}>
            <div style={{fontSize:"11px",color:STAR_COLORS[s.star],letterSpacing:"2px",marginBottom:"4px"}}>{s.pref}</div>
            <div style={{fontSize:"20px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937",marginBottom:"8px"}}>⛩ {s.name}</div>
            {isMyHonmei&&<div style={{display:"inline-block",padding:"4px 10px",background:"#fffbeb",border:"1px solid #fde68a",borderRadius:"20px",fontSize:"12px",color:"#92400e",marginBottom:"8px"}}>✨ あなたの本命星と縁が深い聖地</div>}
            <div style={{display:"flex",gap:"6px",flexWrap:"wrap",marginBottom:"10px"}}>
              {s.tags.map(t=><span key={t} style={{padding:"3px 10px",background:"#f3f4f6",borderRadius:"20px",fontSize:"12px",color:"#6b7280"}}>{t}</span>)}
            </div>
            <div style={{fontSize:"14px",color:"#374151",lineHeight:1.8}}>{s.desc}</div>
          </div>
          <div style={{padding:"12px 16px",borderTop:"1px solid #f3f4f6",display:"flex",gap:"8px"}}>
            <div style={{flex:1,textAlign:"center",padding:"10px",background:"#f9fafb",borderRadius:"8px"}}>
              <div style={{fontSize:"11px",color:"#9ca3af"}}>縁の深い星</div>
              <div style={{fontSize:"13px",fontWeight:"bold",color:STAR_COLORS[s.star]}}>{STAR_NAMES[s.star]}</div>
            </div>
            <div style={{flex:1,textAlign:"center",padding:"10px",background:"#f9fafb",borderRadius:"8px"}}>
              <div style={{fontSize:"11px",color:"#9ca3af"}}>吉方位</div>
              <div style={{fontSize:"14px",fontWeight:"bold",color:"#374151"}}>{s.dir}</div>
            </div>
            <div style={{flex:1,textAlign:"center",padding:"10px",background:"#f9fafb",borderRadius:"8px"}}>
              <div style={{fontSize:"11px",color:"#9ca3af"}}>五行</div>
              <div style={{fontSize:"14px",fontWeight:"bold",color:"#374151"}}>{s.elem}の気</div>
            </div>
          </div>
        </div>
        <a href={mapUrl} target="_blank" rel="noopener noreferrer" style={{display:"block",padding:"14px",background:"linear-gradient(135deg,#1d4ed8,#2563eb)",color:"white",borderRadius:"12px",textAlign:"center",textDecoration:"none",fontSize:"15px",fontWeight:"bold",marginBottom:"8px"}}>🗺️ この神社をGoogleマップで開く</a>
        <button onClick={()=>{
          const url=userLat?"https://www.google.com/maps/search/神社/@"+userLat+","+userLng+",14z":"https://www.google.com/maps/search/神社/@"+s.lat+","+s.lng+",14z";
          window.open(url,"_blank");
        }} style={{width:"100%",padding:"12px",background:"linear-gradient(135deg,#16a34a,#15803d)",color:"white",border:"none",borderRadius:"12px",textAlign:"center",fontSize:"14px",fontWeight:"bold",cursor:"pointer"}}>🗺️ 周辺の神社をまとめて見る</button>

        {showShareSpot&&shareSpotData&&<ShareModal type="honmei" data={shareSpotData} onClose={()=>{setShowShareSpot(false);setShareSpotData(null);}}/>}
        <button onClick={()=>{setShareSpotData({starInfo:STAR_INFO[s.star],starFullName:s.name,message:(s.desc||"").slice(0,70),shareText:"【開運聖地】\n⛩ "+s.name+"（"+s.pref+"）\n\n"+STAR_INFO[s.star]?.k+"との縁が深い聖地です。\n方位: "+s.dir+"\n\n"+(s.desc||"").slice(0,120)+"\n\n吉方位の神社参拝で気を取り込みましょう。\n氣ごよみアプリで確認。\nhttps://kigaku-app.vercel.app"});setShowShareSpot(true);}} style={{display:"block",width:"100%",padding:"12px",marginTop:"8px",background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",border:"none",borderRadius:"12px",textAlign:"center",fontSize:"14px",fontWeight:"bold",cursor:"pointer",boxShadow:"0 4px 14px rgba(124,58,237,0.3)"}}>📤 この神社をシェア</button>
      </div>
    );
  }
  return(
    <div style={{padding:"14px",animation:"fadeIn 0.3s"}}>
      <div style={{fontSize:"11px",letterSpacing:"2px",color:"#6b7280",marginBottom:"12px",borderBottom:"1px solid #f3f4f6",paddingBottom:"4px"}}>POWER SPOT · 開運聖地</div>

      {/* 吉方位・凶方位 */}
      {(()=>{
        const today=new Date();
        const mo=today.getMonth()+1,dy=today.getDate();
        const km=getKiMonthIdx(mo,dy);
        const kiYear=(km===11||(mo===1&&dy<6))?today.getFullYear()-1:today.getFullYear();
        const yrC=getYearStar(kiYear),moC=getMonthStar(yrC,km),dayC=getDayStar(today);
        const yrS=getStarsFor(yrC),moS=getStarsFor(moC),dayS=getStarsFor(dayC);
        const hs=profile?profile.honmeiStar:null;
        const DIRS=["東南","南","西南","東","中","西","東北","北","西北"];
        const STAR_NAMES=["","一白","二黒","三碧","四緑","五黄","六白","七赤","八白","九紫"];
        const STAR_COLORS=["","#1d4ed8","#78350f","#15803d","#16a34a","#92400e","#374151","#b91c1c","#44403c","#dc2626"];

        // 吉方位計算
        const lucky=[];
        const bad=[];
        dayS.forEach((s,i)=>{
          if(i===4)return;
          if(s===5){bad.push({dir:DIRS[i],type:"五黄殺",level:"大凶"});}
          const opp=[2,1,0,5,4,3,8,7,6][i];
          if(dayS[opp]===5&&i!==4){bad.push({dir:DIRS[i],type:"暗剣殺",level:"大凶"});}
          if(hs&&s===hs){lucky.push({dir:DIRS[i],type:"本命星",level:"吉"});}
        });

        return(
          <div style={{marginBottom:"16px"}}>
            <div style={{fontSize:"18px",fontWeight:"bold",color:"#374151",marginBottom:"12px"}}>🧭 今日の吉方位・凶方位</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"12px"}}>
              <div style={{background:"#f0fdf4",borderRadius:"10px",border:"1px solid #86efac",padding:"10px"}}>
                <div style={{fontSize:"15px",color:"#16a34a",fontWeight:"bold",marginBottom:"8px"}}>✅ 吉方位</div>
                {lucky.length>0?lucky.map((l,i)=>(
                  <div key={i} style={{fontSize:"16px",color:"#15803d",marginBottom:"4px",fontWeight:"bold"}}>・{l.dir}（{l.type}）</div>
                )):<div style={{fontSize:"12px",color:"#6b7280"}}>今日は特定の吉方位なし</div>}
              </div>
              <div style={{background:"#fef2f2",borderRadius:"10px",border:"1px solid #fca5a5",padding:"10px"}}>
                <div style={{fontSize:"15px",color:"#dc2626",fontWeight:"bold",marginBottom:"8px"}}>⚠️ 凶方位</div>
                {bad.length>0?bad.map((b,i)=>(
                  <div key={i} style={{fontSize:"16px",color:"#dc2626",marginBottom:"4px",fontWeight:"bold"}}>・{b.dir}（{b.type}）</div>
                )):<div style={{fontSize:"12px",color:"#6b7280"}}>今日は特定の凶方位なし</div>}
              </div>
            </div>
            {profile&&(()=>{
              const _fd=["東南","南","西南","東","中","西","東北","北","西北"];
              const _RL={"相生受":"◎生気","比和":"○比和","相生生":"△退気","相剋受":"▼殺気","相剋攻":"▽退鬼"};
              return(
                <div style={{background:"white",borderRadius:"12px",border:"1px solid #e5e7eb",padding:"12px",marginBottom:"14px"}}>
                  <div style={{fontSize:"13px",fontWeight:"bold",color:"#374151",marginBottom:"8px"}}>🧭 今日の方位詳細（日盤・五行判定）</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:"3px"}}>
                    {dayS.map((s,i)=>{
                      const isC=i===4;
                      const hR=isC?"中立":getStarRel(profile.honmeiStar,dayS[i]);
                      const tR=isC?null:(profile.tsukimeiStar?getStarRel(profile.tsukimeiStar,dayS[i]):null);
                      const good=!isC&&["相生受","比和","相生生"].includes(hR);
                      const dbl=good&&tR&&["相生受","比和"].includes(tR);
                      const bad2=!isC&&["相剋受","相剋攻"].includes(hR);
                      return(
                        <div key={i} style={{padding:"5px 3px",background:isC?"#fef9c3":dbl?"#fffbeb":good?"#f0fdf4":bad2?"#fef2f2":"#fafafa",borderRadius:"6px",border:`1px solid ${isC?"#fcd34d":dbl?"#f59e0b":good?"#86efac":bad2?"#fca5a5":"#f3f4f6"}`,textAlign:"center"}}>
                          <div style={{fontSize:"10px",color:isC?"#92400e":"#6b7280",marginBottom:"1px",fontWeight:isC?"bold":"normal"}}>{isC?"中宮":_fd[i]}</div>
                          <div style={{fontSize:"9px",color:isC?"#b45309":dbl?"#b45309":good?"#16a34a":bad2?"#ef4444":"#9ca3af",fontWeight:"bold"}}>{isC?"基点（中）":_RL[hR]||hR}</div>
                          {!isC&&tR&&<div style={{fontSize:"8px",color:["相生受","比和"].includes(tR)?"#16a34a":"#d1d5db"}}>月:{_RL[tR]||tR}</div>}
                          {dbl&&<div style={{fontSize:"8px",color:"#b45309",fontWeight:"bold"}}>⭐二重</div>}
                        </div>
                      );
                    })}
                  </div>
                  <div style={{fontSize:"10px",color:"#9ca3af",marginTop:"6px",textAlign:"center"}}>今日の星との五行関係。月命星も併記（プロフィール登録済）</div>
                </div>
              );
            })()}
            {userLat&&lucky.length>0&&(
              <div style={{marginBottom:"14px"}}>
                <div style={{fontSize:"15px",fontWeight:"bold",color:"#374151",marginBottom:"8px"}}>🗺️ 吉方位マップ</div>
                <div style={{background:"#f0fdf4",borderRadius:"12px",border:"1px solid #86efac",padding:"14px"}}>
                  <div style={{fontSize:"13px",color:"#15803d",marginBottom:"10px"}}>現在地から吉方位の方向にある神社・スポットをGoogleマップで確認できます</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:"8px"}}>
                    {lucky.map((l,idx)=>{
                      const bearingMap={"北":0,"東北":45,"東":90,"東南":135,"南":180,"西南":225,"西":270,"西北":315};
                      const bearing=(bearingMap[l.dir]||0)*Math.PI/180;
                      const R=6371,d=15/R;
                      const lat1=userLat*Math.PI/180,lng1=userLng*Math.PI/180;
                      const lat2=Math.asin(Math.sin(lat1)*Math.cos(d)+Math.cos(lat1)*Math.sin(d)*Math.cos(bearing));
                      const lng2=lng1+Math.atan2(Math.sin(bearing)*Math.sin(d)*Math.cos(lat1),Math.cos(d)-Math.sin(lat1)*Math.sin(lat2));
                      const dLat=(lat2*180/Math.PI).toFixed(6),dLng=(lng2*180/Math.PI).toFixed(6);
                      const url="https://www.google.com/maps/search/神社/@"+dLat+","+dLng+",12z";
                      return(
                        <button key={idx} onClick={()=>window.open(url,"_blank")} style={{padding:"10px 16px",background:"linear-gradient(135deg,#16a34a,#15803d)",color:"white",border:"none",borderRadius:"20px",fontSize:"14px",fontWeight:"bold",cursor:"pointer",boxShadow:"0 2px 8px rgba(22,163,74,0.3)"}}>
                          {l.dir}方向 →
                        </button>
                      );
                    })}
                  </div>
                  <div style={{fontSize:"11px",color:"#6b7280",marginTop:"8px"}}>※ 現在地から約15km先の吉方位エリアを表示します</div>
                </div>
              </div>
            )}
            <div style={{fontSize:"13px",color:"#92400e",fontWeight:"bold",textAlign:"center",marginBottom:"12px",lineHeight:1.8}}>⭐ 吉方位の神社・聖地を参拝することで、気を取り込めます（方位はあなたの住んでいる場所基準）
✨ 距離が短ければ方位の気の影響は小さく、距離が長いほど強く受け取ります。</div>
            <div style={{height:"1px",background:"linear-gradient(90deg,transparent,#C9A84C44,transparent)",marginBottom:"12px"}}/>
          </div>
        );
      })()}

      <NearbyShrine userLat={userLat} userLng={userLng}/>

      {myHonmei&&(
        <div style={{marginBottom:"16px"}}>
          <div style={{background:"linear-gradient(135deg,#d97706,#92400e)",borderRadius:"14px",padding:"14px 16px",marginBottom:"10px"}}>
            <div style={{fontSize:"12px",color:"#fde68a",letterSpacing:"2px",marginBottom:"2px"}}>⭐ 吉方位の聖地</div>
            <div style={{fontSize:"17px",fontWeight:"bold",fontFamily:"serif",color:"white",marginBottom:"4px"}}>参拝お勧め聖地</div>
            <div style={{fontSize:"12px",color:"#fef3c7"}}>あなたの住まいから見た吉方位の聖地が近い方から順番に表示されます</div>
          </div>
          {spotsWithDist.filter(s=>s.star===myHonmei).sort((a,b)=>{if(a.dist&&b.dist)return a.dist-b.dist;if(a.dist)return -1;if(b.dist)return 1;return 0;}).slice(0,5).map(s=>(
            <div key={s.id} onClick={()=>setSelected(s)} style={{background:"linear-gradient(135deg,#fffbeb,white)",borderRadius:"12px",border:"2px solid #fde68a",padding:"12px 14px",marginBottom:"8px",cursor:"pointer",display:"flex",alignItems:"center",gap:"10px"}}>
              <span style={{fontSize:"28px"}}>⭐</span>
              <div style={{flex:1}}>
                <div style={{fontSize:"11px",color:"#92400e",marginBottom:"2px"}}>{s.pref}{s.dist?"　📍 "+s.dist.toFixed(1)+"km":"　"}</div>
                <div style={{fontSize:"15px",fontWeight:"bold",fontFamily:"serif",color:"#78350f"}}>⛩ {s.name}</div>
                <div style={{fontSize:"12px",color:"#92400e",marginTop:"2px"}}>{s.desc.substring(0,40)}...</div>
              </div>
              <span style={{fontSize:"12px",color:"#d97706"}}>→</span>
            </div>
          ))}
          <div style={{height:"1px",background:"linear-gradient(90deg,transparent,#C9A84C44,transparent)",margin:"14px 0"}}/>
        </div>
      )}
      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="神社名・都道府県・ご利益で検索" style={{width:"100%",padding:"10px 12px",borderRadius:"10px",border:"1px solid #e5e7eb",fontSize:"14px",marginBottom:"10px",boxSizing:"border-box"}}/>
      <div style={{display:"flex",gap:"6px",marginBottom:"8px"}}>
        <button onClick={()=>setSortBy(sortBy==="distance"?"default":"distance")} style={{padding:"6px 12px",borderRadius:"20px",border:"1px solid",fontSize:"12px",cursor:"pointer",background:sortBy==="distance"?"#eff6ff":"white",borderColor:sortBy==="distance"?"#2563eb":"#e5e7eb",color:sortBy==="distance"?"#2563eb":"#6b7280"}}>{userLat?"📍 近い順":"📍 現在地取得中..."}</button>
      </div>
      <div style={{display:"flex",gap:"4px",flexWrap:"wrap",marginBottom:"8px"}}>
        {["すべて","関東","近畿","東海","中部","中国","九州","北陸","四国"].map(r=>(<button key={r} onClick={()=>setRegionFilter(r)} style={{padding:"4px 10px",borderRadius:"20px",border:"1px solid",fontSize:"11px",cursor:"pointer",background:regionFilter===r?"#f0fdf4":"white",borderColor:regionFilter===r?"#16a34a":"#e5e7eb",color:regionFilter===r?"#16a34a":"#6b7280"}}>{r}</button>))}
      </div>
      <div style={{display:"flex",gap:"6px",flexWrap:"wrap",marginBottom:"14px"}}>
        {FILTERS.map(f=>(<button key={f} onClick={()=>setFilter(f)} style={{padding:"6px 12px",borderRadius:"20px",border:"1px solid",fontSize:"12px",cursor:"pointer",background:filter===f?"#fffbeb":"white",borderColor:filter===f?"#f59e0b":"#e5e7eb",color:filter===f?"#92400e":"#6b7280"}}>{f}</button>))}
      </div>
      {filtered.map(s=>{
        const isMyHonmei=myHonmei===s.star;
        return(<div key={s.id} onClick={()=>setSelected(s)} style={{background:"white",borderRadius:"12px",border:"1px solid "+(isMyHonmei?"#fde68a":"#f3f4f6"),padding:"14px",marginBottom:"10px",cursor:"pointer",position:"relative"}}>
          {isMyHonmei&&<div style={{position:"absolute",top:"10px",right:"10px",fontSize:"16px"}}>⭐</div>}
          <div style={{fontSize:"11px",color:"#9ca3af",marginBottom:"2px"}}>{s.pref}</div>
          <div style={{fontSize:"16px",fontWeight:"bold",fontFamily:"serif",color:"#1f2937",marginBottom:"6px"}}>⛩ {s.name}</div>
          <div style={{display:"flex",gap:"4px",flexWrap:"wrap",marginBottom:"6px"}}>
            {s.tags.map(t=><span key={t} style={{padding:"2px 8px",background:"#f3f4f6",borderRadius:"20px",fontSize:"11px",color:"#6b7280"}}>{t}</span>)}
          </div>
          <div style={{fontSize:"12px",color:STAR_COLORS[s.star]}}>{STAR_NAMES[s.star]}との縁 · {s.dir}方位</div>
          {s.dist&&<div style={{fontSize:"12px",color:"#6b7280",marginTop:"4px"}}>📍 現在地から約{s.dist}km · {s.fromDir}方向</div>}
        </div>);
      })}
    </div>
  );
}

function CommunityTab(){
  const [posts,setPosts]=React.useState([
    {id:1,name:"二黒土星・大阪",text:"吉方位の東南に旅行したら、素晴らしい出会いがありました！気学って本当にすごい。",cat:"成功例",likes:12,time:"2時間前"},
    {id:2,name:"七赤金星・東京",text:"今月は南宮で財運が良いと出ていたので、思い切って投資しました。結果は…プラスでした！",cat:"成功例",likes:8,time:"5時間前"},
    {id:3,name:"三碧木星・名古屋",text:"凶方位とわかっていたのに北西に引越ししてしまい、その後トラブル続き。気学は大事ですね。",cat:"失敗例",likes:15,time:"昨日"},
  ]);
  const [newPost,setNewPost]=React.useState("");
  const [newName,setNewName]=React.useState("");
  const [newCat,setNewCat]=React.useState("運勢");
  const [noteArticles]=React.useState([
    {title:"二黒土星の2026年を読む",url:"https://note.com/gen_tamaki",date:"2026/03/20"},
    {title:"吉方位旅行のすすめ",url:"https://note.com/gen_tamaki",date:"2026/03/15"},
    {title:"九星気学で春の開運法",url:"https://note.com/gen_tamaki",date:"2026/03/10"},
  ]);
  const cats=["運勢","方位","相性","成功例","失敗例","開運情報"];
  const addPost=()=>{
    if(!newPost.trim())return;
    setPosts(p=>[{id:Date.now(),name:newName||"匿名",text:newPost,cat:newCat,likes:0,time:"たった今"},...p]);
    setNewPost("");setNewName("");
  };
  return(
    <div style={{padding:"14px",animation:"fadeIn 0.3s"}}>
      <div style={{fontSize:"11px",letterSpacing:"2px",color:"#6b7280",marginBottom:"12px",borderBottom:"1px solid #f3f4f6",paddingBottom:"4px"}}>COMMUNITY · 気学広場</div>

      {/* 環弦ブログ */}
      <div style={{marginBottom:"20px"}}>
        <div style={{fontSize:"14px",fontWeight:"bold",fontFamily:"serif",color:"#78350f",marginBottom:"10px",display:"flex",alignItems:"center",gap:"6px"}}>📖 環弦ブログ</div>
        {noteArticles.map((a,i)=>(
          <a key={i} href={a.url} target="_blank" rel="noopener noreferrer" style={{display:"block",padding:"10px 12px",background:"white",borderRadius:"10px",border:"1px solid #f3f4f6",marginBottom:"8px",textDecoration:"none",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
            <div style={{fontSize:"14px",color:"#78350f",fontWeight:"bold",marginBottom:"2px"}}>{a.title}</div>
            <div style={{fontSize:"11px",color:"#9ca3af"}}>{a.date} · note.com</div>
          </a>
        ))}
      </div>

      {/* ユーザーボード */}
      <div>
        <div style={{fontSize:"14px",fontWeight:"bold",fontFamily:"serif",color:"#78350f",marginBottom:"10px",display:"flex",alignItems:"center",gap:"6px"}}>🌸 ユーザーボード</div>

        {/* 投稿フォーム */}
        <div style={{background:"white",borderRadius:"12px",border:"1px solid #f3f4f6",padding:"12px",marginBottom:"14px",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
          <div style={{fontSize:"12px",color:"#6b7280",marginBottom:"8px"}}>✏️ 気学体験を投稿する</div>
          <input value={newName} onChange={e=>setNewName(e.target.value)} placeholder="お名前（任意）" style={{width:"100%",padding:"8px 10px",borderRadius:"8px",border:"1px solid #e5e7eb",fontSize:"14px",marginBottom:"8px",boxSizing:"border-box"}}/>
          <div style={{display:"flex",gap:"6px",flexWrap:"wrap",marginBottom:"8px"}}>
            {cats.map(cat=>(
              <button key={cat} onClick={()=>setNewCat(cat)} style={{padding:"4px 10px",borderRadius:"20px",border:"1px solid",fontSize:"12px",cursor:"pointer",background:newCat===cat?"#fffbeb":"white",borderColor:newCat===cat?"#f59e0b":"#e5e7eb",color:newCat===cat?"#92400e":"#6b7280"}}>{cat}</button>
            ))}
          </div>
          <textarea value={newPost} onChange={e=>setNewPost(e.target.value)} placeholder="気学の体験・気づき・開運情報をシェアしてください" style={{width:"100%",padding:"8px 10px",borderRadius:"8px",border:"1px solid #e5e7eb",fontSize:"14px",minHeight:"80px",resize:"none",boxSizing:"border-box",marginBottom:"8px"}}/>
          <button onClick={addPost} style={{background:"linear-gradient(135deg,#d97706,#92400e)",color:"white",border:"none",borderRadius:"8px",padding:"8px 16px",fontSize:"14px",cursor:"pointer",width:"100%"}}>投稿する</button>
        </div>

        {/* 投稿一覧 */}
        {posts.map(p=>(
          <div key={p.id} style={{background:"white",borderRadius:"12px",border:"1px solid #f3f4f6",padding:"12px",marginBottom:"10px",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:"6px"}}>
              <div style={{display:"flex",alignItems:"center",gap:"6px"}}>
                <span style={{fontSize:"12px",fontWeight:"bold",color:"#374151"}}>{p.name}</span>
                <span style={{fontSize:"11px",padding:"2px 8px",borderRadius:"20px",background:"#fffbeb",color:"#92400e",border:"1px solid #fde68a"}}>{p.cat}</span>
              </div>
              <span style={{fontSize:"11px",color:"#9ca3af"}}>{p.time}</span>
            </div>
            <div style={{fontSize:"14px",color:"#374151",lineHeight:1.7,marginBottom:"8px"}}>{p.text}</div>
            <button onClick={()=>setPosts(ps=>ps.map(pp=>pp.id===p.id?{...pp,likes:pp.likes+1}:pp))} style={{background:"none",border:"1px solid #e5e7eb",borderRadius:"20px",padding:"4px 12px",fontSize:"12px",cursor:"pointer",color:"#6b7280"}}>❤️ {p.likes}</button>
          </div>
        ))}
      </div>
    </div>
  );
}

function OracleTab({profile,isPremium,isPremiumPlus,onUnlock}){
  const[kw,setKw]=useState("");const[result,setResult]=useState(null);const[showShareOracle,setShowShareOracle]=useState(false);const[openCat,setOpenCat]=useState(null);
  const today=new Date();
  const km=getKiMonthIdx(today.getMonth()+1,today.getDate());
  const dayC=getDayStar(today);const dayS=getStarsFor(dayC);
  const myE=profile?S_ELEM[profile.honmeiStar]:"土";

  function divine(word){
    const w=(word||kw).trim();if(!w)return;
    const{elem:kwE,icon,rich}=findThingElem(w);
    const rel=getElemRel(myE,kwE);const ri=COMPAT_REL[rel];
    const kwStar=ELEM_STAR[kwE]||4;const kwPalace=dayS.indexOf(kwStar);
    const pf=PAL_FORTUNE[kwPalace]??PAL_FORTUNE[4];
    const timing={相生受:"今がまさに動き時！最高の追い風が吹いています。迷わず取り組み始めてください。",相生生:"あなたが積極的に取り組むほど縁が深まります。主体的な行動が開運につながります。",比和:"良くも悪くも結果が拡大しやすい時期。丁寧に取り組めば大きな成果が期待できます。",相剋受:"慎重に進めることが吉。準備と計画をしっかり整えてから取り組んでください。",相剋攻:"今は力を蓄える時期。焦らず、タイミングを見極めて動くことが重要です。"}[rel];
    const enhance={相生受:`${kwE}の気を受け取りやすい環境を整えましょう。${kwE==="水"?"水回りを清潔に保ち、読書や学びの時間を増やすと吉。":kwE==="木"?"植物を飾り、新鮮な空気の中で活動すると運気アップ。":kwE==="火"?"明るい照明や赤・オレンジのアイテムを取り入れると才能が開花。":kwE==="土"?"落ち着いた環境を整え、規則正しい生活を心がけると基盤が固まる。":"整理整頓と計画的な行動で金の気が整います。"}`,相生生:`あなたの${myE}の気を「${w}」に注いでください。積極的な関与と時間の投資が最大の結果をもたらします。`,比和:`互いのエネルギーが共鳴します。${myE}の気を高める環境（${myE==="水"?"青・黒のアイテム":myE==="木"?"緑・青のアイテム":myE==="火"?"赤・紫のアイテム":myE==="土"?"黄・茶のアイテム":"白・銀のアイテム"}）を整えると相乗効果が生まれます。`,相剋受:"防御的な姿勢を持ちつつも、そのエネルギーから学ぶ視点を忘れずに。克服することで大きな成長が待っています。",相剋攻:"強引にではなく、少しずつ関わっていく段階的なアプローチが最も効果的です。焦りは禁物。"}[rel];
    setResult({w,kwE,icon,rich,rel,ri,timing,enhance,kwPalace,pf,myE});
  }

  const CATS=[
    {l:"仕事・お金",ws:["転職","起業","投資","株","副業","昇進","独立","資産","ビジネス"]},
    {l:"恋愛・人間関係",ws:["恋愛","結婚","友達","家族","出会い","婚活","パートナー","人脈"]},
    {l:"健康・生活",ws:["健康","料理","ダイエット","ペット","家","睡眠","病院","介護"]},
    {l:"創作・学び",ws:["音楽","アート","本","勉強","旅行","語学","出版","創作"]},
    {l:"デジタル・テクノロジー",ws:["PC","スマホ","AI","SNS","プログラム","動画","配信","アプリ"]},
    {l:"スポーツ・趣味",ws:["スポーツ","ゴルフ","釣り","ゲーム","映画","アウトドア","料理","カメラ"]},
  ];

  return(
    <div>
      <div style={{borderRadius:"14px",background:"white",border:"1px solid #e5e7eb",boxShadow:"0 1px 8px rgba(0,0,0,0.05)",overflow:"hidden",marginBottom:"12px"}}>
        <div style={{padding:"12px 16px",background:"linear-gradient(90deg,#faf5ff,transparent)",borderBottom:"1px solid #f3f4f6"}}>
          <div style={{fontSize:"14px",letterSpacing:"4px",color:"#7c3aed",marginBottom:"2px"}}>KEYWORD ORACLE</div>
          <div style={{fontSize:"19px",fontWeight:"bold",fontFamily:"serif",color:"#4c1d95"}}>🔮 キーワード占い</div>
          <div style={{fontSize:"14px",color:"#6b7280",marginTop:"2px"}}>{profile?"あなたの本命星との五行相性で鑑定します":"プロフィール未登録でも利用可（五行共通鑑定）"}</div>
        </div>
        <div style={{padding:"14px 16px"}}>
          <div style={{display:"flex",gap:"7px",marginBottom:"12px"}}>
            {true?(
              <>
                <input value={kw} onChange={e=>setKw(e.target.value)} onKeyDown={e=>e.key==="Enter"&&divine()} placeholder="気になるキーワードや物を入力..." style={{...CS.inp,border:"1px solid #ddd6fe"}}/>
                <button onClick={()=>divine()} style={{...CS.btn("#7c3aed"),padding:"9px 16px",whiteSpace:"nowrap"}}>占う</button>
              </>
            ):null}
          </div>
          {CATS.map(cat=>(
            <div key={cat.l} style={{marginBottom:"7px"}}>
              <div onClick={()=>setOpenCat(openCat===cat.l?null:cat.l)} style={{padding:"7px 12px",background:"#f9fafb",borderRadius:"8px",border:"1px solid #f3f4f6",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <span style={{fontSize:"15px",color:"#6b7280"}}>{cat.l}</span><span style={{fontSize:"14px",color:"#6b7280"}}>{openCat===cat.l?"▲":"▼"}</span>
              </div>
              {openCat===cat.l&&(
                <div style={{display:"flex",flexWrap:"wrap",gap:"4px",marginTop:"5px",paddingLeft:"4px"}}>
                  {cat.ws.map(w=>(<button key={w} onClick={()=>{setKw(w);divine(w);}} style={{padding:"4px 10px",background:"#faf5ff",border:"1px solid #ddd6fe",borderRadius:"16px",color:"#7c3aed",fontSize:"15px",cursor:"pointer",fontFamily:"inherit"}}>{w}</button>))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {result&&(
        <div style={{...CS.card,borderLeft:`3px solid ${result.ri.c}`,animation:"fadeIn 0.4s ease"}}>
          <div style={{padding:"12px 16px",background:`linear-gradient(90deg,${result.ri.bg},transparent)`,borderBottom:"1px solid #f3f4f6"}}>
            <div style={{fontSize:"15px",color:"#6b7280"}}>「{result.w}」の氣ごよみ</div>
            <div style={{display:"flex",alignItems:"center",gap:"8px",marginTop:"4px"}}>
              <span style={{fontSize:"30px"}}>{result.icon}</span>
              <div><div style={{fontSize:"20px",fontWeight:"bold",color:result.ri.c,fontFamily:"serif"}}>【{result.ri.lv}】{result.rel}</div>
              <div style={{fontSize:"15px",color:"#6b7280"}}>{result.myE}の気 × {result.kwE}の気</div></div>
            </div>
          </div>
          <div style={{padding:"14px 16px",display:"flex",flexDirection:"column",gap:"10px"}}>
            <SectionTitle>🔮 この物・事柄の気質</SectionTitle>
            <InfoBlock label={`「${result.w}」の五行エネルギー（${result.kwE}の気）`} value={result.rich}/>
            <SectionTitle>⚡ あなたとの相性</SectionTitle>
            <div style={{padding:"12px",background:result.ri.bg,borderRadius:"9px",border:`1px solid ${result.ri.c}33`,fontSize:"15px",color:"#374151",lineHeight:1.75}}>{result.ri.msg}</div>
            <SectionTitle>⏰ 取り組み最適タイミング</SectionTitle>
            <InfoBlock label="今この時期のエネルギー" value={result.timing}/>
            <SectionTitle>💡 運気を引き出す活用法</SectionTitle>
            <InfoBlock label="相性を最大化するアドバイス" value={result.enhance}/>
            <SectionTitle>📍 今日の日盤での位置</SectionTitle>
            <div style={{display:"flex",gap:"6px",flexWrap:"wrap"}}>
              <div style={{flex:"1 1 100px",padding:"9px 12px",background:"#f9fafb",borderRadius:"8px",border:"1px solid #f3f4f6",textAlign:"center"}}>
                <div style={{fontSize:"14px",color:"#6b7280"}}>五行</div><div style={{fontSize:"16px",fontFamily:"serif",color:"#1f2937",fontWeight:"bold"}}>{result.kwE}の気</div>
              </div>
              <div style={{flex:"1 1 100px",padding:"9px 12px",background:"#f9fafb",borderRadius:"8px",border:"1px solid #f3f4f6",textAlign:"center"}}>
                <div style={{fontSize:"14px",color:"#6b7280"}}>今日の位置</div><div style={{fontSize:"16px",fontFamily:"serif",color:"#1f2937",fontWeight:"bold"}}>{PALACES[result.kwPalace]?.d}宮</div>
              </div>
              <div style={{flex:"1 1 100px",padding:"9px 12px",background:"#f9fafb",borderRadius:"8px",border:"1px solid #f3f4f6",textAlign:"center"}}>
                <div style={{fontSize:"14px",color:"#6b7280"}}>宮の運気</div><div style={{fontSize:"15px",fontFamily:"serif",color:"#1f2937",fontWeight:"bold"}}>{result.pf.r}</div>
              </div>
            </div>
            <div style={{padding:"10px 13px",background:"#faf5ff",borderRadius:"9px",border:"1px solid #ddd6fe",fontSize:"14px",color:"#374151",lineHeight:1.75}}>🔮 {result.pf.t}</div>
          {showShareOracle&&<ShareModal type="compat" data={{starInfo1:STAR_INFO[profile?.honmeiStar||1],starInfo2:STAR_INFO[ELEM_STAR[result.kwE]||4],result:result.ri?.lv||"",message:result.timing||"",shareText:"【キーワード占い】「"+result.w+"」の気学鑑定\n"+result.ri?.lv+"\n氣ごよみで鑑定しました。"}} onClose={()=>setShowShareOracle(false)}/>}
          <div style={{textAlign:"center",padding:"12px 0 4px"}}>
            <button onClick={()=>setShowShareOracle(true)} style={{padding:"10px 24px",background:"linear-gradient(135deg,#4c1d95,#7c3aed)",color:"white",border:"none",borderRadius:"12px",fontSize:"14px",fontWeight:"bold",cursor:"pointer",boxShadow:"0 4px 14px rgba(124,58,237,0.3)"}}>📤 この鑑定をシェア</button>
          </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ═══ PREMIUM COMPONENTS ═══
function PremiumLock({msg,onUnlock}){
  const[email,setEmail]=React.useState('');
  const[plan,setPlan]=React.useState('basic');
  const[loading,setLoading]=React.useState(false);
  const[mode,setMode]=React.useState('select'); // select|email
  async function goCheckout(){
    if(!email.trim()){alert('メールアドレスを入力してください');return;}
    setLoading(true);
    try{
      const r=await fetch('/api/create-checkout-session',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:email.trim(),plan})});
      const d=await r.json();
      if(d.url){localStorage.setItem('ki_user_email',email.trim());window.location.href=d.url;}
      else alert('エラーが発生しました。再度お試しください。');
    }catch(e){alert('通信エラーが発生しました。');}
    setLoading(false);
  }
  async function verifyPlan(){
    if(!email.trim()){alert('メールアドレスを入力してください');return;}
    setLoading(true);
    try{
      const r=await fetch('/api/check-subscription?email='+encodeURIComponent(email.trim()));
      const d=await r.json();
      if(d.plan&&d.plan!=='free'){
        localStorage.setItem('ki_user_email',email.trim());
        localStorage.setItem('ki_premium',String(d.plan==='basic'||d.plan==='premium'));
        localStorage.setItem('ki_premium_plus',String(d.plan==='premium'));
        alert((d.plan==='premium'?'プレミアム':'ベーシック')+'プランを確認しました！ページを再読み込みします。');
        window.location.reload();
      }else{alert('このメールアドレスに有効な購読が見つかりません。');}
    }catch(e){alert('確認に失敗しました。');}
    setLoading(false);
  }
  return(
    <div style={{textAlign:'center',padding:'32px 20px',background:'linear-gradient(135deg,#faf5ff,#f5f3ff)',borderRadius:'20px',border:'2px solid #ddd6fe',margin:'12px'}}>
      <div style={{fontSize:'44px',marginBottom:'10px'}}>✨</div>
      <div style={{fontSize:'17px',fontWeight:'bold',color:'#4c1d95',fontFamily:'serif',marginBottom:'8px',lineHeight:1.5}}>{msg}</div>
      {mode==='select'&&(<>
        <div style={{display:'flex',gap:'10px',maxWidth:'300px',margin:'0 auto 16px'}}>
          <button onClick={()=>{setPlan('basic');setMode('email');}} style={{flex:1,padding:'14px 8px',borderRadius:'12px',border:'2px solid #7c3aed',background:'#f5f3ff',cursor:'pointer'}}>
            <div style={{fontSize:'13px',fontWeight:'bold',color:'#7c3aed'}}>ベーシック</div>
            <div style={{fontSize:'22px',fontWeight:'bold',color:'#1f2937'}}>¥180</div>
            <div style={{fontSize:'11px',color:'#6b7280'}}>/月 · 開運相談10回</div>
          </button>
          <button onClick={()=>{setPlan('premium');setMode('email');}} style={{flex:1,padding:'14px 8px',borderRadius:'12px',border:'2px solid #4c1d95',background:'#ede9fe',cursor:'pointer'}}>
            <div style={{fontSize:'13px',fontWeight:'bold',color:'#4c1d95'}}>プレミアム</div>
            <div style={{fontSize:'22px',fontWeight:'bold',color:'#1f2937'}}>¥480</div>
            <div style={{fontSize:'11px',color:'#6b7280'}}>/月 · 全機能</div>
          </button>
        </div>
        <button onClick={()=>setMode('verify')} style={{fontSize:'13px',color:'#7c3aed',background:'none',border:'none',cursor:'pointer',textDecoration:'underline'}}>購読済みの方はこちら</button>
      </>)}
      {(mode==='email'||mode==='verify')&&(<>
        <div style={{fontSize:'14px',color:'#374151',marginBottom:'12px'}}>{mode==='email'?plan==='premium'?'プレミアム ¥480/月':'ベーシック ¥180/月':'購読確認'}</div>
        <input type='email' value={email} onChange={e=>setEmail(e.target.value)} placeholder='メールアドレス' style={{width:'100%',maxWidth:'280px',padding:'11px 14px',borderRadius:'10px',border:'1px solid #d1d5db',fontSize:'15px',boxSizing:'border-box',marginBottom:'10px',display:'block',margin:'0 auto 10px'}}/>
        <button onClick={mode==='email'?goCheckout:verifyPlan} disabled={loading||!email.trim()} style={{width:'100%',maxWidth:'280px',padding:'13px',background:loading?'#e5e7eb':'linear-gradient(135deg,#4c1d95,#7c3aed)',color:loading?'#9ca3af':'white',border:'none',borderRadius:'12px',fontSize:'15px',fontWeight:'bold',cursor:loading?'not-allowed':'pointer',marginBottom:'8px'}}>
          {loading?'処理中...':(mode==='email'?'Stripeで支払いへ進む →':'購読を確認する')}
        </button>
        <button onClick={()=>setMode('select')} style={{fontSize:'13px',color:'#6b7280',background:'none',border:'none',cursor:'pointer'}}>← 戻る</button>
        {mode==='email'&&<div style={{fontSize:'11px',color:'#555',marginTop:'14px',textAlign:'left',background:'#fafafa',borderRadius:'10px',padding:'12px',border:'1px solid #e5e7eb',lineHeight:1.8}}><div style={{marginBottom:'8px'}}>🔒 <b>カード情報の保護について</b><br/>カード情報はStripe社が直接管理します。このサイトではカード番号・セキュリティコード等を一切保持しません。国際セキュリティ基準PCI DSS準拠。</div><div style={{marginBottom:'8px'}}>📧 <b>メールアドレスの取り扱い</b><br/>ご入力のメールアドレスは購読管理のみに使用します。第三者への提供・広告・マーケティング目的での利用は一切行いません。</div><div>🔄 <b>いつでも解約可能</b><br/>違約金・手数料は一切なし。Stripeカスタマーポータルよりご自身でいつでも解約できます。解約後も当月末まで利用可能です。</div></div>}
      </>)}
    </div>
  );
}

function generateKiCard(type,data){
  const W=1080,H=1080;
  const canvas=document.createElement('canvas');
  canvas.width=W;canvas.height=H;
  const ctx=canvas.getContext('2d');
  const grd=(x1,y1,x2,y2,stops)=>{const g=ctx.createLinearGradient(x1,y1,x2,y2);stops.forEach(([s,c])=>g.addColorStop(s,c));return g;};
  const rg=(x,y,r,stops)=>{const g=ctx.createRadialGradient(x,y,0,x,y,r);stops.forEach(([s,c])=>g.addColorStop(s,c));return g;};
  const tx=(t,x,y,font,color,align='center')=>{ctx.font=font;ctx.fillStyle=color;ctx.textAlign=align;ctx.textBaseline='alphabetic';ctx.fillText(String(t),x,y);};
  const wrap=(t,x,y,maxW,lh)=>{ctx.textBaseline='top';let line='',cy=y;[...String(t)].forEach(ch=>{const test=line+ch;if(ctx.measureText(test).width>maxW&&line){ctx.fillText(line,x,cy);line=ch;cy+=lh;}else line=test;});if(line)ctx.fillText(line,x,cy);return cy;};
  const border=(c,w=3,off=40)=>{ctx.strokeStyle=c;ctx.lineWidth=w;ctx.strokeRect(off,off,W-off*2,H-off*2);};
  const logo=()=>{
    tx('氣ごよみ',W-60,H-90,'bold 38px serif','rgba(80,80,80,0.45)','right');
    tx('kigaku-app.vercel.app',W-60,H-48,'24px sans-serif','rgba(120,120,120,0.4)','right');
    tx('#氣ごよみ  #九星気学',60,H-48,'22px sans-serif','rgba(120,120,120,0.4)','left');
  };
  const inf=data.starInfo;const sc=inf?.c||'#fbbf24';const sn=inf?.k||'';const dt=data.date||'';
  if(type==='today'){
    ctx.fillStyle='#ffffff';ctx.fillRect(0,0,W,H);
    ctx.fillStyle=grd(0,0,W,H,[[0,'rgba(184,134,11,0.04)'],[1,'rgba(251,191,36,0.02)']]);ctx.fillRect(0,0,W,H);
    ctx.fillStyle=grd(0,0,W,72,[[0,'#b8860b'],[1,'#d4a017']]);ctx.fillRect(40,40,W-80,72);
    border('rgba(184,134,11,0.7)',4);border('rgba(184,134,11,0.3)',1,52);
    tx('今日の氣',W/2,95,'bold 44px serif','white');
    tx(dt,W/2,185,'34px sans-serif','#374151');
    tx(sn,W/2,432,'bold 160px serif',sc);
    tx('中宮星',W/2,502,'34px sans-serif','#6b7280');
    const fr=data.fortuneRating||'';
    const fc={'大吉':'#b8860b','吉':'#15803d','中吉':'#0369a1','小吉':'#4338ca','注意':'#c2410c','凶':'#dc2626','大凶':'#991b1b','変化':'#7c3aed'}[fr]||'#374151';
    if(fr){ctx.fillStyle=fc+'18';ctx.fillRect(W/2-130,558,260,68);tx('【'+fr+'】',W/2,607,'bold 52px serif',fc);}
    ctx.fillStyle='#374151';ctx.font='33px serif';ctx.textAlign='center';
    wrap(data.message||'',W/2,662,840,52);
    logo();
  }else if(type==='shikigami'){
    ctx.fillStyle='#fffbfb';ctx.fillRect(0,0,W,H);
    ctx.fillStyle=grd(0,0,0,H,[[0,'rgba(220,38,38,0.04)'],[1,'rgba(220,38,38,0.08)']]);ctx.fillRect(0,0,W,H);
    ctx.fillStyle=grd(0,0,W,72,[[0,'#c0392b'],[1,'#e74c3c']]);ctx.fillRect(40,40,W-80,72);
    border('rgba(192,57,43,0.7)',4);border('rgba(192,57,43,0.3)',1,52);
    tx('式神鑑定',W/2,95,'bold 44px serif','white');
    tx(data.emoji||'🦊',W/2,415,'170px serif','black');
    tx(data.shikigamiName||'',W/2,510,'bold 58px serif','#7f1d1d');
    ctx.fillStyle='#374151';ctx.font='33px serif';ctx.textAlign='center';
    wrap(data.message||'',W/2,608,840,52);
    logo();
  }else if(type==='honmei'){
    ctx.fillStyle='#f0fdf4';ctx.fillRect(0,0,W,H);
    ctx.fillStyle=grd(0,0,0,H,[[0,'rgba(21,128,61,0.06)'],[1,'rgba(21,128,61,0.02)']]);ctx.fillRect(0,0,W,H);
    ctx.fillStyle=grd(0,0,W,72,[[0,'#166534'],[1,'#15803d']]);ctx.fillRect(40,40,W-80,72);
    border('rgba(21,128,61,0.6)',4);border('rgba(21,128,61,0.25)',1,52);
    tx('本命星診断',W/2,95,'bold 44px serif','white');
    tx(sn,W/2,428,'bold 150px serif',sc);
    tx(data.starFullName||'',W/2,506,'bold 56px serif','#166534');
    ctx.fillStyle='#374151';ctx.font='33px serif';ctx.textAlign='center';
    wrap(data.message||'',W/2,608,840,52);
    logo();
  }else if(type==='compat'){
    ctx.fillStyle='#faf5ff';ctx.fillRect(0,0,W,H);
    ctx.fillStyle=grd(0,0,0,H,[[0,'rgba(99,102,241,0.04)'],[1,'rgba(99,102,241,0.08)']]);ctx.fillRect(0,0,W,H);
    ctx.fillStyle=grd(0,0,W,72,[[0,'#4338ca'],[1,'#6366f1']]);ctx.fillRect(40,40,W-80,72);
    border('rgba(99,102,241,0.6)',4);border('rgba(99,102,241,0.2)',1,52);
    tx('相性鑑定',W/2,95,'bold 44px serif','white');
    const c1=data.starInfo1?.c||'#3b82f6';const c2=data.starInfo2?.c||'#ec4899';
    tx(data.starInfo1?.k||'★',W/2-160,405,'bold 120px serif',c1);
    tx('×',W/2,390,'bold 64px serif','#4338ca');
    tx(data.starInfo2?.k||'★',W/2+160,405,'bold 120px serif',c2);
    tx(data.result||'相性',W/2,510,'bold 52px serif','#1e1b4b');
    ctx.fillStyle='#374151';ctx.font='33px serif';ctx.textAlign='center';
    wrap(data.message||'',W/2,608,840,52);
    logo();
  }else if(type==='kichinichi'){
    ctx.fillStyle='#fffbeb';ctx.fillRect(0,0,W,H);
    ctx.fillStyle=grd(0,0,W,H,[[0,'rgba(251,191,36,0.12)'],[1,'rgba(251,191,36,0.04)']]);ctx.fillRect(0,0,W,H);
    ctx.fillStyle=grd(0,0,W,72,[[0,'#b8860b'],[1,'#d97706']]);ctx.fillRect(40,40,W-80,72);
    border('rgba(184,134,11,0.7)',4);border('rgba(184,134,11,0.3)',1,52);
    tx('吉日・吉方位',W/2,95,'bold 44px serif','white');
    tx(dt,W/2,190,'34px sans-serif','#78350f');
    tx(data.goodDir||'吉',W/2,392,'bold 120px serif','#b8860b');
    tx('吉方位',W/2,460,'36px sans-serif','#92400e');
    ctx.fillStyle='#78350f';ctx.font='33px serif';ctx.textAlign='center';
    wrap(data.message||'',W/2,562,840,52);
    logo();
  }
  return canvas.toDataURL('image/png');
}

function ShareModal({type,data,onClose}){
  const[imgUrl,setImgUrl]=React.useState(null);
  const[loading,setLoading]=React.useState(true);
  React.useEffect(()=>{
    const t=setTimeout(()=>{
      try{const url=generateKiCard(type,data);setImgUrl(url);}catch(e){console.error('ShareCard error:',e);}
      setLoading(false);
    },80);
    return()=>clearTimeout(t);
  },[]);
  const shareText=data.shareText||'今日の氣を確認しました。';
  const fullText=shareText+'\n\n#氣ごよみ #九星気学\nhttps://kigaku-app.vercel.app';
  const handleX=()=>window.open('https://twitter.com/intent/tweet?text='+encodeURIComponent(fullText));
  const handleLine=()=>window.open('https://social-plugins.line.me/lineit/share?url='+encodeURIComponent('https://kigaku-app.vercel.app')+'&text='+encodeURIComponent(shareText));
  const handleSave=()=>{if(!imgUrl)return;const a=document.createElement('a');a.href=imgUrl;a.download='kigoyomi-card.png';a.click();};
  const handleNative=async()=>{
    if(!navigator.share){handleX();return;}
    try{
      if(imgUrl){
        const byteStr=atob(imgUrl.split(',')[1]);
        const ab=new ArrayBuffer(byteStr.length);
        const ia=new Uint8Array(ab);
        for(let i=0;i<byteStr.length;i++)ia[i]=byteStr.charCodeAt(i);
        const blob=new Blob([ab],{type:'image/png'});
        const file=new File([blob],'kigoyomi.png',{type:'image/png'});
        if(navigator.canShare&&navigator.canShare({files:[file]})){
          await navigator.share({files:[file],title:'氣ごよみ - 九星気学',text:shareText,url:'https://kigaku-app.vercel.app'});
          return;
        }
      }
      await navigator.share({title:'氣ごよみ - 九星気学',text:fullText,url:'https://kigaku-app.vercel.app'});
    }catch(e){if(e.name!=='AbortError')handleX();}
  };
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:"16px"}} onClick={onClose}>
      <div style={{background:"white",borderRadius:"20px",padding:"20px",maxWidth:"400px",width:"100%",maxHeight:"92vh",overflowY:"auto",boxShadow:"0 20px 60px rgba(0,0,0,0.25)",border:"1px solid #e5e7eb"}} onClick={e=>e.stopPropagation()}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"16px"}}>
          <div style={{fontSize:"18px",fontWeight:"bold",color:"#1f2937",fontFamily:"serif"}}>📤 シェアカード</div>
          <button onClick={onClose} style={{background:"#f3f4f6",border:"none",color:"#6b7280",fontSize:"20px",cursor:"pointer",width:"32px",height:"32px",borderRadius:"50%"}}>×</button>
        </div>
        <div style={{marginBottom:"16px",borderRadius:"12px",overflow:"hidden",border:"1px solid #e5e7eb",background:"#f9fafb",minHeight:"180px",display:"flex",alignItems:"center",justifyContent:"center"}}>
          {loading
            ?<div style={{color:"#6b7280",fontSize:"14px"}}>生成中...</div>
            :imgUrl
              ?<img src={imgUrl} style={{width:"100%",display:"block"}} alt="シェアカード"/>
              :<div style={{color:"#ef4444",fontSize:"14px",padding:"20px",textAlign:"center"}}>生成に失敗しました</div>
          }
        </div>
        <button onClick={handleNative} style={{width:"100%",padding:"14px",background:"linear-gradient(135deg,#b8860b,#d4a017)",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:"pointer",marginBottom:"10px"}}>
          📤 シェアする（画像付き）
        </button>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:"8px",marginBottom:"10px"}}>
          <button onClick={handleX} style={{padding:"12px 4px",background:"#000",color:"white",border:"none",borderRadius:"10px",fontSize:"14px",fontWeight:"bold",cursor:"pointer"}}>𝕏 ポスト</button>
          <button onClick={handleLine} style={{padding:"12px 4px",background:"#06c755",color:"white",border:"none",borderRadius:"10px",fontSize:"14px",fontWeight:"bold",cursor:"pointer"}}>LINE</button>
          <button onClick={handleSave} style={{padding:"12px 4px",background:"#374151",color:"white",border:"none",borderRadius:"10px",fontSize:"14px",fontWeight:"bold",cursor:"pointer"}}>💾 保存</button>
        </div>
        <div style={{fontSize:"12px",color:"#9ca3af",textAlign:"center"}}>カードを長押し → 保存も可能です</div>
      </div>
    </div>
  );
}

// ═══ 気学基礎知識ページ ═══
function KisoPage({onBack}){
  return(
    <div style={{minHeight:"100vh",background:"#f8f9fa",color:"#F5F0E8",fontFamily:"'Noto Serif JP',serif"}}>
      <ParticleBackground/>
      <div style={{padding:"calc(env(safe-area-inset-top) + 10px) 16px 10px",background:"white",borderBottom:"1px solid #e5e7eb",boxShadow:"0 1px 4px rgba(0,0,0,0.04)",position:"sticky",top:0,zIndex:10}}>
        <div style={{maxWidth:"560px",margin:"0 auto",display:"flex",alignItems:"center",gap:"12px"}}>
          <button onClick={onBack} style={{background:"none",border:"1px solid #e5e7eb",color:"#6b7280",fontSize:"14px",cursor:"pointer",padding:"5px 10px",borderRadius:"8px",fontFamily:"inherit"}}>← 戻る</button>
          <div style={{fontSize:"17px",fontWeight:"bold",fontFamily:"serif",color:"#78350f"}}>📚 九星気学・方位・吉日とは</div>
        </div>
      </div>
      <div style={{maxWidth:"560px",margin:"0 auto",padding:"14px 14px 80px"}}><KigakuReference/></div>
    </div>
  );
}

// ═══ LANDING PAGE ═══
function LandingPage({onNavigate}){
  const[showAbout,setShowAbout]=React.useState(false);
  const[showKiso,setShowKiso]=React.useState(false);
  
  // パーティクル（固定シード）
  const particles=React.useMemo(()=>Array.from({length:60},(_,i)=>({
    x:Math.sin(i*2.39996)*50+50,
    y:Math.sin(i*1.61803)*50+50,
    r:Math.sin(i*3.14)*1.2+0.4,
    sp:Math.sin(i*0.7)*0.3+0.1,
    ph:i*0.5,
  })),[]);

  if(showKiso)return<KisoPage onBack={()=>setShowKiso(false)}/>;
  if(showAbout){
    return(
      <div style={{minHeight:"100vh",background:"#f8f9fa",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"32px 24px",fontFamily:"'Noto Serif JP',serif"}}><ParticleBackground/>
        <div style={{maxWidth:"360px",width:"100%"}}>
          <div style={{fontSize:"28px",fontWeight:"bold",fontFamily:"sans-serif",color:"#1f2937",marginBottom:"28px",textAlign:"center"}}>氣ごよみとは</div>
          <div style={{fontSize:"17px",color:"#1f2937",lineHeight:2.2,marginBottom:"32px"}}>
            <p style={{marginBottom:"16px",fontSize:"16px",fontWeight:"bold",color:"#1f2937",fontFamily:"sans-serif",lineHeight:1.9}}>『氣ごよみ』は、あなたの「なんとなく」を、宇宙のリズムで読み解く―― "気の航海図"です。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>私はかつて、「なんとなく」を頼りに生きていました。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>理由は説明できない。<br/>けれど、心の奥で「こちらだ」と感じる方向へ、ただ導かれるように歩いていたのです。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>人生を遍歴し、気功を学び、直感に従い、流れに身を委ねながら生きる中で、私は少しずつ気づいていきました。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>「なんとなく」に従うことは、偶然ではない。<br/>それは、自分の魂が知っている"本来の流れ"なのだと。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>そして、九星気学と出会ったとき――確信しました。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>あの「なんとなく」は、<br/>宇宙から届いていた"声"だったのだと。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>九星気学は、本来、とても奥深く、複雑な叡智です。<br/>だからこそ私は、強く願いました。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>「この素晴らしさを、もっと多くの人に届けたい」<br/>「この智慧を、特別な知識ではなく、日々の暮らしの中で活かせるものにしたい」と。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>その想いから生まれたのが、『氣ごよみ』です。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>誰にでも、いつでも、気軽に宇宙の流れに触れてほしい。<br/>そんな願いを込めて、『氣ごよみ』のほとんどの機能は、無料でご利用いただけます。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>宇宙の声と対話し、目には見えない"気の流れ"を読み解いていく。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>そのための地図を、あなたの手のひらに。</p>
            <p style={{marginBottom:"16px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>もし今、迷っているなら。もし今、言葉にならない「なんとなく」を感じているなら。<br/>それは、宇宙があなたに送っているサインかもしれません。</p>
            <p style={{marginBottom:"24px",fontSize:"15px",color:"#374151",lineHeight:1.9}}>宇宙の声を聞きながら、<br/>自然とともに、<br/>地球のリズムで生きてみませんか。</p>
            <p style={{marginTop:"24px",textAlign:"right",fontSize:"15px",color:"#b8860b",fontFamily:"sans-serif",fontWeight:"bold"}}>氣ごよみ制作者　環 弦</p>
          </div>
          <button onClick={()=>onNavigate("today")} style={{width:"100%",padding:"16px",background:"linear-gradient(135deg,#b8860b,#d4a017)",color:"white",border:"none",borderRadius:"12px",fontSize:"17px",fontWeight:"bold",cursor:"pointer",letterSpacing:"2px",boxShadow:"0 4px 20px rgba(184,134,11,0.4)"}}>
            今日の氣を見る →
          </button>
          <button onClick={()=>setShowAbout(false)} style={{width:"100%",marginTop:"12px",padding:"12px",background:"transparent",color:"#b8860b",border:"1px solid #b8860b66",borderRadius:"12px",fontSize:"14px",cursor:"pointer"}}>
            ← 戻る
          </button>
        </div>
      </div>
    );
  }

  return(
    <div style={{minHeight:"100vh",background:"#f8f9fa",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"24px",fontFamily:"'Noto Serif JP',serif",position:"relative",overflow:"hidden"}}><KiBackground/><InstallPrompt />


      {/* メインコンテンツ */}
      <div style={{maxWidth:"360px",width:"100%",textAlign:"center",position:"relative",zIndex:1}}>
        {/* ロゴ */}
        <div style={{fontSize:"13px",color:"#b8860b",letterSpacing:"4px",marginBottom:"16px"}}>KI - GOYOMI</div>
        <div style={{fontSize:"38px",fontWeight:"bold",color:"#1f2937",letterSpacing:"4px",marginBottom:"8px",textShadow:"0 0 30px rgba(184,134,11,0.5)"}}>氣ごよみ</div>
        <div style={{width:"60px",height:"1px",background:"linear-gradient(90deg,transparent,#b8860b,transparent)",margin:"0 auto 32px"}}/>

        {/* キャッチコピー */}
        <div style={{fontSize:"20px",color:"#1f2937",lineHeight:2.0,marginBottom:"12px",letterSpacing:"2px"}}>
          氣は、見える。
        </div>
        <div style={{fontSize:"17px",color:"#374151",lineHeight:1.9,marginBottom:"16px"}}>
          感じていた「なんとなく」には、意味がある。
        </div>

        {/* ── メニューボタン（順番：今日の氣→あなた自身→無料鑑定CTA） ── */}
        <div style={{display:"flex",flexDirection:"column",gap:"11px",marginBottom:"24px"}}>
          <button onClick={()=>onNavigate("today")} style={{padding:"16px 18px",background:"linear-gradient(135deg,#b8860b,#d4a017)",color:"white",border:"none",borderRadius:"14px",fontSize:"15px",fontWeight:"bold",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between",boxShadow:"0 4px 24px rgba(184,134,11,0.45)"}}>
            <div style={{textAlign:"left"}}><div>📅 今日の氣を見る</div><div style={{fontSize:"12px",color:"rgba(255,255,255,0.7)",fontWeight:"normal",marginTop:"2px"}}>今日の中宮星・吉方位・運勢を確認</div></div><span>→</span>
          </button>
          <button onClick={()=>onNavigate("profile")} style={{padding:"16px 18px",background:"linear-gradient(135deg,rgba(184,134,11,0.25),rgba(212,160,23,0.12))",color:"#d4a017",border:"1px solid rgba(212,160,23,0.5)",borderRadius:"14px",fontSize:"15px",fontWeight:"bold",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between",boxShadow:"0 4px 20px rgba(184,134,11,0.15)"}}>
            <div style={{textAlign:"left"}}><div>👤 あなた自身の氣を見るには？</div><div style={{fontSize:"12px",color:"rgba(212,160,23,0.7)",fontWeight:"normal",marginTop:"2px"}}>生年月日から本命星・月命星を鑑定</div></div><span>→</span>
          </button>
        </div>

        {/* ── 無料鑑定CTA ── */}
        {(()=>{
          const thisMonth=new Date().getFullYear()+'_'+(new Date().getMonth()+1);
          const freeKey='ki_free_'+thisMonth;
          const freeUsed=parseInt(localStorage.getItem(freeKey)||'0');
          const remaining=Math.max(0,1-freeUsed);
          return(
            <div style={{marginBottom:"24px",background:"linear-gradient(135deg,#fffbeb,#fef3c7)",borderRadius:"16px",padding:"18px",border:"2px solid #f59e0b44"}}>
              <div style={{fontSize:"13px",color:"#92400e",letterSpacing:"1px",marginBottom:"8px",textAlign:"center"}}>✨ 今月の無料鑑定（残{remaining}回）</div>
              <button onClick={()=>onNavigate("fortune")} disabled={remaining===0}
                style={{width:"100%",padding:"14px",background:remaining>0?"linear-gradient(135deg,#d97706,#f59e0b)":"#e5e7eb",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:remaining>0?"pointer":"not-allowed",letterSpacing:"1px",marginBottom:"10px"}}>
                {remaining>0?"今すぐ試す →":"今月の体験は終了しました"}
              </button>
              <div style={{borderTop:"1px solid #f59e0b44",paddingTop:"12px",marginTop:"4px"}}>
                <div style={{fontSize:"12px",color:"#92400e",marginBottom:"8px",textAlign:"center"}}>📊 鑑定実績</div>
                <div style={{fontSize:"12px",color:"#374151",marginBottom:"6px",textAlign:"center"}}>開運相談 累計847件</div>
                <div style={{fontSize:"12px",color:"#374151",marginBottom:"4px"}}>⭐⭐⭐⭐⭐「仕事運が上向いた」</div>
                <div style={{fontSize:"12px",color:"#374151",marginBottom:"10px"}}>⭐⭐⭐⭐⭐「試合結果が的中した」</div>
                <div style={{fontSize:"11px",color:"#9ca3af",textAlign:"center",marginBottom:"10px"}}>月10回使うなら ¥180/月〜</div>
                <button onClick={()=>onNavigate("signup")}
                  style={{width:"100%",padding:"12px",background:"white",color:"#d97706",border:"2px solid #f59e0b",borderRadius:"12px",fontSize:"14px",fontWeight:"bold",cursor:"pointer"}}>
                  有料登録して鑑定を行う
                </button>
              </div>
            </div>
          );
        })()}

        {/* 今日の氣（画面②統合） */}
        {(()=>{
          const today=new Date();
          const yr=today.getFullYear(),mo=today.getMonth()+1,dy=today.getDate();
          const dow=["日","月","火","水","木","金","土"][today.getDay()];
          const dayStar=getDayStar(today);
          const dayStars=getStarsFor(dayStar);
          const inf=STAR_INFO[dayStar];
          const kanMsgs={1:"今日は水の気。静かな内省の中に、大切な気づきがある。",2:"今日は土の気。焦らず、ひとつひとつを丁寧に積み重ねて。",3:"今日は木の気。行動が最大の開運。まず動いてみることを。",4:"今日は木の気。縁を大切に。誰かへの一言が運命を変える。",5:"今日は中心の気。大きな力が動く日。自分を整えて備えて。",6:"今日は金の気。誠実さが天運を引き寄せる。品格ある一日を。",7:"今日は金の気。楽しむことが最大の開運。笑顔でいこう。",8:"今日は土の気。変化の兆しを感じたら、素直に従って。",9:"今日は火の気。直感を信じて。あなたの感性が正しい道を示す。"};
          const msgs={1:"水のように静かに流れる日。焦らず、感じる力を大切に。",2:"大地のように安定する日。地道な積み重ねが吉。",3:"雷のように行動する日。新しい一歩を踏み出して。",4:"風のように縁がつながる日。人との出会いを大切に。",5:"天の采配が動く日。慎重に、大局を見て動いて。",6:"天の気が満ちる日。品格ある行動が運を開く。",7:"喜びと金運の日。楽しいことに素直に向き合って。",8:"転換の気が流れる日。変化を恐れず受け入れて。",9:"直感が輝く日。あなたの感性を信じて進んで。"};
          return(
            <div style={{marginBottom:"32px"}}>
              <div style={{fontSize:"15px",color:"#78350f",letterSpacing:"1px",marginBottom:"10px"}}>{yr}年{mo}月{dy}日（{dow}）の氣</div>
              {/* 九星盤 */}
              <div style={{background:"rgba(0,0,0,0.04)",borderRadius:"16px",border:"1px solid #b8860b66",padding:"16px",marginBottom:"14px",backdropFilter:"blur(4px)"}}>
                <div style={{fontSize:"14px",color:"#78350f",letterSpacing:"2px",marginBottom:"8px"}}>今日の中宮星</div>
                <div style={{fontSize:"24px",fontWeight:"bold",color:inf.c,fontFamily:"serif",textShadow:`0 0 20px ${inf.c}88`,marginBottom:"12px"}}>{inf.k}</div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"3px",maxWidth:"180px",margin:"0 auto 10px"}}>
                  {dayStars.map((star,i)=>{
                    const si=STAR_INFO[star];const isC=i===4;
                    return(
                      <div key={i} style={{padding:isC?"10px 2px":"6px 2px",textAlign:"center",background:isC?inf.bg+"66":"rgba(0,0,0,0.04)",border:`1px solid ${isC?inf.br:"#00000018"}`,borderRadius:isC?"50%":"5px"}}>
                        <div style={{fontSize:"9px",color:"#374151"}}>{PALACES[i].n}</div>
                        <div style={{fontSize:isC?"15px":"13px",color:isC?inf.c:"#374151",fontFamily:"serif",fontWeight:isC?"bold":"normal"}}>{si.k}</div>
                      </div>
                    );
                  })}
                </div>
                <div style={{fontSize:"15px",color:"#374151",lineHeight:1.7}}>
                  今日は<span style={{color:inf.c,fontWeight:"bold"}}>{inf.k}</span>の氣が中心に流れています。
                </div>
              </div>
              {/* 環弦メッセージ */}
              <div style={{background:"rgba(184,134,11,0.08)",borderRadius:"12px",border:"1px solid #b8860b33",padding:"16px"}}>
                <div style={{fontSize:"14px",color:"#78350f",letterSpacing:"1px",marginBottom:"8px"}}>━━ 環 弦より ━━</div>
                <div style={{fontSize:"15px",color:"#1f2937",lineHeight:1.9,marginBottom:"8px"}}>{kanMsgs[dayStar]}</div>
                <div style={{fontSize:"15px",color:"#374151",lineHeight:1.8}}>{msgs[dayStar]}</div>
              </div>
            </div>
          );
        })()}

        {/* ボタン（📖・🧭） */}
        <div style={{display:"flex",flexDirection:"column",gap:"11px",marginTop:"8px"}}>
          <button onClick={()=>setShowAbout(true)} style={{padding:"14px 18px",background:"transparent",color:"#1f2937",border:"none",fontSize:"16px",fontWeight:"bold",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between",width:"100%"}}>
            <span>📖 氣ごよみとは</span><span>→</span>
          </button>
          <button onClick={()=>setShowKiso(true)} style={{padding:"14px 18px",background:"transparent",color:"#1f2937",border:"none",fontSize:"16px",fontWeight:"bold",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between",width:"100%"}}>
            <span>🧭 九星気学・方位・吉日とは？</span><span>→</span>
          </button>
        </div>
        {/* フッター */}
        <div style={{marginTop:"36px",paddingTop:"16px",borderTop:"1px solid rgba(184,134,11,0.2)",textAlign:"center",paddingBottom:"8px"}}>
          <a href="https://note.com/gen_tamaki/n/ncb962d62dee8" target="_blank" rel="noopener noreferrer" style={{fontSize:"13px",color:"#9ca3af",textDecoration:"none",letterSpacing:"0.5px"}}>プライバシーポリシー・個人情報の取り扱い</a>
          <div style={{fontSize:"11px",color:"#b0a090",marginTop:"8px"}}>© 2026 環 弦 / 氣ごよみ</div>
        </div>
      </div>
    </div>
  );
}


// ─── DEV TEST PANEL ───
function DevTestPanel({isPremium,isPremiumPlus,setIsPremium,setIsPremiumPlus}){
  const [tapCount,setTapCount]=useState(0);
  const [open,setOpen]=useState(false);
  const handleTap=()=>{
    const n=tapCount+1;
    setTapCount(n);
    if(n>=5){setOpen(true);setTapCount(0);}
  };
  const enable=()=>{localStorage.setItem('ki_premium','true');localStorage.setItem('ki_premium_plus','true');setIsPremium(true);setIsPremiumPlus(true);};
  const disable=()=>{localStorage.setItem('ki_premium','false');localStorage.setItem('ki_premium_plus','false');setIsPremium(false);setIsPremiumPlus(false);};
  return(
    <div style={{textAlign:"center",paddingBottom:"16px"}}>
      <div onClick={handleTap} style={{fontSize:"10px",color:"#d1c9b8",letterSpacing:"1px",cursor:"default",userSelect:"none",padding:"8px"}}>v1.0.0</div>
      {open&&(
        <div style={{margin:"0 20px 12px",padding:"14px",background:"#fff7ed",borderRadius:"10px",border:"1px dashed #fb923c"}}>
          <div style={{fontSize:"11px",color:"#9a3412",fontWeight:"bold",marginBottom:"10px",letterSpacing:"1px"}}>🛠 開発者テストモード</div>
          <div style={{fontSize:"12px",color:"#c2410c",marginBottom:"10px"}}>現在: {isPremiumPlus?'Premium Plus ✓':isPremium?'Premium ✓':'無料'}</div>
          <div style={{display:"flex",gap:"8px",justifyContent:"center",marginBottom:"8px"}}>
            <button onClick={enable} style={{padding:"8px 16px",background:"#ea580c",color:"white",border:"none",borderRadius:"8px",fontSize:"13px",fontWeight:"bold",cursor:"pointer"}}>開運・勝負を有効化</button>
            <button onClick={disable} style={{padding:"8px 16px",background:"#6b7280",color:"white",border:"none",borderRadius:"8px",fontSize:"13px",cursor:"pointer"}}>無効化</button>
          </div>
          <button onClick={()=>setOpen(false)} style={{fontSize:"11px",color:"#9ca3af",background:"none",border:"none",cursor:"pointer"}}>閉じる</button>
        </div>
      )}
    </div>
  );
}

// ═══ ONBOARDING SCREENS ═══

function OnboardingTodayKi({onNext,onSkip}){
  const today=new Date();
  const yr=today.getFullYear(),mo=today.getMonth()+1,dy=today.getDate();
  const dow=["日","月","火","水","木","金","土"][today.getDay()];
  const dayStar=getDayStar(today);
  const dayStars=getStarsFor(dayStar);
  const inf=STAR_INFO[dayStar];
  const msgs={
    1:"水のように静かに流れる日。焦らず、感じる力を大切に。",
    2:"大地のように安定する日。地道な積み重ねが吉。",
    3:"雷のように行動する日。新しい一歩を踏み出して。",
    4:"風のように縁がつながる日。人との出会いを大切に。",
    5:"天の采配が動く日。慎重に、大局を見て動いて。",
    6:"天の気が満ちる日。品格ある行動が運を開く。",
    7:"喜びと金運の日。楽しいことに素直に向き合って。",
    8:"転換の気が流れる日。変化を恐れず受け入れて。",
    9:"直感が輝く日。あなたの感性を信じて進んで。",
  };
  const kanMsgs={
    1:"今日は水の気。静かな内省の中に、大切な気づきがある。",
    2:"今日は土の気。焦らず、ひとつひとつを丁寧に積み重ねて。",
    3:"今日は木の気。行動が最大の開運。まず動いてみることを。",
    4:"今日は木の気。縁を大切に。誰かへの一言が運命を変える。",
    5:"今日は中心の気。大きな力が動く日。自分を整えて備えて。",
    6:"今日は金の気。誠実さが天運を引き寄せる。品格ある一日を。",
    7:"今日は金の気。楽しむことが最大の開運。笑顔でいこう。",
    8:"今日は土の気。変化の兆しを感じたら、素直に従って。",
    9:"今日は火の気。直感を信じて。あなたの感性が正しい道を示す。",
  };

  const[tick,setTick]=React.useState(0);
  React.useEffect(()=>{
    const id=setInterval(()=>setTick(t=>t+1),60);
    return()=>clearInterval(id);
  },[]);

  return(
    <div style={{minHeight:"100vh",background:"#ffffff",fontFamily:"'Noto Serif JP',serif",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"24px",position:"relative",overflow:"hidden"}}>
      {/* パーティクル */}
      <svg style={{position:"absolute",inset:0,width:"100%",height:"100%",pointerEvents:"none"}} viewBox="0 0 100 100" preserveAspectRatio="none">
        {[...Array(20)].map((_,i)=>{
          const x=Math.sin(i*2.4)*45+50;
          const y=(Math.sin(i*1.6)*45+50+tick*0.08*(i%3===0?1:-1))%100;
          const op=0.2+Math.sin(tick*0.05+i)*0.2;
          return<circle key={i} cx={x} cy={y} r="0.4" fill={i%2===0?"#b8860b":"#4a6fa5"} opacity={op}/>;
        })}
      </svg>

      <div style={{maxWidth:"360px",width:"100%",position:"relative",zIndex:1}}>
        {/* 日付ヘッダー */}
        <div style={{textAlign:"center",marginBottom:"24px"}}>
          <div style={{fontSize:"12px",color:"#b8860b",letterSpacing:"3px",marginBottom:"6px"}}>TODAY'S KI</div>
          <div style={{fontSize:"18px",color:"#1f2937",fontWeight:"bold"}}>{yr}年{mo}月{dy}日（{dow}）</div>
        </div>

        {/* 九星盤 */}
        <div style={{background:"rgba(0,0,0,0.04)",borderRadius:"16px",border:"1px solid #b8860b66",padding:"20px",marginBottom:"20px",backdropFilter:"blur(4px)"}}>
          <div style={{textAlign:"center",marginBottom:"12px"}}>
            <div style={{fontSize:"12px",color:"#b8860b",letterSpacing:"2px",marginBottom:"4px"}}>今日の中宮星</div>
            <div style={{fontSize:"28px",fontWeight:"bold",color:inf.c,fontFamily:"serif",textShadow:`0 0 20px ${inf.c}88`}}>{inf.k}</div>
          </div>
          {/* ミニ九星盤 */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"4px",maxWidth:"200px",margin:"0 auto"}}>
            {dayStars.map((star,i)=>{
              const si=STAR_INFO[star];const isC=i===4;
              return(
                <div key={i} style={{padding:isC?"12px 4px":"8px 4px",textAlign:"center",background:isC?inf.bg+"88":"rgba(0,0,0,0.04)",border:`1px solid ${isC?inf.br:"#00000018"}`,borderRadius:isC?"50%":"6px",transition:"all 0.3s"}}>
                  <div style={{fontSize:"8px",color:"#6b7280"}}>{PALACES[i].n}</div>
                  <div style={{fontSize:isC?"14px":"11px",color:isC?inf.c:"#c8b89a",fontFamily:"serif",fontWeight:isC?"bold":"normal"}}>{si.k}</div>
                </div>
              );
            })}
          </div>
          <div style={{textAlign:"center",marginTop:"12px",fontSize:"14px",color:"#6b7280",lineHeight:1.8}}>
            今日は<span style={{color:inf.c,fontWeight:"bold"}}>{inf.k}</span>の氣が中心に流れています。
          </div>
        </div>

        {/* 環 弦のメッセージ */}
        <div style={{background:"rgba(184,134,11,0.08)",borderRadius:"14px",border:"1px solid #b8860b66",padding:"20px",marginBottom:"24px"}}>
          <div style={{fontSize:"11px",color:"#b8860b",letterSpacing:"2px",marginBottom:"10px",textAlign:"center"}}>━━━ 環 弦より ━━━</div>
          <div style={{fontSize:"16px",color:"#1f2937",lineHeight:2.0,textAlign:"center",marginBottom:"12px"}}>{kanMsgs[dayStar]}</div>
          <div style={{fontSize:"13px",color:"#6b7280",lineHeight:1.8,textAlign:"center"}}>{msgs[dayStar]}</div>
        </div>

        {/* CTA */}
        <div style={{textAlign:"center",marginBottom:"20px"}}>
          <div style={{fontSize:"15px",color:"#1f2937",marginBottom:"16px"}}>あなた自身の氣を見るには？</div>
          <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
            <button onClick={onNext} style={{padding:"16px",background:"linear-gradient(135deg,#b8860b,#d4a017)",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:"pointer",letterSpacing:"1px",boxShadow:"0 4px 20px rgba(184,134,11,0.4)"}}>
              今すぐ入力する →
            </button>
            <button onClick={onSkip} style={{padding:"14px",background:"transparent",color:"#9ca3af",border:"1px solid #374151",borderRadius:"12px",fontSize:"14px",cursor:"pointer"}}>
              あとで →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function OnboardingBirth({onNext,onSkip}){
  const[by,setBY]=React.useState("");
  const[bm,setBM]=React.useState("");
  const[bd,setBD]=React.useState("");

  const[nm,setNM]=React.useState("");
  const canNext=by&&bm;

  return(
    <div style={{minHeight:"100vh",background:"#f8f9fa",fontFamily:"'Noto Serif JP',serif",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"24px"}}><ParticleBackground/>
      <div style={{maxWidth:"360px",width:"100%"}}>
        <div style={{textAlign:"center",marginBottom:"32px"}}>
          <div style={{fontSize:"12px",color:"#b8860b",letterSpacing:"3px",marginBottom:"8px"}}>STEP 1</div>
          <div style={{fontSize:"24px",color:"#1f2937",fontWeight:"bold",marginBottom:"8px"}}>あなたの本命星を調べます</div>
          <div style={{fontSize:"14px",color:"#78716c",lineHeight:1.8}}>生年月日から、あなたの九星を導きます。</div>
        </div>

        <div style={{background:"rgba(0,0,0,0.04)",borderRadius:"16px",border:"1px solid #b8860b66",padding:"24px",marginBottom:"24px"}}>
          <div style={{marginBottom:"20px"}}>
            <label style={{fontSize:"13px",color:"#b8860b",display:"block",marginBottom:"8px",letterSpacing:"1px"}}>生年（西暦）</label>
            <select value={by} onChange={e=>setBY(e.target.value)} style={{width:"100%",padding:"12px",background:"rgba(0,0,0,0.05)",border:"1px solid #b8860b66",borderRadius:"10px",color:"#1f2937",fontSize:"16px",appearance:"auto"}}>
              <option value="">選択してください</option>
              {Array.from({length:100},(_,i)=>new Date().getFullYear()-i).map(y=><option key={y} value={y} style={{background:"#0d1a2e"}}>{y}年</option>)}
            </select>
          </div>
          <div style={{display:"flex",gap:"12px",marginBottom:"8px"}}>
            <div style={{flex:1}}>
              <label style={{fontSize:"13px",color:"#b8860b",display:"block",marginBottom:"8px",letterSpacing:"1px"}}>生月</label>
              <select value={bm} onChange={e=>setBM(e.target.value)} style={{width:"100%",padding:"12px",background:"rgba(0,0,0,0.05)",border:"1px solid #b8860b66",borderRadius:"10px",color:"#1f2937",fontSize:"16px",appearance:"auto"}}>
                <option value="">月</option>
                {Array.from({length:12},(_,i)=>i+1).map(m=><option key={m} value={m} style={{background:"#0d1a2e"}}>{m}月</option>)}
              </select>
            </div>
            <div style={{flex:1}}>
              <label style={{fontSize:"13px",color:"#b8860b",display:"block",marginBottom:"8px",letterSpacing:"1px"}}>生日（任意）</label>
              <select value={bd} onChange={e=>setBD(e.target.value)} style={{width:"100%",padding:"12px",background:"rgba(0,0,0,0.05)",border:"1px solid #b8860b66",borderRadius:"10px",color:"#1f2937",fontSize:"16px",appearance:"auto"}}>
                <option value="">日</option>
                {Array.from({length:31},(_,i)=>i+1).map(d=><option key={d} value={d} style={{background:"#0d1a2e"}}>{d}日</option>)}
              </select>
            </div>
          </div>
          {by&&bm&&(()=>{
            const hs=getHonmei(Number(by),Number(bm),Number(bd||15));
            const inf=STAR_INFO[hs];
            return(
              <div style={{marginTop:"16px",padding:"14px",background:`${inf.bg}22`,borderRadius:"10px",border:`1px solid ${inf.br}66`,textAlign:"center"}}>
                <div style={{fontSize:"12px",color:"#b8860b",marginBottom:"4px"}}>あなたの本命星</div>
                <div style={{fontSize:"22px",fontWeight:"bold",color:inf.c,fontFamily:"serif"}}>{inf.name}</div>
              </div>
            );
          })()}
        </div>

        <div style={{marginBottom:"20px"}}>
          <label style={{fontSize:"13px",color:"#b8860b",display:"block",marginBottom:"8px",letterSpacing:"1px"}}>お名前（ニックネームでOK）</label>
          <input value={nm} onChange={e=>setNM(e.target.value)} placeholder="例：花子" style={{width:"100%",padding:"12px",background:"rgba(0,0,0,0.05)",border:"1px solid #b8860b66",borderRadius:"10px",color:"#1f2937",fontSize:"16px",boxSizing:"border-box"}}/>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
          <button onClick={()=>canNext&&onNext({by:Number(by),bm:Number(bm),bd:Number(bd||15),name:nm||'メイン'})} style={{padding:"16px",background:canNext?"linear-gradient(135deg,#b8860b,#d4a017)":"#374151",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:canNext?"pointer":"not-allowed",letterSpacing:"1px",boxShadow:canNext?"0 4px 20px rgba(184,134,11,0.4)":"none",opacity:canNext?1:0.5}}>
            次へ →
          </button>
          <button onClick={onSkip} style={{padding:"14px",background:"transparent",color:"#9ca3af",border:"1px solid #374151",borderRadius:"12px",fontSize:"14px",cursor:"pointer"}}>
            あとで →
          </button>
        </div>
      </div>
    </div>
  );
}

function OnboardingEmail({name,onNext,onSkip}){
  return(
    <div style={{minHeight:"100vh",background:"#f8f9fa",fontFamily:"'Noto Serif JP',serif",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"24px"}}><ParticleBackground/>
      <div style={{maxWidth:"360px",width:"100%"}}>
        <div style={{textAlign:"center",marginBottom:"32px"}}>
          <div style={{fontSize:"12px",color:"#b8860b",letterSpacing:"3px",marginBottom:"8px"}}>STEP 2</div>
          <div style={{fontSize:"22px",color:"#1f2937",fontWeight:"bold",marginBottom:"12px"}}>プロフィールを登録します</div>
          <div style={{fontSize:"14px",color:"#78716c",lineHeight:1.9}}>
            プロフィールを登録すると、<br/>あなた専用の氣のカレンダーが完成します。<br/>メールアドレスはプレミアム機能の購読に使用します。
          </div>
        </div>

        <div style={{background:"rgba(184,134,11,0.08)",borderRadius:"14px",border:"1px solid #b8860b66",padding:"20px",marginBottom:"24px"}}>
          {[
            {icon:"📅",text:"鑑定結果の保存・履歴確認"},
            {icon:"🧭",text:"あなただけの吉凶カレンダー"},
            {icon:"☯",text:"相性診断・方角診断の保存"},
            {icon:"✨",text:"家族・友人のプロフィール管理"},
          ].map((item,i)=>(
            <div key={i} style={{display:"flex",gap:"12px",alignItems:"center",marginBottom:i<3?"14px":"0",paddingBottom:i<3?"14px":"0",borderBottom:i<3?"1px solid #b8860b22":"none"}}>
              <span style={{fontSize:"20px"}}>{item.icon}</span>
              <span style={{fontSize:"14px",color:"#78716c"}}>{item.text}</span>
              <span style={{marginLeft:"auto",color:"#b8860b",fontSize:"16px"}}>✓</span>
            </div>
          ))}
        </div>

        <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
          <button onClick={onNext} style={{padding:"16px",background:"linear-gradient(135deg,#b8860b,#d4a017)",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:"pointer",letterSpacing:"1px",boxShadow:"0 4px 20px rgba(184,134,11,0.4)"}}>
            登録する →
          </button>
          <button onClick={onSkip} style={{padding:"14px",background:"transparent",color:"#9ca3af",border:"1px solid #374151",borderRadius:"12px",fontSize:"14px",cursor:"pointer"}}>
            登録せずに使う →
          </button>
        </div>
      </div>
    </div>
  );
}

function OnboardingComplete({name,onDone,onInputBirth}){
  return(
    <div style={{minHeight:"100vh",background:"#f8f9fa",fontFamily:"'Noto Serif JP',serif",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"24px"}}><ParticleBackground/>
      <div style={{maxWidth:"360px",width:"100%",textAlign:"center"}}>
        <div style={{fontSize:"40px",marginBottom:"16px"}}>✨</div>
        <div style={{fontSize:"22px",color:"#1f2937",fontWeight:"bold",marginBottom:"8px"}}>
          ようこそ、{name}さん。
        </div>
        <div style={{fontSize:"16px",color:"#b8860b",marginBottom:"32px",letterSpacing:"1px"}}>
          あなたの氣の旅が始まります。
        </div>
        <div style={{background:"rgba(184,134,11,0.08)",borderRadius:"14px",border:"1px solid #b8860b66",padding:"24px",marginBottom:"24px",textAlign:"left"}}>
          <div style={{fontSize:"13px",color:"#b8860b",letterSpacing:"2px",marginBottom:"12px"}}>次のステップ</div>
          <div style={{fontSize:"16px",color:"#1f2937",marginBottom:"8px"}}>あなたの本命星を調べましょう。</div>
          <div style={{fontSize:"13px",color:"#6b7280",lineHeight:1.8}}>生年月日を入力すると、あなたの九星と月命星がわかり、毎日の吉凶方位が表示されます。</div>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
          <button onClick={onInputBirth} style={{padding:"16px",background:"linear-gradient(135deg,#b8860b,#d4a017)",color:"white",border:"none",borderRadius:"12px",fontSize:"16px",fontWeight:"bold",cursor:"pointer",letterSpacing:"1px",boxShadow:"0 4px 20px rgba(184,134,11,0.4)"}}>
            生年月日を入力する →
          </button>
          <button onClick={onDone} style={{padding:"14px",background:"transparent",color:"#9ca3af",border:"1px solid #374151",borderRadius:"12px",fontSize:"14px",cursor:"pointer"}}>
            あとで →
          </button>
        </div>
      </div>
    </div>
  );
}

function PremiumModal({onClose,onUnlock}){
  const feats=[
    {i:"👤",t:"プロフィール無制限登録",d:"家族・友人など複数人を登録して一括鑑定"},
    {i:"🏠",t:"住んでいる場所の登録",d:"方角の相性診断に使用"},
    {i:"🗓️",t:"年盤・月盤・日盤の表示",d:"九宮の動きを視覚的に確認"},
    {i:"🧭",t:"吉方位・凶方位の表示",d:"五黄殺・暗剣殺・本命殺・月命殺を完全表示"},
    {i:"☯",t:"相性診断フル機能",d:"人・場所・方角・日付との完全な相性鑑定"},
    {i:"📅",t:"イベント日付鑑定",d:"任意の日付を指定して吉日診断"},
    {i:"🔮",t:"キーワード自由入力",d:"任意のキーワードを入力して占い"},
    {i:"📄",t:"PDF出力・印刷・保存",d:"鑑定結果をPDFとして保存・印刷可能"},
  ];
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:100,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div style={{background:"white",borderRadius:"20px 20px 0 0",width:"100%",maxWidth:"560px",maxHeight:"85vh",overflowY:"auto",padding:"0 0 32px"}}>
        {/* Header */}
        <div style={{padding:"20px 20px 16px",background:"linear-gradient(135deg,#fffbeb,#fef9c3)",borderRadius:"20px 20px 0 0",textAlign:"center",position:"sticky",top:0}}>
          <div style={{fontSize:"34px",marginBottom:"6px"}}>⭐</div>
          <div style={{fontSize:"22px",fontWeight:"900",fontFamily:"serif",background:"linear-gradient(135deg,#d97706,#78350f)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>氣ごよみ プレミアム</div>
          <div style={{fontSize:"15px",color:"#92400e",marginTop:"4px"}}>ベーシック¥180/月 〜 プレミアム¥480/月</div>
          <button onClick={onClose} style={{position:"absolute",top:"16px",right:"16px",background:"none",border:"none",fontSize:"22px",cursor:"pointer",color:"#6b7280"}}>✕</button>
        </div>
        {/* Features */}
        <div style={{padding:"16px 18px",display:"flex",flexDirection:"column",gap:"8px"}}>
          {feats.map(f=>(
            <div key={f.t} style={{display:"flex",gap:"12px",alignItems:"flex-start",padding:"10px 12px",background:"#fffbeb",borderRadius:"10px",border:"1px solid #fde68a"}}>
              <span style={{fontSize:"22px",flexShrink:0}}>{f.i}</span>
              <div><div style={{fontSize:"15px",fontWeight:"bold",color:"#78350f"}}>{f.t}</div><div style={{fontSize:"15px",color:"#a16207",marginTop:"2px"}}>{f.d}</div></div>
              <span style={{marginLeft:"auto",color:"#16a34a",fontSize:"18px",flexShrink:0}}>✓</span>
            </div>
          ))}
        </div>
        {/* CTA */}
        <div style={{padding:"0 18px"}}>
          <button onClick={onUnlock} style={{...CS.btn("#d97706"),width:"100%",padding:"15px",fontSize:"18px",fontWeight:"bold",borderRadius:"14px",boxShadow:"0 4px 16px rgba(217,119,6,0.35)"}}>
            🌟 ベーシック¥180/月 または プレミアム¥480/月で解放
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══ MAIN APP ═══
const TABS=[
  {id:"today",icon:"📅",label:"今日"},
  {id:"power",icon:"🧭",label:"方位"},
  {id:"calendar",icon:"🗓",label:"暦"},
  {id:"event",icon:"📋",label:"イベント"},
  {id:"compat",icon:"☯",label:"相性"},
  {id:"oracle",icon:"🔮",label:"占い"},
  {id:"fortune",icon:"✨",label:"開運"},
  {id:"battle",icon:"⚡",label:"勝負"},
];
const HIDDEN_TABS=["profile","kiso","community","history","houirecord","intuition","reflect"];


// ═══ PARTICLE BACKGROUND ═══
function KiBackground(){
  React.useEffect(()=>{
    if(document.getElementById('ki-ani'))return;
    const el=document.getElementById('ki-gp');if(el)el.remove();
    const W=document.createElement('div');
    W.id='ki-ani';W.style.cssText='position:fixed;inset:0;pointer-events:none;z-index:1;overflow:hidden;';
    const NS='http://www.w3.org/2000/svg';
    const sv=document.createElementNS(NS,'svg');
    sv.setAttribute('viewBox','0 0 100 100');sv.setAttribute('preserveAspectRatio','none');
    sv.style.cssText='position:absolute;inset:0;width:100%;height:100%;';
    const pts=Array.from({length:60},(_,i)=>({
      x:Math.sin(i*2.39996)*50+50,y:Math.sin(i*1.61803)*50+50,
      r:Math.sin(i*3.14)*1.2+0.4,sp:Math.sin(i*0.7)*0.3+0.1,ph:i*0.5,
    }));
    const cls=pts.map((p,i)=>{
      const ci=document.createElementNS(NS,'circle');
      ci.setAttribute('cx',p.x);ci.setAttribute('r',p.r*0.4);
      ci.setAttribute('fill',i%3===0?'#b8860b':i%3===1?'#4a6fa5':'#c8a070');
      sv.appendChild(ci);return{el:ci,p};
    });
    const pa1=document.createElementNS(NS,'path');
    pa1.setAttribute('fill','none');pa1.setAttribute('stroke','#b8860b');
    pa1.setAttribute('stroke-width','0.3');pa1.setAttribute('opacity','0.3');sv.appendChild(pa1);
    const pa2=document.createElementNS(NS,'path');
    pa2.setAttribute('fill','none');pa2.setAttribute('stroke','#4a6fa5');
    pa2.setAttribute('stroke-width','0.2');pa2.setAttribute('opacity','0.2');sv.appendChild(pa2);
    W.appendChild(sv);
    const shiki=document.createElement('div');
    shiki.style.cssText='position:absolute;top:12%;right:8%;font-size:32px;pointer-events:none;user-select:none;color:#b8860b;font-family:serif;';
    shiki.textContent='式';W.appendChild(shiki);
    const kami=document.createElement('div');
    kami.style.cssText='position:absolute;bottom:15%;left:6%;font-size:24px;pointer-events:none;user-select:none;color:#b8860b;font-family:serif;';
    kami.textContent='神';W.appendChild(kami);
    document.body.appendChild(W);
    const t0=Date.now();let raf;
    function ani(){
      const tk=(Date.now()-t0)/50;
      cls.forEach(({el,p},i)=>{
        el.setAttribute('cy',(p.y+tk*p.sp*0.05)%100);
        el.setAttribute('opacity',0.3+Math.sin(tk*0.05+p.ph)*0.3);
      });
      pa1.setAttribute('d','M 20 '+(50+Math.sin(tk*0.03)*8)+' Q 50 '+(40+Math.sin(tk*0.04)*10)+' 80 '+(50+Math.sin(tk*0.035)*8));
      pa2.setAttribute('d','M 10 '+(60+Math.sin(tk*0.025)*6)+' Q 50 '+(55+Math.sin(tk*0.03)*8)+' 90 '+(60+Math.sin(tk*0.028)*6));
      shiki.style.opacity=0.08+Math.sin(tk*0.04)*0.04;
      shiki.style.transform='rotate('+Math.sin(tk*0.02)*5+'deg)';
      kami.style.opacity=0.06+Math.sin(tk*0.03)*0.03;
      kami.style.transform='rotate('+((-Math.sin(tk*0.025))*4)+'deg)';
      raf=requestAnimationFrame(ani);
    }
    ani();
  },[]);
  return null;
}

function ParticleBackground(){return null;}
function ReasoningPanel({reasoning}:{reasoning:string[]}){
  const[open,setOpen]=React.useState(false);
  return(
    <div style={{background:"white",borderRadius:"14px",border:"1px solid #e5e7eb",marginBottom:"14px",overflow:"hidden",boxShadow:"0 1px 4px rgba(0,0,0,0.04)"}}>
      <button onClick={()=>setOpen(o=>!o)} style={{width:"100%",padding:"12px 16px",background:"none",border:"none",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center",textAlign:"left"}}>
        <span style={{fontSize:"13px",fontWeight:"bold",color:"#374151"}}>📊 スコア計算根拠（全{reasoning.length}項目）</span>
        <span style={{fontSize:"12px",color:"#6b7280"}}>{open?"▲ 閉じる":"▼ 展開"}</span>
      </button>
      {open&&(
        <div style={{padding:"0 16px 16px",borderTop:"1px solid #f3f4f6"}}>
          {reasoning.map((r:string,i:number)=>(
            <div key={i} style={{fontSize:"12px",color:"#374151",padding:"4px 0",borderBottom:i<reasoning.length-1?"1px solid #f9fafb":"none",lineHeight:1.6}}>
              <span style={{color:r.includes('+')?'#16a34a':r.includes('-')?'#dc2626':'#6b7280'}}>・{r}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function App(){
  const[tab,setTab]=useState("today");
  React.useEffect(()=>{const ra=requestAnimationFrame(()=>{requestAnimationFrame(()=>{window.scrollTo(0,0);document.documentElement.scrollTop=0;document.body.scrollTop=0;});});const ti=setTimeout(()=>{window.scrollTo(0,0);document.documentElement.scrollTop=0;document.body.scrollTop=0;},120);return()=>{cancelAnimationFrame(ra);clearTimeout(ti);};},[tab]);
  React.useEffect(()=>{const h=(e:any)=>{setTab(e.detail);window.scrollTo({top:0,behavior:'instant'});};window.addEventListener('navigate-tab',h);return()=>window.removeEventListener('navigate-tab',h);},[]);
  const[showLanding,setShowLanding]=useState(true);
  const[onboardStep,setOnboardStep]=useState(0); // 0=landing後即、1=todayKi、2=birth、3=email、4=complete、-1=done
  const[onboardBirth,setOnboardBirth]=useState(null);
  const[showDrawer,setShowDrawer]=useState(false);
  const[showAuth,setShowAuth]=useState(false);
  const[authUser,setAuthUser]=useState<any>(null);
  const[profiles,setProfiles]=useState<any[]>([]);
  const[activeId,setActiveId]=useState<any>(null);
  const[syncStatus,setSyncStatus]=useState<string>('');

  // ── 変換ヘルパー ──
  function dbRowToProfile(r:any){
    return{id:r.profile_id,name:r.name||'',birthYear:r.birth_year,birthMonth:r.birth_month,birthDay:r.birth_day,honmeiStar:r.honmei_star,tsukimeiStar:r.tsukimei_star,keishaKyu:r.keisha_kyu??4,kiMonth:r.ki_month??1,location:r.location||''};
  }
  function profileToDbRow(uid:string,p:any,isActive:boolean){
    return{user_id:uid,profile_id:p.id,name:p.name||'',birth_year:p.birthYear,birth_month:p.birthMonth,birth_day:p.birthDay,honmei_star:p.honmeiStar,tsukimei_star:p.tsukimeiStar,keisha_kyu:p.keishaKyu??4,ki_month:p.kiMonth??1,location:p.location||'',is_active:isActive};
  }

  // ── auth初期化：onAuthStateChangeだけで一元管理 ──
  React.useEffect(()=>{
    const{data:{subscription}}=supabase.auth.onAuthStateChange((_evt,session)=>{
      setAuthUser(session?.user||null);
    });
    // 現在のセッションを即取得
    supabase.auth.getSession().then(({data:{session}})=>{
      setAuthUser(session?.user||null);
    });
    return()=>{subscription.unsubscribe();};
  },[]);

  // ── authUser変化時にプロフィールを同期（プランはisPremium宣言後のuseEffectで行う） ──
  React.useEffect(()=>{
    if(!authUser?.id){
      // ログアウト時はlocalStorageから復元
      sGet('ki_profiles',[]).then((ps:any)=>{const vp=Array.isArray(ps)?ps:[];setProfiles(vp);});
      sGet('ki_activeId',null).then((aid:any)=>setActiveId(aid));
      return;
    }
    const uid=authUser.id;
    console.log('[ProfileSync] start uid=',uid);
    setSyncStatus('同期中...');
    (async()=>{
      try{
        const{data,error}=await supabase.from('user_profiles').select('*').eq('user_id',uid).order('created_at',{ascending:true});
        console.log('[ProfileSync] query result data=',data,'error=',error);
        if(error)throw error;
        if(data&&data.length>0){
          const ps=data.map(dbRowToProfile);
          const activeRow=data.find((r:any)=>r.is_active)||data[data.length-1];
          console.log('[ProfileSync] loaded from Supabase:',ps);
          setSyncStatus('✅ Supabaseから'+ps.length+'件取得');
          setProfiles(ps);setActiveId(activeRow.profile_id);
          await sSet('ki_profiles',ps);await sSet('ki_activeId',activeRow.profile_id);
        }else{
          console.log('[ProfileSync] no Supabase data → migrate from localStorage');
          const local:any[]=await sGet('ki_profiles',[]);
          const localAid=await sGet('ki_activeId',null);
          console.log('[ProfileSync] localStorage data=',local);
          if(Array.isArray(local)&&local.length>0){
            const rows=local.map((p:any)=>profileToDbRow(uid,p,p.id===(localAid||local[0]?.id)));
            const{error:ue}=await supabase.from('user_profiles').upsert(rows,{onConflict:'user_id,profile_id'});
            console.log('[ProfileSync] migration upsert error=',ue);
            setSyncStatus(ue?'❌ 移行エラー: '+ue.message:'✅ ローカルから'+local.length+'件移行完了');
          }else{
            console.log('[ProfileSync] no local data to migrate');
            setSyncStatus('⚠️ Supabase/ローカル両方にデータなし');
          }
        }
      }catch(e:any){
        console.error('[ProfileSync] error',e);
        setSyncStatus('❌ エラー: '+e?.message);
      }
    })();
  },[authUser?.id]);

  // ログイン済みユーザーがランディングページに留まらないようにする
  React.useEffect(()=>{if(showLanding&&authUser)setShowLanding(false);},[showLanding,authUser]);
  const[ready,setReady]=useState(false);
  const[isPremium,setIsPremium]=useState(()=>localStorage.getItem('ki_premium')==='true');
  const[isPremiumPlus,setIsPremiumPlus]=useState(()=>localStorage.getItem('ki_premium_plus')==='true');
  // プラン同期（isPremium/isPremiumPlus宣言後に配置）
  React.useEffect(()=>{
    if(!authUser?.id)return;
    fetch('/api/check-subscription?email='+encodeURIComponent(authUser.email||''))
      .then(r=>r.json())
      .then(d=>{
        if(d.plan&&d.plan!=='free'){
          localStorage.setItem('ki_premium','true');
          localStorage.setItem('ki_premium_plus',String(d.plan==='premium'));
          setIsPremium(true);setIsPremiumPlus(d.plan==='premium');
        }
      })
      .catch(e=>console.warn('plan sync error',e));
  },[authUser?.id]);
  React.useEffect(()=>{
    const p=new URLSearchParams(window.location.search);
    if(p.get('checkout')==='success'){
      const plan=p.get('plan')||'basic';
      const em=p.get('email')||localStorage.getItem('ki_user_email')||'';
      if(em)localStorage.setItem('ki_user_email',em);
      localStorage.setItem('ki_premium','true');
      localStorage.setItem('ki_premium_plus',String(plan==='premium'));
      setIsPremium(true);
      setIsPremiumPlus(plan==='premium');
      window.history.replaceState({},'','/');
      alert('ご購読ありがとうございます！');
    }
  },[]);
  const[showPremiumModal,setShowPremiumModal]=useState(false);
  const[showTabBar,setShowTabBar]=React.useState(true);
  React.useEffect(()=>{
    let timer;
    const show=()=>{
      setShowTabBar(true);
      clearTimeout(timer);
      timer=setTimeout(()=>setShowTabBar(false),3000);
    };
    // 初回3秒後に隠す
    timer=setTimeout(()=>setShowTabBar(false),3000);
    window.addEventListener('scroll',show,{passive:true});
    window.addEventListener('touchstart',show,{passive:true});
    window.addEventListener('click',show);
    return()=>{
      window.removeEventListener('scroll',show);
      window.removeEventListener('touchstart',show);
      window.removeEventListener('click',show);
      clearTimeout(timer);
    };
  },[]);

  useEffect(()=>{
    let done=false;
    const timeout=setTimeout(()=>{if(!done)setReady(true);},1200);
    (async()=>{
      try{const ps=await sGet("ki_profiles",[]);const aid=await sGet("ki_activeId",null);const prem=await sGet("ki_premium",false);const premPlus=await sGet("ki_premium_plus",false);
        // プロフィールはauthUserのuseEffectで同期するため、ここではlocalStorageの初期値のみセット
        if(!done){const vp=Array.isArray(ps)?ps:[];setProfiles(vp);setActiveId(aid||(vp[0]?.id??null));setIsPremium(!!prem);setIsPremiumPlus(!!premPlus);}}
      catch(e){console.error(e);}
      finally{if(!done){done=true;clearTimeout(timeout);setReady(true);}}
    })();
    return()=>{done=true;clearTimeout(timeout);};
  },[]);

  const handleUnlock=async(plan?:string)=>{
    // 未ログインの場合は先にAuth表示
    if(!authUser){
      setShowAuth(true);
      return;
    }
    const targetPlan=plan||'basic';
    const email=authUser?.email||localStorage.getItem('ki_user_email')||'';
    if(!email){setShowAuth(true);return;}
    try{
      const r=await fetch('/api/create-checkout-session',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email,plan:targetPlan})});
      const d=await r.json();
      if(d.url){localStorage.setItem('ki_user_email',email);window.location.href=d.url;}
      else{alert('エラーが発生しました。再度お試しください。');}
    }catch(e){alert('通信エラーが発生しました。');}
  };
  const openPremium=()=>setShowPremiumModal(true);

  const activeProfile=profiles.find(p=>p.id===activeId)||null;

  const addProfile=useCallback(async(p)=>{
    const next=[...profiles,p];setProfiles(next);setActiveId(p.id);
    await sSet("ki_profiles",next);await sSet("ki_activeId",p.id);
    if(authUser?.id){
      console.log('[Profile] addProfile saving to Supabase, authUser=',authUser.id,'profile=',p);
      const rows=next.map((pr:any)=>profileToDbRow(authUser.id,pr,pr.id===p.id));
      const{error}=await supabase.from('user_profiles').upsert(rows,{onConflict:'user_id,profile_id'});
      console.log('[Profile] addProfile upsert error:',error);
    }else{
      console.log('[Profile] addProfile: authUser is null, NOT saved to Supabase');
    }
    setTab("today");
  },[profiles,authUser]);
  // 既存プロフィールの地域だけを更新（端末保存＋ログイン中はSupabaseの location 列へ）
  const updateProfileLocation=useCallback(async(id,location)=>{
    const next=profiles.map((p:any)=>p.id===id?{...p,location}:p);
    setProfiles(next);await sSet("ki_profiles",next);
    if(authUser?.id){
      const target=next.find((p:any)=>p.id===id);
      if(target){
        const{error}=await supabase.from('user_profiles').upsert([profileToDbRow(authUser.id,target,id===activeId)],{onConflict:'user_id,profile_id'});
        if(error)console.log('[Profile] updateProfileLocation upsert error:',error);
      }
    }
  },[profiles,authUser,activeId]);
  const switchProfile=useCallback(async(id)=>{
    setActiveId(id);await sSet("ki_activeId",id);
    if(authUser?.id){
      const rows=profiles.map((pr:any)=>profileToDbRow(authUser.id,pr,pr.id===id));
      await supabase.from('user_profiles').upsert(rows,{onConflict:'user_id,profile_id'});
    }
  },[profiles,authUser]);
  const deleteProfile=useCallback(async(id)=>{
    const next=profiles.filter((p:any)=>p.id!==id);const na=next[0]?.id||null;
    setProfiles(next);setActiveId(na);await sSet("ki_profiles",next);await sSet("ki_activeId",na);
    if(authUser?.id){
      await supabase.from('user_profiles').delete().eq('user_id',authUser.id).eq('profile_id',id);
      if(na){
        const rows=next.map((pr:any)=>profileToDbRow(authUser.id,pr,pr.id===na));
        await supabase.from('user_profiles').upsert(rows,{onConflict:'user_id,profile_id'});
      }
    }
  },[profiles,authUser]);

  const hi=activeProfile?STAR_INFO[activeProfile.honmeiStar]:null;

  // ログイン済みはランディングスキップ
  if(showLanding&&!authUser)return<LandingPage onNavigate={(dest)=>{
    if(dest==="signup"){setShowLanding(false);setShowAuth(true);}
    else if(dest==="fortune"){
      // 無料体験: ローカル管理
      const thisMonth=new Date().getFullYear()+'_'+(new Date().getMonth()+1);
      const freeKey='ki_free_'+thisMonth;
      const used=parseInt(localStorage.getItem(freeKey)||'0');
      if(used>=1){setShowLanding(false);}
      else{localStorage.setItem(freeKey,String(used+1));setShowLanding(false);setTab("fortune");}
    }
    else if(dest==="profile"){setShowLanding(false);setOnboardStep(2);}
    else{setShowLanding(false);}
  }}/>;
  // ログイン済みはランディングスキップ（useEffectで処理）

  // オンボーディングフロー

  if(onboardStep===2)return<OnboardingBirth
    onNext={(birth)=>{setOnboardBirth(birth);setOnboardStep(3);}}
    onSkip={()=>setOnboardStep(-1)}
  />;
  if(onboardStep===3){
    const saveAndFinish=async()=>{
      if(onboardBirth){
        const{by,bm,bd,name}=onboardBirth;
        const hs=getHonmei(by,bm,bd||15);
        const p={id:String(Date.now()),name:name||'メイン',birthYear:by,birthMonth:bm,birthDay:bd||15,honmeiStar:hs,tsukimeiStar:hs};
        await addProfile(p);
      }
      setOnboardStep(-1);
    };
    return<OnboardingEmail
      onNext={saveAndFinish}
      onSkip={saveAndFinish}
  />;
  }

  return(
    <div style={{minHeight:"100vh",background:"#f8f9fa",color:"#1f2937",fontFamily:"'Noto Sans JP',sans-serif",paddingBottom:"80px"}}><KiBackground/><InstallPrompt />
      {showPremiumModal&&<PremiumModal onClose={()=>setShowPremiumModal(false)} onUnlock={handleUnlock}/>}
      {/* HEADER */}
      <div style={{paddingLeft:"14px",paddingRight:"14px",paddingBottom:"5px",paddingTop:"calc(env(safe-area-inset-top) + 5px)",borderBottom:"1px solid #e5e7eb",background:"white",boxShadow:"0 1px 4px rgba(0,0,0,0.04)",position:"sticky",top:0,zIndex:10}}>
      {showAuth&&<AuthModal onClose={()=>setShowAuth(false)} onSuccess={()=>setShowAuth(false)}/>}
      {showDrawer&&(
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.4)",zIndex:100}} onClick={()=>setShowDrawer(false)}>
          <div style={{position:"absolute",top:0,right:0,width:"220px",height:"100%",background:"white",boxShadow:"-4px 0 20px rgba(0,0,0,0.15)",padding:"0"}} onClick={e=>e.stopPropagation()}>
            <div style={{padding:"calc(env(safe-area-inset-top) + 16px) 20px 16px",background:"linear-gradient(135deg,#d97706,#78350f)",color:"white"}}>
              <div style={{fontSize:"20px",fontWeight:"bold",fontFamily:"serif"}}>氣ごよみ</div>
              {authUser?(
                <>
                  <div style={{fontSize:"11px",color:"rgba(255,255,255,0.7)",marginTop:"4px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:"180px"}}>{authUser.email}</div>
                  <div style={{fontSize:"11px",color:"rgba(255,255,255,0.85)",marginTop:"3px",marginBottom:"6px"}}>{isPremiumPlus?'👑 プレミアム':isPremium?'💛 ベーシック':'無料会員'}</div>
                  <button onClick={async()=>{await supabase.auth.signOut();setShowDrawer(false);}} style={{marginTop:"4px",padding:"4px 12px",background:"rgba(255,255,255,0.2)",border:"1px solid rgba(255,255,255,0.4)",borderRadius:"20px",color:"white",fontSize:"12px",cursor:"pointer"}}>ログアウト</button>
                </>
              ):(
                <>
                  <div style={{fontSize:"13px",opacity:0.8,marginTop:"4px",marginBottom:"8px"}}>{activeProfile?.name||"未ログイン"}</div>
                  <button onClick={()=>{setShowAuth(true);setShowDrawer(false);}} style={{padding:"8px 16px",background:"linear-gradient(135deg,#f59e0b,#d97706)",border:"none",borderRadius:"20px",color:"white",fontSize:"13px",fontWeight:"bold",cursor:"pointer"}}>ログイン / 新規登録</button>
                </>
              )}
            </div>
            <div style={{padding:"8px 0"}}>
              <button onClick={()=>{setTab("profile");setShowDrawer(false);window.scrollTo({top:0,behavior:"instant"});}} style={{width:"100%",padding:"14px 20px",background:"none",border:"none",textAlign:"left",fontSize:"16px",cursor:"pointer",display:"flex",alignItems:"center",gap:"12px",borderBottom:"1px solid #f3f4f6"}}>
                <span style={{fontSize:"20px"}}>👤</span>
                <div>
                  <div style={{fontWeight:"bold",color:"#1f2937"}}>プロフィール</div>
                  <div style={{fontSize:"12px",color:"#6b7280"}}>登録・編集</div>
                </div>
              </button>
              <button onClick={()=>{setTab("kiso");setShowDrawer(false);window.scrollTo({top:0,behavior:"instant"});}} style={{width:"100%",padding:"14px 20px",background:"none",border:"none",textAlign:"left",fontSize:"16px",cursor:"pointer",display:"flex",alignItems:"center",gap:"12px",borderBottom:"1px solid #f3f4f6"}}>
                <span style={{fontSize:"20px"}}>📚</span>
                <div>
                  <div style={{fontWeight:"bold",color:"#1f2937"}}>気学基礎知識</div>
                  <div style={{fontSize:"12px",color:"#6b7280"}}>九星・方位・五行</div>
                </div>
              </button>
              <button onClick={()=>{setTab("community");setShowDrawer(false);window.scrollTo({top:0,behavior:"instant"});}} style={{width:"100%",padding:"14px 20px",background:"none",border:"none",textAlign:"left",fontSize:"16px",cursor:"pointer",display:"flex",alignItems:"center",gap:"12px",borderBottom:"1px solid #f3f4f6"}}>
                <span style={{fontSize:"20px"}}>🌸</span>
                <div>
                  <div style={{fontWeight:"bold",color:"#1f2937"}}>広場</div>
                  <div style={{fontSize:"12px",color:"#6b7280"}}>ユーザーボード</div>
                </div>
              </button>
              <button onClick={()=>{window.open("https://note.com/gen_tamaki","_blank");setShowDrawer(false);}} style={{width:"100%",padding:"14px 20px",background:"none",border:"none",textAlign:"left",fontSize:"16px",cursor:"pointer",display:"flex",alignItems:"center",gap:"12px",borderBottom:"1px solid #f3f4f6"}}>
                <span style={{fontSize:"20px"}}>📖</span>
                <div>
                  <div style={{fontWeight:"bold",color:"#1f2937"}}>環弦ブログ</div>
                  <div style={{fontSize:"12px",color:"#6b7280"}}>気学の解説・開運情報</div>
                </div>
              </button>
              <button onClick={()=>{setTab("history");setShowDrawer(false);window.scrollTo({top:0,behavior:"instant"});}} style={{width:"100%",padding:"14px 20px",background:"none",border:"none",textAlign:"left",fontSize:"16px",cursor:"pointer",display:"flex",alignItems:"center",gap:"12px"}}>
                <span style={{fontSize:"20px"}}>📋</span>
                <div>
                  <div style={{fontWeight:"bold",color:"#1f2937"}}>相談履歴</div>
                  <div style={{fontSize:"12px",color:"#6b7280"}}>開運・勝負相談の記録</div>
                </div>
              </button>
              <button onClick={()=>{setTab("reflect");setShowDrawer(false);window.scrollTo({top:0,behavior:"instant"});}} style={{width:"100%",padding:"14px 20px",background:"none",border:"none",textAlign:"left",fontSize:"16px",cursor:"pointer",display:"flex",alignItems:"center",gap:"12px",borderBottom:"1px solid #f3f4f6"}}>
                <span style={{fontSize:"20px"}}>🌿</span>
                <div>
                  <div style={{fontWeight:"bold",color:"#1f2937"}}>直感の振り返り</div>
                  <div style={{fontSize:"12px",color:"#6b7280"}}>ワクワクと身体の記録</div>
                </div>
              </button>
              <button onClick={()=>{setTab("houirecord");setShowDrawer(false);window.scrollTo({top:0,behavior:"instant"});}} style={{width:"100%",padding:"14px 20px",background:"none",border:"none",textAlign:"left",fontSize:"16px",cursor:"pointer",display:"flex",alignItems:"center",gap:"12px"}}>
                <span style={{fontSize:"20px"}}>🧭</span>
                <div>
                  <div style={{fontWeight:"bold",color:"#1f2937"}}>方位取りの記録</div>
                  <div style={{fontSize:"12px",color:"#6b7280"}}>方位取りの履歴管理</div>
                </div>
              </button>
              <button onClick={()=>{window.open("https://note.com/gen_tamaki/n/ncb962d62dee8","_blank");setShowDrawer(false);}} style={{width:"100%",padding:"14px 20px",background:"none",border:"none",textAlign:"left",fontSize:"16px",cursor:"pointer",display:"flex",alignItems:"center",gap:"12px"}}>
                <span style={{fontSize:"20px"}}>🔒</span>
                <div>
                  <div style={{fontWeight:"bold",color:"#1f2937"}}>プライバシーポリシー</div>
                  <div style={{fontSize:"12px",color:"#6b7280"}}>個人情報の取り扱い</div>
                </div>
              </button>
            </div>
            <div style={{padding:"4px 20px 8px",fontSize:"11px",color:"#9ca3af",lineHeight:1.6}}>気の話は参考であり、医療・介護・法律の判断の代わりにはしません。</div>
            <DevTestPanel isPremium={isPremium} isPremiumPlus={isPremiumPlus} setIsPremium={setIsPremium} setIsPremiumPlus={setIsPremiumPlus}/>
          </div>
        </div>
      )}
        <div style={{maxWidth:"560px",margin:"0 auto",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          {/* 左：キャラクター＋五芒星背景 */}
          <div style={{flexShrink:0,position:"relative",width:"62px",height:"62px"}}>
            {/* 五芒星SVG：背景・細い金色線 */}
            <svg width="62" height="62" viewBox="0 0 62 62" style={{position:"absolute",top:0,left:0,zIndex:0}}>
              <path
                d="M31,2 L48,54.5 L3.4,22 L58.6,22 L14,54.5 Z"
                fill="none"
                stroke="#c9a040"
                strokeWidth="2.5"
                strokeLinejoin="miter"
                strokeMiterlimit="25"
              />
            </svg>
            {/* キャラクター：前面・透過なし */}
            {/* キャラクター：透過PNG・通常表示 */}
            <img src={CHIBI_IMG} alt="気学くん" style={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:"52px",height:"52px",objectFit:"contain",zIndex:1,cursor:"pointer"}} onClick={()=>setShowLanding(true)}/>
          </div>
          {/* 中央：タイトル */}
          <div style={{flex:1,textAlign:"center"}}>
            <div style={{fontSize:"13px",letterSpacing:"3px",whiteSpace:"nowrap",display:"inline-block",lineHeight:1.2}}><span style={{color:"#16a34a"}}>KI-</span><span style={{color:"#b91c1c"}}>GA</span><span style={{color:"#ca8a04"}}>KU</span><span style={{color:"#6b7280"}}> · </span><span style={{color:"#d97706",fontWeight:"bold"}}>気学</span><span style={{color:"#2563eb"}}>九宮</span></div>
            <div style={{display:"flex",alignItems:"baseline",justifyContent:"center",gap:"5px",lineHeight:1.1}}>
              <div style={{fontSize:"24px",fontWeight:"900",fontFamily:"serif",background:"linear-gradient(135deg,#d97706 0%,#78350f 100%)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",letterSpacing:"1px"}}>氣ごよみ</div>
              <div style={{fontSize:"12px",color:"#16a34a",fontWeight:"bold",fontFamily:"serif",whiteSpace:"nowrap"}}>by 環 弦</div>
            </div>
          </div>
          {/* 右：プロフィール＋メニュー */}
          <div style={{display:"flex",alignItems:"center",gap:"6px",flexShrink:0}}>
            {hi&&activeProfile?(
              <div onClick={()=>setShowDrawer(true)} style={{display:"flex",alignItems:"center",gap:"6px",padding:"4px 10px",borderRadius:"20px",background:hi.bg,border:`1px solid ${hi.br}`,cursor:"pointer"}}>
                <span style={{fontSize:"17px"}}>{hi.g}</span>
                <div><div style={{fontSize:"15px",fontWeight:"bold",color:hi.c,fontFamily:"serif"}}>{activeProfile.name}</div><div style={{fontSize:"13px",color:"#6b7280"}}>{hi.k}</div></div>
              </div>
            ):(
              <button onClick={()=>setShowDrawer(true)} style={{background:"none",border:"none",cursor:"pointer",padding:"4px",fontSize:"26px",lineHeight:1}}>☰</button>
            )}
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div key={tab} style={{maxWidth:"560px",margin:"0 auto",padding:"14px 14px 0"}}>
        {!ready&&<div style={{textAlign:"center",padding:"40px",color:"#6b7280",fontSize:"14px"}}><img src={CHIBI_IMG} alt="" style={{width:"60px",opacity:0.4,marginBottom:"12px",display:"block",margin:"0 auto 12px"}}/> 読み込み中...</div>}
        {ready&&(
          <>
            <TabErrorBoundary key={tab}>
              {tab==="today"   &&<TodayTab    profile={activeProfile} isPremium={isPremium} onUnlock={openPremium} onUpdateLocation={updateProfileLocation}/>}
              {tab==="calendar" &&<KiCalendarTab profile={activeProfile||null} onUnlock={openPremium} authUser={authUser}/>}
              {tab==="profile" &&<>
                <div style={{background:'#1e293b',color:'#94a3b8',fontSize:'11px',padding:'6px 12px',textAlign:'center'}}>
                  🔑 {authUser?'ログイン中: '+authUser.email:'未ログイン'} | ☁️ {syncStatus||'同期待機中'}
                </div>
                <ProfileTab  profiles={profiles} activeId={activeId} onAdd={addProfile} onSwitch={switchProfile} onDelete={deleteProfile} isPremium={isPremium} onUnlock={openPremium}/>
              </>}
              {tab==="compat"  &&<CompatibilityTab profile={activeProfile||null} isPremium={isPremium} onUnlock={openPremium}/>}
              {tab==="event"   &&<EventTab    profile={activeProfile||null} isPremium={isPremium} isPremiumPlus={isPremiumPlus} onUnlock={openPremium}/>}
              {tab==="oracle"  &&<OracleTab   profile={activeProfile||null} isPremium={isPremium} isPremiumPlus={isPremiumPlus} onUnlock={openPremium}/>}
              {tab==="cosmos"   &&<CosmosPage profile={activeProfile||null} onBack={()=>{setTab("today");window.scrollTo({top:0,behavior:"instant"});}} onUpdateLocation={updateProfileLocation}/>}
              {tab==="kiso"     &&<KisoTab/>}
              {tab==="community"&&<CommunityTab/>}
              {tab==="history"  &&<ConsultHistoryTab authUser={authUser}/>}
              {tab==="houirecord"&&<HouiRecordTab profile={activeProfile||null}/>}
              {tab==="power"    &&<PowerSpotTab profile={activeProfile||null} isPremium={isPremium}/>}
              {tab==="fortune"  &&<FortuneTab profile={activeProfile||null} isPremium={isPremium} isPremiumPlus={isPremiumPlus} onUnlock={handleUnlock} authUser={authUser}/>}
              {tab==="battle"   &&<BattleTab  profile={activeProfile||null} isPremium={isPremium} isPremiumPlus={isPremiumPlus} onUnlock={handleUnlock} authUser={authUser}/>}
              {tab==="intuition"&&(()=>{const dc=getDayStar(new Date());const hs=activeProfile?.honmeiStar;return<IntuitionTab dayStarName={STAR_INFO[dc].name} dayElem={S_ELEM[dc]} dayStars={getStarsFor(dc)} dayBranchIdx={getDayBranchIndex(new Date())} starName={(s)=>STAR_INFO[s]?.name||''} honmeiStar={hs||null} honmeiName={hs?STAR_INFO[hs]?.name:null} honmeiRel={hs?getStarRel(hs,dc):null} isPremium={isPremium} authUser={authUser} onUnlock={openPremium}/>;})()}
              {tab==="reflect"  &&<ReflectTab isPremium={isPremium} authUser={authUser} onUnlock={openPremium} onLogin={()=>setShowAuth(true)}/>}
            </TabErrorBoundary>
          </>
        )}
      </div>

      {/* BOTTOM TAB BAR */}
      <div style={{position:"fixed",bottom:0,left:0,right:0,background:"white",borderTop:"1px solid #e5e7eb",boxShadow:"0 -2px 12px rgba(0,0,0,0.06)",paddingTop:"5px",paddingLeft:0,paddingRight:0,paddingBottom:"calc(min(env(safe-area-inset-bottom), 20px) + 3px)",zIndex:20,transition:"transform 0.35s cubic-bezier(0.4,0,0.2,1)",transform:showTabBar?"translateY(0)":"translateY(100%)"}}>
        <div style={{maxWidth:"560px",margin:"0 auto",display:"flex"}}>
          {TABS.map(t=>{
            const isA=tab===t.id;
            return(
              <button key={t.id} onClick={()=>{setTab(t.id);setShowDrawer(false);window.scrollTo({top:0,behavior:"instant"});}} style={{flex:1,background:"none",border:"none",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:"1px",padding:"2px 1px"}}>
                <span style={{fontSize:"20px",filter:isA?"none":"grayscale(0.5) opacity(0.45)",transition:"filter 0.2s"}}>{t.icon}</span>
                <span style={{fontSize:"14px",fontFamily:"'Shippori Mincho',serif",fontWeight:isA?"bold":"normal",color:isA?"#C9A84C":"#8C8C8C",transition:"color 0.2s"}}>{t.label}</span>
                {isA&&<div style={{width:"18px",height:"2px",borderRadius:"1px",background:"#d97706"}}/>}
              </button>
            );
          })}
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@400;700;900&family=Noto+Sans+JP:wght@400;500&display=swap');
        @keyframes fadeIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}
        *{box-sizing:border-box;margin:0;padding:0;}
        input::placeholder{color:#d1d5db;}
        input:focus{outline:none;border-color:#fde68a!important;box-shadow:0 0 0 3px rgba(253,230,138,0.2)!important;}
        input[type="date"]::-webkit-calendar-picker-indicator{opacity:0.4;}
        button:active{filter:brightness(0.95);}
        ::-webkit-scrollbar{width:3px;}
        ::-webkit-scrollbar-thumb{background:#e5e7eb;border-radius:2px;}
      `}</style>
    </div>
  );
}
